"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// ==============================
//  main.js
//  Main file for javascript consolidation. Do not write any javascript in this
//  file! Only include other modules as required.
//  Author: Diff - Foxpod
//  Please review practices documentation before contributing.
// ==============================

// ------------------------------
// MODULES
// ------------------------------
/**
 * UTILITIES LIBRARY
 *
 * @description General global JavaScript utility functions.
 * @namespace utils
 */

(function (theme) {
  /**
   * Class of general JavaScript utilities.
   */
  var Utilities = /*#__PURE__*/function () {
    function Utilities() {
      _classCallCheck(this, Utilities);
      // Initialize the handleize and toMoney functions
      this._handleize();
      this.suppressAgeGateRestrictedElements();
    }

    /**
     * Initializes the handleize function on the String object.
     * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
     *
     * @private
     * @memberof Utilities
     */
    _createClass(Utilities, [{
      key: "_handleize",
      value: function _handleize() {
        // UTF to ASCII map. Removes accents.
        var defaultDiacriticsRemovalap = [{
          base: 'A',
          letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
        }, {
          base: 'AA',
          letters: "\uA732"
        }, {
          base: 'AE',
          letters: "\xC6\u01FC\u01E2"
        }, {
          base: 'AO',
          letters: "\uA734"
        }, {
          base: 'AU',
          letters: "\uA736"
        }, {
          base: 'AV',
          letters: "\uA738\uA73A"
        }, {
          base: 'AY',
          letters: "\uA73C"
        }, {
          base: 'B',
          letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
        }, {
          base: 'C',
          letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
        }, {
          base: 'D',
          letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
        }, {
          base: 'DZ',
          letters: "\u01F1\u01C4"
        }, {
          base: 'Dz',
          letters: "\u01F2\u01C5"
        }, {
          base: 'E',
          letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
        }, {
          base: 'F',
          letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
        }, {
          base: 'G',
          letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
        }, {
          base: 'H',
          letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
        }, {
          base: 'I',
          letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
        }, {
          base: 'J',
          letters: "J\u24BF\uFF2A\u0134\u0248"
        }, {
          base: 'K',
          letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
        }, {
          base: 'L',
          letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
        }, {
          base: 'LJ',
          letters: "\u01C7"
        }, {
          base: 'Lj',
          letters: "\u01C8"
        }, {
          base: 'M',
          letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
        }, {
          base: 'N',
          letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
        }, {
          base: 'NJ',
          letters: "\u01CA"
        }, {
          base: 'Nj',
          letters: "\u01CB"
        }, {
          base: 'O',
          letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
        }, {
          base: 'OI',
          letters: "\u01A2"
        }, {
          base: 'OO',
          letters: "\uA74E"
        }, {
          base: 'OU',
          letters: "\u0222"
        }, {
          base: 'OE',
          letters: "\x8C\u0152"
        }, {
          base: 'oe',
          letters: "\x9C\u0153"
        }, {
          base: 'P',
          letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
        }, {
          base: 'Q',
          letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
        }, {
          base: 'R',
          letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
        }, {
          base: 'S',
          letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
        }, {
          base: 'T',
          letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
        }, {
          base: 'TZ',
          letters: "\uA728"
        }, {
          base: 'U',
          letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
        }, {
          base: 'V',
          letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
        }, {
          base: 'VY',
          letters: "\uA760"
        }, {
          base: 'W',
          letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
        }, {
          base: 'X',
          letters: "X\u24CD\uFF38\u1E8A\u1E8C"
        }, {
          base: 'Y',
          letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
        }, {
          base: 'Z',
          letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
        }, {
          base: 'a',
          letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
        }, {
          base: 'aa',
          letters: "\uA733"
        }, {
          base: 'ae',
          letters: "\xE6\u01FD\u01E3"
        }, {
          base: 'ao',
          letters: "\uA735"
        }, {
          base: 'au',
          letters: "\uA737"
        }, {
          base: 'av',
          letters: "\uA739\uA73B"
        }, {
          base: 'ay',
          letters: "\uA73D"
        }, {
          base: 'b',
          letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
        }, {
          base: 'c',
          letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
        }, {
          base: 'd',
          letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
        }, {
          base: 'dz',
          letters: "\u01F3\u01C6"
        }, {
          base: 'e',
          letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
        }, {
          base: 'f',
          letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
        }, {
          base: 'g',
          letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
        }, {
          base: 'h',
          letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
        }, {
          base: 'hv',
          letters: "\u0195"
        }, {
          base: 'i',
          letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
        }, {
          base: 'j',
          letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
        }, {
          base: 'k',
          letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
        }, {
          base: 'l',
          letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
        }, {
          base: 'lj',
          letters: "\u01C9"
        }, {
          base: 'm',
          letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
        }, {
          base: 'n',
          letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
        }, {
          base: 'nj',
          letters: "\u01CC"
        }, {
          base: 'o',
          letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
        }, {
          base: 'oi',
          letters: "\u01A3"
        }, {
          base: 'ou',
          letters: "\u0223"
        }, {
          base: 'oo',
          letters: "\uA74F"
        }, {
          base: 'p',
          letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
        }, {
          base: 'q',
          letters: "q\u24E0\uFF51\u024B\uA757\uA759"
        }, {
          base: 'r',
          letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
        }, {
          base: 's',
          letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
        }, {
          base: 't',
          letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
        }, {
          base: 'tz',
          letters: "\uA729"
        }, {
          base: 'u',
          letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
        }, {
          base: 'v',
          letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
        }, {
          base: 'vy',
          letters: "\uA761"
        }, {
          base: 'w',
          letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
        }, {
          base: 'x',
          letters: "x\u24E7\uFF58\u1E8B\u1E8D"
        }, {
          base: 'y',
          letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
        }, {
          base: 'z',
          letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
        }];

        // Generate the diacritics map to replace accented characters.
        var diacriticsMap = {};
        for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
          var letters = defaultDiacriticsRemovalap[i].letters.split('');
          for (var j = 0; j < letters.length; j++) {
            diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
          }
        }

        /**
         * Replaces accented characters with their non-accented counterparts.<br>
         * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
         *
         * @param {boolean} [remove=false] - Whether to remove unicode characters that are not mapped to a non-accented characters.
         * 	This includes all non-ascii characters.
         * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
         * @returns {string} String without accents.
         * @memberof Utilities
         * @example
         * // returns 'My accented string$.'
         * 'My áccentéd string$.'.noAccents();
         */
        String.prototype.noAccents = function (remove, replacement) {
          // x00-x7E is the ASCII character range
          var withoutAccents = this.replace(/[^\u0000-\u007E]/g, function (ch) {
            return diacriticsMap[ch] || ch;
          });
          replacement = replacement || '';
          if (remove) {
            withoutAccents = withoutAccents.replace(/[^\u0000-\u007E]/g, replacement);
          }
          return withoutAccents;
        };

        /**
         * Returns a "handleized" version of a string suitable for URLs and file names.<br>
         * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
         *
         * @param {string} [seperator=-] - The character to use as a separator.
         * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
         * @returns {string} The handleized string.
         * @memberof Utilities
         * @example
         * var myString = 'My áccentéd string$.';
         *
         * // returns 'my-accented-string'
         * myString.handleize();
         *
         * // returns 'my_accented_string##'
         * myString.handleize('_', '#');
         */
        String.prototype.handleize = function (separator, replacement) {
          var slug;
          separator = separator || '-';
          replacement = replacement || '';
          slug = this.noAccents(true, replacement).trim().replace(/[^a-z0-9\s-]/gi, replacement).replace(/\s/gi, separator);
          return slug.toLowerCase();
        };
      }

      /**
       * Curency formating function.
       *
       * @param {(number|string)} price - The price to format.
       * @param {object} options - The options for the currency formatter.
       * @param {boolean} [options.cents=false] - Wether or not the price is currently in cents.
       * @param {string} [options.locale=Shop locale or 'en-CA'] - Override the locale to format to.
       * @param {string} [options.currency=Shop currency or 'CAD'] - Override the currency to output.
       * @returns {(string|null)} The price formatted based on the locale and currency.
       * @memberof Utilities
       * @example
       * // Returns '$12.56'
       * theme.utils.toMoney(15.26)
       *
       * // Returns '12,56 $'
       * theme.utils.toMoney('12.56', { locale: 'fr-CA', currency: 'CAD' })
       *
       * // Returns '$12.56'
       * theme.utils.toMoney('1256', { cents: true })
       */
    }, {
      key: "toMoney",
      value: function toMoney(price, options) {
        if (!price && price !== 0) {
          console.error('Utilities.toMoney: Invalid price passed.', price);
          return null;
        }
        var price = new Number(price);
        var options = options || {};

        // Assign defaults if no options are passed.
        options.cents = options.cents || false;
        options.locale = options.locale || (theme.locales ? theme.locales.current_locale : null) || 'en-CA';
        options.currency = options.currency || (theme.shop ? theme.shop.currency : null) || 'CAD';

        // Convert to dollars if the amount passed is in cents
        if (options.cents) {
          price = price / 100;
        }
        return price.toLocaleString(options.locale, {
          style: 'currency',
          currency: options.currency
        });
      }

      /**
       * Removes the URL protocol.
       *
       * @param {string} path - The URL to strip out the protocol from.
       * @returns {(string|null)} The URL without protocol.
       * @memberof Utilities
       */
    }, {
      key: "removeProtocol",
      value: function removeProtocol(path) {
        if (!path) {
          console.error('Utilities.removeProtocol: Invalid path passed.', path);
          return null;
        }
        return path.replace(/http(s)?:/, '');
      }

      /**
       * Adds a Shopify size attribute to an image URL.
       *
       * @param {string} src - The image source URL.
       * @param {string} size - The size parameters to fetch, following Shopify's img_url guidelines.
       * @returns {(string|null)} The updated URL.
       * @memberof Utilities
       * @example
       * theme.utils.getSizedImageUrl('cdn.shopify.com/some-image.jpg', '500x300_crop_center');
       */
    }, {
      key: "getSizedImageUrl",
      value: function getSizedImageUrl(src, size) {
        if (!size) {
          console.error('Utilities.getSizedImageUrl: Invalid size passed.', size);
          return src;
        }
        if (size === 'master') {
          return this.removeProtocol(src);
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match) {
          var prefix = src.split(match[0]);
          var suffix = match[0];
          return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else {
          console.error('Utilities.getSizedImageUrl: Invalid image URL passed.', src);
          return null;
        }
      }

      /**
       * Created an object from a parameter string.
       *
       * @param {string} object_string - The string to parse to an object.
       * @returns {object} The object created from the string.
       * @memberof Utilities
       * @example
       * // If called on a form that takes a name and email, could return { name: "Joe", email: "joe@diffagency.com" }
       * theme.utils.toObject($form.serialize());
       */
    }, {
      key: "toObject",
      value: function toObject(object_string) {
        var parameters = {};
        var elements;
        if (!object_string) {
          return {};
        }

        // Decode the query string to get original characters
        object_string = decodeURIComponent(object_string);

        // Split into each element
        elements = object_string.split('&');
        elements.forEach(function (element) {
          var element = element.split('=');
          parameters[element[0]] = element[1] || null;
        });
        return parameters;
      }

      /**
       * Created an object from a parameter string.
       *
       * @param {string} inputStr - The string to parse to convert.
       * @returns {string} snake case string.
       * @memberof Utilities
       * @example
       * // If called on a e Comm- onLine will return e_comm_on_line
       * theme.utils.toSnakeCase('test_String');
       */
    }, {
      key: "toSnakeCase",
      value: function toSnakeCase(inputStr) {
        //regex to convert to snake case
        return inputStr === null || inputStr === void 0 ? void 0 : inputStr.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (s) {
          return s.toLowerCase();
        }).join('_');
      }

      /**
       * Extracts the URL parameters into an object.
       *
       * @param {string} [url=window.location.href] - The URL to parse.
       * @returns {object} The query parameters object.
       * @memberof Utilities
       * @example
       * // Returns { name: "Joe", email: "joe@diffagency.com" }
       * theme.utils.getURLParams('https://example.com/?name%3DJoe%26email%3Djoe%40diffagency.com');
       */
    }, {
      key: "getURLParams",
      value: function getURLParams(url) {
        var url = url || window.location.href;
        // Get the string after the '?' from the URL
        var query_string = url.split(/\?([^\#]+)/)[1];
        if (!query_string) {
          return {};
        }
        return this.toObject(query_string);
      }

      /**
       * Sets URL parameters.
       *
       * @param {object} [params] - The parameters to add to the URL.
       * @param {object} [options] - Method options.
       * @param {boolean} [options.clear=false] - Clear previous parameters.
       * @param {boolean} [options.no_overwrite=false] - Don't overwrite parameters with same key.
       * @param {boolean} [options.push_state=false] - Push a window history state. Defaults to replace state.
       * @memberof Utilities
       * @example
       * // Examples with a current URL of 'example.com/?page=2'
       *
       * // Will set url to 'example.com/?page=3&view=grid'
       * theme.utils.setURLParams({ page: 3, view: 'grid' });
       *
       * // Will set url to 'example.com/?page=2'
       * theme.utils.setURLParams({ page: 3 }, { no_overwrite: true });
       *
       * // Will clear parameters: 'example.com/'
       * theme.utils.setURLParams({}, { clear: true });
       *
       * // Will replace parameters: 'example.com/?view=grid'
       * theme.utils.setURLParams({ view: 'grid' }, { clear: true });
       */
    }, {
      key: "setURLParams",
      value: function setURLParams(params) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var current_params = this.getURLParams();
        var new_params = options.clear ? {} : current_params;
        var query_array = [];
        var url = window.location.pathname;

        // Add new parameters
        Object.keys(params).forEach(function (key) {
          var param_value = params[key];
          new_params[key] = options.no_overwrite ? new_params[key] || param_value : param_value;
        });

        // Convert object to URL string
        Object.keys(new_params).forEach(function (key) {
          query_array.push(encodeURIComponent(key) + '=' + encodeURIComponent(new_params[key]));
        });
        if (query_array.length) {
          url += '?' + query_array.join('&');
        }
        if (options.push_state) {
          window.history.pushState({}, null, url);
        } else {
          window.history.replaceState({}, null, url);
        }
      }

      /**
       * Generate the formatted cannabinoid content for a product based on metafields.
       *
       * @param {*} product
       * @returns Object with thc and cbd properties with formatted strings.
       * @memberof Utilities
       */
    }, {
      key: "formatCannabinoids",
      value: function formatCannabinoids(product) {
        var metafields = product.metafields || product.meta;
        var thc_range = [];
        var cbd_range = [];

        /* -----------------
         * THC
         * ----------------- */

        // Percentage
        if (metafields.product && metafields.product.thc_content_min !== undefined) {
          thc_range.push(parseFloat(metafields.product.thc_content_min).toFixed(2) + (metafields.product.thc_content_max != metafields.product.thc_content_min ? ' - ' + parseFloat(metafields.product.thc_content_max).toFixed(2) : '') + '%');
        }

        // Amount
        if (metafields.variant && metafields.variant.thc_min_per !== undefined) {
          thc_range.push(parseFloat(metafields.variant.thc_min_per).toFixed(2) + (metafields.variant.thc_max_per != metafields.variant.thc_min_per ? ' - ' + parseFloat(metafields.variant.thc_max_per).toFixed(2) : '') + ' mg' + (this.containsAtleastOne(["subcategory--Beverages", "subsubcategory--Bottled Oils"], product.tags) ? '' : metafields.product.content_uom ? '/' + metafields.product.content_uom : ''));
        }

        /* -----------------
         * CBD
         * ----------------- */

        // Percentage
        if (metafields.product && metafields.product.cbd_content_min !== undefined) {
          cbd_range.push(parseFloat(metafields.product.cbd_content_min).toFixed(2) + (metafields.product.cbd_content_max != metafields.product.cbd_content_min ? ' - ' + parseFloat(metafields.product.cbd_content_max).toFixed(2) : '') + '%');
        }

        // Amount
        if (metafields.variant && metafields.variant.cbd_min_per !== undefined) {
          cbd_range.push(parseFloat(metafields.variant.cbd_min_per).toFixed(2) + (metafields.variant.cbd_max_per != metafields.variant.cbd_min_per ? ' - ' + parseFloat(metafields.variant.cbd_max_per).toFixed(2) : '') + ' mg' + (this.containsAtleastOne(["subcategory--Beverages", "subsubcategory--Bottled Oils"], product.tags) ? '' : metafields.product.content_uom ? '/' + metafields.product.content_uom : ''));
        }
        return {
          thc: thc_range.join(' | '),
          cbd: cbd_range.join(' | ')
        };
      }

      /**
       * Prevents page zooming on mobile when inputs are focused. 
       * Does so by toggling 'user-scalable' property of viewport meta tag.
       *
       * @param {object} [input] - The input element for disabling zoom
       * @memberof Utilities
       */
    }, {
      key: "disableInputZoom",
      value: function disableInputZoom(input) {
        var viewport = document.querySelector("meta[name=viewport]");
        input.addEventListener('focus', function () {
          viewport.setAttribute('content', 'width=device-width, height=device-height, initial-scale=1.0, user-scalable=no, maximum-scale=1.0, minimal-ui');
        });
        input.addEventListener('blur', function () {
          viewport.setAttribute('content', 'width=device-width, height=device-height, initial-scale=1.0, user-scalable=yes, maximum-scale=1.0, minimal-ui');
        });
      }
    }, {
      key: "createSimpleUUID",
      value: function createSimpleUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      }
    }, {
      key: "createSimpleUUIDv4",
      value: function createSimpleUUIDv4() {
        var d = new Date().getTime(); // Timestamp
        var d2 = performance && performance.now && performance.now() * 1000 || 0; //Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16; //random number between 0 and 16
          if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
          } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
          }
          return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
      }
    }, {
      key: "containsAll",
      value: function containsAll(needles, haystack) {
        for (var i = 0; i < needles.length; i++) {
          if ($.inArray(needles[i], haystack) == -1) return false;
        }
        return true;

        // return needles.filter((v) => {
        //   return haystack.includes(v);
        // }).length === needles.length;
      }
    }, {
      key: "containsAtleastOne",
      value: function containsAtleastOne(needles, haystack) {
        for (var i = 0; i < needles.length; i++) {
          if ($.inArray(needles[i], haystack) != -1) return true;
        }
        return false;
      }

      /**
       * Verifies the tags or metafields to determine isAgeGateOverride flag
       * If the resource has a 'no_age-gate' tag or metafield, then age gate is overridden
       * @memberof Utilities
       * @example 
       * theme.utils.isAgeGateOverride();
       */
    }, {
      key: "isAgeGateOverride",
      value: function isAgeGateOverride() {
        var ageGateOverride = false;
        var themeTags;

        // Check if page tags exist
        if (window.theme && window.theme.current_object) {
          themeTags = window.theme.current_object.tags;
        }

        // Check if age gate exempt tag exists
        if (window.location.href.indexOf('/pages') > 0 || window.location.href.indexOf('/blogs') > 0 || window.location.href.indexOf('/articles') > 0) {
          if (themeTags) {
            for (var i = 0; i < themeTags.length; i++) {
              if (themeTags[i] === 'no_age-gate') {
                ageGateOverride = true;
              }
            }
          }
          if (window.age_validated) {
            ageGateOverride = true;
          }
        }
        return ageGateOverride;
      }

      /**
       * Verifies the age cookie
       * If age cookie is valid and defined, let's you pass through
       * If age cookie is invalid or undefined, triggeres the age gate condition
       * @memberof Utilities
       * @example 
       * theme.utils.isAgeVerified();
       */
    }, {
      key: "isAgeVerified",
      value: function isAgeVerified() {
        var ageCookie = Cookies.get('age_verified');
        var ageVerified = false;
        if (ageCookie && ageCookie === 'verified') {
          ageVerified = true;
        } else {
          ageVerified = false;
        }
        return ageVerified;
      }

      /**
       * Verifies the age cookie, metafields and tags and subsequently show/hide the age gate to the user
       * If age cookie is valid and defined, let's you pass through
       * If age cookie is invalid or undefined, triggeres the age gate
       * If the resource has a 'no_age-gate' tag or metafield, then age gate is overridden
       * @memberof Utilities
       * @example 
       * theme.utils.showAgeGate();
       */
    }, {
      key: "showAgeGate",
      value: function showAgeGate() {
        var ageGateVisible = true;
        var ageVerified = this.isAgeVerified();
        var ageGateOverride = this.isAgeGateOverride();

        // If valid ageCookie is found OR ageGateOverride flag is true, override the age gate
        if (ageVerified || ageGateOverride) {
          ageGateVisible = false;
          $('body').removeClass('agewall-show checking-age');
        } else {
          ageGateVisible = true;
          $('body').addClass('agewall-show');
        }
        return ageGateVisible;
      }

      /**
       * Suppresses the age-gate restricted elements for age-gated users
       * @memberof Utilities
       * @example 
       * theme.utils.suppressAgeGateRestrictedElements();
       */
    }, {
      key: "suppressAgeGateRestrictedElements",
      value: function suppressAgeGateRestrictedElements() {
        theme.ageGateRestrictedExperience = this.isAgeGateOverride() && !this.isAgeVerified();
        if (theme.ageGateRestrictedExperience) {
          $('.js-age-gate__remove-item').remove();
          $('.js-age-gate__remove-section').closest('.shopify-section').remove();
        }
        $('.js-age-gate__remove-item').removeClass('js-age-gate__remove-item');
        $('.js-age-gate__remove-section').removeClass('js-age-gate__remove-section');
      }
    }, {
      key: "getDefaultCarousalSettings",
      value: function getDefaultCarousalSettings(settings) {
        return Object.assign({
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
          dots: false,
          speed: 300,
          arrows: true,
          prevArrow: "<button type=\"button\" class=\"btn btn--unstyled slick-arrow--prev\" aria-label=\"".concat(theme.translations.previous, "\"><span aria-hidden=\"true\" class=\"icon icon--back\"></span></button>"),
          nextArrow: "<button type=\"button\" class=\"btn btn--unstyled slick-arrow--next\" aria-label=\"".concat(theme.translations.next, "\"><span aria-hidden=\"true\" class=\"icon icon--forward\"></span></button>"),
          swipe: true,
          swipeToSlide: true,
          touchTreshold: 1000,
          mobileFirst: true,
          infinite: true,
          customPaging: function customPaging(slider, index) {
            var num_pages = Math.ceil(slider.slideCount / slider.options.slidesToShow);
            var page_html = '';
            if (num_pages > 1) {
              for (var i = 0; i < num_pages; i++) {
                page_html = "<button class=\"slick-dots__page\" type=\"button\"><span class=\"sr-only\">".concat(index + 1, "</span></button>");
              }
            }
            return page_html;
          },
          responsive: [{
            breakpoint: theme.bp.sm - 1,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              swipeToSlide: true,
              centerMode: false
            }
          }, {
            breakpoint: theme.bp.md - 1,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: true,
              dots: true,
              swipeToSlide: false,
              centerMode: false
            }
          }, {
            breakpoint: theme.bp.lg - 1,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: true,
              dots: true,
              swipeToSlide: false,
              centerMode: false
            }
          }, {
            breakpoint: theme.bp.xl - 1,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: true,
              dots: true,
              swipeToSlide: false,
              centerMode: false
            }
          }]
        }, settings || {});
      }
    }]);
    return Utilities;
  }(); // Global export
  theme.utils = new Utilities();
})(window.theme = window.theme || {});
/**
 * CART LIBRARY
 *
 * @description Handles the Shopify cart interactions.
 * @namespace cart
 */

(function (theme, $) {
  /**
   * Class representing the cart.
   */
  var Cart = /*#__PURE__*/function () {
    /**
     * Creates an instance of Cart.
     *
     * @param {object} [cart] - A cart object to use. Passing this argument will avoid an AJAX call to the Shopify API.
     * @constructs Cart
     * @memberof Cart
     */
    function Cart(cart) {
      _classCallCheck(this, Cart);
      this.content = cart || {};
      this._queue = $.when();

      // If no cart is passed, fetch it.
      if (!cart) {
        this.fetch();
      }
    }

    // ------------------------------
    //  Getters and Setters
    // ------------------------------

    /**
     * The cart object.<br><br>
     * @example
     * // Get the cart object
     * theme.cart.content
     *
     * @type {object}
     * @fires cart_set
     * @memberof Cart
     */
    _createClass(Cart, [{
      key: "content",
      get: function get() {
        return this._object;
      },
      set: function set(cart) {
        // The Cart class uses a private variable to keep track of the cart content.
        this._object = cart || this._object;

        /**
         * The cart has been updated.
         * The event is attached to the document element.<br><br>
         *
         * @event cart_set
         * @property {object} cart - The cart object.
         * @memberof Cart
         * @example
         * $(document).on('cart_set', function(event, cart) {});
         */
        $(document).trigger('cart_set', this.content);
      }

      // ------------------------------
      //  Methods
      // ------------------------------

      /**
       * Queries the Shopify API to refresh the cart.<br>
       * Calling this function will update the cart object.
       *
       * @fires cart_fetch
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * theme.cart.fetch();
       */
    }, {
      key: "fetch",
      value: function fetch() {
        var _this = this;
        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json'
          }).done(function (cart) {
            _this.content = cart;

            /**
             * The cart has been fetched.
             * The event is attached to the document element.<br><br>
             *
             * @event cart_fetch
             * @property {object} cart - The cart object.
             * @memberof Cart
             * @example
             * $(document).on('cart_fetch', function(event, cart) {});
             */
            $(document).trigger('cart_fetch', _this.content);
          }).fail(function (resp) {
            console.error('Cart.fetch: Failed getting the cart.', resp);
          });
        });
        return this._queue;
      }

      /**
       * Adds an item to cart.
       *
       * @param {(object|number)} item - The item id or item object to add.
       * @param {number} item.id - The id of the variant to add.
       * @param {number} [item.quantity=1] - Quantity to add, defaults to 1.
       * @param {object} options - The options to pass
       * @fires cart_add
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Adds 1 of item 1234567 to the cart.
       * theme.cart.add(1234567);
       */
    }, {
      key: "add",
      value: function add(item, options) {
        var _this2 = this,
          _item;
        if (!item) {
          console.warn('Cart.add: No item was passed.');
          return $.when();
        }
        options = options || {};

        // Set up the object if only an id is passed.
        if (_typeof(item) != 'object') {
          item = {
            id: item
          };
        }

        // Default the quantity to 1 if none is passed.
        item.quantity = item.quantity || 1;

        // If previous promise is rejected, ensure chain can continue
        if (this._queue.state() == 'rejected') {
          this._queue = $.when();
        }
        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/add.js',
            data: item,
            type: 'POST',
            dataType: 'json'
          }).done(function (item) {
            // Refresh the cart
            _this2.fetch();

            /**
             * An item has been added to cart.
             * The event is attached to the document element.<br><br>
             *
             * @event cart_add
             * @property {object} item - The item added to cart.
             * @memberof Cart
             * @example
             * $(document).on('cart_add', function(event, item) {});
             */

            // Trigger cart add unless quiet option is passed
            if (typeof options.quiet === 'undefined' || options.quiet === false) {
              $(document).trigger('cart_add', item);
            }
          }).fail(function (resp) {
            console.error('Cart.add: Failed adding to the cart.', resp);
          });
        });

        // Send event to GTM for tracking
        $(document).trigger('gtm_add_to_cart', (_item = item) === null || _item === void 0 ? void 0 : _item.analytics);
        return this._queue;
      }

      /**
       * Updates an item in the cart.
       *
       * @param {(object|object[]|number|number[])} items - The item id, id array, item object or object array to update.
       * @param {number} items.id - The id of the variant to update.
       * @param {number} [items.quantity=1] - Quantity to add, defaults to 1.
       * @fires cart_update
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Updated item 1234567's quantity to 5
       * theme.cart.update({ id: 1234567, quantity: 5 });
       *
       * // Updated item 1234567's quantity to 5 and item 7654321's quantity to 1
       * theme.cart.update([{ id: 1234567, quantity: 5 }, 7654321]);
       */
    }, {
      key: "update",
      value: function update(items) {
        var _this3 = this;
        if (!items) {
          console.warn('Cart.update: No item was passed.');
          return $.when();
        }
        var data = {};

        /**
         * Internal function to convert items to the proper format for Shopify's update API call.
         *
         * @param {object} data - The data object to add the key/value pair to.
         * @param {(object|number)} item - The item id or item object to format.
         * @private
         */
        var _addUpdateItem = function _addUpdateItem(item) {
          // Set up the object if only an id is passed.
          if (_typeof(item) === 'object') {
            if (!item.id) {
              console.warn('Cart.update: No id was passed with the product object.');
              return $.when();
            }
            data[item.id] = item.quantity || item.quantity === 0 ? item.quantity : 1;
          } else {
            data[item] = 1;
          }
        };
        if (Array.isArray(items)) {
          items.forEach(function (item) {
            _addUpdateItem(item);
          });
        } else {
          _addUpdateItem(items);
        }

        // If data is empty, return empty promise
        if (!Object.keys(data).length) {
          return $.when();
        }

        // If previous promise is rejected, ensure chain can continue
        if (this._queue.state() == 'rejected') {
          this._queue = $.when();
        }
        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/update.js',
            data: {
              updates: data
            },
            type: 'POST',
            dataType: 'json'
          }).done(function (cart) {
            // Refresh the cart
            _this3.content = cart;

            /**
             * An item in the cart has been updated.
             * The event is attached to the document element.<br><br>
             *
             * @event cart_update
             * @property {object} cart - The cart object.
             * @property {object} item - The item changed.
             * @memberof Cart
             * @example
             * $(document).on('cart_update', function(event, cart, item) {});
             */
            $(document).trigger('cart_update', [cart, items]);
          }).fail(function (resp) {
            console.error('Cart.update: Failed updating a cart item.', resp);
          });
        });
        return this._queue;
      }

      /**
       * Change an item in the cart.
       *
       * @param {(object|number)} item - The item id or item object to update.
       * @param {number} item.id - The id of the variant to update.
       * @param {number} [item.quantity=1] - Quantity to add, defaults to 1.
       * @fires cart_change
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Changes item 1234567's quantity to 2
       * theme.cart.change({ id: 1234567, quantity: 2 });
       */
    }, {
      key: "change",
      value: function change(item) {
        var _this4 = this;
        if (!item) {
          console.warn('Cart.change: No item was passed.');
          return $.when();
        }

        // Set up the object if only an id is passed.
        if (_typeof(item) != 'object') {
          item = {
            id: item,
            quantity: 1
          };
        }
        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/change.js',
            data: item,
            type: 'POST',
            dataType: 'json'
          }).done(function (cart) {
            // Refresh the cart
            _this4.content = cart;

            /**
             * An item in the cart's quantity has been changed.
             * The event is attached to the document element.<br><br>
             *
             * @event cart_change
             * @property {object} cart - The cart object.
             * @property {object} item - The item changed.
             * @memberof Cart
             * @example
             * $(document).on('cart_change', function(event, cart, item) {});
             */
            $(document).trigger('cart_change', [cart, item]);
          }).fail(function (resp) {
            console.error('Cart.change: Failed changing a cart quantity.', resp);
          });
        });
        return this._queue;
      }

      /**
       * Updates an item in the cart.
       *
       * @param {(object|object[]|number|number[])} item - The item id, id array, item object or object array to remove.
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Removes item 1234567 from the cart
       * theme.cart.remove(1234567);
       */
    }, {
      key: "remove",
      value: function remove(items) {
        if (!items) {
          console.warn('Cart.remove: No item was passed.');
          return $.when();
        }

        // Create an array of items with quantity 0 and feed to the update function.
        var remove_items = [];
        if (Array.isArray(items)) {
          items.forEach(function (item) {
            remove_items.push({
              id: _typeof(item) === 'object' ? item.id : item,
              quantity: 0
            });
          });
        } else {
          remove_items.push({
            id: _typeof(items) === 'object' ? items.id : items,
            quantity: 0
          });
        }
        return this.update(remove_items);
      }

      /**
       * Empty the cart.
       *
       * @fires cart_clear
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * theme.cart.clear();
       */
    }, {
      key: "clear",
      value: function clear() {
        var _this5 = this;
        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/clear.js',
            type: 'POST',
            dataType: 'json'
          }).done(function (cart) {
            // Refresh the cart
            _this5.content = cart;

            /**
             * The cart has been cleared.
             * The event is attached to the document element.<br><br>
             *
             * @event cart_clear
             * @property {object} cart - The cart object.
             * @memberof Cart
             * @example
             * $(document).on('cart_clear', function(event, cart) {});
             */
            $(document).trigger('cart_clear', cart);
          }).fail(function (resp) {
            console.error('Cart.clear: Failed clearing the cart.', resp);
          });
        });
        return this._queue;
      }

      /**
       * Updates an attribute in the cart.
       *
       * @param {object} attributes - The attribute(s) to update.
       * @param {object} options - The options to pass
       * @param {boolean} [options.no_overwrite=false] - Option to skip setting attributes if they are already set.
       * @fires cart_attributeUpdate
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Update the language attribute to 'fr' and currency to CAD
       * theme.cart.updateAttributes({ langauge: 'fr', currency: 'CAD' });
       *
       * // Update the language attribute to 'fr' but don't overwrite if already set
       * theme.cart.updateAttributes({ langauge: 'fr' }, { no_overwrite: true });
       */
    }, {
      key: "updateAttributes",
      value: function updateAttributes(attributes, options) {
        var _this6 = this;
        if (!attributes) {
          console.warn('Cart.updateAttribute: No attributes were passed.');
          return $.when();
        }
        var data = {};
        options = options || {};

        // If we don't overwrite, only add attributes that are not set in cart
        if (options.no_overwrite) {
          for (var _i = 0, _Object$keys = Object.keys(attributes); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (!this.content.attributes[key]) {
              data[key] = attributes[key];
            }
          }
        } else {
          data = attributes;
        }

        // If data is empty, return empty promise
        if (!Object.keys(data).length) {
          return $.when();
        }
        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/update.js',
            data: {
              attributes: data
            },
            type: 'POST',
            dataType: 'json'
          }).done(function (cart) {
            if (options.quiet) {
              return false;
            }

            // Refresh the cart
            _this6.content = cart;

            /**
             * An item in the cart has been updated.
             * The event is attached to the document element.<br><br>
             *
             * @event cart_attributeUpdate
             * @property {object} cart - The cart object.
             * @property {object} attributes - The attributes changed.
             * @memberof Cart
             * @example
             * $(document).on('cart_attributeUpdate', function(event, cart, attributes) {});
             */
            $(document).trigger('cart_update', [cart, data]);
          }).fail(function (resp) {
            console.error('Cart.attributeUpdate: Failed updating a cart attribute.', resp);
          });
        });
        return this._queue;
      }

      /**
       * Clears all or specific attributes in the cart.
       *
       * @param {(string|string[])} [attributes] - The attribute(s) to clear. If none are passed, all will be cleared.
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Clears all cart attributes
       * theme.cart.clearAttributes();
       *
       * // Only clears the language attribute
       * theme.cart.clearAttributes('language');
       *
       * // Clears the language and currency attributes
       * theme.cart.clearAttributes(['language', 'currency']);
       */
    }, {
      key: "clearAttributes",
      value: function clearAttributes(attributes) {
        var cleared_attributes = {};

        // If no attributes are passed, use all cart attributes to clear
        var attribute_keys = attributes !== undefined ? [].concat(attributes || []) : Object.keys(theme.cart.content.attributes);
        var _iterator = _createForOfIteratorHelper(attribute_keys),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            cleared_attributes[key] = '';
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return this.updateAttributes(cleared_attributes);
      }
    }]);
    return Cart;
  }(); // Global export
  // Uses the cart information stored by the global object if available
  theme.cart = new Cart(theme.cart || null);
})(window.theme = window.theme || {}, jQuery);
(function ($, Handlebars, theme) {
  $(function () {
    if (window.theme.template.name == 'collection' || window.theme.template.name == 'search') {
      var createSlider = function createSlider(slider, bounds, margin) {
        var options = {
          start: bounds,
          connect: true,
          step: 1,
          range: {
            'min': bounds[0],
            'max': bounds[1]
          },
          margin: margin,
          tooltips: true
        };
        noUiSlider.create(slider, options);

        /**
         * Handle Keyboard events
         * Move handles when arrows are pressed
         */
        $(slider).find('.noUi-handle').each(function (i, handle) {
          $(handle).on('keydown', function (e) {
            var values = slider.noUiSlider.get();
            if (e.which === 37) {
              values[i] = Number(values[i]) - options.step;
              slider.noUiSlider.set(values);
            }
            if (e.which === 39) {
              values[i] = Number(values[i]) + options.step;
              slider.noUiSlider.set(values);
            }
          });
        });
      };
      var loader = '.collection .loader',
        pagination = '.collection .pagination-wrapper',
        loadingNextPage = false;

      // Infinite Scroll Event
      $(document).on('click', '.js-load-more', function (e) {
        e.preventDefault();
        var page_url = $(this).attr('href');
        if (!loadingNextPage) {
          loadingNextPage = true;
          var $nextPage = $('.pagination--mobile');
          if ($nextPage.length) {
            $(loader).fadeIn();
            $.get(page_url, function (response) {
              if (response) {
                $(pagination).html('');
                var responseProducts = $(response).find('.product-grid').html();
                var $responsePagination = $(response).find('.pagination-wrapper');
                $('.product-grid').append(responseProducts);
                $(pagination).replaceWith($responsePagination);
              } else {
                $(loader).fadeOut();
              }
            }).always(function () {
              loadingNextPage = false;
            });
          }
        }
      });
      var nb_hits_last = 0;
      var thcContentSlider = document.getElementById('thc-content-slider');
      var cbdContentSlider = document.getElementById('cbd-content-slider');
      if (thcContentSlider != undefined || cbdContentSlider != undefined) {
        /**
         * THC Content Range Slider
         */
        var thc_content_min = theme.min_thc,
          thc_content_max = theme.max_thc,
          percentage = this.bounds.max > 100 ? 0.15 : thc_content_max > 75 ? 0.12 : 0.1,
          calculated_margin = Math.ceil(thc_content_max * percentage);
        createSlider(thcContentSlider, [thc_content_min, thc_content_max], calculated_margin);
        thcContentSlider.noUiSlider.on('set', function (values, handle) {
          // THC reset if values on the handles are the default ones
          if (values[0] <= thc_content_min && values[1] >= thc_content_max) {
            $('#thc-content-max, #thc-volume-max, #thc-capsule-max').prop('checked', false);
            $('#thc-content-min, #thc-volume-min, #thc-capsule-min').prop('checked', false).change();
          } else {
            $('#thc-content-max, #thc-volume-max, #thc-capsule-max').val(values[0] + ' TO ' + values[1]).prop('checked', true);
            $('#thc-content-min').data('display-name', 'THC ' + values[0] + '-' + values[1]);
            $('#thc-content-min, #thc-volume-min, #thc-capsule-min').val(values[0] + ' TO ' + values[1]).prop('checked', true).change();
          }
        });
        var thc_content_min_last = thc_content_min,
          thc_content_max_last = thc_content_max;

        // Look for THC values in URL and set if present
        var url_values = theme.utils.getURLParams();
        if (url_values['thc-content-min'] && url_values['thc-content-max']) {
          var url_thc_content_min = parseFloat(url_values['thc-content-min'].split(' TO ')[0]),
            url_thc_content_max = parseFloat(url_values['thc-content-max'].split(' TO ')[1]);
          thc_content_min_last = url_thc_content_min;
          thc_content_max_last = url_thc_content_max;
          thcContentSlider.noUiSlider.set([url_thc_content_min, url_thc_content_max]);
        }
        var cbd_content_min = theme.min_cbd,
          cbd_content_max = theme.max_cbd,
          percentage = this.bounds.max > 100 ? 0.15 : cbd_content_max > 75 ? 0.12 : 0.1,
          calculated_margin = Math.ceil(cbd_content_max * percentage);
        createSlider(cbdContentSlider, [cbd_content_min, cbd_content_max], calculated_margin);
        cbdContentSlider.noUiSlider.on('set', function (values, handle) {
          // CBD reset if values on the handles are the default ones
          if (values[0] <= cbd_content_min && values[1] >= cbd_content_max) {
            $('#cbd-content-max, #cbd-volume-max, #cbd-capsule-max').prop('checked', false);
            $('#cbd-content-min, #cbd-volume-min, #cbd-capsule-min').prop('checked', false).change();
          } else {
            $('#cbd-content-max, #cbd-volume-max, #cbd-capsule-max').val(values[0] + ' TO ' + values[1]).prop('checked', true);
            $('#cbd-content-min, #cbd-volume-min, #cbd-capsule-min').val(values[0] + ' TO ' + values[1]).prop('checked', true);
            $('#cbd-content-min').data('display-name', 'CBD ' + values[0] + '-' + values[1]).change();
          }
        });
        var cbd_content_min_last = cbd_content_min;
        var cbd_content_max_last = cbd_content_max;

        // Look for CBD values in URL and set if present
        var url_values = theme.utils.getURLParams();
        if (url_values['cbd-content-min'] && url_values['cbd-content-max']) {
          var url_cbd_content_min = parseFloat(url_values['cbd-content-min'].split(' TO ')[0]),
            url_cbd_content_max = parseFloat(url_values['cbd-content-max'].split(' TO ')[1]);
          cbd_content_min_last = url_cbd_content_min;
          cbd_content_max_last = url_cbd_content_max;
          cbdContentSlider.noUiSlider.set([url_cbd_content_min, url_cbd_content_max]);
        }

        /**
         * Force reset on slider UI in case of removed THC / CBD filter
         */
        $(document).on('click', '.filter__active-filter[for=thc-content-min]', function (e) {
          thcContentSlider.noUiSlider.set([thc_content_min, thc_content_max]);
          $('#thc-content-min, #thc-volume-min, #thc-capsule-min').prop('checked', false).change();
          $('#thc-content-max, #thc-volume-max, #thc-capsule-max').prop('checked', false).change();
        });
        $(document).on('click', '.filter__active-filter[for=cbd-content-min]', function (e) {
          cbdContentSlider.noUiSlider.set([cbd_content_min, cbd_content_max]);
          $('#cbd-content-min, #cbd-volume-min, #cbd-capsule-min').prop('checked', false).change();
          $('#cbd-content-max, #cbd-volume-max, #cbd-capsule-max').prop('checked', false).change();
        });
      }

      /**
       * Creates new quick adds without duplicates
       */
      theme.quick_add_factory = theme.quick_add_factory || new QuickAdds({
        translations: {
          dismiss_text: '',
          cbd: '',
          thc: '',
          help_text: '',
          view_details_text: '',
          color_help_text: ''
        },
        random: theme.random()
      });

      /**
       * Handle quick-add logic
       */
      $('[data-toggle-quick-add]').each(function () {
        var $el = $(this),
          $tile = $el.closest('.product-tile'),
          handle = $el.data('toggle-quick-add'),
          translated_handle = $el.data('translated-product-handle') || handle,
          data = $el.data('tile-data'),
          translation_data = $el.data('translation-data');
        var quick_add = theme.quick_add_factory["new"]($el, $tile, handle, translated_handle, data, translation_data);
        if ($el.hasClass('product-tile__trigger')) {
          quick_add.render();
        }
      });
      $(document).on('click', '[data-close-quick-add]', function (e) {
        e.preventDefault();
        var quick_add = theme.quick_add_factory.closeAll();
      });

      // Handle quick add overlay click
      $(document).on('click', '.overlay--quick-add', function (e) {
        theme.quick_add_factory.closeAll();
      });
    }
    ;

    // the search instantiation is done in search.js
    if (window.theme.template.name == 'collection') {
      var params = {
        filterScopeSelector: '#flyout--filters',
        sortScopeSelector: '.sort-by-wrapper',
        hitsPerPage: theme.paginate_by,
        productCount: theme.product_count,
        paginationSelector: '.collection .pagination-wrapper',
        productGridSelector: '.collection__products .product-grid',
        activeFiltersSelector: '.filter__applied-filters',
        beforeFilter: function beforeFilter() {},
        afterFilter: function afterFilter(results, displayProducts) {
          if (displayProducts) {
            if (results && results.nbHits) {
              $('.collection__count span').html(results.nbHits);
            } else if (results && results.hits) {
              var count = results.hits.filter(function (product) {
                return !!product.title;
              }).length;
              $('.collection__count span').html(count);
            }
          }
        }
      };
      if (theme.current_collection.handle.indexOf('dried-flower') > -1 || theme.current_collection.handle.indexOf('pre-rolled') > -1 || theme.current_collection.handle.indexOf('fleurs-sechees') > -1 || theme.current_collection.handle.indexOf('pre-roules') > -1) {
        params.indexKey = window.algoliaShopify.config.index_prefix + 'products_price_per_uom_asc';
      } else if (theme.current_collection.tags.indexOf('category--Vapes') > -1 || theme.current_collection.tags.indexOf('subcategory--Cartridges') > -1) {
        params.indexKey = window.algoliaShopify.config.index_prefix + 'products_custom_pricing_asc';
      } else {
        params.indexKey = 'products_price_asc';
      }
      if (theme.current_collection.handle != 'all' && theme.current_collection.handle != 'tous') {
        params.collectionHandle = theme.current_collection.handle;
      }
      if (window.theme.template.name == 'search') {
        params.searchTerms = window.theme.search.terms;
      }
    }
    ;
  });
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, Handlebars, theme) {
  if (theme.template.name == 'product') {
    var current_options;

    // Multilingual product options
    var product = theme.pdp.product;
    var base_product = theme.pdp.base_product;
    var translated_product = theme.pdp.translated_product;
    var params = theme.utils.getURLParams();
    $(function () {
      // Set parent collection's breadcrumb to be the referrer value
      // if the collection handle matches, in order to preserve filter values in URL
      var ref_collection = ~document.referrer.indexOf('/collections/') && document.referrer.split('?')[0].split('/collections/')[1];
      var collection_href = $('.breadcrumbs__collection').attr('href');
      if (ref_collection && !!collection_href && ref_collection == collection_href.split('/collections/')[1]) {
        $('.breadcrumbs__collection').attr('href', document.referrer);
      }
      var $submit_btn = $('.variant-selector__submit');
      if ($submit_btn.length) {
        if ($submit_btn.text().indexOf(theme.translations.product.choose_options.size) > -1 || $submit_btn.text().indexOf(theme.translations.product.choose_options.poids > -1)) {
          $submit_btn.css('opacity', '0.65');
        }
        $submit_btn.on('click', function (e) {
          handlePDPSubmit(e);
        });
      }
      // Setup a clone because js-price-compare--ppu is in (.product__price) on load and product__price resets on selection change
      var $price_compare_clone = $('.js-price-compare--ppu').clone();

      //Add padding b/w banner and badges if both are present in mobile view
      var $logoContainer = $('.product__logo-container');
      var $newBanner = $('.product__new-banner');
      var $discountBanner = $('.product__discount-banner');
      if ($newBanner && !$newBanner.hasClass('is-hidden') || $discountBanner && !$discountBanner.hasClass('is-hidden')) {
        $logoContainer.addClass('has-visible-banner');
      }

      // Variant selector change callback
      var on_selection_change = function on_selection_change(variants, selected_options, option_count) {
        var $submit = $('.variant-selector__submit'),
          $price = $submit.find('.price'),
          $price_main = $('.product__price'),
          $price_compare = $price_main.find('.js-price-compare--ppu '),
          $price_discount_banner = $('.js-product-discount-banner'),
          $price_new_banner = $('.js-product-new-banner'),
          $sku = $('.product__sku, [data-target=gtin]');
        $('.quantity-selector').removeClass('is-hidden');
        $submit.removeClass('is-hidden');
        if ($('.swatches--color').length == 0) {
          var _$;
          $submit.css('opacity', 1);
          (_$ = $('#variant_select_vldn_err')) === null || _$ === void 0 ? void 0 : _$.remove();
        } else {
          var _$2, _$4;
          var $existing_err = (_$2 = $('#variant_select_vldn_err')) === null || _$2 === void 0 ? void 0 : _$2.text();
          if ($existing_err === theme.translations.product.choose_options.choose_colour_vldn_msg) {
            var _$3;
            $submit.css('opacity', 1);
            (_$3 = $('#variant_select_vldn_err')) === null || _$3 === void 0 ? void 0 : _$3.remove();
          }
          (_$4 = $('#variant_select_vldn_err')) === null || _$4 === void 0 ? void 0 : _$4.text(theme.translations.product.choose_options.choose_colour_vldn_msg);
        }
        $('.product__price--wrapper').removeClass('is-visibility-hidden');
        var hideNewBanner = function hideNewBanner() {
          $price_new_banner.addClass('is-hidden');
        };
        var hideDiscount = function hideDiscount() {
          $price_discount_banner.addClass('is-hidden');
          $price_compare.addClass('is-hidden');
          $price_new_banner.removeClass('product__new-banner--badge-offset');
        };

        // Hide on change to reset before evaluating
        hideDiscount();
        hideNewBanner();
        if (selected_options.length == option_count && variants.length == 1) {
          var _variant$metafields$t, _variant$metafields, _variant$metafields$v, _variant$metafields$v2;
          $submit.css('opacity', 1);
          var variant = variants[0];
          var $submit_copy = $submit.find('span').first();
          var $qty = $('.product input[name="quantity"]');
          var qty = Math.max($('.product input[name="quantity"]').val(), 1);
          var gram = parseFloat(variant.metafields.variant.retail_pack_net_content);
          var total_price_gram_collection = variant.metafields.variant.retail_pack_net_content * variant.metafields.variant.price_per_unit;
          var regular_price = variant.price * qty;
          var price = theme.utils.toMoney(variant.price, {
            cents: true,
            locale: theme.locales.current_locale
          });

          //checks for metafield fr-CA_display_uom in translation namespace otherwise use display_uom as default.
          var translated_display_uom = (_variant$metafields$t = variant.metafields.translation[theme.locales.current_locale + '_display_uom']) !== null && _variant$metafields$t !== void 0 ? _variant$metafields$t : variant.metafields.variant.display_uom;

          // let collection_type = theme.product_json.type;
          // let flower_collection = collection_type == 'Flower' ? true : false;
          var gram_collection = variant.metafields.variant.display_uom_type == 'g'; // Setup for compare at price/red tag display

          // Setup for compare at price/red tag display
          var displayDiscount = function displayDiscount(is_gram_collection) {
            var old_price = is_gram_collection == true ? "".concat(total_compare_price_gram_collection).concat(gram_unit) : "".concat(price_compare).concat(product_unit);
            var price_diff = is_gram_collection == true ? "(".concat(price_diff_gram_collection, ")") : "(".concat(reg_price_diff, ")");
            var price_percentage = is_gram_collection == true ? "".concat(price_percentage_gram_collection, "%") : "".concat(reg_price_percentage, "%");
            $price_discount_banner.find('.label').text("".concat(price_percentage, " ").concat(theme.translations.product.discount_label, " ").concat(price_diff));
            $price_discount_banner.removeClass('is-hidden');
            $price_new_banner.addClass('product__new-banner--badge-offset');
            $price_compare_clone.appendTo($price_main);
            $price_compare_clone.text(old_price);
            $price_compare_clone.removeClass('is-hidden');
          };

          // Evaluate compare at price to determine whether there is a valid discount
          var has_discounted_price = gram_collection == true ? variant.compare_at_price && variant.compare_at_price / 100.0 > total_price_gram_collection ? true : false : variant.compare_at_price && variant.compare_at_price / 100.0 > regular_price / 100.0 ? true : false;
          if (!variant.in_store_exclusive) {
            if (gram_collection == true) {
              total_price_gram_collection = theme.utils.toMoney(total_price_gram_collection, {
                cents: false,
                locale: theme.locales.current_locale
              });
            } else {
              price = theme.utils.toMoney(regular_price, {
                cents: true,
                locale: theme.locales.current_locale
              });
            }
          }
          var max = theme.cart_quantity_range;
          var price_main = price;
          var price_compare = variant.compare_at_price / 100.0;
          var product_unit = '';
          var gram_unit = '';

          // Set up variables for compare prices, price difference and percentage off
          var total_compare_price_gram_collection = '';
          var price_diff_gram_collection = '';
          var price_percentage_gram_collection = '';
          var reg_price_diff = '';
          var reg_price_percentage = '';
          if (has_discounted_price == true && !variant.in_store_exclusive) {
            if (gram_collection == true) {
              total_compare_price_gram_collection = theme.utils.toMoney(variant.compare_at_price / 100, {
                cents: false,
                locale: theme.locales.current_locale
              });
              price_diff_gram_collection = variant.compare_at_price / 100.0 - variant.metafields.variant.retail_pack_net_content * variant.metafields.variant.price_per_unit;
              price_percentage_gram_collection = Math.floor((variant.compare_at_price / 100.0 - variant.metafields.variant.retail_pack_net_content * variant.metafields.variant.price_per_unit) * 100 / (variant.compare_at_price / 100.0));
              price_diff_gram_collection = theme.utils.toMoney(price_diff_gram_collection, {
                cents: false,
                locale: theme.locales.current_locale
              });
            } else {
              reg_price_diff = price_compare - regular_price / 100.0;
              reg_price_percentage = Math.floor(reg_price_diff * 100 / price_compare);
              reg_price_diff = theme.utils.toMoney(reg_price_diff, {
                cents: false,
                locale: theme.locales.current_locale
              });
              price_compare = theme.utils.toMoney(price_compare, {
                cents: false,
                locale: theme.locales.current_locale
              });
            }
          }
          current_options = theme.translate_options(variant.options, base_product.options_with_values, translated_product.options_with_values);
          if (variant.metafields.variant.display_ppu && translated_display_uom) {
            price_main = theme.utils.toMoney(variant.metafields.variant.display_ppu, {
              locale: theme.locales.current_locale
            });
            product_unit = " / ".concat(translated_display_uom);
            gram_unit = " / ".concat(gram).concat(translated_display_uom);
          }
          $submit.prop('disabled', !variant.available || variant.in_store_exclusive);
          $price.text(price).show();

          // Check collection type for proper variant values and display/hide
          if (gram_collection) {
            var is_gram_collection = true;
            $price_main.text("".concat(total_price_gram_collection).concat(gram_unit));
            if (has_discounted_price == true && !variant.in_store_exclusive) {
              displayDiscount(is_gram_collection);
            } else {
              hideDiscount();
            }
          } else {
            $price_main.text("".concat(price_main).concat(product_unit));
            if (has_discounted_price == true && !variant.in_store_exclusive) {
              displayDiscount();
            } else {
              hideDiscount();
            }
          }
          $sku.html('&zwj;' + variant.sku);
          var _product2 = theme.pdp.product;
          for (var i = 0; i < _product2.images.length; i++) {
            if (_product2.images[i].includes(variant.sku.toString())) {
              $('.product-images__carousel.slick-initialized:not(.hidden)').slick('slickGoTo', i);
            }
          }
          if (!variant.available) {
            $submit_copy.html(theme.translations.product.sold_out_text);
          } else {
            $submit_copy.html(theme.translations.product.add_to_cart);
          }
          $qty.attr('max', max);
          $qty.closest('.counter').attr('data-max', max);
          if ($qty.val() > max) {
            $qty.attr('value', max).trigger('change');
          }
          $qty.val($qty.attr('min'));
          if (variant.in_store_exclusive) {
            $('.quantity-selector').addClass('is-hidden');
            $submit.addClass('is-hidden');
            $price.text('');
            $price_main.text('\xa0'); // better alternative to &nbsp;
            $('.product__price--wrapper').addClass('is-visibility-hidden');
          }
          updateOnlineAvailibility(variant);
          if (!variant.in_store_exclusive && (variant === null || variant === void 0 ? void 0 : (_variant$metafields = variant.metafields) === null || _variant$metafields === void 0 ? void 0 : (_variant$metafields$v = _variant$metafields.variant) === null || _variant$metafields$v === void 0 ? void 0 : (_variant$metafields$v2 = _variant$metafields$v.variant_status) === null || _variant$metafields$v2 === void 0 ? void 0 : _variant$metafields$v2.split("|").indexOf("new")) > -1) {
            $price_new_banner.removeClass('is-hidden');
          }
        } else {
          // Multiple options but selection incomplete
          $price.text('').hide();
          hideDiscount();
          hideNewBanner();
        }
      };

      // Render selected color
      $(document).on('change', '.swatch--color input', function () {
        if ($(this).is(':checked')) {
          $('.variant-selector__color-selection').html(theme.translations.product.color_selection + ': <span>' + $(this).val() + '</span>').removeClass('is-hidden');
        } else {
          $('.variant-selector__color-selection').addClass('is-hidden');
        }
      });

      // Update price on submit button
      $('.js-quantity').on('change', function () {
        var selected_variant_id = $('.js-selected-variant-id').val();
        var variant = variants.filter(function (v) {
          return v.id == selected_variant_id;
        })[0];
        var $submit = $('.variant-selector__submit'),
          $price = $submit.find('.price'),
          qty = Number($(this).val()),
          maxQty = Number($(this).attr('max')) || qty,
          price = theme.utils.toMoney(variant.price * Math.min(qty, maxQty), {
            cents: true,
            locale: theme.locales.current_locale
          });
        $price.text(price).show();
      });

      // Handle add to cart
      $('.product__info').on('submit', '.variant-selector', function (e) {
        e.preventDefault();
        var id = $(this).find('[name=id]').val();
        var quantity = $(this).find('[name=quantity]').val() || 1;
        var payload = {
          id: id,
          quantity: quantity,
          properties: {
            // '_en-CA': base_product.metafields.translation['en-CA'],
            '_fr-CA': base_product.metafields.translation['fr-CA'] || '',
            '_fr-CA_title': base_product.metafields.translation['fr-CA_title'] || '',
            '_fr-CA_vendor': base_product.metafields.translation['fr-CA_vendor'] || '',
            '_fr-CA_options': current_options
          },
          analytics: {
            variant_id: id,
            variant_option: current_options,
            quantity: quantity,
            base_product: base_product,
            location: 'PDP'
          }
        };

        // Send any analytics to Algolia if available
        if (window.aa && params.objectIDs) {
          window.aa('convertedObjectIDsAfterSearch', {
            index: params.index || '',
            eventName: 'atc_on_pdp',
            queryID: params.queryID || '',
            objectIDs: [params.objectIDs]
          });
        }

        // Handle case where product already in cart
        theme.cart.add(payload).fail(function (e) {
          if (e.status == 422) {
            $('body').addClass('showing-maximum body--freeze');
            $('html').addClass('body--freeze');
            $('.js-maximum-exceeded').addClass('is-shown');
            setTimeout(function () {
              $('.js-maximum-exceeded .js-close-maximum').focus();
            }, 200);
          }
        });
      });
      if (product.options_with_values && base_product.options_with_values) {
        var formatEquivalency = function formatEquivalency(number) {
          if (!number) {
            return false;
          }
          return Number(number).toFixed(2).toString().replace('.00', '').replace(/(\.[1-9])0/, '$1');
        };
        var variants = theme.replace_variant_options(base_product.variants, base_product.options_with_values, product.options_with_values);
        variants.map(function (v) {
          var _v$metafields$variant;
          // Set up the price per unit
          var price_per_unit = v.metafields.variant.price_per_unit;
          v.price_per_unit = price_per_unit ? Number(price_per_unit) : false;

          // Set up the equivalency data
          v.equivalency = {
            retail_pack_consumer_item_size: formatEquivalency(v.metafields.variant.retail_pack_consumer_item_size),
            retail_pack_net_content: formatEquivalency(v.metafields.variant.retail_pack_net_content),
            retail_pack_number_of_items: formatEquivalency(v.metafields.variant.retail_pack_number_of_items),
            gram_equivalency: formatEquivalency(v.metafields.variant.gram_equivalency)
          };

          //set up if variant is instore only
          v.in_store_exclusive = /^in-store$/i.test((_v$metafields$variant = v.metafields.variant.availability) === null || _v$metafields$variant === void 0 ? void 0 : _v$metafields$variant.trim());
          return v;
        });
        if (variants) {
          // Instantiate a new variant selector
          var settings = {
            callbacks: {
              selection_change: on_selection_change
            },
            product: product,
            scope_selector: "#product_".concat(base_product.id, "_pdp"),
            product_id: product.id,
            tags: product.tags,
            container_selector: '.variant-selector__option-selectors',
            variants: variants,
            options_with_values: product.options_with_values,
            default_template: '#option-selector--default',
            data: {
              unselected_text: theme.translations.product.unselected_text,
              choose_option: theme.translations.product.choose_option,
              capsules: theme.translations.product.capsule,
              capsule_suffix: theme.translations.product.capsule_suffix,
              gram_per_capsule_suffix: theme.translations.product.gram_per_capsule_suffix,
              volume: theme.translations.product.volume,
              seeds: theme.translations.product.seed,
              total_suffix: theme.translations.product.total_suffix,
              equivalent_suffix: theme.translations.product.equivalent_suffix,
              roll_total_suffix: theme.translations.product.roll_total_suffix,
              roll_suffix_singular: theme.translations.product.roll_suffix_singular,
              roll_suffix_plural: theme.translations.product.roll_suffix_plural,
              gram_per_roll_suffix: theme.translations.product.gram_per_roll_suffix,
              product_unit: product.metafields.product.unit_suffix
            },
            templates: [{
              options: ['Color', 'Couleur', 'Colour'],
              selector_type: 'option',
              template: '#option-selector--color'
            }, {
              options: ['Size', 'Grandeur'],
              selector_type: 'variant',
              template: '#option-selector--weight'
            }, {
              options: ['Amount', 'Quantité'],
              selector_type: 'variant',
              template: '#option-selector--volume'
            }]
          };
          if (product.options.length == 1) {
            settings.templates.push({
              tags: ['subcategory--Oils'],
              selector_type: 'variant',
              template: '#variant-selector--volume'
            });
            settings.templates.push({
              tags: ['subcategory--Capsules'],
              selector_type: 'variant',
              template: '#variant-selector--capsules'
            });
            settings.templates.push({
              tags: ['subcategory--Seeds'],
              selector_type: 'variant',
              template: '#variant-selector--seeds'
            });
            if (~product.tags.indexOf('subcategory--Pre-Rolled')) {
              settings.templates.push({
                tags: ['subcategory--Pre-Rolled'],
                selector_type: 'variant',
                template: '#variant-selector--rolls'
              });
            } else {
              settings.templates.push({
                options: ['Weight', 'Pois', 'Poids'],
                selector_type: 'variant',
                template: '#variant-selector--weight'
              });
              settings.templates.push({
                options: ['Amount', 'Montant'],
                selector_type: 'variant',
                template: '#variant-selector--weight'
              });
            }
          } else {
            if (~product.tags.indexOf('subcategory--Oils')) {
              settings.templates.push({
                tags: ['subcategory--Oils'],
                options: ['Weight', 'Pois', 'Poids'],
                selector_type: 'option',
                template: '#option-selector--volume'
              });
            } else if (~product.tags.indexOf('subcategory--Capsules')) {
              settings.templates.push({
                tags: ['subcategory--Capsules'],
                options: ['Weight', 'Pois', 'Poids'],
                selector_type: 'option',
                template: '#option-selector--capsules'
              });
            } else if (~product.tags.indexOf('subcategory--Seeds')) {
              settings.templates.push({
                tags: ['subcategory--Seeds'],
                options: ['Weight', 'Pois', 'Poids'],
                selector_type: 'option',
                template: '#option-selector--seeds'
              });
            } else if (~product.tags.indexOf('subcategory--Pre-Rolled')) {
              settings.templates.push({
                tags: ['subcategory--Pre-Rolled'],
                options: ['Weight', 'Pois', 'Poids'],
                selector_type: 'option',
                template: '#option-selector--rolls'
              });
            } else if (~product.tags.indexOf('subcategory--Vaporizers')) {
              settings.templates = settings.templates.map(function (t) {
                return t.template === '#variant-selector--weight' ? {
                  tags: ['subcategory--Vaporizers'],
                  options: ['Size', 'Grandeur'],
                  selector_type: 'option',
                  template: '#option-selector--size'
                } : t;
              });
            } else if (~product.tags.indexOf('subcategory--Bongs')) {
              settings.templates = settings.templates.map(function (t) {
                return t.template === '#variant-selector--weight' ? {
                  tags: ['subcategory--Bongs'],
                  options: ['Size', 'Grandeur'],
                  selector_type: 'option',
                  template: '#option-selector--size'
                } : t;
              });
            } else {
              settings.templates.push({
                options: ['Weight', 'Pois', 'Poids'],
                selector_type: 'option',
                template: '#option-selector--weight'
              });
            }
          }
          theme.variant_selector = new VariantSelector(settings);
        }
      } else {
        console.error('[Variant Selector] Base product options or base product are not being loaded');
      }

      // Instantiate a new Product gallery
      theme.product_gallery = new ProductGallery({
        selector: '.product-images__carousel'
      });

      // Instantiate a new Safe Use section
      theme.safe_use_section = new ProductSafeUse({
        selector: '.product__safe-use__methods'
      });
      function updateOnlineAvailibility(variant) {
        var online_availability_source = $('#online-availability').html();
        var online_availability_template = Handlebars.compile(online_availability_source);
        var payload = {
          variant: variant,
          available: variant.available,
          show_shipping_message: true,
          available_online: theme.pdp.available_online,
          stock_low: false,
          translations: window.theme.translations
        };
        $('.online-availability-wrapper').html(online_availability_template(payload));
      }
      if (theme && theme.product_json.variants.length == 1) {
        updateOnlineAvailibility(base_product.variants[0]);
      } else {
        var all_unavailable = true;
        theme.product_json.variants.forEach(function (variant, index) {
          if (variant.available) {
            all_unavailable = false;
            return false;
          }
        });
        if (all_unavailable) {
          var _base_product$variant;
          var unavailable_online_variant = (_base_product$variant = base_product.variants.filter(function (v) {
            return !v.in_store_exclusive;
          })) === null || _base_product$variant === void 0 ? void 0 : _base_product$variant[0];
          updateOnlineAvailibility(unavailable_online_variant !== null && unavailable_online_variant !== void 0 ? unavailable_online_variant : base_product.variants[0]);
        }
      }
      var $properties = $('#product__properties-table tr'),
        $toggles = $('.js-properties-toggles'),
        $show_more = $('.js-properties-show-more'),
        $show_less = $('.js-properties-show-less');
      if ($properties.length > 8) {
        var _show_more = function _show_more($properties) {
          $properties.show();
          $show_more.removeClass('enabled');
          $show_less.addClass('enabled');
        };
        var _show_less = function _show_less($properties) {
          $properties.each(function (i) {
            $(this).toggle(i < 8);
          });
          $show_more.addClass('enabled');
          $show_less.removeClass('enabled');
        };
        $toggles.show();
        $show_more.on('click', function () {
          _show_more($properties);
        });
        $show_less.on('click', function () {
          _show_less($properties);
        });
        _show_less($properties);
      }
    });
  }
  function fadeOutPDPCta() {
    if (window.innerWidth < 1024) {
      var paymentElement = document.querySelector('.payment-methods');
      window.scrollY + window.innerHeight - paymentElement.offsetTop > 0 ? $('.pdp-cta-sticky').css({
        'display': 'none'
      }) : $('.pdp-cta-sticky').css({
        'display': ''
      });
    }
  }
  function handlePDPSubmit(event) {
    var $submit_btn_txt = $('.variant-selector__submit').text();
    if ($submit_btn_txt.indexOf(theme.translations.product.choose_options.size) > -1 || $submit_btn_txt.indexOf(theme.translations.product.choose_options.colour) > -1 || $submit_btn_txt.indexOf(theme.translations.product.choose_options.poids) > -1) {
      event.preventDefault();
      event.stopPropagation();
      if (!$('#variant_select_vldn_err').length) {
        $('.variant-selector__option-selectors').append('<span id=variant_select_vldn_err class=variant-selector__err-txt>' + theme.translations.product.choose_options.choose_size_vldn_msg + '</span>');
      }
      if (window.innerWidth < 1024) {
        window.scrollTo({
          top: window.innerHeight - document.querySelector('.quantity-selector').offsetTop + document.querySelector('.quantity-selector').offsetHeight,
          left: 0,
          behavior: "smooth"
        });
      }
      return false;
    }
  }
  window.addEventListener("scroll", fadeOutPDPCta, false);
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, Handlebars, theme) {
  function StoreRepository(store_data, availability_url, product_store_availability_url, store_availability_url) {
    var _store_data;
    var _availability_url;
    var _product_store_availability_url;
    var _store_availability_url;
    var _active_products_store;
    var _stores;
    var _store_products;
    var _product_stores;
    var _event_prefix = 'stores_';
    function _init() {
      _store_availability_url = store_availability_url;
      _availability_url = availability_url;
      _product_store_availability_url = product_store_availability_url;
      _store_data = store_data;
      _stores = [];
      _store_products = [];
      _product_stores = [];
    }
    function _fetch_stores(cb) {
      if (store_data) _stores = store_data;else _stores = [];
      if (cb) cb(_stores);
      _trigger_event('update', _stores);
      return $.Deferred().resolve(_stores).promise();
    }
    function _fetch_store_products(store_id, skus, cb) {
      if (_store_products.length && store_id == _active_products_store) {
        return $.Deferred().resolve(_store_products).promise();
      } else {
        var sku_string = '';
        skus.forEach(function (sku) {
          sku_string += '&skus[]=' + sku;
        });
        return $.get(_availability_url + '?store_id=' + store_id + sku_string).then(function (store_products) {
          _store_products = store_products.inventory;
          _active_products_store = store_id;
          if (cb) {
            cb(_store_products);
          }
          _trigger_event('update', _stores);
          return _store_products;
        });
      }
    }
    function _fetch_product_stores(sku, cb) {
      if (_product_stores.length) {
        return $.Deferred().resolve(_product_stores).promise();
      } else {
        return $.get(_product_store_availability_url + '?sku=' + sku).then(function (product_stores) {
          if (product_stores.inventory) {
            _product_stores = product_stores.inventory;
          }
          if (cb) {
            cb(_product_stores);
          }
          _trigger_event('update', _stores);
          return _product_stores;
        });
      }
    }
    function _fetch_store_availability(product_ids, store_id, cb) {
      return $.post(_store_availability_url, {
        store_ids: [store_id],
        product_ids: product_ids
      }).then(function (availabilities) {
        availabilities = availabilities.inventory;
        if (cb) {
          cb(availabilities);
        }
        return availabilities;
      });
    }
    function _trigger_event(name, payload) {
      name = _event_prefix + name;
      $(document).trigger(name, payload);
    }

    /**
     * Public API
     */

    /**
     * Fetch and store all stores from server
     * @param {function} cb optional callback
     */
    this.fetch_stores = function (cb) {
      return _fetch_stores(cb);
    };

    /**
     * Return the availability for the given skus at a particular store id
     * @param {string} store_id store id to use
     * @param {array} skus skus to check
     * @param {function} cb optional callback
     */
    this.fetch_store_products = function (store_id, skus, cb) {
      return _fetch_store_products(store_id, skus, cb);
    };

    /**
     * Return the availability of one product over a multitude of stores
     * @param {string} sku sku of store product
     * @param {function} cb optional callback
     */
    this.fetch_product_stores = function (sku, cb) {
      return _fetch_product_stores(sku, cb);
    };

    /**
     * Return the availability of multiple product ids for a particular store
     * @param {array} product_ids
     * @param {array} store_id
     * @param {function} cb
     */
    this.fetch_store_availability = function (product_ids, store_id, cb) {
      _fetch_store_availability(product_ids, store_id, cb);
    };

    /**
     * Return all stores within a given km radius from latlong point
     * @param {array} latlong
     * @param {int} radius_km
     */
    this.filter_by_radius = function (latlong, radius_km, reference_point) {
      var stores = [];
      _stores.forEach(function (store) {
        var dist = theme.haversine_distance(latlong, [store.latitude, store.longitude]);
        if (reference_point) {
          var reference_distance = theme.haversine_distance(reference_point, [store.latitude, store.longitude]);
          store.distance_km = Math.floor(reference_distance * 100) / 100;
        } else {
          store.distance_km = Math.floor(dist * 100) / 100;
        }
        if (dist < radius_km) {
          stores.push(store);
        }
      });
      return stores.sort(function (a, b) {
        return a.distance_km - b.distance_km;
      }).map(function (store, i) {
        store.index = i + 1;
        return store;
      });
    };

    /**
     * Return all stores within a given km radius from latlong point
     * that have inventory for the sku provided
     * @param {array} latlong
     * @param {int} radius_km
     * @param {string} sku
     */
    this.filter_by_radius_and_sku = function (latlong, radius_km, sku, reference_point) {
      var stores = [];
      _stores.forEach(function (store) {
        var dist = theme.haversine_distance(latlong, [store.latitude, store.longitude]);
        if (reference_point) {
          var reference_distance = theme.haversine_distance(reference_point, [store.latitude, store.longitude]);
          store.distance_km = Math.floor(reference_distance * 100) / 100;
        } else {
          store.distance_km = Math.floor(dist * 100) / 100;
        }
        if (dist < radius_km) {
          store.inventory = _product_stores[sku] ? _product_stores[sku].filter(function (x) {
            return x.store_id == store.id;
          })[0].quantity || 0 : 0;
          stores.push(store);
        }
      });
      return stores.sort(function (a, b) {
        return a.distance_km - b.distance_km;
      }).map(function (store, i) {
        store.index = i + 1;
        return store;
      });
    };

    /**
     * Return first store with matching ID
     * @param {int} id
     */
    this.find_store = function (id) {
      return _stores.filter(function (store) {
        return store.id == id;
      })[0];
    };
    _init();
  }
  window.StoreRepository = StoreRepository;
  window.theme.store_repository = new StoreRepository(window.theme.stores, '/apps/api/v1/product_availability', '/apps/api/v1/product_store_availability', '/apps/api/v1/store_availability');
})(jQuery, Handlebars, window.theme = window.theme || {});

/**
 * Alert Module
 *
 * - Alert class: Actual alert element representation in a class
 * - AlertManager class: Used to manage the creation and display of alerts on the site
 */

(function ($, Handlebars, theme) {
  $(function () {
    var ALERT_SOURCE = $('#alert-template').html(),
      ALERT_TEMPLATE = Handlebars.compile(ALERT_SOURCE),
      ALERT_CLOSE_SELECTOR = '.js-alert__close',
      ALERTS_SELECTOR = '.js-alerts',
      ALERT_SHOW = 'show-alert',
      ALERT_EXIT_LEFT = 'exit-left',
      ALERT_EXIT_RIGHT = 'exit-right',
      FOCUSABLE = 'input:visible, button:visible, textarea:visible, [tabindex], a:visible';

    /**
     * Alert class.
     * Represents an alert element.
     */
    var Alert = /*#__PURE__*/function () {
      /**
       * Creates an instance of Alert.
       *
       * @param {object} [settings] - A settings object to use.
       * @constructs Alert
       * @memberof Alert
       *
       * @example
       * let alert = new Alert({
       *  title: '<strong>Bolded</strong> Alert Title',
       *  content: '<p>Some content</p>',
       *  classes: 'cart-dropdown',
       *  item_added: '.added_identifier',
       *  duration: 2000,
       *  stack: false
       * });
       */
      function Alert(settings) {
        _classCallCheck(this, Alert);
        this._duration = settings.duration || 2000;
        if (ALERT_SOURCE) {
          this._source = ALERT_TEMPLATE({
            title: settings.title,
            content: settings.content,
            classes: settings.classes,
            duration: this._duration / 1000,
            data: {
              random: theme.random()
            }
          });
          this.$alert = $(this._source);
        } else {
          this._alert = '';
          this.$alert = null;
        }

        // FIXME: it detects that this.$alert.find(settings.item_added).length is 0
        // Currently doing this in _cart.js using a .then() after the loadCartAlert() AJAX call
        // if (settings.item_added) {
        //   this.$alert.find(settings.item_added).show();
        // }

        this._destroyed = false;
      }

      /**
       * The alert's HTML
       *
       * @type {string}
       * @memberof Alert
       *
       * @example
       * alert.source
       */
      _createClass(Alert, [{
        key: "element",
        get: function get() {
          return this.$alert;
        }

        /**
         * Whether or not the alert is still in use
         *
         * @type {boolean}
         * @memberof Alert
         *
         * @example
         * alert.destroyed
         */
      }, {
        key: "destroyed",
        get: function get() {
          return this._destroyed;
        }

        /**
         * Function to reveal the alert in the UI
         * and handle its lifespan and events
         *
         * @type {string}
         * @memberof Alert
         *
         * @example
         * alert.init();
         */
      }, {
        key: "init",
        value: function init() {
          var _this7 = this;
          // Destroy the alert (with animation) when it's swiped up
          this.$alert.on('swipeup', function () {
            _this7.destroy(200);
          });

          // Destroy the alert (with animation) when it's swiped left
          this.$alert.on('swipeleft', function () {
            _this7.destroy(200, 'left');
          });

          // Destroy the alert (with animation) when it's swiped right
          this.$alert.on('swiperight', function () {
            _this7.destroy(200, 'right');
          });

          // Prevent scrolling when swiping up on touchscreens
          this.$alert.on('touchmove', function (event) {
            event.preventDefault();
          });

          // Kill timer when hovering on the alert
          this.$alert.on('mouseover focusin', function () {
            clearTimeout(_this7._timer);
          });

          // Restart timer when hovering ends
          this.$alert.on('mouseout focusout', function () {
            _this7._timer = setTimeout(function () {
              _this7.destroy(500);
            }, _this7._duration);
          });

          // Destroy the alert when close element clicked
          this.$alert.on('click', ALERT_CLOSE_SELECTOR, function () {
            _this7.destroy(300);
          });
          this.$alert.on('keydown', function (e) {
            // Destroy the alert when Esc key is pressed
            if (e.keyCode === 27) {
              _this7.destroy(300);
            }
            // Pause alert timeout when P key is pressed
            else if (e.keyCode === 80) {
              clearTimeout(_this7._timer);
            }
          });

          // Set a timer and destroy the alert when expired
          this._timer = setTimeout(function () {
            _this7.destroy(500);
          }, this._duration);

          // Show the alert
          this.$alert.closest(ALERTS_SELECTOR).addClass(ALERT_SHOW);

          // Focus on first Focusable element
          //this.$alert.find(FOCUSABLE).first().focus();
        }

        /**
         * Function to remove the alert from the UI
         * with/without animation
         *
         * @param {number} [duration] - Optional, duration of slide up animation
         * @memberof Alert
         *
         * @example
         * alert.destroy();
         * alert.destroy(300);
         */
      }, {
        key: "destroy",
        value: function destroy(duration, direction) {
          var _this8 = this;
          duration = duration || false;
          direction = direction || 'default';

          // Don't bother doing this if it's already in progress
          if (!this.destroyed) {
            this._destroyed = true;
            if (!!duration) {
              switch (direction) {
                case 'left':
                  this.$alert.closest(ALERTS_SELECTOR).addClass(ALERT_EXIT_LEFT);
                  break;
                case 'right':
                  this.$alert.closest(ALERTS_SELECTOR).addClass(ALERT_EXIT_RIGHT);
                  break;
              }
              this.$alert.closest(ALERTS_SELECTOR).delay(duration).removeClass(ALERT_SHOW);
              setTimeout(function () {
                _this8.$alert.closest(ALERTS_SELECTOR).removeClass(ALERT_EXIT_LEFT).removeClass(ALERT_EXIT_RIGHT);
                _this8.$alert.remove();
              }, duration);
            } else {
              return this.$alert.remove();
            }
          }
          return true;
        }
      }]);
      return Alert;
    }();
    /**
     * AlertManager class.
     * Handles the creation of Alert objects and how to display them together on the page.
     */
    var AlertManager = /*#__PURE__*/function () {
      /**
       * Creates an instance of AlertManager.
       *
       * @constructs AlertManager
       * @memberof AlertManager
       */
      function AlertManager() {
        _classCallCheck(this, AlertManager);
        this._alerts = [];
        this.$alerts = $(ALERTS_SELECTOR);
      }

      /**
       * Creates a new Alert object and stores in internal list of existing alerts
       *
       * @param {(object)} [settings] - The settings to create the alert from.
       * @memberof AlertManager
       *
       * @example
       * alerts.createAlert({
       *  title: '<strong>Bolded</strong> Alert Title',
       *  content: '<p>Some content</p>',
       *  classes: 'cart-dropdown',
       *  duration: 2000,
       *  stack: false
       * });
       */
      _createClass(AlertManager, [{
        key: "createAlert",
        value: function createAlert(settings) {
          // Create new alert object
          var alert = new Alert(settings);

          // If the alert should not stack below previous alerts,
          // destroy other alerts
          if (settings.stack === false) {
            this._alerts.forEach(function (alert) {
              alert.destroy();
            });
          }

          // Weed out destroyed alerts
          this._alerts = this._alerts.filter(function (alert) {
            return !alert.destroyed;
          });

          // Add new alert to alerts, both in object and on page
          this._alerts.push(alert);
          this.$alerts.append(alert.element);

          // Initialize the new alert
          alert.init();
        }
      }]);
      return AlertManager;
    }(); // Instantiate an AlertManager and add to the theme object
    theme.alerts = new AlertManager();
  });
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, theme) {
  var AlgoliaQuery = /*#__PURE__*/function () {
    function AlgoliaQuery(index) {
      _classCallCheck(this, AlgoliaQuery);
      this.client = algoliasearch(window.algoliaShopify.config.app_id, window.algoliaShopify.config.search_api_key, {
        urlSync: {
          trackedParameters: []
        }
      });
      this.index = index;
    }
    _createClass(AlgoliaQuery, [{
      key: "index",
      get: function get() {
        return this._index;
      },
      set: function set(index) {
        var index_key = "".concat(window.algoliaShopify.config.index_prefix).concat(index ? "".concat(index) : '');
        this._index = this.client.initIndex(index_key);
      }
    }, {
      key: "run",
      value: function run() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Set global options
        options.analytics = true;
        return this.index.search(options);
      }
    }, {
      key: "groupHits",
      value: function groupHits(hits) {
        var grouped_products = [];
        hits.forEach(function (result, index) {
          var prev_result = hits[index - 1];
          result.available = result.variants_inventory_count > 0;
          if (prev_result && prev_result.handle == result.handle) {
            var last_entry = grouped_products[grouped_products.length - 1];
            // Keep track of availability
            last_entry.available = last_entry.available || result.available;

            // Keep track of lowest prices and unit of measure for them
            last_entry.lowest_price = Math.min(result.price, last_entry.lowest_price);
            // Check if the metafield exists and if it's smaller than lowest ppu
            if (result.meta.variant && result.meta.variant.display_ppu && result.meta.variant.display_uom && result.meta.variant.display_ppu < last_entry.lowest_ppu) {
              last_entry.lowest_ppu = result.meta.variant.display_ppu;
              last_entry.uom = result.meta.variant.display_uom;
            }
            last_entry.price_varies = true;

            // Calculate lowest available price
            if (result.available) {
              last_entry.available_lowest_price = last_entry.available_lowest_price ? Math.min(result.price, last_entry.available_lowest_price) : result.price;
              // Check if the metafield exists and if it's smaller than lowest ppu
              if (result.meta.variant && result.meta.variant.display_ppu && result.meta.variant.display_uom && (!last_entry.lowest_ppu || result.meta.variant.display_ppu < last_entry.lowest_ppu)) {
                last_entry.available_lowest_ppu = result.meta.variant.display_ppu;
                last_entry.available_uom = result.meta.variant.display_uom;
              }
              last_entry.available_price_varies = last_entry.available_price_varies === undefined ? false : true;
            }
          } else {
            // Keep track of lowest prices
            result.lowest_price = result.price;
            if (result.meta.variant && result.meta.variant.display_ppu && result.meta.variant.display_uom) {
              result.lowest_ppu = result.meta.variant.display_ppu;
              result.uom = result.meta.product.content_uom;
            }
            result.price_varies = false;

            // Calculate lowest available price
            if (result.available) {
              result.available_lowest_price = result.price;
              if (result.meta.variant && result.meta.variant.display_ppu && result.meta.variant.display_uom) {
                result.available_lowest_ppu = result.meta.variant.display_ppu;
                result.available_uom = result.meta.product.content_uom;
              }
              result.available_price_varies = false;
            }
            grouped_products.push(result);
          }
        });
        grouped_products.map(function (p) {
          p.display_price = (p.available_lowest_price || p.lowest_price || +p.price) * 100;
          if (p.uom && p.lowest_ppu) {
            p.display_price = (p.available_lowest_ppu || p.lowest_ppu) * 100;
            p.product_unit = " / ".concat(p.uom || p.available_uom);
            p.compare_price = p.meta.variant.display_uom_type == 'g' ? p.compare_at_price / Number(p.meta.variant.retail_pack_net_content) * 100 : p.compare_at_price * 100;
          } else {
            p.compare_price = p.compare_at_price * 100;
          }
          p.price_varies = p.available_price_varies || p.price_varies;
          return p;
        });
        return grouped_products;
      }
    }, {
      key: "convertHit",
      value: function convertHit(product) {
        var p = product;
        var current_locale = theme.locales.current_locale;
        var trans = p.meta ? p.meta.translation : undefined;
        p.metafields = p.meta;
        p.has_thc_content = p.tags.includes('has_thc_content');
        p.has_cbd_content = p.tags.includes('has_cbd_content');
        p.has_thc_cbd_caps = p.metafields.product && (p.metafields.product.thc_cont_per_cap > 0 || p.metafields.product.cbd_cont_per_cap > 0);
        p.has_thc_cbd_vol = p.metafields.product && (p.metafields.product.thc_cont_per_vol > 0 || p.metafields.product.cbd_cont_per_vol > 0);
        if (trans && trans['fr-CA']) {
          p.fr_handle = trans['fr-CA'];
        } else {
          p.fr_handle = p.handle;
        }

        // We prepare the plant type translation for use in JS tile template
        if (p.metafields.product && p.metafields.product.plant_type) {
          switch (p.metafields.product.plant_type) {
            case 'Indica Dominant':
              p.plant_type = theme.translations.indica;
              break;
            case 'Sativa Dominant':
              p.plant_type = theme.translations.sativa;
              break;
            case 'Hybrid':
              p.plant_type = theme.translations.hybrid;
              break;
            case 'Blend':
              p.plant_type = theme.translations.blend;
              break;
            default:
              p.plant_type = theme.translations.blend;
          }
        }

        // Generate the cannabinoid content
        p.cannabinoid_content = theme.utils.formatCannabinoids(p);

        // Find subcategory and subsubcategory tags if present
        product.tags.forEach(function (tag) {
          var tagSplit = tag.split('--');
          if (tagSplit.length > 1 && tagSplit[0] == 'subcategory') {
            p.subcategory = tagSplit[1];
          } else if (tagSplit.length > 1 && tagSplit[0] == 'subsubcategory') {
            var tagTitle = theme.translations.product.subsubcategories[tagSplit[1].handleize('_').split('-').join('_')] || '';
            p.subsubcategory = tagTitle;
          }
        });

        /**
         * Ensure that all translations are present for quickview to be displayed
         */
        if (current_locale == 'fr-CA') {
          if (trans && trans['fr-CA_title'] && trans['fr-CA_vendor'] && trans['fr-CA']) {
            p.title = trans['fr-CA_title'];
            p.vendor = trans['fr-CA_vendor'];
            p.translated_handle = trans['fr-CA'];
          }
        }

        // Resize image
        if (p.image) {
          p.featured_image = theme.utils.getSizedImageUrl(p.image, '480x');
        }
        return p;
      }
    }]);
    return AlgoliaQuery;
  }();
  window.AlgoliaQuery = AlgoliaQuery;
})(window.jQuery, window.theme = window.theme || {});
(function ($, theme) {
  var query_params = theme.utils.getURLParams();
  var FilterOption = /*#__PURE__*/function () {
    function FilterOption(value, name, filter) {
      _classCallCheck(this, FilterOption);
      this.filter = filter;
      this.name = name;
      this.value = value;
      this.elements = {};

      // Sorry for the hardcoding here
      if (this.filter.facet.value == 'product.plant_type') {
        var name_key = this.name.split(' ')[0].toLowerCase();
        this.translated_name = theme.translations[name_key];
      } else if (filter.absolute) {
        var absolute_value_key = theme.utils.toSnakeCase(this.value);
        this.name = theme.translations.filters.absolute_values[absolute_value_key] || this.name;
      }
      if (~this.filter.facet.value.join(',').indexOf('certified_goods_id')) {
        this.name = theme.translations.certified_goods[this.name.handleize()] || this.name;
      }
    }
    _createClass(FilterOption, [{
      key: "checked",
      get: function get() {
        return this.elements.input.prop('checked');
      },
      set: function set(check) {
        this.elements.input.prop('checked', check).trigger('change');
      }
    }, {
      key: "clear",
      value: function clear() {
        this.checked = false;
      }
    }, {
      key: "render",
      value: function render() {
        var id = "".concat(this.filter.name.handleize(), "-").concat(this.name.handleize(), "-").concat(Math.floor(Math.random() * 1000000));
        this.elements.input = $("<input type=\"checkbox\" hidden id=\"".concat(id, "\" value=\"").concat(this.value, "\" ").concat(~this.filter.initial_options.indexOf(this.value) ? 'checked' : '', " data-option-name=\"").concat(this.filter.name, "\"/>"));
        // Leaving commented for now in case decide to use for screen readers.
        // let description = theme.translations.filters.descriptions[this.name.handleize('_')];
        // ${description ? `<p class="filter__option-description">${description}</p>` : ''}

        if (~['poids', 'taille', 'poid', 'size'].indexOf(this.filter.name.noAccents().toLowerCase())) {
          var label_text = theme.locales.language_code == 'en' ? this.name.noAccents() : this.translated_name ? this.translated_name : this.name;
          label_text = label_text.toLowerCase().replace(/x/, ' x ').replace(/  /g, ' ');
          this.elements.input.addClass('swatch__input');
          this.elements.option = $("\n        <div class=\"filter__option swatch swatch--filter\">\n          <label for=\"".concat(id, "\" class=\"swatch__label\" tabindex=\"-1\"><div class=\"swatch__inner\"><span class=\"swatch__title\">").concat(label_text, "</span></div></label>\n        </div>\n      ")).prepend(this.elements.input);
        } else if (~['plant type', 'type de plante', 'allergens'].indexOf(this.filter.name.noAccents().toLowerCase())) {
          this.elements.option = $("\n          <div class=\"filter__option\">\n            <label class=\"toggle-button-label toggle-button-label--filter\" for=\"".concat(id, "\" tabindex=\"-1\">").concat(theme.locales.language_code == 'en' ? this.name.noAccents() : this.translated_name ? this.translated_name : this.name, "</label>\n          </div>\n        ")).prepend(this.elements.input);
        } else {
          this.elements.option = $("\n          <div class=\"filter__option\">\n            <label for=\"".concat(id, "\" tabindex=\"-1\">").concat(theme.locales.language_code == 'en' ? this.name.noAccents() : this.translated_name ? this.translated_name : this.name, "</label>\n          </div>\n        ")).prepend(this.elements.input);
        }
        return this.elements.option;
      }
    }]);
    return FilterOption;
  }();
  var Filter = /*#__PURE__*/function () {
    function Filter(filter) {
      var _this9 = this;
      _classCallCheck(this, Filter);
      this.name = filter.name;
      this.facet = filter.facet;
      this.absolute = filter.absolute || false;
      this.exclude = filter.exclude || false;
      this.classes = [];
      this.elements = {};
      this.info = {
        // description: filter.description || '',
        // tooltip: filter.tooltip || '',d
        description: false,
        tooltip: false,
        cta: {
          link: filter.cta.link || '',
          text: filter.cta.text || ''
        }
      };
      this.options = filter.options.map(function (option) {
        option = _this9.generateOption(option);
        return new FilterOption(option.value, option.name, _this9);
      });
    }
    _createClass(Filter, [{
      key: "initial_options",
      get: function get() {
        return query_params[this.name] ? query_params[this.name].split(',') : [];
      }
    }, {
      key: "applied_options",
      get: function get() {
        return this.options.filter(function (option) {
          return option.checked;
        });
      }
    }, {
      key: "generateOption",
      value: function generateOption(option) {
        return {
          name: option,
          value: option
        };
      }

      // Checks if filter is active, updates its label's class accordingly
    }, {
      key: "setActiveLabel",
      value: function setActiveLabel(filter) {
        var active = filter.textContent;
        var label = filter.previousElementSibling;
        if (active) {
          label.classList.add('is-active');
        } else {
          label.classList.remove('is-active');
        }
      }
    }, {
      key: "setState",
      value: function setState(filters_state) {
        var _this10 = this;
        // Only keep states for this filter
        var active_options = filters_state.filter(function (state) {
          return state.filter.name == _this10.name;
        }).map(function (state) {
          return state.value;
        });
        this.options.forEach(function (option) {
          option.checked = ~active_options.indexOf(option.value);
        });
      }
    }, {
      key: "query",
      value: function query() {
        var _this11 = this;
        var query_string = '';
        var query = [];
        this.options.filter(function (option) {
          return option.checked;
        }).forEach(function (option) {
          // Build the query based on if the facet has multiple values or not
          if (_this11.facet.value.length) {
            query = [].concat(_toConsumableArray(query), _toConsumableArray(_this11.facet.value.map(function (value) {
              if (_this11.facet.type == 'tags') {
                // Adding this check to enable functionality of Absolute checkbox ("id": "absolute") from en-filters and fr-filters
                if (option.filter.absolute && value == option.value) {
                  return "".concat(_this11.facet.type, ":\"").concat(value, "\"");
                }
                return "".concat(_this11.facet.type, ":\"").concat(value).concat(option.value, "\"");
              } else {
                return "".concat(_this11.facet.type, ".").concat(value, ":\"").concat(option.value, "\"");
              }
            })));
          } else {
            query.push("".concat(_this11.facet.type, ":\"").concat(option.value, "\""));
          }
        });

        // Format the query for Algolia
        if (query.length) {
          query_string = query.join(this.exclude ? ' AND NOT ' : ' OR ');
          if (this.exclude) {
            query_string = "NOT ".concat(query_string);
          }
          if (query.length > 1) {
            query_string = "(".concat(query_string, ")");
          }
        }
        return query_string;
      }
    }, {
      key: "update",
      value: function update(option) {
        this.elements.group.trigger('Filter:update', [option, filter]);
        this.elements.active_filters.html(this.activeFiltersString());
        var filter = this.elements.active_filters[0];
        this.setActiveLabel(filter);
      }
    }, {
      key: "activeFiltersString",
      value: function activeFiltersString() {
        return this.applied_options.map(function (option) {
          return option.name;
        }).join(', ');
      }
    }, {
      key: "sortOptions",
      value: function sortOptions() {
        var numberWithGram = /^[\d\.]+(?=g$)/;
        var multiplierWithGram = /^[\d\.]+[xX][\d\.]+(?=g$)/; // Regex matching options with multipliers
        var noGramValues;
        var values;

        // Finds options with multipliers and turns each of them into a single value for proper sorting
        this.options.filter(function (e) {
          return e.value.match(multiplierWithGram);
        }).forEach(function (e) {
          noGramValues = e.name.split('g');
          values = noGramValues.toString().split('x');
          e.name = (parseFloat(values[0]) * parseFloat(values[1])).toFixed(5) + 'g';
        });
        this.options.sort(function (a, b) {
          if (a.name.match(numberWithGram) && b.name.match(numberWithGram)) {
            return Number(a.name.match(numberWithGram)[0]) > Number(b.name.match(numberWithGram)[0]) || -1;
          } else {
            return a.name > b.name || -1;
          }
        });

        // Reverts single values into their original values with the multipliers
        this.options.filter(function (e) {
          return e.value.match(multiplierWithGram);
        }).map(function (e) {
          return e.name = e.value;
        });
      }
    }, {
      key: "renderValues",
      value: function renderValues() {
        var _this12 = this;
        this.sortOptions();
        this.options.forEach(function (option) {
          var $option = option.render();
          _this12.elements.fieldset.append($option);
          $option.on('change', theme.debounce(function () {
            _this12.update(option);
          }, 300));
        });
      }
    }, {
      key: "render",
      value: function render() {
        var data_id = "filter--".concat(this.name.handleize(), "-").concat(Math.floor(Math.random() * 1000000));
        var options_wrapper_height; // declared here to allow height caching

        this.elements.group = $("\n        <div class=\"filter__group filter__group--".concat(this.type, " ").concat(this.classes.join(' '), "\">\n          <input type=\"checkbox\" id=\"input--").concat(data_id, "\" class=\"toggle-button toggle-button-input--filter\">\n          <label for=\"input--").concat(data_id, "\" class=\"toggle-button-label toggle-button-label--").concat(this.name.handleize(), " toggle-button-label--filter\" data-filter=\"").concat(data_id, "\" data-option-name=\"").concat(this.name, "\" tabindex=\"0\">\n            <span class=\"toggle-button-label__wrapper\">\n              <div class=\"toggle-button-name__wrapper\">\n                <span class=\"sort--filter\">").concat(this.name, "</span>\n              </div>\n              <span aria-hidden=\"true\" class=\"toggle-button__plus\">\n                <svg class=\"plus_svg\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n                  <g fill-rule=\"evenodd\">\n                    <path d=\"M0 6.072H13.196V7.478H0z\" transform=\"translate(.66 .119)\" />\n                    <path d=\"M0.206 6.05L12.99 6.05 12.99 7.501 0.206 7.501z\" transform=\"translate(.66 .119) rotate(90 6.598 6.776)\" />\n                  </g>\n                </svg>\n              </span>\n              <span aria-hidden=\"true\" class=\"toggle-button__minus icon--subtract\"></span>\n            </span>\n          </label>\n          <div class=\"filter__options filter__options--").concat(this.name.handleize(), "\" id=\"").concat(data_id, "\">\n            <div class=\"filter__options-wrapper\"></div>\n          </div>\n          <p id=\"filter-").concat(this.name.handleize(), "-label\" class=\"filter__group--description sr-only\">\n            ").concat(this.info.description, "\n          </p>\n        </div>\n      "));
        this.elements.fieldset = this.elements.group.find('.filter__options-wrapper');
        this.renderValues();
        this.elements.active_filters = $("<span class=\"sort--active-filters\">".concat(this.activeFiltersString(), "</span>"));
        this.elements.group.find('.toggle-button-name__wrapper').append(this.elements.active_filters);
        this.elements.group.find('.toggle-button-input--filter').change(function (e) {
          var current_target = $(e.currentTarget);
          var is_list_dropdown = current_target.closest('.filter__group').hasClass('filter__group--list');
          $('.toggle-button-input--filter').not(current_target).prop('checked', false).siblings('.toggle-button-label--filter').attr('style', '').siblings('.filter__options').find('label, .noUi-handle').attr('tabindex', -1);
          if (current_target.is(':checked')) {
            current_target.siblings('.filter__options').find('label, .noUi-handle').attr('tabindex', 0);
          } else {
            current_target.siblings('.filter__options').find('label, .noUi-handle').attr('tabindex', -1);
          }
          if ($(window).outerWidth() >= 1280) {
            if (current_target.is(':checked')) {
              var button_height = $('.toggle-button:not(:checked) + .toggle-button-label').eq(0).outerHeight();
              options_wrapper_height ? '' : options_wrapper_height = current_target.siblings('.filter__options').find('.filter__options-wrapper').outerHeight(true); // avoids computing height value more than once, also fixes different outputs on certain pages
              var dist; // distance between the top of the `.filters__load-more` container & the targeted toggle

              if ($('.filters__load-more.is-visible').length) {
                dist = button_height + (current_target.siblings('.toggle-button-label').offset().top - $('.filters__load-more').offset().top);
              }
              if (is_list_dropdown) {
                current_target.siblings('.toggle-button-label').css('margin-bottom', options_wrapper_height);
                current_target.siblings('.filter__options').find('.filter__options-wrapper').css('top', "".concat(dist > 0 ? dist : 40, "px"));
              } else {
                current_target.siblings('.filter__options').find('.filter__options-wrapper').css('position', 'relative');
              }
            } else {
              current_target.siblings('.toggle-button-label').attr('style', '');
            }
          }
          if ($(window).outerWidth() < 1280 && current_target.is(':checked')) {
            $('html, body').stop().animate({
              scrollTop: current_target.offset().top - 200
            }, 400);
          }
        });
        return this.elements.group;
      }
    }, {
      key: "clear",
      value: function clear() {
        this.options.forEach(function (f) {
          return f.clear();
        });
      }
    }]);
    return Filter;
  }();
  var RangeFilter = /*#__PURE__*/function (_Filter) {
    _inherits(RangeFilter, _Filter);
    var _super = _createSuper(RangeFilter);
    function RangeFilter(filter) {
      var _this13;
      _classCallCheck(this, RangeFilter);
      _this13 = _super.call(this, filter);
      _this13.type = 'range';
      _this13.convert_to_percent = filter.convert_to_percent || false;
      _this13.prefix = filter.prefix || '';
      _this13.suffix = filter.suffix || '';
      return _this13;
    }
    _createClass(RangeFilter, [{
      key: "range",
      get: function get() {
        var values = this.slider.get();
        var min = Number(this.convert_to_percent ? Math.floor(values[0].replace('%', '')) * 10 : values[0].replace(this.prefix, '').replace(this.suffix, ''));
        var max = Number(this.convert_to_percent ? Math.ceil(values[1].replace('%', '')) * 10 : values[1].replace(this.prefix, '').replace(this.suffix, ''));
        if (min === 0 && max === 0) {
          return {
            min: 0,
            max: 0
          };
        } else {
          return {
            min: values.length && min || this.bounds.min,
            max: values.length && max || this.bounds.max
          };
        }
      },
      set: function set(range) {
        this.slider.set([range.min, range.max]);
      }
    }, {
      key: "initial_options",
      get: function get() {
        var query_param = query_params[this.name];
        var initial_range = {
          min: null,
          max: null
        };
        if (query_param) {
          query_param = query_param.split('-');
          initial_range.min = parseFloat(query_param[0]);
          initial_range.max = parseFloat(query_param[1]);
        }
        return initial_range;
      }
    }, {
      key: "applied_options",
      get: function get() {
        var _this14 = this;
        // Check if the range is different than the initial values
        if (this.range.min > this.bounds.min || this.range.max < this.bounds.max) {
          return [{
            name: this.convert_to_percent ? "".concat(this.range.min / 10, "% - ").concat(this.range.max / 10, "%") : "".concat(this.prefix).concat(this.range.min, " - ").concat(this.prefix).concat(this.range.max).concat(this.suffix),
            value: "".concat(this.range.min, "-").concat(this.range.max),
            filter: this,
            clear: function clear() {
              _this14.clear();
            }
          }];
        } else {
          return [];
        }
      }
    }, {
      key: "generateOption",
      value: function generateOption(option) {
        return {
          name: option,
          value: parseFloat(option)
        };
      }
    }, {
      key: "setState",
      value: function setState(filters_state) {
        var _this15 = this;
        // Only keep states for this filter
        var active_options = filters_state.filter(function (state) {
          return state.filter.name == _this15.name;
        });
        if (active_options.length) {
          var active_option = active_options[0].value.split('-');
          this.range = {
            min: Math.floor(parseFloat(active_option[0])),
            max: Math.ceil(parseFloat(active_option[1]))
          };
        } else {
          this.clear();
        }
      }
    }, {
      key: "clear",
      value: function clear() {
        this.range = this.bounds;
      }
    }, {
      key: "query",
      value: function query() {
        var _this16 = this;
        // Don't add to query if the range isn't set or there isn't enough data
        if (this.bounds.min == this.bounds.max || this.range.min == this.bounds.min && this.range.max == this.bounds.max) {
          return;
        }
        var query_string = '';
        var query = [];
        if (this.facet.value.length) {
          query = [].concat(_toConsumableArray(query), _toConsumableArray(this.facet.value.map(function (value) {
            return "".concat(_this16.facet.type, ".").concat(value, ":").concat(_this16.range.min, " TO ").concat(_this16.range.max);
          })));
        } else {
          query.push("".concat(this.facet.type, ":").concat(this.range.min, " TO ").concat(this.range.max));
        }

        // Format the query for Algolia
        if (query.length) {
          // using an OR for the join, to use the facet values concurrently
          query_string = query.join(' OR ');
          if (query.length > 1) {
            query_string = "(".concat(query_string, ")");
          }
        }
        return query_string;
      }
    }, {
      key: "update",
      value: function update() {
        this.elements.group.trigger('Filter:update', this);
        this.elements.active_filters.html(this.activeFiltersString());
        var filter = this.elements.active_filters[0];
        this.setActiveLabel(filter);
      }
    }, {
      key: "sortOptions",
      value: function sortOptions() {
        this.options = this.options.sort(function (a, b) {
          return parseFloat(a.value) - parseFloat(b.value);
        });
      }
    }, {
      key: "addAriaLabels",
      value: function addAriaLabels() {
        var filterContentEl = document.querySelector('#FilterContent');
        var observer = new MutationObserver(mCallback);
        observer.observe(filterContentEl, {
          childList: true
        });
        $('.filter__toggle').one('click', function () {
          observer.disconnect();
        });
        function mCallback(mutations) {
          var _iterator2 = _createForOfIteratorHelper(mutations),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var mutation = _step2.value;
              if (mutation.type === 'childList') {
                updateAriaLabels();
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        function updateAriaLabels() {
          $('.filter__group--range').each(function () {
            var labelId = $(this).find('.filter__group--description')[0].id;
            var handles = $(this).find('.noUi-handle');
            handles.each(function () {
              if (!$(this).attr('aria-labelledby')) {
                $(this).attr('aria-labelledby', labelId);
                $(this).attr('tabindex', -1);
              }
            });
          });
        }
      }
    }, {
      key: "renderValues",
      value: function renderValues() {
        var _this17 = this;
        this.sortOptions();
        var multiplier = this.convert_to_percent ? 10 : 1;
        this.bounds = {
          min: Math.floor(this.options[0].value / multiplier) * multiplier,
          max: Math.ceil(this.options[this.options.length - 1].value / multiplier) * multiplier
        };
        if (this.initial_options.min === 0 && this.initial_options.max === 0) {
          this.start = [0, 0];
        } else {
          this.start = [this.initial_options.min || this.bounds.min, this.initial_options.max || this.bounds.max];
        }
        this.elements.slider = $('<div class="noUIslider"></div>');
        var options = {
          start: this.start,
          connect: true,
          step: 1,
          range: {
            'min': this.bounds.min,
            'max': this.bounds.max
          },
          margin: 1,
          tooltips: true,
          format: {
            to: function to(value) {
              return _this17.convert_to_percent ? "".concat(Math.round(value / 10), "%") : "".concat(_this17.prefix).concat(Math.round(value)).concat(_this17.suffix);
            },
            from: function from(value) {
              return Number(value.replace(_this17.prefix, '').replace(_this17.suffix, ''));
            }
          }
        };
        this.slider = noUiSlider.create(this.elements.slider[0], options);

        /**
         * Handle Keyboard events
         * Move handles when arrows are pressed
         */
        this.elements.slider.find('.noUi-handle').each(function (i, handle) {
          $(handle).on('keydown', function (e) {
            var values = [_this17.range.min, _this17.range.max];
            var step = _this17.convert_to_percent ? options.step * 10 : options.step;
            if (e.which === 37) {
              values[i] = Math.floor(values[i] - step);
              _this17.elements.slider[0].noUiSlider.set(values);
            }
            if (e.which === 39) {
              values[i] = Math.ceil(values[i] + step);
              _this17.elements.slider[0].noUiSlider.set(values);
            }
          });
        });
        this.slider.on('set', function (values) {
          _this17.update();
          var min = Number(_this17.convert_to_percent ? Math.floor(values[0].replace('%', '')) * 10 : values[0].replace(_this17.prefix, '').replace(_this17.suffix, ''));
          var max = Number(_this17.convert_to_percent ? Math.ceil(values[1].replace('%', '')) * 10 : values[1].replace(_this17.prefix, '').replace(_this17.suffix, ''));
          if (_this17.convert_to_percent) {
            _this17.elements.selection_min.html(min);
            _this17.elements.selection_max.html(max);
          }
        });
        this.addAriaLabels();
        this.elements.fieldset.append(this.elements.slider);
        if (this.convert_to_percent) {
          this.elements.selection = $("\n            <div class=\"filter__selection\">\n              <span class=\"js-range-min\">".concat(this.start[0], "</span> - <span class=\"js-range-max\">").concat(this.start[1], "</span> ").concat(this.suffix, "\n            </div>\n          "));
          this.elements.selection_min = this.elements.selection.find('.js-range-min');
          this.elements.selection_max = this.elements.selection.find('.js-range-max');
          this.elements.fieldset.append(this.elements.selection);
        }
      }
    }]);
    return RangeFilter;
  }(Filter);
  var ListFilter = /*#__PURE__*/function (_Filter2) {
    _inherits(ListFilter, _Filter2);
    var _super2 = _createSuper(ListFilter);
    function ListFilter(filter) {
      var _this18;
      _classCallCheck(this, ListFilter);
      _this18 = _super2.call(this, filter);
      _this18.type = 'list';
      return _this18;
    }
    return _createClass(ListFilter);
  }(Filter);
  var ItemsFilter = /*#__PURE__*/function (_Filter3) {
    _inherits(ItemsFilter, _Filter3);
    var _super3 = _createSuper(ItemsFilter);
    function ItemsFilter(filter, settings) {
      var _this19;
      _classCallCheck(this, ItemsFilter);
      var GRID_SIZES = ['auto', 'half', 'full'];
      _this19 = _super3.call(this, filter);
      _this19.type = 'items';
      _this19.settings = settings || {};
      _this19.grid_size = ~GRID_SIZES.indexOf(_this19.settings.size) ? _this19.settings.size : 'auto';
      _this19.classes = ["filter__group--".concat(_this19.grid_size)];
      return _this19;
    }
    return _createClass(ItemsFilter);
  }(Filter); // Global export
  window.filter = {
    Range: RangeFilter,
    List: ListFilter,
    Items: ItemsFilter
  };
})(window.jQuery, window.theme = window.theme || {});

// language cookie
$(document).ready(function () {
  var lang = window.theme.locales.language_code;
  switch (lang) {
    case 'en':
      localStorage.setItem('content_language', 'lang-en');
      break;
    case 'fr':
      localStorage.setItem('content_language', 'lang-fr');
      break;
    default:
      localStorage.setItem('content_language', 'lang-en');
      break;
  }
});

// ------------------------------
// SECTIONS
// ------------------------------
(function ($, Handlebars, theme) {
  $(function () {
    "use strict";

    $('.suggested-accessories .product-grid').each(function () {
      var $carousel = $(this);
      $carousel.on('init', function (event, slick) {
        $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
      }).on('afterChange', function (event, slick) {
        $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
        $('.slick-slide[aria-hidden="false"]').find('a, .product-tile__vendor, .product-tile__price, .product-tile__tax-notice, li').attr('tabindex', 0);
      }).slick(window.theme.utils.getDefaultCarousalSettings({
        customPaging: function customPaging(slider, index) {
          return "<button type=\"button\"><span class=\"sr-only\">".concat(index + 1, "</span></button>");
        }
      }));
    });
    $(window).on('resize orientationchange', function () {
      $('.suggested-accessories .product-grid').each(function () {
        $(this).slick('resize');
      });
    });
  });
})(jQuery, Handlebars, window.theme = window.theme || {});

// ------------------------------
// PARTIALS
// ------------------------------
(function ($) {
  $(function () {
    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);
    var xDown = null;
    var yDown = null;
    var element = null;
    function getTouches(evt) {
      return evt.touches ||
      // browser API
      evt.originalEvent.touches; // jQuery
    }

    function handleTouchStart(evt) {
      var firstTouch = getTouches(evt)[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
      element = evt.target;
    }
    ;
    function handleTouchMove(evt) {
      if (!xDown || !yDown) {
        return;
      }
      var xUp = evt.touches[0].clientX;
      var yUp = evt.touches[0].clientY;
      var xDiff = xDown - xUp;
      var yDiff = yDown - yUp;
      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) {
          $(element).trigger('swipeleft');
        } else {
          $(element).trigger('swiperight');
        }
      } else {
        if (yDiff > 0) {
          $(element).trigger('swipeup');
        } else {
          $(element).trigger('swipedown');
        }
      }
      xDown = null;
      yDown = null;
    }
    ;
  });
})(jQuery);
(function ($, Handlebars, theme) {
  $(function () {
    if ($('#contact_form').length) {
      theme.contactForm = new FormValidator('#contact_form');
    }
  });
})(jQuery, Handlebars, window.theme = window.theme || {});
(function (theme, Cookies) {
  var SavedStore = function SavedStore(customer_store_id) {
    var _store_id;
    var _$events;
    function _init() {
      var id_string = customer_store_id || Cookies.get('_saved_store');
      _store_id = id_string ? parseInt(id_string) : undefined;
      _$events = $(document);
    }
    function _get(cb) {
      if (theme.store_repository) {
        theme.store_repository.fetch_stores(function () {
          cb(theme.store_repository.find_store(_store_id));
        });
      } else {
        console.error('[Saved Store] Store repository not instantiated');
      }
    }

    /**
     * Public API
     */
    this.get = function (cb) {
      return _get(cb);
    };
    this.get_id = function (cb) {
      return _store_id;
    };
    this.is_set = function () {
      return typeof _store_id !== 'undefined';
    };
    this.set = function (store_id, cb) {
      if (theme.store_repository) {
        // Use only cookies in interim
        _store_id = store_id;
        Cookies.set('_saved_store', _store_id);
        _get(function (store) {
          if (cb) {
            _$events.trigger('saved-store-change', store);
            return cb(store);
          }
        });
      } else {
        console.error('[Saved Store] Store repository not instantiated');
      }
    };
    this.remove = function (cb) {
      // Use only cookies in interim
      _store_id = undefined;
      Cookies.remove('_saved_store');
      _$events.trigger('saved-store-change');
      if (cb) {
        cb(true);
      }
    };
    _init();
  };
  theme.saved_store = new SavedStore();
})(theme, Cookies);
(function ($, theme) {
  $(function () {
    'use strict';

    // Sets useful variables
    var $body = $('body'),
      $html = $('html'),
      $window = $(window),
      $header = $('header.nav'),
      $menubar = $('.menu-bar'),
      $megaMenu = $('.js-mega-menu'),
      $megaMenuClose = $('.js-mega-menu__close-btn'),
      $hamburgerMenu = $('.js-hamburger-menu'),
      $searchResultsPanel = $('.js-instant-search'),
      $searchFullSearchBar = $('#full-search-bar'),
      $searchInput = $searchFullSearchBar.find('.js-search-input'),
      $popularSearchPanel = $searchFullSearchBar.find('.js-search-popular'),
      $menu = $('.js-menu'),
      $skiptomain = $('.js-skip-link'),
      openedByClicked = false;
    var current_window_width = $(window).width(),
      $tier_one_link = $('.js-menu__tier-one--link'),
      tier_one = '.js-menu__tier-one',
      $tier_one = $(tier_one),
      $tier_two = $('.js-menu__tier-two'),
      $tier_three = $('.js-menu__tier-three'),
      tier_three_link = '.js-menu__tier-three__link',
      $mega_menu = $('.js-mega-menu'),
      $faq_search_form = $('.js-menu-faq-search-form'),
      $faq_search_input = $('.js-menu-search-input'),
      $faq_link = $('.js-menu__faq-link'),
      $return_prev = $('.js-return-prev'),
      $account_link = $('.js-menu__account-link');

    // prevents accordion behaviour on desktop
    if (current_window_width >= theme.bp.md) {
      $tier_three.removeClass('accordionize');
      // adjustTier3Heights();
    } else {
      $tier_three.find('.accordionize__content--mega-menu').addClass('is-hidden');
    }
    $(document).on('keydown', tier_one, function (e) {
      if (e.type === 'keydown' && e.keyCode == 32) {
        e.preventDefault();
        $(this).toggleClass('has-tier-two-open');
        $(tier_one).not(this).removeClass('has-tier-two-open');
        return;
      }
    });

    /*
     * mobile faq nav menu has links with urls to the faq page and a url parameter of the article id
     * this uses the id to scroll to the article and click it open
     */
    if (theme.template.suffix == 'faq') {
      var params = theme.utils.getURLParams();
      if (params.article_id && $('#' + params.article_id).length) {
        var article_id = params.article_id;
        setTimeout(function () {
          document.getElementById(article_id).scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          $('#' + article_id).trigger('click');
        }, 300);
      }
    }

    /* 	EVENT HANDLERS */

    // adds / removes accordion behaviour on mobile/desktop
    $(window).resize(theme.debounce(function () {
      // Stick / unstick header
      positionHeader();
      var newWidth = $(window).width();

      // If crossing from mobile to tablet
      if (current_window_width < theme.bp.md && newWidth >= theme.bp.md) {
        closeFlyout();
        $tier_three.removeClass('accordionize');
        $('.accordionize__content').removeClass('accordion--show');
        $tier_three.find('.accordionize__content--mega-menu').removeClass('is-hidden');
        $tier_three.find('.accordionize__content--mega-menu').css('max-height', '');
      }

      // If crossing from tablet to mobile
      else if (current_window_width >= theme.bp.md && newWidth < theme.bp.md) {
        closeFlyout();
        $tier_three.css('height', 'auto');
        $tier_three.css('height', 'unset');
        $tier_three.addClass('accordionize');
        $tier_three.find('.accordionize__content--mega-menu').addClass('is-hidden');
      }

      // If currently tablet or desktop
      // if (newWidth >= theme.bp.md) {
      //   adjustTier3Heights();
      // }

      current_window_width = newWidth;
    }, 300));

    // scroll related functionality
    $(window).scroll(positionHeader);
    $('.menu-search__field').on('keyup', positionHeader);

    // Position header on initial page load
    positionHeader();

    // opens mobile menu
    $hamburgerMenu.click(function (e) {
      e.preventDefault();
      openFlyout();
    });
    $hamburgerMenu.on('keydown', function (e) {
      if (e.which == 13 || e.which == 32) {
        e.preventDefault();
        openFlyout();
      }
    });

    // closes desktop menu when user clicks out
    $(document).on('click', function (e) {
      var $chain = $(e.target).parents().addBack();
      if (!$chain.is(tier_one)) {
        $tier_one.removeClass('has-tier-two-open');
        e.stopPropagation();
      }
    });
    $megaMenuClose.click(function (e) {
      e.preventDefault();
      closeFlyout();
    });
    $megaMenuClose.on('keydown', function (e) {
      if (e.which == 13) {
        e.preventDefault();
        closeFlyout();
      }
    });
    $megaMenu.on('keydown', function (e) {
      if (e.which == 27) {
        e.preventDefault();
        closeFlyout();
      }
    });
    $tier_one_link.on('click', function (e) {
      e.preventDefault();
      // if already open & you click, close it
      if ($(this).closest(tier_one).hasClass('has-tier-two-open')) {
        $(this).closest(tier_one).removeClass('has-tier-two-open');
        openedByClicked = false;
      } else {
        // if not already open, remove class from the one that did, and then open it
        $tier_one.removeClass('has-tier-two-open');
        $(this).closest(tier_one).addClass('has-tier-two-open');
        openedByClicked = true;

        // this doesnt need to be removed when you click the link bc if the mobile version is open
        // you cant access the link
        if (current_window_width < theme.bp.md) {
          $mega_menu.addClass('has-tier-two-open--mobile');
        }
      }
      focusFirstElement(true);
    });

    // Force-close any other tier one menus when hovering on any tier one menu
    $tier_one.on('mouseover', function (e) {
      e.preventDefault();
      var $current = $(this);

      // find and close any other tier one menu
      if (!openedByClicked) {
        $tier_one.not($current).removeClass('has-tier-two-open');
      }
    });

    // Prevents tier three links from redirecting on mobile
    $tier_three.on('click', '> a', function (e) {
      if (current_window_width < theme.bp.md && $(this).siblings('.accordionize__content--mega-menu').length) {
        e.preventDefault();
      }
    });

    // Enter to navigate to tier three accordion links (as opposed to tier three spans which open accordions)
    $mega_menu.on('keydown.enterThreeLink', tier_three_link, function (e) {
      if (e.charCode === 13) {
        e.currentTarget.click();
      }
    });

    // 'Return' arrow in mobile navigation
    ['click', 'keydown'].forEach(function (ev) {
      $return_prev.on(ev, function (e) {
        if (e.which == 13 || ev == 'click') {
          e.preventDefault();
          $('.accordionize__content.accordion--show').closest('.accordionize').trigger('click');
          $tier_one.removeClass('has-tier-two-open');
          $mega_menu.removeClass('has-tier-two-open--mobile');
          focusFirstElement();
        }
      });
    });
    $('.gram-widget__pricing').hover(function () {
      $('.gram-widget-wrapper').addClass('is-active');
    }, function () {
      $('.gram-widget-wrapper').removeClass('is-active');
    });

    //my-account widget click and focus on tab 
    $(document).on('click keydown', '.my-account-widget', function (e) {
      if (e.type === 'click' || e.key === " " || e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        window.location.href = $account_link.attr('href');
      }
    });

    /* mobile search form in mega menu
     * grabs the search term and turns it into a url parameter of the faq page url
     */
    $faq_search_form.on('submit', function (e) {
      e.preventDefault();
      var faq_link = $faq_link.attr('href');
      var search_term = $('.js-menu-search-input').val();
      var faq_search_url = faq_link + '?search=' + search_term;
      window.location = faq_search_url;
    });

    /* FUNCTION DECLARATIONS */
    function focusFirstElement(fromTierOne) {
      var $menu = fromTierOne ? $('.menu__tier-one.has-tier-two-open .menu__tier-two') : $megaMenu;

      // To allow the CSS transition to kick in before focusing
      setTimeout(function () {
        $menu.find('input:visible, button:visible, textarea:visible, a:visible, [tabindex]').first().focus();
      }, 100);
    }
    function openFlyout() {
      window.InfoBubbles.reinitializeBubbles();
      $body.addClass('body--freeze');
      $html.addClass('body--freeze');
      $megaMenu.addClass('active');
      $skiptomain.addClass('skip-disabled');
      // Set-timeout to allow jQuery slideUp transition to finish if user scrolls a little
      // after opening menu. Set 'display' inline to override jQuery setting 'display: none'.
      setTimeout(function () {
        $header.css('display', 'block');
      }, 300);
      focusFirstElement();

      // Changes the position of shop all button for mobile menu
      $('.desktop__cta').hide();
      $('.burger__cta').show();
    }
    function closeFlyout() {
      if ((!$('#flyout--overlay').is('.active') || !$('.flyout--cart').is('.active')) && !$searchResultsPanel.is('.active')) {
        $body.removeClass('body--freeze');
        $html.removeClass('body--freeze');
        $skiptomain.removeClass('skip-disabled');
        // Unset inline 'display' so as to use styles from stylesheet.
        $header.css('display', '');
      }
      // Changes the position of shop all button for desktop menu
      $('.desktop__cta').show();
      $('.burger__cta').hide();
      $tier_one.removeClass('has-tier-two-open');
      $megaMenu.removeClass('active has-tier-two-open--mobile');
      toggleAriaHidden($megaMenu.find('[aria-hidden=false]'), "true");
    }
    function adjustTier3Heights() {
      if (current_window_width < theme.bp.md) {
        return;
      }
      $tier_two.each(function () {
        var tallest_height = 0;
        var $tier_threes = $(this).find('.js-menu__tier-three');
        $tier_threes.each(function (i) {
          $(this).css('min-height', 'auto').css('height', 'auto');
          if (Number($(this).outerHeight()) > tallest_height) {
            tallest_height = Number($(this).outerHeight());
          }
        });
        $tier_threes.outerHeight(tallest_height);
      });
    }
    function positionHeader() {
      var scroll = $window.scrollTop(),
        width = $window.width(),
        // threshold to unstick the menu. smallest of either the header before it was stuck, or after it was stuck
        menu_margin = $menubar.position().top,
        sticky_margin = $body.data('sticky-margin') < menu_margin ? $body.data('sticky-margin') : menu_margin;

      // Which scroll position the document is at presently
      var prevScroll = $(document).scrollTop();

      //Function hides the header when scrolling down and then makes it reappear if scrolling up
      function scrollHandler() {
        if (!$megaMenu.hasClass('active') && !$searchResultsPanel.hasClass('active')) {
          var newScroll = $(document).scrollTop();
          if (newScroll < prevScroll) {
            $header.slideDown(200);
          } else if (newScroll <= 0) {
            $header.slideDown(200);
          } else if (newScroll > $header.outerHeight()) {
            $header.slideUp(200);
          }
          prevScroll = newScroll;
        }
      }

      // If not yet stuck,
      // whenever scrolling past 0 on mobile
      // or scrolling past the header's height on desktop, stick the header
      if (width < theme.bp.md && scroll > 0 || width >= theme.bp.md && scroll > sticky_margin) {
        if (!$body.hasClass('header--sticky')) {
          // Recalculate body margin needed to fill the void while the header is stuck
          var margin_top = $header.outerHeight();
          $body.css('margin-top', margin_top).data('sticky-margin', margin_top);
          $body.addClass('header--sticky');
        }

        // On mobile, only hide banner if further down the page
        if (width < theme.bp.md) {
          $('.global-banner, .notice-banner').toggleClass('is-hidden', scroll > 250);
        } else {
          $('.global-banner, .notice-banner').removeClass('is-hidden');
        }
      } else {
        // Unstick the header
        $body.css('margin-top', 0);
        $body.removeClass('header--sticky');
        $('.global-banner, .notice-banner').removeClass('is-hidden');
      }
      // Will run the function once user scrolls
      if (width < theme.bp.md) {
        $window.one('scroll.mobile', theme.debounce(scrollHandler, 100));
      }
      // Remove the hidden class in case user changes browser size after scrolling down
      if (width >= theme.bp.md) {
        $window.off('scroll.mobile');
        $header.slideDown(200);
      }
      // Calculate the top offset for the Algolia search autocomplete element
      var search_margin = $('.header').outerHeight();
      if ($('.global-banner').is(':visible')) {
        search_margin += $('.global-banner').outerHeight();
      }
      if ($('.tool-bar').is(':visible')) {
        search_margin += $('.tool-bar').outerHeight();
      }
      $('.algolia-autocomplete').css('top', search_margin);
    }

    // Moves the Algolia autocomplete element in the right place for stacking order
    function positionAutocomplete() {
      $('.algolia-autocomplete').prependTo('.header');
    }
    function toggleAriaHidden(collection, isHidden) {
      $.each(collection, function () {
        $(this).attr("aria-hidden", isHidden);
      });
    }

    // Initialize Search
    // Assign click events
    function initalizeSearch() {
      var searchFullSearchBarSubmit = $searchFullSearchBar.find('.js-search-submit');
      var searchFullSearchBarClear = $searchFullSearchBar.find('.js-search-clear');
      var searchPopularItems = $popularSearchPanel.find('.js-search-popular-item');
      function positionPopularSearch() {
        $('html, body').addClass('body--freeze');
        $body.addClass('header--popular-search');
      }
      function clearPopularSearch() {
        $('html, body').removeClass('body--freeze');
        $body.removeClass('header--popular-search');
      }
      function hidePopularSearch() {
        $popularSearchPanel.addClass('hidden');
      }
      function showPopularSearch() {
        if (typeof $searchInput.val() !== 'undefined' && $searchInput.val().trim().length < 1) {
          $popularSearchPanel.removeClass('hidden');
          positionPopularSearch();
        } else {
          hidePopularSearch();
        }
      }
      if ($popularSearchPanel.length > 0) {
        searchPopularItems.click(function (e) {
          hidePopularSearch();
          $searchInput.val(e.currentTarget.title);
          searchFullSearchBarSubmit.click();
        });
        $(document).on('focus click', 'body', function (e) {
          if (!$searchFullSearchBar.is(e.target) && $searchFullSearchBar.has(e.target).length === 0) {
            hidePopularSearch();
            clearPopularSearch();
          }
        });
      }
      $searchInput.on('focus', function () {
        if ($popularSearchPanel.length > 0) {
          showPopularSearch();
        }
      });
      searchFullSearchBarClear.click(function (e) {
        e.preventDefault();
        $searchInput.val('').focus();
      });
      searchFullSearchBarSubmit.click(function (e) {
        e.preventDefault();
        if (typeof $searchInput.val() !== 'undefined' && $searchInput.val().trim().length > 0) {
          $searchFullSearchBar.find('form').submit();
        }
      });
    }
    window.positionHeader = positionHeader;

    /*
      !!! currently obsolete !!!
      TODO: Update this with current menu link classes
      Handles accessability tabbing on the desktop header menu
    */
    // focus on the menu item link and press enter, close all submenus and open this submenu
    $(document).on('keydown', 'a.menu__item--link', function (e) {
      if (e.which == 13) {
        $('li.menu__item').removeClass('menu-open');
        $(this).closest('li.menu__item').addClass('menu-open');
      }
    });

    // focus on any element besides the menu item links, close all submenus
    $('.menu-bar').on('focus', 'a, button, input, [tab-index]', function (e) {
      if (!$(this).closest('.menu__list--nested__container').length) {
        $('li.menu__item').removeClass('menu-open');
      }
    });

    // press escape while on any element in the menu and all submenus will close
    $('.menu-bar').on('keydown', function (e) {
      if (e.which == 27) {
        $('li.menu__item').removeClass('menu-open');
      }
    });

    // Closes mega menu container after tabbing out of the last element in <header>
    $('.js-widget-pricing').focusout(function () {
      $tier_one.removeClass('has-tier-two-open');
    });

    // making this global so that it can be called when agegate
    // is validated to prevent menu items from stacking on eachother
    theme.adjustTier3Heights = adjustTier3Heights;
    positionAutocomplete();
    initalizeSearch();
  });
})(jQuery, window.theme = window.theme || {});
(function ($, Handlebars, theme) {
  $(function () {
    // Toggle Overlay tranlucid Menu
    $(document).on('click', '.js-toggle-overlay-menu', function (e) {
      e.preventDefault();
      var $chain = $(e.target).parents().addBack();
      if ($(e.target).closest('button').hasClass('toggle-button')) {
        $(e.target).closest('button').toggleClass('toggle-button--active');
      } else {
        $(e.target).closest('button').removeClass('toggle-button--active');
      }
      if (!$chain.is('label') && !$chain.is('input')) {
        $(this).closest('.nav__item').siblings().removeClass('menu--open');
        $(this).closest('.nav__item').toggleClass('menu--open');
      }
    });
    $(document).on('keyup', '.js-toggle-overlay-menu', function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        toggleOverlayMenu(e);
      }
    });

    // Close Menu when clicking outside
    $(document).on('click', function (e) {
      var $chain = $(e.target).parents().addBack();
      if (!$chain.is('.js-toggle-overlay-menu') && !$chain.is('.overlay-menu')) {
        $('.js-toggle-overlay-menu').removeClass('toggle-button--active');
        $('.js-toggle-overlay-menu').closest('ul').find('li.menu--open').removeClass('menu--open');
        $('.collection__list, .filter__sort').removeClass('menu--open');
        e.stopPropagation();
      }
      if (!$chain.hasClass('filter__right-wrapper') && !$chain.hasClass('overlay-menu') && !$chain.hasClass('sort-by-wrapper')) {
        $('#sort-toggle').prop('checked', false);
        e.stopPropagation();
      }
      if (!$chain.hasClass('collection__nav')) {
        $('.toggle-button').not(this).not('.filter__filter-toggle').prop('checked', false);
        $('.toggle-button-input--filter').siblings('.toggle-button-label').css('margin-bottom', '');
        e.stopPropagation();
      }
    });

    // Close Overlay tranlucid Menu when actionned
    $(document).on('click', '.overlay-menu > li > input', function (e) {
      var $overlayMenu = $(this).closest('.overlay-menu').parent();
      setTimeout(function () {
        $overlayMenu.removeClass('menu--open');
        $('#sort-toggle').prop('checked', false);
      }, 500);
    });
  });
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($) {
  $(function () {
    /**
     * Modal opening and closing logic.
     * Assumes an element with data-modal-close="{{ modal name }}" attribute,
     * or an element with data-modal-close="{{ modal name }}".
     */
    $(document).on('keydown', '[data-modal-close], [data-modal-open]', function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        try {
          $(this).click();
        } catch (e) {}
      }
    });
    $(document).on('click', '[data-modal-close], [data-modal-open]', function () {
      var $trigger = $(this),
        modal_name = $trigger.data('modal-close') || $trigger.data('modal-open'),
        $modal = $('[data-modal-name=' + modal_name + ']'),
        $body = $('body');
      var focusable = 'input:visible, button:visible, textarea:visible, a:visible, [tabindex]';
      if ($trigger.data('modal-close')) {
        $modal.removeClass('show');
        $body.removeClass('overflow-hidden');
        $('.footer, .header, .payment-methods, .store-location-tile, .store-locator, .global-banner, .skip-link').removeAttr('aria-hidden');
      } else {
        $modal.addClass('show');
        // For voice over you have to hide all elements that aren't in the modal, so you will need to add classes here if new sections/features is added to store locator page
        $('.footer, .header, .payment-methods, .store-location-tile, .store-locator, .global-banner, .skip-link').attr('aria-hidden', 'true');
        $body.addClass('overflow-hidden');
        var $firstelement = $modal.find(focusable).first();
        $firstelement.focus();
        $body.on('keydown', function (e) {
          if (e.key === 'Tab' || e.keyCode === 9) {
            if (e.shiftKey) /* shift + tab */{
                if ($firstelement.is(":focus")) {
                  setTimeout(function () {
                    $('#last-element').focus();
                  }, 300);
                }
              } else /* tab */{
                if ($('#last-element').is(":focus")) {
                  setTimeout(function () {
                    $firstelement.focus();
                  }, 300);
                }
              }
          }
          if (e.key === 'Escape' || e.keyCode === 27) {
            $firstelement.click();
          }
        });
      }
    });
  });
})(jQuery);
(function ($, Handlebars, theme) {
  $(function () {
    $(document).on('click keyup', '.language-toggles__switch-lang', function (e) {
      if (e.type === 'keyup' && e.keyCode !== 13) {
        return;
      }
      $('.language-toggles__options').toggleClass('show');
    });

    // putting this here for now, maybe should move it to a more appropriate location:
    $(document).on('click', '.text-cta--dropdown', function (e) {
      e.preventDefault();
      if ($(this).hasClass('up')) {
        $(this).removeClass('up');
      } else {
        $(this).addClass('up');
      }
    });
    $(document).on('click', '.language-toggle__link:not(.language-toggle__link--active)', function (e) {
      e.preventDefault();
      var $this = $(this);
      var locale = $this.data('locale');
      var params = 'attributes[_language]=' + locale;
      var url = '/cart/update';

      // update the cart attribute
      $.post(url, params, function () {
        var redirect_url = $this.attr('href') || window.location.href;
        if (window.location.href == redirect_url) {
          if (theme.template.name == 'search') {
            if (redirect_url.indexOf(encodeURIComponent('language--en')) >= 0) {
              redirect_url = redirect_url.replace(encodeURIComponent('language--en'), encodeURIComponent('language--fr'));
            } else if (redirect_url.indexOf(encodeURIComponent('language--fr')) >= 0) {
              redirect_url = redirect_url.replace(encodeURIComponent('language--fr'), encodeURIComponent('language--en'));
            }
            window.location.href = redirect_url;
          } else {
            window.location.reload();
          }
        } else {
          window.location.href = redirect_url;
        }
      });
    });

    /**
     * Determine if language is set via URL param,
     * If so, remove the param and toggle the switcher
     */
    var lang = theme.utils.getURLParams(window.location.href).lang || null;
    if (lang) {
      var $lang_link = $('.tool-bar .language-toggle__link[data-locale=' + lang + ']');
      var clean_uri = location.protocol + "//" + location.host + location.pathname;
      window.history.replaceState({}, document.title, clean_uri);

      // If locale matches the existing page language, do not redirect
      if (theme.locales.current_locale && theme.locales.current_locale !== lang) {
        $lang_link.trigger('click');
      }
    }
  });
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, Handlebars) {
  /**
   * Variant selector contstructor.
   * Can be instantiated on either a product or collection page.
   *
   * Dependencies:
   * - jQuery
   * - Handlebars
   *
   * Required parameters:
   * - {callbacks} A hash of callbacks, currently only 'selection_change' is supported
   * - {scope_selector} A unique container selector for the current variant selector form
   * - {variants} A JSON array representation of a products variants
   * - {product_id} The ID of the product this selector will operate on. Used for scoping variables
   * - {tags} An array of product tags used to determine tagged templates
   * - {options_with_values} A JSON array representation of a products options_with_values string
   * - {container_selector} A selector string for the container where the controls should be rendered
   * - {default_template} A default handlebars template to use when no others apply
   * - {data} A hash of additional data to pass to the template
   * - {templates} A hash of handlebar template selectors with the options they apply to:
   *   - options: ['Weight', 'Number Rolls']
   *   - selector_type: 'variant'
   *   - template: '#variant-selector--weight'
   *
   * @TODO: Consider try/catching any risky business
   *
   * @param {*} params
   */

  window.VariantSelector = function (params) {
    var _$context,
      _variants,
      _options_with_values,
      _option_count,
      _container_selector,
      _templates,
      _default_template,
      _product_id,
      _product,
      _tags,
      _data,
      _preselect = true,
      _callbacks = {},
      _option_selector = '.option-selector',
      _variant_selector = '.variant-selector',
      _template_liquid,
      _$trigger;

    /**
     * On object initialize
     */
    function _init() {
      _$context = $(params.scope_selector);
      _variants = params.variants;
      _options_with_values = params.options_with_values;
      _option_count = _options_with_values.length;
      _container_selector = params.container_selector;
      _templates = params.templates || [];
      _default_template = params.default_template;
      _product_id = params.product_id;
      _tags = params.tags;
      _data = params.data;
      _product = params.product;
      _template_liquid = theme.template.name;
      if (params.$trigger) {
        _$trigger = params.$trigger;
      }
      if (params.preselect === false) {
        _preselect = false;
      }

      // Incoming options with values naturally sorted by their name
      _options_with_values = $.each(_options_with_values, function () {
        this.values = this.values.map(function (value) {
          return value.name ? value.name : value;
        }) // for some reasons, this.values from liquid returns an array of strings instead of an array of object like it should do. this ensures we always get the strings.
        .sort(function (a, b) {
          var ax = [],
            bx = [];
          a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
            ax.push([$1 || Infinity, $2 || ""]);
          });
          b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
            bx.push([$1 || Infinity, $2 || ""]);
          });
          while (ax.length && bx.length) {
            var an = ax.shift();
            var bn = bx.shift();
            var nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
            if (nn) return nn;
          }
          return ax.length - bx.length;
        });
      });

      // Incoming variants naturally sorted by their first options's name
      _variants = _variants.sort(function (a, b) {
        var ax = [],
          bx = [];
        a.option1.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
          ax.push([$1 || Infinity, $2 || ""]);
        });
        b.option1.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
          bx.push([$1 || Infinity, $2 || ""]);
        });
        while (ax.length && bx.length) {
          var an = ax.shift();
          var bn = bx.shift();
          var nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
          if (nn) return nn;
        }
        return ax.length - bx.length;
      });

      // Register initialization callbacks
      $.each(params.callbacks, function (key, callback) {
        _register_callback(key, callback);
      });

      // Register required handlers
      _register_handler('change', params.scope_selector + ' ' + _option_selector, _handle_option_change);
      _register_handler('change', params.scope_selector + ' ' + _variant_selector, _handle_variant_change);

      // Perform initial render
      _render(_options_with_values, _variants);

      // Kick things off if any values are set onload
      _$context.find(_option_selector + ', ' + _variant_selector).each(function () {
        if (_has_selection($(this))) {
          $(this).trigger('change');
          return false;
        }
      });
    }

    /**
     * Helpers
     *
     * Determines if an input element has value
     * @param {*} $el
     */
    function _has_selection($el) {
      $el = $el.add($el.find('input, select'));
      return $el.filter(function () {
        var tag = $(this).prop('tagName');
        return tag == 'SELECT' && $(this).val() || tag == 'INPUT' && $(this).is(':checked');
      }).length;
    }
    function _unselect($el) {
      $el = $el.add($el.closest('select'));
      $el.each(function () {
        var tag = $(this).prop('tagName');
        return tag == 'SELECT' && $(this).val('') || tag == 'INPUT' && $(this).prop('checked', false);
      });
    }
    function _select($el) {
      var val = $el.val();
      $el = $el.add($el.closest('select'));
      $el.each(function () {
        var tag = $(this).prop('tagName');
        return tag == 'SELECT' && $(this).val(val) || tag == 'INPUT' && $(this).prop('checked', true);
      });
    }

    /**
     * Private handlers
     *
     * Handler for option selection changes.
     * Filters variants and disables unused options.
     */
    function _handle_option_change() {
      if (_has_selection($(this))) {
        var option_name = $(this).data('option-name');

        // Disable and unselect options that don't qualify
        // Enable and potentially re-select the ones that do
        _render_disabled_options(option_name);

        // Determine all option values that are actually selected on the page
        // Now that we have sorted out what gets disabled
        var selected_options_with_values = _$context.find(_option_selector).filter(function () {
          return _has_selection($(this));
        }).map(function (i, option) {
          // Figure out the option's index
          var option_name = $(option).data('option-name');
          var index = _options_with_values.filter(function (opt) {
            return opt.name == option_name;
          })[0].position - 1;

          // Create a dataset for the option and its value
          return {
            name: option_name,
            value: $(this).val(),
            index: index
          };
        }).toArray();

        // Filter variants by all selected values
        var selected_variants = _filter_variants_by_option_values(selected_options_with_values);

        // Create a simplified version of the options chosen for the 'selection_change' callback
        var selected_option_values = [];
        selected_options_with_values.forEach(function (option) {
          selected_option_values.push(option.value);
        });
        _trigger_callback('selection_change', selected_variants, selected_option_values, _option_count, $(this));
        var $submit_button = $('.variant-selector__submit');
        if (selected_variants.length == 1 && selected_option_values.length == _option_count) {
          _$context.find('[name=id]').val(selected_variants[0].id);
        } else {
          var unselectedOption = '';
          _$context.find('fieldset[data-option-name]').each(function () {
            if (!unselectedOption) {
              var $this = $(this);
              var $checkedRadios = $this.find('input[type=radio].option-selector:checked');
              var $selectValue = $this.find('input[type="select"].option-selector');
              if (!$checkedRadios.length || !$selectValue) {
                var translated_option = theme.translations.product.choose_options[($this.data('option-name') || '').handleize()];
                unselectedOption = translated_option ? translated_option : theme.translations.product.choose_option;
              }
            }
          });
          $submit_button.find('span').first().html(unselectedOption);
        }
      }
    }

    /**
     * Handler for variant selection changes.
     * Filters variants and disables unused options.
     */
    function _handle_variant_change() {
      var variant = _find_variant_by_id(parseInt($(this).val()));
      _trigger_callback('selection_change', [variant], variant.options, variant.options.length, $(this));
      _$context.find('[name=id]').val(variant.id);
    }

    /**
     * Private methods
     *
     * Filter variants by an array of option value names
     * @param {*} selected_options_with_values
     */
    function _filter_variants_by_option_values(selected_options_with_values) {
      return _variants.filter(function (variant) {
        var match = true;
        selected_options_with_values.forEach(function (option) {
          if (variant.options[option.index] != option.value) {
            match = false;
          }
        });
        return match;
      });
    }

    /**
     * Disable options which are not included in the variants array passed in
     * @param {*} options
     * @param {*} option_name
     */
    function _render_disabled_options(selected_option_name) {
      var selected_option_index = _options_with_values.filter(function (opt) {
        return opt.name == selected_option_name;
      })[0].position - 1;
      _options_with_values.forEach(function (option, i) {
        var selected_options_with_values = _$context.find(_option_selector).filter(function () {
          var _this20 = this;
          var this_option_index = _options_with_values.filter(function (opt) {
            return opt.name == $(_this20).data('option-name');
          })[0].position - 1;
          return _has_selection($(this)) && this_option_index <= i;
        }).map(function (i, option) {
          // Figure out the option's index
          var option_name = $(option).data('option-name');
          var index = _options_with_values.filter(function (opt) {
            return opt.name == option_name;
          })[0].position - 1;

          // Create a dataset for the option and its value
          return {
            name: option_name,
            value: $(this).val(),
            index: index
          };
        }).toArray();
        var selectable_variants = _filter_variants_by_option_values(selected_options_with_values);

        // If there is a next option and it's not the one that was changed by the user
        if (_options_with_values[i + 1] && _options_with_values[i + 1].position - 1 > selected_option_index) {
          var next_option = _options_with_values[i + 1];

          // Check if this option was selected on page and note down its element
          var $selected_option = _$context.find('[data-option-value][data-option-name="' + escape(next_option.name) + '"]:checked').add('[data-option-value][data-option-name="' + escape(next_option.name) + '"]:selected');

          // Unselect and disable all elements for this option
          _unselect(_$context.find('[data-option-value][data-option-name="' + escape(next_option.name) + '"]').prop('disabled', true));
          // Enable only the ones that are selectable
          selectable_variants.forEach(function (variant) {
            _$context.find('[data-option-name="' + escape(next_option.name) + '"][data-option-value="' + variant.options[i + 1] + '"]').prop('disabled', false);
          });

          // If the option that was selected is still enabled, re-select it
          if ($selected_option.length) {
            if ($selected_option.prop('disabled') == false) {
              _select($selected_option);
            }
          }
        }
      });
    }

    /**
     * Private methods
     *
     * Sort Option Values
     * @param {*} option_values
     */
    function _sort_option_values(option_values) {
      // Sort options by alphabetical order
      option_values.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });

      // Sort options by size order
      var size_sort_order = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'];
      option_values.sort(function (a, b) {
        return size_sort_order.indexOf(a.name.toLowerCase()) - size_sort_order.indexOf(b.name.toLowerCase());
      });
    }

    /**
     * Compile a handlebars template and render it to the DOM
     * @param {*} template_selector
     * @param {*} payload
     */
    function _render_template(template_selector, $parent, payload, replace) {
      try {
        var source = $(template_selector).html();
        var template = Handlebars.compile(source);
        if (replace) {
          $parent.html(template(payload));
        } else {
          $parent.append(template(payload));
        }
      } catch (err) {
        console.error('[Variant Selector] Error rendering handlebars template', err);
      }
    }

    /**
     * Render controller, prepares variables and templates for rendering
     * @param {*} options_with_values
     * @param {*} variants
     */
    function _render(options_with_values, variants) {
      _$context.find('noscript').remove();

      // For pre-selection of options when only one variant is available.
      var only_one_variant_available = variants.filter(function (v) {
        return v.available;
      }).length == 1 || false;
      var _iterator3 = _createForOfIteratorHelper(options_with_values),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var option = _step3.value;
          // Do not render the option if:
          // - We are dealing with a single option named "Title"
          // - We have a single value for it named "Default Title"
          // - The product is not an "Oil and Capsule" product
          if (option.values.length == 1 && option.values[0] == "Default Title" && option.name == 'Title' && _tags.indexOf('subcategory--Oils') == -1 && _tags.indexOf('subcategory--Capsules') == -1) {
            continue;
          }

          // add availability to option data
          var option_values = [];
          option.values.forEach(function (value) {
            var option_value = {
              'name': value,
              'available': !!_filter_variants_by_option_values([{
                name: option.name,
                value: value,
                index: option.position - 1
              }]).filter(function (variant) {
                return variant.available;
              }).length,
              'in_store_exclusive': !!_filter_variants_by_option_values([{
                name: option.name,
                value: value,
                index: option.position - 1
              }]).filter(function (variant) {
                return variant.in_store_exclusive;
              }).length
            };
            if (['Weight', 'Pois', 'Poids'].indexOf(option.name) > -1) {
              option_value.variant = variants.filter(function (v) {
                return v.options[option.position - 1] == value;
              })[0];
            }
            option_values.push(option_value);
          });
          option.values = option_values;
          _sort_option_values(option_values);
          var template = _templates.filter(function (template, i) {
            if (template.options) {
              return template.options.indexOf(option.name) > -1;
            } else if (template.tags) {
              return template.tags.some(function (tag) {
                return _tags.some(function (t) {
                  return t.toLowerCase().includes(tag.toLowerCase());
                });
              });
            } else {
              return false;
            }
          })[0];
          var template_selector = template ? template.template : _default_template;

          // Format cannabinoid content
          variants.forEach(function (variant) {
            variant.info = '';
            if (variant.metafields && variant.metafields.variant) {
              // TEMPORARY FIX TO BAD DATA (NPC-360)
              // Skip product types that don't have correct THC and CBD values
              if (_product.tags.indexOf('category--Edibles') < 0 && _product.tags.indexOf('category--Topicals') < 0 && _product.tags.indexOf('category--Vapes') < 0 && _product.tags.indexOf('category--Extracts') < 0) {
                // THC
                if (variant.metafields.variant.thc_mg_min) {
                  var thc_info = "".concat(parseFloat(variant.metafields.variant.thc_mg_min).toFixed(2));
                  if (variant.metafields.variant.thc_mg_max && variant.metafields.variant.thc_mg_min !== variant.metafields.variant.thc_mg_max) {
                    thc_info = "".concat(thc_info, " - ").concat(parseFloat(variant.metafields.variant.thc_mg_max).toFixed(2));
                  }
                  variant.info = "".concat(variant.info, "<p>THC: ").concat(thc_info, " mg</p>");
                }

                // CBD
                if (variant.metafields.variant.cbd_mg_min) {
                  var cbd_info = "".concat(parseFloat(variant.metafields.variant.cbd_mg_min).toFixed(2));
                  if (variant.metafields.variant.cbd_mg_max && variant.metafields.variant.cbd_mg_min !== variant.metafields.variant.cbd_mg_max) {
                    cbd_info = "".concat(cbd_info, " - ").concat(parseFloat(variant.metafields.variant.cbd_mg_max).toFixed(2));
                  }
                  variant.info = "".concat(variant.info, "<p>CBD: ").concat(cbd_info, " mg</p>");
                }
              }

              // Gram equivalency
              if (variant.metafields.variant.gram_equivalency) {
                variant.info = "".concat(variant.info, "<p>").concat(parseFloat(variant.metafields.variant.gram_equivalency).toFixed(2), " ").concat(theme.translations.unit_names.g_cannabis, "</p>");
              }
            }
          });
          var is_tile = _template_liquid === 'collection' ? true : _template_liquid === 'search' ? true : false;
          _render_template(template_selector, _$context.find(_container_selector), {
            variants: variants,
            option: option,
            product: _product,
            product_id: _product_id,
            preselect: only_one_variant_available && _preselect,
            metafields: _product ? _product.metafields : {},
            is_PDP: _template_liquid === 'product' ? true : false,
            is_tile: is_tile,
            data: _data,
            random: theme.random()
          }, is_tile);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      ;
    }

    /**
     * Find a variant by specific option value. Should only be used on
     * variants with a single option
     * @param {*} option_value
     */
    function _find_variant_by_option_value(option_value) {
      return _variants.filter(function (variant) {
        return variant.options.indexOf(option_value) > -1;
      })[0];
    }

    /**
     * Find a variant by its ID.
     * @param {*} variant_id
     */
    function _find_variant_by_id(variant_id) {
      return _variants.filter(function (variant) {
        return variant.id == variant_id;
      })[0];
    }

    /**
     * Find option which contains the given value
     * @param {*} option_value
     */
    function _find_option_with_value(option_value) {
      return _options_with_values.filter(function (option) {
        return option.values.indexOf(option_value) > -1;
      })[0];
    }

    /**
     * Register a handler with event delegation
     * @param {} vent
     * @param {*} selector
     * @param {*} callback
     */
    function _register_handler(vent, selector, callback) {
      $(document).on(vent, selector, callback);
    }

    /**
     * Trigger a given callback method by appending _on to the name
     * @param {} event_name
     * @param {*} payload1
     * @param {*} payload2
     * @param {*} payload3
     */
    function _trigger_callback(name, payload1, payload2, payload3, payload4) {
      if (_callbacks[name]) {
        _callbacks[name].forEach(function (cb) {
          return cb(payload1, payload2, payload3, payload4);
        });
      }
    }

    /**
     * Add a callback to the _callbacks array by name for use later
     * @param {} name
     * @param {*} callback
     */
    function _register_callback(name, callback) {
      _callbacks[name] = _callbacks[name] || [];
      _callbacks[name].push(callback);
    }

    /**
     * Public API
     *
     * Register a function to be called on option selection change
     * @param {*} callback
     */
    this.on_selection_change = function (callback) {
      _register_callback('selection_change', callback);
    };
    _init();
  };
})(jQuery, Handlebars);
(function ($, theme) {
  /**
   * Product Gallery constructor.
   * Can be instantiated on a product page.
   *
   * Dependencies:
   * - jQuery
   *
   * Required parameters:
   * - {selector} A selector wrapper containing product images
   * - {alt} * Optional * Filter images in carousel by value of alt tag stored in [data-alt] on each slide.
   *
   * @param {*} params
   */
  window.ProductGallery = function (params) {
    var _product_images_selector = params.selector,
      _alt = params.alt,
      _slickOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        speed: 300,
        arrows: true,
        prevArrow: "<button type=\"button\" class=\"btn btn--unstyled slick-previous slick-arrow--prev\" aria-label=\"".concat(theme.translations.previous, "\"><span aria-hidden=\"true\" class=\"icon icon--back\"></span></button>"),
        nextArrow: "<button type=\"button\" class=\"btn btn--unstyled slick-next slick-arrow--next\" aria-label=\"".concat(theme.translations.next, "\"><span aria-hidden=\"true\" class=\"icon icon--forward\"></span></button>"),
        focusOnSelect: true,
        swipe: true,
        customPaging: function customPaging(slider, i) {
          return "<button type=\"button\" class=\"sr-only\">".concat(i + 1, "</button>");
        }
      };

    /**
     * On object initialize
     */
    function _init() {
      if (!_alt) {
        $(_product_images_selector).slick(_slickOptions);
        $(_product_images_selector).each(function () {
          if ($(this).hasClass('js-product-carousel')) {
            $(this).addClass('hidden');
          }
        });
        var $sku_images = $('.js-product-carousel:first');
        if ($sku_images.length) {
          $sku_images.removeClass('hidden');
          if ($sku_images.length > 1) {
            $sku_images.get(0).slick.setPostion();
          }
        }
      } else {
        if ($(_product_images_selector).hasClass('slick-initialized')) {
          $(_product_images_selector).slick('slickUnfilter').slick('slickFilter', '[data-alt="' + _alt + '"]');
        } else {
          $(_product_images_selector).slick(_slickOptions).slick('slickFilter', '[data-alt="' + _alt + '"]');
          ;
          ;
        }
      }
    }
    _init();
  };
})(jQuery, window.theme || {});
(function ($, theme) {
  /**
   * Product Safe Use contstructor.
   * Can be instantiated on a product page.
   *
   * Dependencies:
   * - jQuery
   *
   * Required parameters:
   * - {selector} A selector wrapper containing product safe use items
   *
   * @param {*} params
   */
  window.ProductSafeUse = function (params) {
    var _product_safe_use_selector = params.selector,
      _slickOptions = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        speed: 300,
        arrows: true,
        focusOnSelect: false,
        swipe: true,
        touchThreshold: 8,
        prevArrow: '<button type="button" class="slick-previous" aria-label="' + theme.translations.general.pagination.previous + '"><span aria-hidden="true" class="icon icon--back"></span></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.translations.general.pagination.next + '"><span aria-hidden="true" class="icon icon--forward"></span></button>',
        responsive: [{
          breakpoint: theme.bp.sm,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      };

    /**
     * On object initialize
     */
    function _init() {
      $(_product_safe_use_selector).slick(_slickOptions);
    }
    _init();
  };
})(jQuery, window.theme || {});
(function ($, Handlebars, theme) {
  /**
   * Replaces all option references in a collection of variants with those passed in.
   * Must accept Shopify's options_with_values in JSON format
   * @param {*} variants
   * @param {*} original_owv
   * @param {*} alt_owv
   */
  theme.replace_variant_options = function (variants, original_owv, alt_owv) {
    var option_hash = {};
    var translate_fields = ['title', 'public_title', 'option1', 'option2', 'option3', 'options'];
    try {
      // Generate hash of translated values
      original_owv.forEach(function (option, i) {
        option.values.forEach(function (option_value, ii) {
          option_hash[option_value] = alt_owv[i].values[ii];
        });
      });

      // Replace given fields with values from the translation array
      variants.forEach(function (variant) {
        translate_fields.forEach(function (field) {
          if (variant[field]) {
            if (field == 'title' || field == 'public_title') {
              if (variant[field].indexOf(' / ') !== -1) {
                var title_fragments = variant[field].split(' / ').map(function (fragment) {
                  return option_hash[fragment];
                });
                variant[field] = title_fragments.join(' / ') ? title_fragments.join(' / ') : variant[field];
              }
            } else {
              if (variant[field].constructor === Array) {
                variant[field].forEach(function (item, index) {
                  variant[field][index] = option_hash[variant[field][index]] ? option_hash[variant[field][index]] : variant[field][index];
                });
              } else {
                variant[field] = option_hash[variant[field]] ? option_hash[variant[field]] : variant[field];
              }
            }
          }
        });
      });
      return variants;
    } catch (err) {
      console.error('[Multilingual Options] Multilingual product options are undefined or incorrectly formatted');
    }
  };

  /**
   * Determine if a given product is available online
   * @param {*} product
   */
  theme.available_online = function (product) {
    var availability_tags = ['archived', 'hazardous'];
    return product.tags.filter(function (tag) {
      return availability_tags.filter(function (a_tag) {
        return tag == a_tag;
      }).length;
    }).length === 0;
  };

  /**
   * Overwrite default errors for html inputs in a form by locale
   * @param {*} form selector
   */

  theme.overwrite_form_errors = function (formId) {
    $(formId).each(function () {
      $(this).find('input').each(function () {
        $(this).on('invalid', function (event) {
          updateCustomValidity(this);
        });
        $(this).on('input focus', function (event) {
          this.setCustomValidity('');
          updateCustomValidity(this);
        });
      });
    });
    function updateCustomValidity(this_) {
      if (!this_.validity.valid) {
        if (this_.validity.valueMissing) {
          this_.setCustomValidity(theme.translations.general.errors.fill_out_filed);
        } else {
          this_.setCustomValidity(theme.translations.general.errors.pattern_not_match);
        }
      }
    }
  };

  /**
  * Determine if a given product is available in-store exclusive
  * @param {*} product
  */
  theme.in_store_exclusive = function (product) {
    var _product$tags;
    return (product === null || product === void 0 ? void 0 : (_product$tags = product.tags) === null || _product$tags === void 0 ? void 0 : _product$tags.indexOf('availability--in-store')) !== -1;
  };

  /**
   * Determine if a given product quantity is below threshold
   * @param {*} product
   */
  theme.low_stock = function (product) {
    return product.inventory_quantity > 0 && product.inventory_quantity < theme.low_stock_threshold;
  };

  /**
   * Determine if a given product should have a quick add panel
   * @param {*} product
   */
  theme.has_quick_add = function (product) {
    var opts = product.option_names ? product.option_names : product.options;
    var first_opt = opts.length && opts[0].toLowerCase();
    return product.available && theme.available_online(product);
  };

  /**
   * Determine if a product is a base product. Product must have translation metafields set
   * @param {*} product
   */
  theme.is_base_product = function (product) {
    if (product.tags) {
      var lang = product.tags.filter(function (x) {
        return x.indexOf('language') >= 0;
      })[0];
      if (lang) {
        lang = lang.split('--')[1];
        return theme.shop.locale.indexOf(lang) >= 0;
      }
    }
  };

  /**
   * Convert metafield array into hash
   * @param {*} quantities
   */
  theme.parse_unit_quantities = function (quantities) {
    var q = {};
    if (quantities) {
      quantities.forEach(function (b) {
        var arr = b.split(':');
        q[arr[0].trim()] = arr[1].trim();
      });
    }
    return q;
  };

  /**
   * Calculates the haversine distance between point A, and B.
   * @param {number[]} latlngA [lat, lng] point A
   * @param {number[]} latlngB [lat, lng] point B
   * @param {boolean} isMiles If we are using miles, else km.
   */
  theme.haversine_distance = function (latlngA, latlngB, isMiles) {
    var toRad = function toRad(x) {
      return x * Math.PI / 180;
    };
    var R = 6371; // earth's radius in km
    var φ1 = toRad(latlngA[0]);
    var φ2 = toRad(latlngB[0]);
    var Δφ = toRad(latlngB[0] - latlngA[0]);
    var Δλ = toRad(latlngB[1] - latlngA[1]);
    var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    if (isMiles) d /= 1.60934;
    return d;
  };
  $(document).on('click', '[data-add-variant]', function (e) {
    e.preventDefault();
    var payload = {
      id: $(this).data('add-variant')
    };
    var translation_data = $(this).data('translation-data');
    if (translation_data) {
      payload.properties = translation_data;
    }
    theme.cart.add(payload).done(function (response) {
      callback(response);
    }).fail(function (e) {
      alert(e.responseJSON.description);
    });
  });

  // Check User Agent
  if (window.theme.is_native_android) {
    $('html').addClass('is-native-android');
  }

  // Read More Functionality
  $(document).on('click', '.js-read-more', function (e) {
    e.preventDefault();
    var $container = $(this).parent();
    var fullText = $container.data('full-text');
    $container.each(function () {
      var el = $(this);
      el.stop(true, true, false);
      var finish = {
        width: this.style.width,
        height: this.style.height
      };
      var cur = {
        width: el.width() + "px",
        height: el.height() + "px"
      };
      el.html(fullText);
      var next = {
        width: el.width() + "px",
        height: el.height() + "px"
      };
      el.css(cur).animate(next, 200, function () {
        el.css(finish);
      });
    });
  });
  function scrollTo($target) {
    var focusable = 'input:visible, button:visible, textarea:visible, a:visible, [tabindex], :not(.js-tooltip)';
    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.first().offset().top - $('header.nav').outerHeight()
      }, 300);
      $target.first().find(focusable).first().focus();
    }
  }

  // Animated scroll-to functionality
  $(document).on('click', '.js-scroll-to', function (e) {
    e.preventDefault();
    var $target = $($(this).data('target'));
    scrollTo($target);
  });
  $(document).on('keydown', '.js-scroll-to', function (e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      var $target = $($(this).data('target'));
      scrollTo($target);
    }
  });

  /**
   * Render the availability of a given product to its corresponding tile in the $scope
   * @param {array} availabilities
   * @param {$} $scope
   */
  theme.render_tile_store_availability = function (availabilities, $scope) {
    var template = '<span aria-hidden="true" class="icon icon--%%ICON%%"></span><h3 class="h5 notice__heading">%%COPY%%</h3>';
    function parse_template(icon, copy) {
      return template.replace('%%ICON%%', icon).replace('%%COPY%%', copy);
    }
    var data = {
      available: {
        icon: 'tick',
        copy: theme.translations.available_in_stores_text
      },
      unavailable: {
        icon: 'unavailable',
        copy: theme.translations.unavailable_in_stores_text
      },
      in_stock: {
        icon: 'tick',
        copy: theme.translations.in_stock_stores_text
      },
      out_of_stock: {
        icon: 'cross',
        copy: theme.translations.no_stock_stores_text
      }
    };
    if (theme.saved_store.is_set()) {
      data.available.copy = theme.translations.available_in_store_text;
      data.unavailable.copy = theme.translations.unavailable_in_store_text;
      data.in_stock.copy = theme.translations.in_stock_store_text;
      data.out_of_stock.copy = theme.translations.no_stock_store_text;
    }
    availabilities.forEach(function (a) {
      var markup = '';
      if (a.availability) {
        markup = parse_template(data.in_stock.icon, data.in_stock.copy);

        // if(a.in_stock === true) {
        // 	markup = parse_template(data.in_stock.icon, data.in_stock.copy);
        // } else {
        // 	markup = parse_template(data.out_of_stock.icon, data.out_of_stock.copy);
        // }
      } else {
        markup = parse_template(data.unavailable.icon, data.unavailable.copy);
      }
      $scope.find('[data-product-id=' + a.product_id + ']').find('.product-tile__notice--stores').html(markup).removeClass('is-loading');
    });
  };

  /**
   * Scrape dom for product tile IDs
   * @param {$} $scope
   */
  theme.product_ids_from_dom = function ($scope) {
    var product_ids = [];
    $scope.find('[data-product-id]').each(function () {
      var id = $(this).data('product-id');
      if ($.inArray(id, product_ids) === -1) product_ids.push($(this).data('product-id'));
    });
    return product_ids;
  };

  /**
   * Translates given options
   *
   * @param {*} options
   * @param {*} local_options_with_values
   * @param {*} foreign_options_with_values
   */
  theme.translate_options = function (options, local_options_with_values, foreign_options_with_values) {
    if (!foreign_options_with_values) {
      foreign_options_with_values = local_options_with_values;
    }
    if (options && local_options_with_values && foreign_options_with_values) {
      return options.map(function (option) {
        if (option != 'Default Title') {
          var option_index, value_index;
          local_options_with_values.forEach(function (local_option, i) {
            if (local_option.values.indexOf(option) !== -1) {
              option_index = i;
              value_index = local_option.values.indexOf(option);
            }
          });
          var f = foreign_options_with_values[option_index];
          return f ? f.values[value_index] : option;
        }
      }).join(',');
    } else {
      console.error('[Option Translation] Missing options, or foreign options for translation');
    }
  };

  /**
   * Register toMoney for use in handlebars
   */
  Handlebars.registerHelper('money', function (amount, options) {
    var _options$hash;
    options.hash.locale = (_options$hash = options.hash) !== null && _options$hash !== void 0 && _options$hash.overwriteLocale ? options.hash.overwriteLocale : theme.locales.current_locale;
    return theme.utils.toMoney(amount, options.hash);
  });

  /**
   * Register Round to 2dp for use in handlebars
   */
  Handlebars.registerHelper('round', function (amount, options) {
    amount = parseFloat(amount);
    return amount && amount > 0 ? amount.toFixed(2) : 0.0;
  });

  /**
   * Register escape handler
   */
  Handlebars.registerHelper('escape', function (variable) {
    return variable.replace(/(['"])/g, '\\$1');
  });

  // Check if 2 arguments are equal
  Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
    return arg1 == arg2 ? options.fn(this) : options.inverse(this);
  });

  // Check if two arguments are not equal
  Handlebars.registerHelper('ifNotEquals', function (arg1, arg2, options) {
    return arg1 == arg2 ? options.inverse(this) : options.fn(this);
  });

  /**
   * Register if Logical Conditional  handler for handlebar
   * this helper uses Function() refer to documentation here : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function
   * usage {{#ifHelper isAvailable '||' isInStore}}<p>you can buy</p>{{/ifHelper}}
   */
  Handlebars.registerHelper('ifHelper', function (v1, operator, v2, options) {
    var checkCondition = new Function('return ' + v1 + operator + v2)();
    return checkCondition ? options.fn(this) : options.inverse(this);
  });

  /**
   * Register unless Logical Conditional  handler for handlebar
   * this helper uses Function() for js evaluation refer to documentation here : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function
   * usage {{#unlessHelper isAvailable '||' isInStore}}<p>you can buy</p>{{/unlessHelper}}
   */
  Handlebars.registerHelper('unlessHelper', function (v1, operator, v2, options) {
    var checkCondition = new Function('return ' + v1 + operator + v2)();
    return checkCondition ? options.inverse(this) : options.fn(this);
  });

  /**
   * Function accepts any number of arguments.
   * It checks if the first argument passed is not equal to any of the succeeding arguments
   * If it is equal to any of them, we return false. If not, we return true
   * 
   * Useful in cases where we want to show/hide information from a multiple specific collections, products, etc.
   */
  Handlebars.registerHelper('ifNotEqualsOptns', function () {
    var args = [];
    for (var i = 0; i < arguments.length; ++i) args[i] = arguments[i]; // Insert all function arguments in an array for better manipulation

    var options = args.pop(); // Last argument is the handlebars options, so we remove it and store it in a variable
    var currentCollection = args.shift(); // First argument is the one we are evaluating, so we remove it and store it in a variable

    // Check if the argument matches any of the other ones passed. If so, return false
    for (var _i2 = 0; _i2 < args.length; ++_i2) {
      if (currentCollection === args[_i2]) return options.inverse(this);
    }
    return options.fn(this);
  });

  // Change string into float (used for thc/cbd metafields in product-tile.handlebars.liquid)
  Handlebars.registerHelper('parseFloat', function (digits) {
    return parseFloat(digits);
  });

  // THC potency scale on product tile. To change colours of scale, change the stop colors of each linearGradient tag. Each tag is 1/6th of the scale
  Handlebars.registerHelper('thcsvg', function (potency) {
    var simpleUUID = theme.utils.createSimpleUUID();
    var svgLitoral = "<div class=\"svg-div\">";
    if (potency == 'Peu à Minimale') {
      potency = 'Little to Minimal';
    }
    if (potency == 'Très Douce') {
      potency = 'Very Mild';
    }
    if (potency == 'Douce') {
      potency = 'Mild';
    }
    if (potency == 'Moyenne') {
      potency = 'Medium';
    }
    if (potency == 'Forte') {
      potency = 'Strong';
    }
    if (potency == 'Très Forte') {
      potency = 'Very Strong';
    }
    svgLitoral += "<svg width=\"100%\" height=\"100%\" viewBox=\"-10 0 300 300\">\n\t\t<linearGradient id=\"linearColors1-" + simpleUUID + "\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#91c44d\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#8cc63f\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"linearColors2-" + simpleUUID + "\" x1=\"0.5\" y1=\"0\" x2=\"0.5\" y2=\"1\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#8cc63f\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#ebc750\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"linearColors3-" + simpleUUID + "\" x1=\"1\" y1=\"0\" x2=\"0\" y2=\"1\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#ebc750\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#f7d373\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"linearColors4-" + simpleUUID + "\" x1=\"1\" y1=\"1\" x2=\"0\" y2=\"0\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#f7d373\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#e27c2a\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"linearColors5-" + simpleUUID + "\" x1=\"0.5\" y1=\"1\" x2=\"0.5\" y2=\"0\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#e27c2a\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#ab3726\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"linearColors6-" + simpleUUID + "\" x1=\"0\" y1=\"1\" x2=\"1\" y2=\"0\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#ab3726\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#ab3726\"></stop>\n\t\t</linearGradient>\n\t\t<text class=\"scale-text\" x=\"50%\" y=\"45%\" text-anchor=\"middle\" stroke=\"black\" stroke-width=\"2px\" dy=\".3em\">THC</text>";
    switch (potency) {
      case 'Little to Minimal':
        svgLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#linearColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Very Mild':
        svgLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#linearColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#linearColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Mild':
        svgLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#linearColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#linearColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"url(#linearColors3-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Medium':
        svgLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#linearColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#linearColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"url(#linearColors3-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"url(#linearColors4-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Strong':
        svgLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#linearColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#linearColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"url(#linearColors3-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"url(#linearColors4-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"url(#linearColors5-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Very Strong':
        svgLitoral += "<path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#linearColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#linearColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"url(#linearColors3-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"url(#linearColors4-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -120\" fill=\"none\" stroke=\"url(#linearColors5-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"url(#linearColors6-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
    }
    svgLitoral += '</div>';
    return new Handlebars.SafeString(svgLitoral);
  });

  // CBD potency scale on product tile
  Handlebars.registerHelper('cbdsvg', function (potency) {
    var simpleUUID = theme.utils.createSimpleUUID();
    var cbdLitoral = "<div class=\"svg-div\">";
    potency = parseFloat(potency);
    if (potency == 0) {
      potency = 'none';
    }
    if (potency < 2) {
      potency = 'Little to Minimal';
    }
    if (potency >= 2 && potency < 7) {
      potency = 'Very Mild';
    }
    if (potency >= 7 && potency < 12) {
      potency = 'Mild';
    }
    if (potency >= 12 && potency < 17) {
      potency = 'Medium';
    }
    if (potency >= 17 && potency < 22) {
      potency = 'Strong';
    }
    if (potency >= 22) {
      potency = 'Very Strong';
    }
    cbdLitoral += "<svg width=\"100%\" height=\"100%\" viewBox=\"-10 0 300 300\">\n\t\t<linearGradient id=\"cbdColors1-" + simpleUUID + "\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#acebff\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#acebff\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"cbdColors2-" + simpleUUID + "\" x1=\"0.5\" y1=\"0\" x2=\"0.5\" y2=\"1\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#acebff\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#3ecefc\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"cbdColors3-" + simpleUUID + "\" x1=\"1\" y1=\"0\" x2=\"0\" y2=\"1\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#3ecefc\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#3ecefc\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"cbdColors4-" + simpleUUID + "\" x1=\"1\" y1=\"1\" x2=\"0\" y2=\"0\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#3ecefc\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#3ecefc\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"cbdColors5-" + simpleUUID + "\" x1=\"0.5\" y1=\"1\" x2=\"0.5\" y2=\"0\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#3ecefc\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#3ecefc\"></stop>\n\t\t</linearGradient>\n\t\t<linearGradient id=\"cbdColors6-" + simpleUUID + "\" x1=\"0\" y1=\"1\" x2=\"1\" y2=\"0\">\n\t\t\t<stop offset=\"0%\" stop-color=\"#3ecefc\"></stop>\n\t\t\t<stop offset=\"100%\" stop-color=\"#00a99d\"</stop>\n\t\t</linearGradient>\n\t\t<text class=\"scale-text\" x=\"50%\" y=\"45%\" text-anchor=\"middle\" stroke=\"black\" stroke-width=\"2px\" dy=\".3em\">CBD</text>";
    switch (potency) {
      case 'none':
        cbdLitoral += "<path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Little to Minimal':
        cbdLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Very Mild':
        cbdLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#cbdColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Mild':
        cbdLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#cbdColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors3-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Medium':
        cbdLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#cbdColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors3-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"url(#cbdColors4-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Strong':
        cbdLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#cbdColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors3-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"url(#cbdColors4-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -118\" fill=\"none\" stroke=\"url(#cbdColors5-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"#f4f4f4\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
      case 'Very Strong':
        cbdLitoral += " <path d=\"M150 10 a120 120 0 0 1 103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors1-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 70 a120 120 0 0 1 0 120\" fill=\"none\" stroke=\"url(#cbdColors2-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M253.9230 190 a120 120 0 0 1 -103.9230 60\" fill=\"none\" stroke=\"url(#cbdColors3-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M150 250 a120 120 0 0 1 -103.9230 -60\" fill=\"none\" stroke=\"url(#cbdColors4-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 190 a120 120 0 0 1 0 -120\" fill=\"none\" stroke=\"url(#cbdColors5-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 10\" />\n            <path d=\"M46.077 70 a120 120 0 0 1 103.9230 -60\" fill=\"none\" stroke=\"url(#cbdColors6-" + simpleUUID + ")\" stroke-width=\"25\" stroke-dasharray=\"120 \" />\n          </svg>";
        break;
    }
    cbdLitoral += '</div>';
    return new Handlebars.SafeString(cbdLitoral);
  });

  /**
   * Register escape handler
   */
  Handlebars.registerHelper('toUpperCase', function (string) {
    return string.toString().toUpperCase();
  });

  /**
   * Register handleize for use in handlebars
   */
  Handlebars.registerHelper('handleize', function (string) {
    return string.handleize();
  });

  /**
   * Register replace for use in handlebars
   */
  Handlebars.registerHelper('replace', function (string, search_value, new_value) {
    return string.replace(new RegExp(search_value, 'g'), new_value);
  });

  /**
   * Register contains for use in handlebars
   */
  Handlebars.registerHelper('contains', function (needle, haystack, options) {
    needle = Handlebars.escapeExpression(needle);
    haystack = Handlebars.escapeExpression(haystack);
    return haystack.indexOf(needle) > -1 ? options.fn(this) : options.inverse(this);
  });

  /**
   * Register setVar for use in handlebars
   */
  Handlebars.registerHelper("setVar", function (varName, varValue, options) {
    options.data.root[varName] = varValue;
  });

  /**
   * Handle menu click
   */
  $(document).on('click', '.js-toggle-menu, .ternary-menu', function (e) {
    var $chain = $(e.target).parents().addBack();
    if (!$chain.is('.overlay-menu')) {
      $(this).siblings().removeClass('menu--open');
      $(this).toggleClass('menu--open');
    }
  });

  /**
   * Disable Right Click on images
   */
  $(document).on('contextmenu', 'img', function (e) {
    return false;
  });

  /**
   * Replace all literals with their HTML entities
   */
  theme.unescapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '').replace('&amp;', '&').replace('&lt;', '<').replace('&gt;', '>').replace('&quot;', '"').replace('&#039;', "'").replace('&#39;', "'");
  };

  /**
   * A debounce function to be used for analytics
   * TODO: Manage this code after Algolia is gone
   */
  theme.debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };
  theme.sendAnalytics = theme.debounce(function (query, hits) {
    // Google Analytics
    window.ga('set', 'page', '/search?q=' + encodeURIComponent(query));
    window.ga('send', 'pageView');

    // GTM
    var gtmOptions = {
      'event': 'search',
      'Search Query': query
    };
    if (typeof hits !== 'undefined') {
      gtmOptions['Number of Hits'] = hits;
    }
    dataLayer.push(gtmOptions);
  }, 1000);
  theme.unicodeToChar = function (text) {
    return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    });
  };
  theme.random = function () {
    return Math.floor(Math.random() * 1000000 + 10000);
  };
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, Handlebars, theme) {
  if (theme.template.name == 'product') {
    /*********************************************************
     * Methods used to keep track of recently viewed products
     * @Author: Johnny and Danvi
     */
    var recentlyViewed = {
      addProduct: function addProduct(product) {
        var recentlyViewed = localStorage.getItem('recently_viewed');
        var productArray = recentlyViewed != null ? JSON.parse(recentlyViewed).filter(function (p) {
          return p.id != product.id;
        }) : [];
        productArray.unshift(product);
        var stringArray = JSON.stringify(productArray);
        localStorage.setItem('recently_viewed', stringArray);
      },
      getProducts: function getProducts() {
        var recentlyViewed = localStorage.getItem('recently_viewed');
        var productArray = [];
        if (recentlyViewed != null) {
          productArray = JSON.parse(recentlyViewed);
        }
        return productArray;
      },
      initSlider: function initSlider($slider) {
        var productsInView = parseInt($('.recently-viewed').attr("data-prod-num") || 4);

        // Add in carousel classes
        $('.recently-viewed').addClass('product-carousel product-carousel--centered');
        $slider.addClass('product-carousel__products');

        /* Initializes a slick carousel only on mobile screens */
        $slider.on('init', function (event, slick) {
          $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
        }).on('afterChange', function (event, slick) {
          $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
          $('.slick-slide[aria-hidden="false"]').find('a, .product-tile__vendor, .product-tile__price, .product-tile__tax-notice, li').attr('tabindex', 0);

          // Slick custom pagination dots
          var $activeSlide = $slider.find('.slick-dots li.slick-active');
          if (!$activeSlide.find('.slick-dots__page').length) {
            $activeSlide.prevAll().each(function (e, slide) {
              if ($(slide).find('.slick-dots__page').length) {
                $(slide).addClass('slick-active');
                return false;
              }
            });
          }
        }).slick(theme.utils.getDefaultCarousalSettings());
      }
    };
    $.fn.initiateRecentlyViewed = function (productArray, baseProductHandle, numberOfProducts) {
      var current_locale = theme.locales.current_locale;
      var productsViewedLimit = parseInt($('.recently-viewed').attr("data-prod-limit") || productArray.length);
      var count = 0;
      for (var i = 0; i < Math.min(productArray.length, productsViewedLimit); i++) {
        var product = productArray[i];
        if (theme.is_base_product(product)) {
          if (current_locale == 'fr-CA') {
            product.title = product.metafields.translation['fr-CA_title'] || '';
            product.vendor = product.metafields.translation['fr-CA_vendor'] || '';
            product.handle = product.metafields.translation['fr-CA'] || product.handle;
            product.translated_handle = product.metafields.translation['fr-CA'] || product.handle;
          }

          // We prepare the plant type translation for use in JS tile template
          if (product.metafields.product['plant_type']) {
            switch (product.metafields.product['plant_type']) {
              case 'Indica Dominant':
                product.plant_type = theme.translations.indica;
                break;
              case 'Sativa Dominant':
                product.plant_type = theme.translations.sativa;
                break;
              case 'Hybrid':
                product.plant_type = theme.translations.hybrid;
                break;
              case 'Blend':
                product.plant_type = theme.translations.blend;
                break;
              default:
                product.plant_type = theme.translations.blend;
            }
          }
          product.has_thc_content = product.tags.includes('has_thc_content');
          product.has_cbd_content = product.tags.includes('has_cbd_content');
          product.has_thc_cbd_caps = product.metafields.product.thc_cont_per_cap > 0 || product.metafields.product.cbd_cont_per_cap > 0;
          product.has_thc_cbd_vol = product.metafields.product.thc_cont_per_vol > 0 || product.metafields.product.cbd_cont_per_vol > 0;

          // Resize image
          if (product.featured_image) {
            product.featured_image = theme.utils.getSizedImageUrl(product.featured_image, '480x');
            product.image = theme.utils.getSizedImageUrl(product.featured_image, '480x');
          }

          // Create a new product tile
          var tile = theme.tile_factory["new"]({
            product: product,
            show_properties: true,
            show_notices: false,
            show_price: false,
            data: {
              translations: theme.translations,
              random: theme.random()
            },
            images: theme.images,
            cart_has_plant: theme.cart_has_plant,
            is_collection: false
          });
          this.append(tile.html());
          count++;
        }
        ;
      }
      if (productArray.length) {
        recentlyViewed.initSlider($(this));
      }
    };
    $(function () {
      if (recently_viewed_product) {
        var _$$find$;
        recentlyViewed.addProduct(recently_viewed_product);
        var recently_viewed_num = parseInt($('.recently-viewed').data('prod-num'));
        var productArray = recentlyViewed.getProducts();
        $('.recently-viewed .product-grid').initiateRecentlyViewed(productArray, recently_viewed_product.handle, recently_viewed_num - 1);
        var recentlyViewedSection = $('.recently-viewed');
        var suggestedAccessoriesSection = (_$$find$ = $('.product').find('.suggested-accessories')[0]) === null || _$$find$ === void 0 ? void 0 : _$$find$.parentElement;

        // Only show the recently viewed section if it has more products than the currently viewed product.
        // Only show the grey line separation when suggested accessories section sits above recently viewed section
        if (productArray.length) {
          if (recentlyViewedSection.prev()[0] === suggestedAccessoriesSection) {
            $('.recently-viewed').addClass('border');
          } else {
            $('.recently-viewed').addClass('no-border');
          }
          $('.recently-viewed').show();
        }
      }
    });
  }
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, theme) {
  $(function () {
    'use strict';

    $('.product-carousel__products.js-carousel-centered').each(function () {
      var $this = $(this);
      if (!$this.hasClass('slick-initialized')) {
        $this.on('init', function (event, slick) {
          $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
        }).on('afterChange', function (event, slick) {
          $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
          $('.slick-slide[aria-hidden="false"]').find('a, .product-tile__vendor, .product-tile__price, .product-tile__tax-notice, li').attr('tabindex', 0);
        }).slick(window.theme.utils.getDefaultCarousalSettings());
      }
    });
    $('.product-carousel__products:not(.js-carousel-centered)').each(function () {
      var $this = $(this);
      if (!$this.hasClass('slick-initialized')) {
        $this.on('init', function (event, slick) {
          $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
        }).on('afterChange', function (event, slick) {
          $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
          $('.slick-slide[aria-hidden="false"]').find('a, .product-tile__vendor, .product-tile__price, .product-tile__tax-notice, li').attr('tabindex', 0);
        }).slick(window.theme.utils.getDefaultCarousalSettings());
      }
    });
    $('.product-carousel--2__products').each(function () {
      var $this = $(this);
      if (!$this.hasClass('slick-initialized')) {
        $this.on('init', function (event, slick) {
          $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
        }).on('afterChange', function (event, slick) {
          $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
          $('.slick-slide[aria-hidden="false"]').find('a, .product-tile__vendor, .product-tile__price, .product-tile__tax-notice, li').attr('tabindex', 0);
        }).slick(window.theme.utils.getDefaultCarousalSettings());
      }
    });
    $(window).on('resize orientationchange', function () {
      $('.product-carousel__products').each(function () {
        var $this = $(this);
        if ($this.hasClass('slick-initialized')) {
          $this.slick('setPosition').slick('resize');
        }
      });
      $('.product-carousel--2__products').each(function () {
        var $this = $(this);
        if ($this.hasClass('slick-initialized')) {
          $this.slick('setPosition').slick('resize');
        }
      });
    });
  });
})(window.jQuery, window.theme || {});
/* Accessible Tabs Functionality. From
* http://accessibility.athena-ict.com/aria/examples/tabpanel2.shtml
* by Lisa Seeman
*/
(function ($, theme) {
  $(function () {
    // Tabs Functionality
    var focusable = 'input:visible, button:visible, textarea:visible, a:visible';
    $('.tabs').each(function (i, tabs) {
      $(tabs).on('click', 'li[role="tab"]:not(.tab--disabled)', function (e) {
        $(tabs).find('li[role="tab"]').attr('aria-selected', false).removeClass('tab--active'); // deselect all the tabs
        $(this).attr('aria-selected', true).addClass('tab--active'); // select this tab

        var tabContentId = $(this).attr('aria-controls'); // find out what tab panel this tab controls
        $(tabs).find('div[role="tabpanel"]').attr('aria-hidden', true).removeClass('tab__content--active') // hide all the panels
        .find(focusable).attr('tabindex', -1);
        $(tabs).find('#' + tabContentId).attr('aria-hidden', false).addClass('tab__content--active') // show our panel
        .find(focusable).attr('tabindex', 0);
      });
      $(tabs).on('keydown', 'li[role="tab"]:not(.tab--disabled)', function (e) {
        // Pressing Enter on a Focused tab will diplay it
        if (e.which == 13) {
          $(this).click();
        }
        // Using Left Arrow in tabs to go to previous tabs
        if (e.which == 37) {
          if ($(this).prev().length) $(this).prev().focus().click(); // select previous tab
          else $(this).siblings(':last').focus().click(); // select last tab
        }
        // Using Right Arrow in tabs to go to next tabs
        if (e.which == 39) {
          if ($(this).next().length) $(this).next().focus().click(); // select next tab
          else $(this).siblings(':first').focus().click(); // select last tab
        }

        var $tabWrapper = $(this).closest('.tab-list--wrapper');
        $tabWrapper.animate({
          scrollRight: $(this)
        }, 300);
      });
      $(tabs).on('click', 'li[role="tab"]:not(.tab--disabled)', function (e) {
        var $tabWrapper = $(this).closest('.tab-list--wrapper');
        var position = $(this).position().left;
        $tabWrapper.animate({
          scrollLeft: position
        }, 300);
      });
    });
  });
})(jQuery, window.theme = window.theme || {});
(function ($) {
  $(function () {
    /**
     * Handle counter control input
     */
    $(document).on('click', '.counter__increment, .counter__decrement', function (e) {
      e.preventDefault();
      var $root = $(this).closest('.counter');
      var $input = $(this).siblings('input'),
        step = $root.data('step-size'),
        operation = $(this).hasClass('counter__increment') ? step : -step,
        current_val = $input.val(),
        new_val = parseInt(current_val) + operation;
      setCounterValue($input, $root, new_val);
      $input.trigger('change');
    });
    $(document).on('change', '.counter input[type="number"]', function (e) {
      e.preventDefault();
      var $root = $(this).closest('.counter');
      setCounterValue($(this), $root, parseInt($(this).val()), true);
    });
    function setCounterValue($input, $root, value, from_input) {
      var max = parseInt($root.attr('data-max'));
      var min = parseInt($root.attr('data-min'));
      if (value > max) {
        $input.trigger('maxExceeded');
      }
      value = Math.max(min, Math.min(value, max));
      $input.attr('value', value).val(value);
    }
  });
})(jQuery);
(function ($, theme) {
  /**
   * Adds keyboard control to focusable labels.
   * - Simulates a click if the enter key is pressed.
   */

  $(function () {
    $(document).on('keydown', 'label[for]', function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        try {
          $('#' + $(this).attr('for')).click();
        } catch (e) {}
      }
    });

    // Focus on first product tile when user Paginates
    $(document).on('click', '.pagination-wrapper .js-page-link', function (e) {
      e.preventDefault();
      try {
        setTimeout(function () {
          $('.collection__products .product-grid').first().find('.product-tile').first().find('a').first().focus();
        }, 50);
      } catch (e) {}
    });

    // Focus after view all on search flyout
    $(document).on('keydown', '.instant-search__view-all', function (e) {
      // on Key tab
      if ((e.key === 'Tab' || e.keyCode === 9) && !e.shiftKey) {
        e.preventDefault();
        $('.js-search-submit').focus();
      }
    });

    // Select Autocomplete Suggestion accessibility
    $(document).on('keydown', '.aa-suggestion', function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        try {
          $(this).click();
        } catch (e) {}
      }
    });

    // Hide all focusable elements within aria-hidden tabs
    $(function () {
      var focusable = 'input:visible, button:visible, textarea:visible, a:visible';
      $('.tab__content[aria-hidden="true"]').find(focusable).attr('tabindex', -1);
    });
    $(window).on('load', function () {
      $('#UIF-IMG-1404').attr('tabindex', 0);
    });
    $('.js-skip-link').click(function (e) {
      e.preventDefault();
      var target = $(this).attr('href');
      var scrollToTarget = $(target).offset().top;
      var focusable = 'input:visible, button:visible, textarea:visible, a:visible, [tabindex]';
      $('html, body').animate({
        scrollTop: scrollToTarget
      }, {
        done: function done() {
          $(target).find(focusable).first().focus();
        }
      }, 400);
    });
  });
})(jQuery, window.theme = window.theme || {});
(function ($) {
  /**
      * Forces external links to open in a new tab.
      */

  $(function () {
    $('a[href^="http://"], a[href^="https://"]').each(function () {
      // We clean the href's string to find the exact hostname, so we can check for equality
      // Get rid of protocol, pathname, and the "www.".
      var hostname = this.href.split('://')[1].split('/')[0].split('www.');
      hostname = hostname.length == 1 ? hostname[0] : hostname[1];
      if (hostname != location.hostname) {
        $(this).attr('target', '_blank');
      }
    });
  });
})(jQuery);
(function ($, theme) {
  $(function () {
    'use strict';

    var accordionize = '.accordionize';
    var currentWindow = $(window).width();
    $(document).on('keydown', accordionize + ' .icon--plus', function (e) {
      // Open accordion on press 'Enter' or 'ArrowDown'
      if (e.keyCode === 13 || e.keyCode === 40) {
        $(this).closest(accordionize).click();
      }
    });
    $(document).on('click', accordionize + ',.accordionize_trigger', function (e) {
      var _this21 = this;
      if ($(this).hasClass('accordionize_trigger')) {
        $(this).closest(accordionize).trigger('click');
      }
      var $chain = $(e.target).parents().addBack();
      if ($chain.is('.accordionize__content') || $chain.is('.icon--question-mark')) {
        return;
      }
      $(accordionize).removeClass('accordionize--active').find('[aria-hidden]').attr('aria-hidden', true);
      $(accordionize).find('[aria-expanded]').attr('aria-expanded', false);

      // $(accordionize)
      //   .find('[tabindex]')
      //   .attr('tabindex', -1);

      if ($(this).find('.accordionize__content').hasClass('accordion--show')) {
        e.preventDefault();
        $(this).find('.accordionize__content').removeClass('accordion--show');
        if ($(window).width() < theme.bp.md) {
          $(this).find('.accordionize__content.accordionize__content--no-desktop, .accordionize__content.accordionize__content--mega-menu').css('max-height', '0');
        }
        if ($(this).find('.accordionize__content').is('.accordionize__content--both')) {
          $(this).find('.accordionize__content').css('max-height', '0');
        }

        // this timeout should be greater than the CSS transition time which is currently 0.3s
        // more elegant fix is to create transitionend event callbacks
        setTimeout(function () {
          $(_this21).closest("ul").find('.accordionize__content').addClass('is-hidden');
        }, 350);
      } else {
        $(this).addClass('accordionize--active').find('[aria-expanded]').attr('aria-expanded', true);
        $(this).find('[aria-hidden]').attr('aria-hidden', false);

        // $(this)
        //   .find('[tabindex]')
        //   .attr('tabindex', 0);

        $(this).find('.u-bounce').removeClass('u-bounce');
        $('.accordionize__content').removeClass('accordion--show').attr('style', '');

        // this timeout should be greater than the CSS transition time which is currently 0.3s
        // more elegant fix is to create transitionend event callbacks
        setTimeout(function () {
          var currentEl = $(_this21).find('.accordionize__content');
          currentEl.closest('ul').find('.accordionize__content').each(function () {
            if (currentEl && currentEl.length > 0 && this !== currentEl[0]) {
              $(this).addClass('is-hidden');
            }
          });
        }, 350);
        $(this).find('.accordionize__content').removeClass('is-hidden');
        var contentHeight = $(this).find('.accordionize__content > *').outerHeight(true);
        $(this).find('.accordionize__content').addClass('accordion--show').css('max-height', contentHeight);
      }
      $(document).trigger('accordion_change', this);
    });

    // closes the accordions when the width crosses the tablet breakpoint
    window.resetAccordionize = function () {
      var newWidth = $(window).width();
      if (currentWindow <= theme.bp.sm && newWidth > theme.bp.sm) {
        $(accordionize).removeClass('accordionize--active');
        $('.accordionize__content').removeClass('accordion--show').attr('style', '');
      } else if (currentWindow > theme.bp.sm && newWidth <= theme.bp.sm) {
        $(accordionize).removeClass('accordionize--active');
        $('.accordionize__content').removeClass('accordion--show').attr('style', '');
      }
    };
  });
})(jQuery, window.theme = window.theme || {});
(function ($, VariantSelector, theme, Handlebars) {
  var QuickAdd = function QuickAdd($trigger, $tile, product_handle, translated_product_handle, parent_data, data, translation_data) {
    var CONTAINER_SELECTOR = '.product-tile__quick-add';
    var TEMPLATE_SELECTOR = '#product-tile__quick-add';
    var OVERLAY_SELECTOR = ".overlay--quick-add";
    var _$trigger;
    var _$tile;
    var _$container;
    var _product_handle;
    var _translated_product_handle;
    var _rendered;
    var _parent_data;
    var _data;
    var _id;
    var _visible;
    var _fr_product;
    var _base_product;
    var _translation_data; // Needs to be a var for ios read / write only bug

    function _init() {
      _$trigger = $trigger;
      _$tile = $tile;
      _$container = $tile.find(CONTAINER_SELECTOR);
      _product_handle = product_handle;
      _translated_product_handle = translated_product_handle;
      _rendered = false;
      _parent_data = parent_data;
      _translation_data = translation_data;
      _data = data;
      _visible = false;
      _id = _guid();
      _$tile.attr('data-guid', _id);
      _$trigger.on('click', function (e) {
        if ($(this).data('toggle-quick-add')) {
          e.preventDefault();
          var $el = $(this),
            $tile = $el.closest('.product-tile'),
            handle = $el.data('toggle-quick-add'),
            translated_handle = $el.data('translated-product-handle') || handle,
            data = $el.data('tile-data'),
            translation_data = $el.data('translation-data');
          var quick_add = window.quick_add_factory["new"]($el, $tile, handle, translated_handle, data, translation_data);
          quick_add.toggle();
        }
      });
    }
    function _guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
    function _get_product(handle, callback) {
      $.ajax({
        url: '/products/' + handle + '.js',
        success: callback,
        dataType: 'json'
      });
    }
    function _toggle_panel(hide_only) {
      _$container.toggleClass('is-hidden');
      $('body').toggleClass('quick-add--active');
      _$tile.toggleClass('quick-add--active');
      _$tile.closest('.container').toggleClass('quick-add--active');
      _$tile.find(OVERLAY_SELECTOR).toggleClass('show');
      $('.js-cart-accessories, .cart__accessories .accordionize__content').toggleClass('quick-add--active');
      if (hide_only) {
        _$container.addClass('is-hidden');
        $('body').removeClass('quick-add--active');
        $('.js-cart-accessories, .cart__accessories .accordionize__content').removeClass('quick-add--active');
        _$tile.removeClass('quick-add--active');
        _$tile.closest('.container').removeClass('quick-add--active');
        _$tile.find(OVERLAY_SELECTOR).removeClass('show');
      }
    }
    function _render_quick_add(base_product, translated_product) {
      try {
        var source = $(TEMPLATE_SELECTOR).html();
        var template = Handlebars.compile(source);
        _$container.html(template({
          product: translated_product,
          parent_data: _parent_data,
          data: _data
        }));
      } catch (err) {
        console.error('[Quick Add] Error rendering handlebars template', err);
      }
      _render_variant_selector(base_product, translated_product);
    }
    function _on_selection(variants, callback) {
      if (variants.length == 1) {
        var variant = variants[0];
        var fr_options = theme.translate_options(variant.options, _base_product.options, _fr_product.options);
        var _translation_data2 = translation_data || {};
        var payload = {
          id: variant.id
        };
        if (_translation_data2) {
          _translation_data2['_fr-CA_options'] = fr_options;
          payload.properties = _translation_data2;
        }
        theme.cart.add(payload).done(function (response) {
          callback(response);
          openFlyout('#flyout--cart');
        }).fail(function (e) {
          console.error(e.responseJSON.description);
        });
      }
    }
    function _render_variant_selector(base_product, translated_product) {
      var template_settings = [];
      if (base_product.options.length == 1) {
        template_settings.push({
          options: ['Weight', 'Pois', 'Poids', 'Size', 'Taille'],
          selector_type: 'variant',
          template: '#variant-selector--weight'
        }, {
          options: ['Colour', 'Couleur', 'Color'],
          selector_type: 'variant',
          template: '#variant-selector--colour--small'
        });
      } else {
        template_settings.push({
          options: ['Weight', 'Pois', 'Poids', 'Size', 'Taille'],
          selector_type: 'option',
          template: '#option-selector--weight'
        }, {
          options: ['Colour', 'Couleur', 'Color'],
          selector_type: 'option',
          template: '#option-selector--color'
        });
      }
      new VariantSelector({
        callbacks: {
          selection_change: function selection_change(variants, a, b, $el) {
            _on_selection(variants, function () {
              _toggle_panel();
              $el.prop('checked', false);
            });
          }
        },
        scope_selector: '[id*="product_' + base_product.id + '"][data-guid="' + _id + '"]',
        product_id: base_product.id,
        product: base_product,
        variants: base_product.variants,
        tags: base_product.tags,
        options_with_values: translated_product.options,
        container_selector: '.product-tile__variants',
        default_template: '#option-selector--default',
        templates: template_settings,
        $trigger: _$trigger,
        preselect: false,
        data: _parent_data
      });
      _rendered = true;
    }

    /**
     * Public methods
     */
    this.render = function () {
      if (!_rendered) {
        _get_product(_product_handle, function (base_product) {
          _get_product(_translated_product_handle, function (fr_product) {
            _fr_product = fr_product;
            _base_product = base_product;
            if (_product_handle != _translated_product_handle) {
              _get_product(_translated_product_handle, function (option_product) {
                theme.replace_variant_options(base_product.variants, base_product.options, option_product.options);
                _render_quick_add(base_product, option_product);
              });
            } else {
              _render_quick_add(base_product, base_product);
            }
          });
        });
      }
    };
    this.toggle = function () {
      _visible = !_visible;
      _toggle_panel();
    };
    this.close = function () {
      _visible = false;
      _toggle_panel(true);
    };
    this.isVisible = function () {
      return _visible;
    };
    _init();
  };
  var QuickAdds = function QuickAdds(data) {
    var _quick_adds = {};
    var _parent_data;
    function _init() {
      _parent_data = data;
    }

    /**
     * Public methods
     */
    this["new"] = function ($trigger, $tile, product_handle, translated_product_handle, data, translated_data, overwrite) {
      if ($tile, product_handle, translated_product_handle) {
        if (_quick_adds[product_handle] && !overwrite) {
          return _quick_adds[product_handle];
        } else {
          return _quick_adds[product_handle] = new QuickAdd($trigger, $tile, product_handle, translated_product_handle, _parent_data, data, translated_data);
        }
      } else {
        console.error('[Quick Add] Missing required parameter');
      }
    };
    this.getVisible = function () {
      for (var add in _quick_adds) {
        if (_quick_adds.hasOwnProperty(add) && _quick_adds[add].isVisible()) {
          return _quick_adds[add];
        }
      }
    };
    this.closeAll = function () {
      for (var add in _quick_adds) {
        _quick_adds[add].close();
      }
    };
    _init();
  };
  window.QuickAdds = QuickAdds;
})(jQuery, VariantSelector, theme, Handlebars);
(function ($, Handlebars, theme) {
  /**
   * A single product tile instance
   */
  var Tile = function Tile(product, data, images, show_quick_add, show_properties, show_notices, show_store_stock, show_price, purchasing_enabled, cart_has_plant, accessory, custom_ppu, cache, is_collection, aa_id, aa_position) {
    var TEMPLATE_SELECTOR = '#product-tile';
    //Update TEMPLATE_SELECTOR_SLIDE to '#product-tile__slide' for using old selector
    var TEMPLATE_SELECTOR_SLIDE = '#product-tile__recently-viewed';
    var QUICK_ADD_SELECTOR = '#product-tile__quick-add';
    var _html;
    var _product;
    var _show_properties;
    var _show_notices;
    var _show_quick_add;
    var _show_store_stock;
    var _show_price;
    var _purchasing_enabled;
    var _cart_has_plant;
    var _data;
    var _images;
    var _accessory;
    var _custom_ppu;
    var _cache;
    var _is_collection;
    function _init() {
      _product = product;
      _show_properties = show_properties;
      _show_quick_add = show_quick_add;
      _show_notices = show_notices;
      _show_store_stock = show_store_stock;
      _show_price = show_price;
      _purchasing_enabled = purchasing_enabled;
      _cart_has_plant = cart_has_plant;
      _accessory = accessory || false;
      _custom_ppu = custom_ppu || false;
      _cache = cache || true;
      _is_collection = is_collection;
      _data = data;
      _images = images;
      _html = _generate_template(_product, show_properties, _is_collection);
    }

    /**
     * Private methods
     */
    function _generate_template(product, show_properties, is_collection) {
      try {
        var source = is_collection === true ? $(TEMPLATE_SELECTOR).html() : $(TEMPLATE_SELECTOR_SLIDE).html();
        var template = Handlebars.compile(source);
        var available_online = theme.available_online(product);
        var in_store_exclusive = theme.in_store_exclusive(product);
        var low_stock = theme.low_stock(product);
        // Delete if OCS wants to show low stock notice
        var low_stock = false;
        var multi_price_indicator_tile = product.variants_max_price != product.variants_min_price ? theme.translations.multi_price_indicator_tile : '';
        product.cannabinoid_content = product.cannabinoid_content || theme.utils.formatCannabinoids(product);
        product.new_label = theme.translations.product_tile_new_label;
        product.display_price = product.display_price || product.price;
        product.compare_price = product.compare_price || product.compare_at_price * 100;
        var show_discount = product.compare_price > product.display_price ? true : false;
        product.discount_label = theme.translations.product_tile_discount_label;
        product.compare_price = show_discount == true ? product.compare_price : '';
        return template({
          product: product,
          show_properties: show_properties,
          show_quick_add: show_quick_add,
          show_notices: _show_notices,
          show_store_stock: _show_store_stock,
          show_price: _show_price,
          has_online_stock: available_online && product.available,
          available_online: available_online && product.available,
          low_stock: low_stock,
          purchasing_enabled: _purchasing_enabled,
          purchasable: _purchasing_enabled && !_cart_has_plant && available_online && product.available,
          accessory: _accessory,
          custom_ppu: _custom_ppu,
          data: _data,
          images: _images,
          multi_price_indicator_tile: multi_price_indicator_tile,
          aa_id: aa_id,
          aa_position: aa_position,
          in_store_exclusive: in_store_exclusive
        });
      } catch (err) {
        console.error('[Product Tile] Error rendering handlebars template');
        console.error(err);
      }
    }

    /**
     * Public methods
     */
    this.html = function () {
      return _html;
    };
    _init();
  };

  /**
   * Factory responsible for the construction and non-duplication
   * of product tile instances
   */
  var ProductTiles = function ProductTiles(purchasing_enabled) {
    var _tiles = {};
    var _tiles_options = {};

    /**
     * Public methods
     */
    this["new"] = function (options) {
      if (options.product) {
        // Determine if product tile already exists,
        // return it or create a new one
        if (options.cache && _tiles[options.product.id]) {
          return _tiles[options.product.id];
        } else {
          _tiles[options.product.id] = new Tile(options.product, options.data, options.images, options.show_quick_add, options.show_properties, options.show_notices, options.show_store_stock, options.show_price, purchasing_enabled, options.cart_has_plant, options.accessory, options.custom_ppu, options.cache, options.is_collection, options.aa_id, options.aa_position);

          // storing the options object for global access and
          // creating deep copy to protect the original object
          _tiles_options[options.product.id] = jQuery.extend(true, {}, options);
          return _tiles[options.product.id];
        }
      } else {
        console.error('[Product Tile] Missing required parameter');
      }
    };

    /**
     * Public methods
     */
    this.getOptions = function (params) {
      // Determine if product tile already exists,
      // return it or return null (if absent), when specifying cache_only: true
      if (_tiles_options[params.product_id]) {
        return _tiles_options[params.product_id];
      } else {
        console.error('[Product Tile Options] Missing from cache');
        return null;
      }
    };
  };
  window.theme.tile_factory = new ProductTiles(theme.purchasing_enabled);
})(jQuery, Handlebars, theme);
(function ($, theme) {
  $(function () {
    window.InfoBubbles = new InfoBubbles();
    function InfoBubbles() {
      var _this22 = this;
      // holds array of all the infobubbles on the website
      this._infoBubbles = [];
      this.newBubble = function (params) {
        var bubble = new InfoBubble(params);
        _this22._infoBubbles.push(bubble);
      };
      this.reinitializeBubbles = function () {
        _this22._infoBubbles.forEach(function (x) {
          x.reinitialize();
        });
      };
      this.reinitializeOtherBubbles = function (instance) {
        _this22._infoBubbles.filter(function (x) {
          return x.getInstance() !== instance;
        }).forEach(function (x) {
          x.reinitialize();
        });
      };
    }
    function InfoBubble(params) {
      var _$triggerElement,
        _instance,
        shownWithClick = false;
      /* about the trigger element
      - the trigger element is the reference point for the tool tip. it can be the tigger element itself
      or the wrapper. It's for positioning and click events.
      - the tool tip gets inserted next to the _$triggerElement, so the _$triggerElement needs to have an id
      */
      // sets the type of trigger depending on if desktop or mobile
      function adjustTrigger() {
        if ($(window).width() > theme.bp.sm) return 'hover focus';
        return 'click';
      }
      // sets the placement depending on if desktop or mobile
      function adjustPlacement() {
        if ($(window).width() > theme.bp.sm) return params.placementDesktop;
        return params.placementMobile;
      }
      function _init() {
        _$triggerElement = $(params.triggerElement);
        _initInstance();
        _$triggerElement.off('click').on('click', function () {
          window.InfoBubbles.reinitializeOtherBubbles(_instance);
        });
        _$triggerElement.parent().off('click').on('click', '.tooltip__hide', function () {
          window.InfoBubbles.reinitializeBubbles();
        });
      }
      function _initInstance() {
        _$triggerElement = $(params.triggerElement);
        _instance = new Tooltip(_$triggerElement, {
          trigger: adjustTrigger(),
          placement: adjustPlacement(),
          html: true,
          removeOnDestroy: true,
          title: "<h5>".concat(params.header, "</h5><span class=\"tooltip__hide\"><span aria-hidden=\"true\" class=\"icon icon--close-thick\"></span></span><p>").concat(params.details, "</p>"),
          template: '<div class="ocs-tooltip" role="tooltip"><div class="tooltip__arrow"></div><div class="tooltip__inner"></div></div>'
        });
      }
      this.getInstance = function () {
        return _instance;
      };
      this.reinitialize = function () {
        _instance.dispose();
        _init();
      };
      _init();
    }

    // TODO: Refactor this into a InfoBubble manager

    var currentWindow = $(window).width();

    // reinitializes bubbles so they have correct placement and trigger when user resizes the window
    $(window).resize(function () {
      var newWidth = $(window).width();
      if (currentWindow <= theme.bp.sm && newWidth > theme.bp.sm) {
        window.InfoBubbles.reinitializeBubbles();
      } else if (currentWindow > theme.bp.sm && newWidth <= theme.bp.sm) {
        window.InfoBubbles.reinitializeBubbles();
      }
      currentWindow = newWidth;
    });
    window.initizalizeTooltips = function () {
      $('.js-tooltip').each(function () {
        var $this = $(this);
        if ($this.hasClass('is-loaded')) {
          return;
        }
        var tooltip = {
          triggerElement: "#".concat($this.attr('id')),
          header: $this.data('header'),
          details: $this.data('description'),
          placementDesktop: $this.data('placement-desktop') || 'right-start',
          placementMobile: $this.data('placement-mobile') || 'right-start'
        };
        if (tooltip.header && tooltip.details) {
          window.InfoBubbles.newBubble(tooltip);
          $this.addClass('is-loaded');
        }
      });
    };
    window.initizalizeTooltips();

    // Whenever a click happens outside any of the tooltip elements on the page, close them all
    // Except if the element clicked was a tooltip trigger
    $(document).on('click', function (event) {
      if (!($(event.target).hasClass('ocs-tooltip') || $(event.target).closest('.ocs-tooltip').length) && !($(event.target).hasClass('js-tooltip') || $(event.target).closest('.js-tooltip').length)) {
        window.InfoBubbles.reinitializeBubbles();
      }
    });
  });
})(jQuery, window.theme = window.theme || {});
(function ($) {
  $(function () {
    'use strict';

    var $flyoutOverlay = $('#flyout--overlay'),
      $flyouts = $('.flyout'),
      $flyout_cart = $('.flyout--cart');
    var session_key = 'hide_suggestions';
    $(window).on('load resize orientationChange', function () {
      alterCartFlyout();
    });

    // Filter Flyout set content height when accordion changes
    $(document).on('accordion_change', function (e) {
      alterCartFlyout();
    });

    // Close Flyout Event
    $(document).on('click', '.js-close-flyout', function (e) {
      var elementID = $(this).data('closes');
      if ($(e.target).hasClass('js-close-flyout') || $(e.target).hasClass('flyout--cart')) {
        closeFlyout();
      }
      setTimeout(function () {
        $('[data-flyout="' + elementID + '"]').focus();
      }, 200);
    });
    $(document).on('keyup', '.flyout', function (e) {
      if (e.keyCode == 27) {
        closeFlyout();
      }
    });
    $(document).on('keyup', '.js-close-flyout', function (e) {
      e.preventDefault();
      var $chain = $(e.target).parents().addBack();
      if ($chain.is('.flyout.active')) {
        return;
      }
      if (e.keyCode == 13) {
        closeFlyout();
      }
    });
    $(document).on('click', '.flyout--cart .js-close-flyout', function (e) {
      $flyout_cart.addClass('u-user-closed');
      closeFlyout();
    });

    // Open Flyout Event
    $(document).on('click keyup', '[data-flyout]', function (e) {
      if (e.type === 'keyup' && e.keyCode !== 13) {
        return false;
      }
      e.preventDefault();
      var flyoutSelector = $(this).data('flyout');
      if (flyoutSelector == '#flyout--cart') {
        openFlyout(flyoutSelector);
        $(flyoutSelector).addClass('is-loading');
        window.updateCartFlyout().then(function () {
          $(flyoutSelector).removeClass('is-loading');
          //checks what state the accessory flyout was in with the session data)
          window.userSession();
          alterCartFlyout();
        });
      } else {
        openFlyout(flyoutSelector);
      }
    });
    window.alterCartFlyout = function () {
      var $flyoutCartItems = $('#flyout--cart .cart__items'),
        $flyoutCartForm = $('#flyout--cart form'),
        $flyoutCartBottom = $('#flyout--cart .cart__bottom');
      var screenOrientation = $(window).width() > $(window).height() ? 90 : 0;
      var isRelative = screenOrientation == 90 && $(window).width() <= theme.bp.sm;
      if (isRelative) {
        $flyoutCartItems.attr('style', '');
        $flyoutCartForm.addClass('scroll--added');
        $flyoutCartBottom.addClass('non-absolute');
      } else {
        $flyoutCartForm.removeClass('scroll--added');
        $flyoutCartBottom.removeClass('non-absolute');
        setCartItemsHeight();
      }

      // Init slider on cart accessories
      $('.js-cart-accessories .product-carousel__products.js-carousel-centered').each(function () {
        var $this = $(this);
        if ($(window).width() < theme.bp.sm) {
          if (!$this.hasClass('slick-initialized')) {
            $this.on('init', function (event, slick) {
              $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
            }).on('afterChange', function (event, slick) {
              $('.slick-slide[aria-hidden="true"] *').removeAttr('tabindex');
              $('.slick-slide[aria-hidden="false"]').find('a, .product-tile__vendor, .product-tile__price, .product-tile__tax-notice, li').attr('tabindex', 0);
            }).slick(window.theme.utils.getDefaultCarousalSettings({
              speed: 500,
              infinite: false,
              prevArrow: "<button type=\"button\" class=\"btn btn--unstyled btn--prev-accessory\">\n                            <span aria-hidden=\"true\" class=\"icon icon--back\"></span>\n                            <span class=\"sr-only\">".concat(theme.translations.cart.cart_accessories_prev, "</span>\n                          </button>"),
              nextArrow: "<button type=\"button\" class=\"btn btn--unstyled btn--next-accessory\">\n                            <span aria-hidden=\"true\" class=\"icon icon--forward\"></span>\n                            <span class=\"is-hidden\">".concat(theme.translations.cart.cart_accessories_next, "</span>\n                          </button>")
            }));
          }
        } else {
          if ($this.hasClass('slick-initialized')) {
            $this.slick('unslick');
          }
        }
      });
    };

    // Sets the max-height of the cart flyout items section of the cart flyout
    window.setCartItemsHeight = function () {
      // Wait until CSS transition is complete
      setTimeout(function () {
        var $flyoutCartHeader = $('#flyout--cart .cart__header'),
          $flyoutCartBottom = $('#flyout--cart .cart__bottom'),
          $flyoutCartItems = $('#flyout--cart .cart__items');
        var flyoutCartItemsHeight = $flyoutCartHeader.outerHeight() + $flyoutCartBottom.outerHeight();
        $flyoutCartItems.css('max-height', 'calc(100% - ' + flyoutCartItemsHeight + 'px)');
      }, 350);
    };
    if ($(window).width() > theme.bp.sm) {
      $(document).on('click', '.accessory-tab', function () {
        if ($('.accordionize').hasClass('accordionize--active')) {
          sessionStorage.setItem(session_key, true);
        } else {
          sessionStorage.removeItem(session_key);
        }
      });
    }
    // Function that hides or shows the accessory tab depending on the session value
    window.userSession = function () {
      if (sessionStorage) {
        if (sessionStorage.getItem(session_key) || $(window).width() <= theme.bp.md) {
          $('#flyout--cart .accordionize').removeClass('accordionize--active');
          $('#flyout--cart .accordionize .accordionize__content').removeClass('accordion--show');
        } else {
          $('#flyout--cart .accordionize').addClass('accordionize--active');
          $('#flyout--cart .accordionize .accordionize__content').addClass('accordion--show');
        }
      }
    };
    /**
     * Open a flyout
     *
     * @param {string} flyoutSelector - The Flyout Selector to open
     */
    window.openFlyout = function (flyoutSelector) {
      var $flyout = $(flyoutSelector);
      var focusable = "[aria-label], input:visible, button:visible, textarea:visible, a:visible, [tabindex], :not(.js-tooltip)";
      var ariaVisible = '[aria-hidden]:visible';
      window.InfoBubbles.reinitializeBubbles();
      $flyoutOverlay.addClass('active js-close-flyout');
      $flyoutOverlay.append($flyout);
      $flyout.siblings().removeClass('active');
      $flyout.addClass('active');

      // Tell screen-readers that rest of page isn't focusable
      $('#main').attr('role', 'presentation');
      if ($flyout[0].ariaLabel) {
        $flyout.focus();
      } else {
        $flyout.find(focusable).first().focus();
      }
      $flyout.find(ariaVisible).attr('aria-hidden', 'false');
      $flyout.trigger('flyout:open');
      // Used because flyout renders before instant search click event which removes body freeze
      setTimeout(function () {
        $('body, html').addClass('body--freeze');
      }, 100);
    };

    /**
     * Close All site flyouts
     *
     */
    window.closeFlyout = function () {
      var ariaHidden = '[aria-hidden]';
      $flyoutOverlay.removeClass('active js-close-flyout');
      $flyouts.removeClass('active');
      $flyouts.find(ariaHidden).attr('aria-hidden', 'true');
      $('body, html').removeClass('body--freeze');
      $('#main').attr('role', 'main');
    };
  });
})(jQuery);
(function ($, theme) {
  $(function () {
    'use strict';

    var $cartFlyout = $('#flyout--cart'),
      $cartPage = $('#cart__form--fallback'),
      $cartFormFallback = $('#cart__form--fallback');
    var lineItemRemove = '#flyout--cart .cart__item--delete',
      ageConfirmation = '#age_confirm',
      termsConfirmation = '#terms_confirm',
      ageConfirmationFlyout = '#age_confirm--flyout',
      termsConfirmationFlyout = '#terms_confirm--flyout',
      accessoryAdd = '.accessory--add',
      quantitySelect = '.cart__item--edit input',
      fallBackQtySelect = '.cart__quantity__edit--fallback';
    var bounce_key = 'cart_bounce';
    var cart_items_scrollTop = 0;

    /*
     * ============================
     *  METHODS
     * ============================
     */

    // Validates the cart in order to proceed to checkout if all criteria are met
    function validateCart($form) {
      var $cartGramsExceeded = $('#hidden_cart_grams').val();
      return ($form.find(termsConfirmation).is(':checked') || $form.find(termsConfirmationFlyout).is(':checked')) && $cartGramsExceeded <= 0 && !isNaN($cartGramsExceeded) && theme.cart.content.item_count > 0;
    }

    /*
     * ============================
     *  EVENT LISTENERS
     * ============================
     */

    // Empties the cart flyout and appends the latest content
    window.updateCartFlyout = function () {
      return $.get('/cart?view=flyout', function (cart) {
        $cartFlyout.empty().append(cart);
        window.setCartItemsHeight();
        window.InfoBubbles.reinitializeBubbles();
        // This function keeps the accessory flyout in whatever state the user had it in when we update the cart (delete or add something)
        window.userSession();
        $('.flyout--cart .cart__items').scrollTop(cart_items_scrollTop);
        $('.flyout--cart .cart__items').scroll(theme.debounce(function (e) {
          cart_items_scrollTop = $(this).scrollTop();
        }));
        if (sessionStorage) {
          if (sessionStorage.getItem(bounce_key)) {
            $cartFlyout.find('.u-bounce').removeClass('u-bounce');
          } else {
            $('#flyout--cart').off('flyout:open').on('flyout:open', function (e) {
              if ($(window).width() <= theme.bp.md) {
                sessionStorage.setItem(bounce_key, true);
              }
            });
          }
        }
        window.quick_add_factory = window.quick_add_factory || new QuickAdds({
          translations: {
            dismiss_text: '',
            cbd: '',
            thc: '',
            help_text: '',
            view_details_text: '',
            color_help_text: ''
          },
          random: theme.random()
        });
        $cartFlyout.find('[data-toggle-quick-add]').each(function () {
          var $el = $(this),
            $tile = $el.closest('.product-tile'),
            handle = $el.data('toggle-quick-add'),
            translated_handle = $el.data('translated-product-handle') || handle,
            data = $el.data('tile-data'),
            translation_data = $el.data('translation-data');
          var quick_add = window.quick_add_factory["new"]($el, $tile, handle, translated_handle, data, translation_data, true);
          if ($el.hasClass('product-tile__trigger')) {
            quick_add.render();
          }
        });
        $(document).on('click', '.overlay--quick-add', function (e) {
          window.quick_add_factory.closeAll();
        });
      });
    };

    // Empties the cart flyout and appends the latest content
    window.loadCartAlert = function (id) {
      return $.get('/cart?view=dropdown', function (cart) {
        theme.alerts.createAlert({
          title: "<span aria-hidden=\"true\" class=\"icon icon--tick\"></span> ".concat(theme.translations.cart.added_to_bag),
          content: cart,
          classes: 'cart-dropdown',
          item_added: '.added_identifier--' + id,
          duration: 5000,
          stack: false
        });
      }).then(function () {
        $('.cart-dropdown').find('.added_identifer--' + id).show();
      });
    };

    // Empties the cart page and appends the latest content
    window.updateCartPage = function () {
      if ($cartPage.length) {
        return $.get('/cart?view=page', function (cart) {
          $cartPage.empty().append(cart);
          window.InfoBubbles.reinitializeBubbles();
        });
      }
    };
    $(document).on('click keyup', lineItemRemove, function (e) {
      e.preventDefault();
      if (e.type === 'keyup' && e.keyCode !== 13) {
        return false;
      }
      theme.cart.remove($(this).data('variant'));
    });
    $(document).on('click', accessoryAdd, function (e) {
      e.preventDefault();
      theme.cart.add($(this).data('variant'));
    });
    $(document).on('change', quantitySelect, function (e) {
      e.preventDefault();

      // Manually construct the object to pass into theme.cart.update function
      var data = {
        id: $(this).data('variant'),
        quantity: $(this).val() || 1
      };
      theme.cart.update(data);
    });
    $(document).on('maxExceeded', quantitySelect, function () {
      $('body').addClass('showing-maximum body--freeze');
      $('html').addClass('body--freeze');
      $('.js-maximum-exceeded').addClass('is-shown');
      setTimeout(function () {
        $('.js-maximum-exceeded .js-close-maximum').focus();
      }, 200);
    });
    $(document).on('change', ageConfirmation + ',' + termsConfirmation + ',' + ageConfirmationFlyout + ',' + termsConfirmationFlyout, function (e) {
      var $form = $(this).closest('form');
      var $checkout = $form.find('.js-checkout-button');
      theme.utils.showAgeGate();

      // Update ARIA hidden property on any relevant elements in this field's label
      var $ariaHidden = $('[for=' + $(this).attr('id') + '] [aria-hidden]');
      if ($ariaHidden.length) {
        $ariaHidden.attr('aria-hidden', !$(this).prop('checked') + '');
      }
      if (validateCart($form)) {
        theme.cart.updateAttributes({
          va: true
        }, {
          quiet: true
        }).always(function () {
          $checkout.attr('disabled', false);
        });
      } else {
        $checkout.attr('disabled', 'disabled');
      }
    });
    $(document).on('change', fallBackQtySelect, function (e) {
      e.preventDefault();
      $cartFormFallback.submit();
    });
    $(document).on('cart_set', function (e, cart) {
      var $cartCount = $('.js-cart-count');
      if (cart.item_count > 99) {
        $cartCount.addClass('has-three-digits');
      } else {
        $cartCount.removeClass('has-three-digits');
      }
      $cartCount.text(cart.item_count);
      updateCartFlyout();
      updateCartPage();
    });

    /**
     * Prevent it from submitting a form
     */
    $cartFlyout.on('submit', function (e) {
      e.preventDefault();
      return false;
    });

    /**
     * Redirect to initiate checkout process from flyout instead of going to the /cart page
     */
    $(document).on('click touchend', '.js-checkout-button', function (e) {
      window.location.href = '/checkout?locale=' + window.theme.locales.current_locale;
    });

    /**
     * Open flyout on cart additions
     */
    $(document).on('cart_add', function (event, item) {
      loadCartAlert(item.id);
    });

    /**
     * Update the theme.cart_json ojbect with the latest cart state.
     * It is currently not being used, but can be useful in future.
     */
    // $(document).on('cart_fetch', function(event, cart) {
    //   theme.cart_json = cart;
    // });

    /**
     * Handle cart additions and updates
     */
    $(document).on('cart_add cart_update', function (event, item) {
      $.ajax({
        url: '/cart?view=grams'
      }).done(function (r) {
        var response = r.trim().split('|');
        $('.js-current-grams span').html(response[0]);
        $('.gram-widget__price').html(response[1]);
        if (Number(response[0]) > 30) {
          $('.js-current-grams').addClass('max-gram-exceeded');
          $('#grams-tooltip-exceeded--header').removeClass('is-hidden');
        } else {
          $('.js-current-grams').removeClass('max-gram-exceeded');
          $('#grams-tooltip-exceeded--header').addClass('is-hidden');
        }
      });
    });
    $(document).on('click touchend', '.js-suggestions-toggle', function () {
      window.setCartItemsHeight();
    });
    $(window).resize(theme.debounce(function () {
      if ($(window).width() < theme.bp.sm && $('.product-tile--flyout.quick-add--active').length) {
        $('.cart__accessories .accordionize__content.accordion--show').css('max-height', 197).removeClass('u-bounce');
      }
    }, 100));
  });
})(jQuery, window.theme = window.theme || {});
(function ($, theme) {
  var query_params = theme.utils.getURLParams();
  var DEFAULTS = {
    page: 1,
    load_view: 'pages'
  };
  var productFallback = function productFallback() {
    $('.product-grid').css({
      opacity: 1
    });
  };

  // The templates on which to load filters
  var TEMPLATES = ['collection', 'search'];

  /**
   * Filter manager object.
   *
   * @class Filters
   */
  var Filters = /*#__PURE__*/function () {
    /**
     * Creates an instance of Filters.
     *
     * @param {Object[]} filter_list – The list of filter objects to generate.
     * @memberof Filters
     */
    function Filters(filter_list) {
      var _this23 = this;
      _classCallCheck(this, Filters);
      this.elements = {
        container: $('#FilterContent'),
        applied_filters: $('#AppliedFilters'),
        applied_filter_list: $('#AppliedFiltersList'),
        filter_count: $('#FiltersCount'),
        apply: $('#FiltersApply'),
        apply_text: $('#FiltersApply > span:first'),
        apply_icon: $('#FiltersApply > span:last'),
        product_grid: $('#FiltersOutput'),
        form: $('.js-filters'),
        product_count: $('.js-filter-count'),
        sort_options: $('.js-filter-sort'),
        sort_label: $('.js-toggle-button-label'),
        sort_active: $('.js-active-sort'),
        pagination: $('.js-pagination'),
        load_more_prev: $('.js-load-more--prev'),
        load_more_next: $('.js-load-more--next'),
        show_oos_products: $('.js-show-oos-products'),
        show_oos_products_mobile: $('.js-show-oos-products-mobile'),
        show_price_drop_products: $('.js-show-price-drop-products'),
        show_price_drop_products_mobile: $('.js-show-price-drop-products-mobile'),
        active_filters: $('.js-active-filters'),
        window: $(window)
      };

      // Keep track of different info regarding product loading
      this.load_parameters = {
        loading: false,
        append: 'after',
        replace: true,
        first_load: true,
        pages: {}
      };

      // Keep array of the collection's sort options, used for validation purposes
      var sort_orders = [];
      this.elements.sort_options.each(function (i, option) {
        sort_orders.push($(option).val());
      });
      this.list = filter_list;
      if (theme.template.name === 'search') {
        this._sort = 'search_products';
      } else {
        // Set a default sort in case below cases don't match
        this._sort = theme.current_collection.tags.indexOf('category--Vapes') > -1 || theme.current_collection.tags.indexOf('subcategory--Cartridges') > -1 ? 'products_custom_pricing_asc' : 'products_price_per_uom_asc';

        // Switch to relevant sort index when possible
        if (theme.current_object && theme.current_object.sort_by) {
          switch (theme.current_object.sort_by) {
            case 'price-descending':
              this._sort = theme.current_collection.tags.indexOf('category--Vapes') > -1 || theme.current_collection.tags.indexOf('category--Cartridges') > -1 ? 'products_custom_pricing_desc' : 'products_price_per_uom_desc';
              break;
            case 'title-ascending':
              this._sort = 'products_title_asc';
              break;
            case 'title-descending':
              this._sort = 'products_title_desc';
              break;
            case 'manual':
              this._sort = 'products';
              break;
          }
        }
      }

      // Check if sort_by is a key in the query params and sort on load based on that instead
      this.sort_label = 'sort_by';
      var queryParamsExist = query_params[this.sort_label] && query_params[this.sort_label] !== null;

      // Check if the sort_by query param exists and has a valid value
      if (queryParamsExist && sort_orders.includes(query_params[this.sort_label])) {
        this._sort = query_params[this.sort_label];
      }
      this.query = new window.AlgoliaQuery(this._sort);
      this._page = query_params.page || DEFAULTS.page;
      this.load_view = query_params.load_view || (this.isMobile() ? 'load' : DEFAULTS.load_view);
      this.elements.sort_options.each(function (i, option) {
        if ($(option).val() == _this23._sort) {
          $(option).prop('checked', true);
        }
      });

      // Keep track of first and last loaded pages
      this.page_first = this.page;
      this.page_last = this.page;
      this._oos = this.elements.show_oos_products.prop('checked');
      this._oos = this.elements.show_oos_products_mobile.prop('checked');
      this._priceDrop = this.elements.show_price_drop_products.prop('checked');
      this._priceDrop = this.elements.show_price_drop_products_mobile.prop('checked');

      // Assign default values for all queries
      this.query_defaults = {
        distinct: true,
        hitsPerPage: 12,
        page: this.page - 1,
        analytics: true
      };

      // Set the collection or search context on the default options
      this.query_defaults = this.setContext(this.query_defaults);
      this.selected_filters = [];
      // Keeps track of the state after clicking apply
      this.applied_state = [];
      this.user_filtering = false;
      this.results;
      this.first_time_rendering = true;
      this.$unique_banner = $('.js-unique-banner');
      this.smaller_than_1280 = $(window).outerWidth() < 1280 ? true : false;
      this.between_1280_1440 = $(window).outerWidth() >= 1280 && $(window).outerWidth() < 1440 ? true : false;
      this.larger_than_1440 = $(window).outerWidth() >= 1440 ? true : false;
      this.started_mobile = $(window).outerWidth() < 1280;
      this.loaded_products = {};

      // Load filters on the page
      this.load();
      this.bindElements();
      this.bindTogglePanelMobile();
      this.setSort(this._sort);
    }
    _createClass(Filters, [{
      key: "sort",
      get: function get() {
        return this._sort;
      },
      set: function set(sort) {
        this._sort = sort;
        this.clearPageCache();

        // Set the query index
        this.query.index = this._sort;

        // Filter on sort change
        this.filter();
      }
    }, {
      key: "page",
      get: function get() {
        return parseInt(this._page);
      },
      set: function set(page) {
        if (page != this._page && page >= 1 && (!this.results || page <= this.results.nbPages)) {
          this._page = page;

          // Set the first and last loaded pages
          this.page_first = Math.min(this._page, this.page_first);
          this.page_last = Math.max(this._page, this.page_last);
          this.filter();
          if (this.load_view == 'pages') {
            this.scrollTop();
          }
        } else {
          this.load_parameters.loading = false;
        }
      }
    }, {
      key: "load_view",
      get: function get() {
        return this._view;
      }

      /**
       * Tracks Out of Stock toggle
       *
       * @memberof Filters
       */,
      set: function set(view) {
        // Only keep load view on mobile
        if (view == 'load' && !this.isMobile()) {
          view = 'pages';
        }
        this._view = view;
        if (this._view == 'pages') {
          this.load_parameters.append = 'after';
          this.load_parameters.replace = true;
          this.clearPageCache();
          if (this.page_in_view) {
            this._page = this.page_in_view;
          }
        } else if (this._view == 'all' || this._view == 'load') {
          this.load_parameters.replace = false;
        }
        this.apply();
      }
    }, {
      key: "oos",
      get: function get() {
        return this._oos;
      }

      /**
       * Tracks Price Drop toggle
       *
       * @memberof Filters
       */,
      set: function set(oos) {
        if (oos != this._oos) {
          this._oos = oos;
          this.clearPageCache();
          this._page = 1;
          this.filter();
          theme.cart.updateAttributes({
            show_oos_products: oos,
            show_oos_products_mobile: oos
          });
        }
      }
    }, {
      key: "priceDrop",
      get: function get() {
        return this._priceDrop;
      },
      set: function set(priceDrop) {
        if (priceDrop != this._priceDrop) {
          this._priceDrop = priceDrop;
          this.clearPageCache();
          this._page = 1;
          this.filter();
          theme.cart.updateAttributes({
            show_price_drop_products: priceDrop,
            show_price_drop_products_mobile: priceDrop
          });
        }
      }
    }, {
      key: "refreshToggleUIView",
      value: function refreshToggleUIView() {
        this.elements.show_oos_products.prop('checked', this.oos);
        this.elements.show_oos_products_mobile.prop('checked', this.oos);
        this.elements.show_price_drop_products.prop('checked', this.priceDrop);
        this.elements.show_price_drop_products_mobile.prop('checked', this.priceDrop);
      }
    }, {
      key: "isMobile",
      value: function isMobile() {
        return $(window).outerWidth() <= theme.bp.sm;
      }

      /**
       * Adds event listeners on elements.
       *
       * @memberof Filters
       */
    }, {
      key: "bindElements",
      value: function bindElements() {
        var _this24 = this;
        var in_mobile = this.isMobile();
        this.elements.sort_options.on('change', function (e) {
          var _e$target, _e$target$nextElement;
          _this24.sort = e.target.value;
          _this24.setSort(_this24.sort);

          // GTM - Sort Filter
          var sorted_by = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$nextElement = _e$target.nextElementSibling) === null || _e$target$nextElement === void 0 ? void 0 : _e$target$nextElement.innerText;
          $(document).trigger('gtm_sort_filter', {
            sorted_by: sorted_by
          });
        });

        // Out of stock toggle events
        this.elements.show_oos_products.on('change', function (e) {
          _this24.first_time_rendering = true;
          _this24.oos = _this24.elements.show_oos_products.prop('checked');
        });
        this.elements.show_oos_products.on('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            _this24.elements.show_oos_products.click();
          }
        });
        this.elements.show_oos_products_mobile.on('change', function (e) {
          _this24.first_time_rendering = true;
          _this24.oos = _this24.elements.show_oos_products_mobile.prop('checked');
        });
        this.elements.show_oos_products_mobile.on('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            _this24.elements.show_oos_products_mobile.click();
          }
        });

        // Price drop toggle events
        this.elements.show_price_drop_products.on('change', function (e) {
          _this24.first_time_rendering = true;
          _this24.priceDrop = _this24.elements.show_price_drop_products.prop('checked');
        });
        this.elements.show_price_drop_products.on('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            _this24.elements.show_price_drop_products.click();
          }
        });
        this.elements.show_price_drop_products_mobile.on('change', function (e) {
          _this24.first_time_rendering = true;
          _this24.priceDrop = _this24.elements.show_price_drop_products_mobile.prop('checked');
        });
        this.elements.show_price_drop_products_mobile.on('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            _this24.elements.show_price_drop_products_mobile.click();
          }
        });
        this.elements.form.on('submit', function (e) {
          e.preventDefault();
          var filters_changed = _this24.elements.apply.hasClass('selecting');
          if (filters_changed) {
            _this24.load_parameters.loading = true;
            // Reset the page number but don't filter yet
            _this24._page = 1;
            _this24.clearPageCache();

            // Setting the Apply button animations phase-1
            _this24.elements.apply.attr("disabled", true);
            _this24.elements.apply_text.text('');
            _this24.elements.apply_icon.removeClass('icon icon--tick');
            _this24.elements.apply_icon.addClass('spin-loader');
            _this24.filter();

            // Update the number of filters in the filter pill on mobile
            _this24.setActiveFiltersCount();
          }
        });

        // Set a timeout so that on scroll doesn't spam call pushState (Most browsers are limited to 100 pushState/30 seconds)
        var timer = null;
        $(document).on('scroll.pagination', function () {
          if (timer !== null) {
            clearTimeout(timer);
          }
          var _filters = _this24;
          timer = setTimeout(function () {
            if (_filters.load_view == 'all') {
              _filters.loadMore();
            }

            // Update the page and scroll position
            _filters.pushState({
              scroll_only: true
            });
          }, 150);
        });

        // Keep track of the view mode based on the window size
        this.elements.window.on('resize', theme.debounce(function () {
          _this24.first_time_rendering = true;
          // Update the view when switching from desktop to mobile or vice versa and all the resolutions based on the new PLP redesign
          if (in_mobile && !_this24.isMobile() && $(window).outerWidth() < 1280) {
            _this24.smaller_than_1280 = true;
            in_mobile = false;
            _this24.load_view = 'pages';
          } else if (_this24.smaller_than_1280 && !_this24.between_1280_1440 && $(window).outerWidth() >= 1280) {
            _this24.smaller_than_1280 = false;
            _this24.between_1280_1440 = true;
            $('.toggle-button-input--filter:checked').prop('checked', false); // if filter is open, it gets closed to prevent visual bug
            _this24.apply();
          } else if (_this24.between_1280_1440 && !_this24.larger_than_1440 && $(window).outerWidth() >= 1440) {
            _this24.between_1280_1440 = false;
            _this24.larger_than_1440 = true;
            _this24.apply();
          }
          if (_this24.larger_than_1440 && !_this24.between_1280_1440 && $(window).outerWidth() < 1440) {
            _this24.larger_than_1440 = false;
            _this24.between_1280_1440 = true;
            _this24.apply();
          } else if (_this24.between_1280_1440 && !_this24.smaller_than_1280 && $(window).outerWidth() < 1280) {
            _this24.between_1280_1440 = false;
            _this24.smaller_than_1280 = true;
            _this24.apply();
          } else if (_this24.smaller_than_1280 && !in_mobile && _this24.isMobile()) {
            in_mobile = true;
            _this24.load_view = 'load';
          }
          if ($(window).outerWidth() < 1280) {
            $('.toggle-button-label--filter').attr('style', '');
          } else {
            $('.filter__group--list').find('.toggle-button-input--filter:checked').siblings('.toggle-button-label--filter').css('margin-bottom', $('.toggle-button-input--filter:checked').siblings('.filter__options').find('.filter__options-wrapper').outerHeight());
          }
        }, 400));
      }
    }, {
      key: "setSort",
      value: function setSort(sort) {
        var _theme$translations$l, _theme$translations$l2;
        switch (sort) {
          case 'products_custom_pricing_asc':
            sort = '$ - $$$';
            break;
          case 'products_custom_pricing_desc':
            sort = '$$$ - $';
            break;
          case 'products_price_per_uom_asc':
            sort = '$ - $$$';
            break;
          case 'products_price_per_uom_desc':
            sort = '$$$ - $';
            break;
          case 'products_title_asc':
            sort = 'A - Z';
            break;
          case 'products_title_desc':
            sort = 'Z - A';
            break;
          case 'products_thc_content_asc':
            sort = 'THC % - %%%';
            break;
          case 'products_thc_content_desc':
            sort = 'THC %%% - %';
            break;
          case 'products_cbd_content_asc':
            sort = 'CBD % - %%%';
            break;
          case 'products_cbd_content_desc':
            sort = 'CBD %%% - %';
            break;
          case 'search_products':
            sort = 'Relevant';
            break;
          case 'products':
            sort = '';
            break;
          case 'products_custom_status_new_asc':
            sort = (_theme$translations$l = theme.translations.launch_date) === null || _theme$translations$l === void 0 ? void 0 : (_theme$translations$l2 = _theme$translations$l.split(' ')) === null || _theme$translations$l2 === void 0 ? void 0 : _theme$translations$l2[0];
            break;
        }
        sort ? this.elements.sort_label.addClass('toggle-button-label--sort') : this.elements.sort_label.removeClass('toggle-button-label--sort'); // We adjust the padding of the sort label to keep it centered on the filter
        this.elements.sort_active.text(sort);
      }

      /**
       * Empty the list of pages that are already loaded
       * Call this when you need to clear the loaded products from view
       *
       * @memberof Filters
       */
    }, {
      key: "clearPageCache",
      value: function clearPageCache() {
        this.load_parameters.append = 'after';
        this.load_parameters.pages = {};
      }
    }, {
      key: "clearFilters",
      value: function clearFilters() {
        var filters_applied = this.selected_filters.length || this.elements.apply.hasClass('selecting');
        if (filters_applied) {
          this.list.forEach(function (f) {
            return f.clear();
          });
          this.selected_filters = [];
          this.load_parameters.loading = true;
          // Reset the page number but don't filter yet
          this._page = 1;
          this.clearPageCache();
          this.filter();

          // Clear the number of filters in the filter pill on mobile
          this.elements.active_filters.html(' ');
        }
      }

      // Scans all filters and sets add class to active ones (called on page load)
    }, {
      key: "setActiveLabels",
      value: function setActiveLabels() {
        var radios = document.getElementsByClassName('sort--active-filters');
        Array.from(radios).forEach(function (e) {
          var active = e.textContent;
          var label = e.previousElementSibling;
          if (active) {
            label.classList.add('is-active');
          } else {
            label.classList.remove('is-active');
          }
        });
      }

      /**
       * Updates the filter panel based on the selection.
       *
       * @memberof Filters
       */
    }, {
      key: "updatePanel",
      value: function updatePanel() {
        // Update the count
        this.elements.filter_count.html("(".concat(this.results.nbHits, ")"));
      }

      /**
       * Adds the collection/search context to Algolia options.
       *
       * @param {Object} options – The Algolia options to extend.
       * @returns {Object} – The updated options.
       * @memberof Filters
       */
    }, {
      key: "setContext",
      value: function setContext(options) {
        if (theme.template.name == 'collection') {
          // Check if the collection page is currently filtered by tag
          var url_tag_filter = theme.current_object.filters ? theme.current_object.filters.map(function (tag) {
            return "tags:\"".concat(tag, "\"");
          }).join(' AND ') : false;
          options.filters = "".concat(options.filters ? "".concat(options.filters, " AND ") : "").concat(url_tag_filter ? "".concat(url_tag_filter, " AND ") : "", "collections:").concat(theme.current_object.handle);
        } else if (theme.template.name == 'search') {
          options.analytics = true;
          options.clickAnalytics = true;
          options.filters = "".concat(options.filters ? "".concat(options.filters, " AND ") : "", "tags:language--").concat(theme.locales.language_code);
          options.query = theme.current_object.terms;
        }
        return options;
      }

      /**
       * Fetches the facets from Algolia to generate filters.
       *
       * @returns {Promise} – The Algolia promise
       * @memberof Filters
       */
    }, {
      key: "getFacets",
      value: function getFacets() {
        var _this25 = this;
        var options = {
          facets: '*',
          hitsPerPage: 0,
          maxValuesPerFacet: 1000,
          page: 0
        };
        options = this.setContext(options);
        return this.query.run(options).then(function (results) {
          _this25.facets = results.facets;
          return $.when(_this25.facets);
        }, productFallback);
      }

      /**
       * Calculates which product and page the user is currently on.
       * Useful for view all functionality and maintaining scroll position.
       *
       * @memberof Filters
       */
    }, {
      key: "updateInView",
      value: function updateInView() {
        var $tiles = this.elements.product_grid.find('.product-tile');
        if ($tiles.length) {
          var scroll_top = this.elements.window.scrollTop();
          var getPosition = function getPosition($element) {
            return Math.abs($element.position().top + $element.height() / 2 - scroll_top);
          };
          var $closest = $tiles.first();
          var closest_position = getPosition($closest);
          $tiles.each(function () {
            var $this = $(this);
            var position = getPosition($this);
            if (position < closest_position) {
              $closest = $this;
              closest_position = position;
            }
          });
          if (!$closest.is(':last-child')) {
            $closest = $closest.next();
          }
          this.in_view = {
            product: $closest.data('product-id'),
            page: $closest.closest('[data-page]').data('page')
          };
        } else {
          this.in_view = {
            product: null,
            page: null
          };
        }
      }
    }, {
      key: "scrollTop",
      value: function scrollTop() {
        $('html, body').stop().animate({
          scrollTop: this.elements.product_grid.position().top
        }, 1000);
      }
    }, {
      key: "setActiveFiltersCount",
      value: function setActiveFiltersCount() {
        var active_filters_count = 0;
        var radios = document.getElementsByClassName('sort--active-filters');
        Array.from(radios).forEach(function (e) {
          var active = e.textContent;
          if (active) {
            active_filters_count++;
          }
        });
        if (active_filters_count === 0) {
          this.elements.active_filters.html(' ');
        } else {
          this.elements.active_filters.html("(".concat(active_filters_count, ")"));
        }
      }

      /**
       * Updates the query parameters based on the filter selection.
       *
       * @param {Object} settings – Settings for the function
       * @param {boolean} settings.scroll_only – Skip re-indexing the filters and only update the scroll values
       * @memberof Filters
       */
    }, {
      key: "pushState",
      value: function pushState() {
        var _this26 = this;
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.params = settings.scroll_only ? this.params || {} : {};
        this.updateInView();
        var page = this.in_view.page || this.page;
        if (this.in_view.product) {
          this.params.product = this.in_view.product;
        }

        // Add the page number if it's not the default
        if (page != DEFAULTS.page) {
          this.params.page = page;
        } else {
          delete this.params.page;
        }

        // Add the view if it's not the default
        if (this.load_view != DEFAULTS.load_view) {
          this.params.load_view = this.load_view;
        } else {
          delete this.params.load_view;
        }

        // Keep track of the query if it exists
        if (query_params.q) {
          this.params.q = query_params.q;
        } else {
          delete this.params.q;
        }
        if (!settings.scroll_only) {
          // Transform the applied filters into an object
          this.selected_filters.forEach(function (option) {
            var key = option.filter.name;
            _this26.params[key] = _this26.params[key] || [];
            _this26.params[key].push(option.value);
          });

          // Add sort option to params only if this.sort is not empty
          if (this.sort) {
            this.params[this.sort_label] = this.params[this.sort_label] || [];
            this.params[this.sort_label].push(this.sort);
          }
        }
        theme.utils.setURLParams(this.params, {
          clear: true
        });
      }
    }, {
      key: "loadMore",
      value: function loadMore() {
        if (!this.load_parameters.loading) {
          this.updateInView();
          var offset = 400;
          var container = {
            top: this.elements.product_grid.position().top
          };
          container.bottom = container.top + this.elements.product_grid.height();
          var _window = {
            top: this.elements.window.scrollTop()
          };
          _window.bottom = _window.top + this.elements.window.height();

          // Check if user has reached the bottom of the page
          if (_window.bottom > container.bottom - offset) {
            this.load_parameters.loading = true;
            this.load_parameters.append = 'after';
            this.page = this.page + 1;
          }

          // Check if user has reached top of the page
          if (_window.top < container.top + offset) {
            this.load_parameters.loading = true;
            this.load_parameters.append = 'before';
            this.load_parameters.product = theme.utils.getURLParams().product;
            this.page = this.page - 1;
          }
        }
      }
    }, {
      key: "cancel",
      value: function cancel() {
        var _this27 = this;
        this.list.forEach(function (filter) {
          filter.setState(_this27.applied_state);
        });
      }
    }, {
      key: "loadProducts",
      value: function loadProducts(first_time) {
        var _this28 = this;
        if (first_time) {
          var products_shown = 0;
          this.first_time_rendering = false;
        }
        if (this.results.hits.length > 0) {
          var page = this.page;
          var $products = $("<div class=\"filter__page\" data-page=\"".concat(page, "\"></div>"));
          var grouped_products = this.query.groupHits(this.results.hits);
          grouped_products.forEach(function (hit, index) {
            var product = _this28.query.convertHit(hit);
            var isAccessory = product.tags.indexOf('category--Accessories') > -1;
            var showQuickAdd = false;
            if (['dried-flower', 'pre-rolls', 'capsules', 'oils'].indexOf(product.subcategory.handleize()) > -1 || Object.keys(product.options).length == 1 && !isAccessory) {
              showQuickAdd = true;
            }
            var hasCustomPPU = (product.tags.indexOf('category--Vapes') > -1 || product.tags.indexOf('subcategory--Cartridges') > -1) && showQuickAdd;
            var tile = theme.tile_factory["new"]({
              accessory: isAccessory,
              cart_has_plant: theme.cart_has_plant,
              custom_ppu: hasCustomPPU,
              data: {
                translations: theme.translations
              },
              images: theme.images,
              is_collection: true,
              product: product,
              show_notices: true,
              show_properties: true,
              show_quick_add: showQuickAdd,
              aa_id: hit.objectID,
              aa_position: index + 1
            });
            var $tile = $(tile.html());
            delete _this28.loaded_products[product.handle];
            if (_this28.between_1280_1440 && !_this28.isMobile()) {
              if (products_shown >= 6 && _this28.$unique_banner.length) {
                $tile.addClass('after-banner');
              }
            } else {
              if (products_shown >= 8 && _this28.$unique_banner.length) {
                $tile.addClass('after-banner');
              }
            }
            $tile.addClass('is-loading').appendTo($products);
            products_shown++;
            if (_this28.between_1280_1440 && !_this28.isMobile()) {
              if (products_shown == 6) {
                $products.append(_this28.$unique_banner);
              }
            } else {
              if (products_shown == 8) {
                $products.append(_this28.$unique_banner);
              }
            }
            if (showQuickAdd && !_this28.loaded_products[product.handle] && !theme.in_store_exclusive(product)) {
              _this28.loaded_products[product.handle] = new theme.CollectionQuickAdd($tile.get(0), product.handle);
            }

            // Animate the product load
            setTimeout(function () {
              $tile.removeClass('is-loading');
            }, (_this28.load_parameters.append == 'before' ? grouped_products.length - index : index) * 100); // Reverse output order if adding above
          });

          if (this.between_1280_1440) {
            if (grouped_products.length % 3 == 2) {
              $products.append(this.generateHelper(1));
            } else if (grouped_products.length % 3 == 1) {
              $products.append(this.generateHelper(2));
            }
          } else if (this.larger_than_1440) {
            if (grouped_products.length % 4 == 3) {
              $products.append(this.generateHelper(1));
            } else if (grouped_products.length % 4 == 2) {
              $products.append(this.generateHelper(2));
            } else if (grouped_products.length % 4 == 1) {
              $products.append(this.generateHelper(3));
            }
          }
          if (this.load_parameters.replace || this.load_parameters.first_load || Object.keys(this.load_parameters.pages).length == 0 || this.user_filtering) {
            this.elements.product_grid.empty();
            this.user_filtering = false;
          }

          // Replace section after the container has been emptied
          var $existing_section = $(".filter__page[data-page=\"".concat(page, "\"]"));

          // If the page exists for one reason or another, replace it
          if ($existing_section.length) {
            if (this.load_parameters.pages[page]) {
              return;
            }
            $existing_section.replaceWith($products);
          } else if (this.load_parameters.append == 'before') {
            this.elements.product_grid.prepend($products);
          } else {
            this.elements.product_grid.append($products);
          }

          // Scroll to the product on first load or add above
          if (this.load_parameters.first_load && query_params.product) {
            var $tile = $(".product-tile[data-product-id=\"".concat(query_params.product, "\"]"));
            if ($tile.length) {
              // Give the animation some time to finish before scrolling
              setTimeout(function () {
                $(document).scrollTop($tile.position().top);
              }, 500);
            }
          } else if (this.load_parameters.append == 'before') {
            var _$tile2 = $(".product-tile[data-product-id=\"".concat(this.load_parameters.product, "\"]"));
            if (_$tile2.length) {
              $(document).scrollTop(_$tile2.position().top);
            }
          }

          // Show the product grid
          this.elements.product_grid.css({
            opacity: 1
          });

          // Keep track of the loaded pages for view all
          if (this._view == 'all' || this._view == 'load') {
            this.load_parameters.pages[page] = true;
          }
          if (window.aa && theme.template.name == 'search') {
            this.elements.product_grid.find('[data-aa-id]').off('click.aa').on('click.aa', function (event) {
              event.preventDefault();
              var $link = $(event.currentTarget);
              window.aa('clickedObjectIDs', {
                eventName: 'CLICK_HIT',
                eventType: 'click',
                index: _this28.query.index.indexName || '',
                objectIDs: [new String($link.data('aa-id'))],
                positions: [$link.data('aa-position')],
                queryID: _this28.queryID || ''
              });
              window.location.href = "".concat($link.closest('a').attr('href'), "?index=").concat(_this28.query.index.indexName, "&objectIDs=").concat($link.data('aa-id'), "&queryID=").concat(_this28.queryID);
            });
          }

          // Keep track of the first load to replace the default products
          this.load_parameters.first_load = false;
        } else {
          this.no_products_div = $("\n          <div class=\"collection__products--empty\">\n            <p>\n              ".concat(theme.translations.no_products, "\n            </p>\n          </div>\n        "));
          this.elements.product_grid.html(this.no_products_div);
          if (!this.oos || this.priceDrop) {
            var broadenSearch = {
              createButton: function createButton() {
                return $('<button/>').text("".concat(theme.translations.broaden_search)).addClass('btn btn--primary btn--outline').click(function () {
                  _this28.broadenSearch();
                });
              },
              callBroadenSearch: function callBroadenSearch() {
                _this28.broadenSearch();
              },
              appendButtonToElement: function appendButtonToElement(element) {
                var button = broadenSearch.createButton();
                element.append(button);
              }
            };
            broadenSearch.appendButtonToElement(this.no_products_div);
          }
          this.elements.product_grid.animate({
            opacity: 1
          }, 300);
        }
        $(document).trigger('Filters:loaded', this);

        // Give the animation some time to finish before unlocking loading
        setTimeout(function () {
          _this28.load_parameters.loading = false;
          _this28.elements.apply.removeClass('selecting');
          _this28.elements.apply.removeClass('is-active');

          // Setting the Apply button animations phase-2
          if (_this28.elements.apply_icon.hasClass('spin-loader')) {
            _this28.elements.apply_icon.removeClass('spin-loader');
            _this28.elements.apply_text.text(theme.translations.filters.general.applied);
            _this28.elements.apply_icon.addClass('icon icon--tick');
          }
        }, 300);

        // Reverting the Apply button to default state
        setTimeout(function () {
          _this28.elements.apply_icon.removeClass('icon icon--tick');
          _this28.elements.apply_icon.removeClass('spin-loader');
          _this28.elements.apply_text.text(theme.translations.filters.general.apply);
          _this28.elements.apply.removeAttr('disabled');
        }, 1000);
      }

      // Generates helper elements based on integer passed
    }, {
      key: "generateHelper",
      value: function generateHelper(_int) {
        var helpers = '';
        for (var i = 0; i < _int; i++) {
          helpers += '<span class="product-tile product-tile--helper"></span>';
        }
        return helpers;
      }

      /**
       * Applies selected filters to the product grid.
       * Set this.reset_grid to true to re-write the product grid.
       *
       * @memberof Filters
       */
    }, {
      key: "apply",
      value: function apply() {
        var _this29 = this;
        // Empty the pre-applied filter queue
        this.applied_state = this.selected_filters;
        if (!this.results) {
          this.load_parameters.loading = false;
          return;
        }

        // If we're replacing the content, don't animate
        if (this.load_parameters.replace) {
          this.elements.product_grid.animate({
            opacity: 0
          }, 300, function () {
            _this29.loadProducts(_this29.first_time_rendering);
          });
        } else {
          this.loadProducts(this.first_time_rendering);
        }

        // Update the product count
        this.elements.product_count.html(this.results.nbHits);

        // Set the query parameters
        this.pushState();

        // Render the pagination
        this.renderPagination();
      }

      /**
       * Generates the query and gets results from Algolia.
       *
       * @returns {Promise} – The Algolia promise
       * @memberof Filters
       */
    }, {
      key: "update",
      value: function update() {
        var _this30 = this;
        var options = $.extend({}, this.query_defaults);
        var query_string = '';
        var query = this.list.map(function (filter) {
          return filter.query();
        }).filter(function (query) {
          return query;
        });

        // Set the page number (Algolia index starts at 0)
        options.page = this.page - 1;

        // Flatten the array of applied filters across all sections
        this.selected_filters = this.list.reduce(function (acc, filter) {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(filter.applied_options));
        }, []);

        // Add the inventory parameter
        if (!this.oos) {
          query.push('variants_inventory_count > 0');
          query.push('inventory_quantity > 0');
        }

        // Query all the price drop products
        if (this.priceDrop) {
          query.push('compare_at_price > 0');
        }
        if (query.length) {
          query_string = query.join(' AND ');
          options.filters = "".concat(options.filters ? "".concat(options.filters, " AND ") : "").concat(query_string);
        }
        return this.query.run(options).then(function (results) {
          window.aa_info = {
            queryID: results.queryID,
            index: _this30.query.index.indexName
          };
          _this30.queryID = results.queryID;
          _this30.results = results;
          _this30.updatePanel();
        }, productFallback);
      }

      /**
       * Updates the query and applies the filters.
       *
       * @memberof Filters
       */
    }, {
      key: "filter",
      value: function filter() {
        var _this31 = this;
        this.update().then(function () {
          _this31.apply();
          if (_this31.load_view === 'all') {
            _this31.load_parameters.loading = false;
          }
        });
      }

      /**
       * Toggles additional filers (> 4).
       *
       * @memberof Filters
       */
    }, {
      key: "toggleMore",
      value: function toggleMore() {
        this.expanded = !this.expanded;
        if (this.expanded) {
          $('.filters__load-more').addClass('is-visible');
          this.elements.toggle_more_text.text(theme.translations.filters.show.less);
        } else {
          $('.filters__load-more').removeClass('is-visible');
          this.elements.toggle_more_text.text(theme.translations.filters.show.more);
        }
        this.elements.toggle_plus.toggleClass('hide-it');
        this.elements.toggle_minus.toggleClass('hide-it');
      }

      /**
      * Broaden search
      *
      * @memberof Filters
      */
    }, {
      key: "broadenSearch",
      value: function broadenSearch() {
        if (!this.oos) {
          this.oos = true;
        }
        if (this.priceDrop) {
          this.priceDrop = false;
        }
        this.refreshToggleUIView();
      }

      /* To-do: done quickly so integrate better with class */
    }, {
      key: "bindTogglePanelMobile",
      value: function bindTogglePanelMobile() {
        if ($(window).width() <= theme.bp.md) {
          var $toggle = $('.js-filters-toggle:visible');
          var $panel = $('.filters');
          $toggle.attr('ARIA-hidden', 'false');
          $panel.attr('ARIA-hidden', 'true');
          $toggle.on('click', function () {
            if (!$panel.hasClass('filters-open')) {
              $panel.addClass('filters-open');
              $panel.attr('ARIA-hidden', 'false');
            } else {
              $panel.removeClass('filters-open');
              $panel.attr('ARIA-hidden', 'true');
            }
          });
        }
      }

      /**
       * Generates the DOM for filters.
       *
       * @returns {jQuery element} - The filter DOM
       * @memberof Filters
       */
    }, {
      key: "renderPanel",
      value: function renderPanel() {
        var _this32 = this;
        var $element = $('<div></div>');
        this.elements.additional_filters = $('<div class="filters__load-more"></div>');
        var filter_counter = 0;
        this.list.forEach(function (filter, index) {
          var $filter = filter.render();
          if (filter_counter == 4) {
            _this32.elements.desktop_toggle_more = $("\n            <button class=\"filter__toggle-more filter__toggle-more--desktop js-toggle-more\" type=\"button\">\n              <span class=\"filter__toggle-text js-toggle-more-text\">".concat(theme.translations.filters.show.more, "</span>\n              <span aria-hidden=\"true\" class=\"toggle-button__plus js-toggle-plus\">\n                <svg class=\"plus_svg\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n                  <g fill-rule=\"evenodd\">\n                    <path d=\"M0 6.072H13.196V7.478H0z\" transform=\"translate(.66 .119)\" />\n                    <path d=\"M0.206 6.05L12.99 6.05 12.99 7.501 0.206 7.501z\" transform=\"translate(.66 .119) rotate(90 6.598 6.776)\" />\n                  </g>\n                </svg>\n              </span>\n              <span aria-hidden=\"true\" class=\"toggle-button__minus icon--subtract js-toggle-minus hide-it\"></span>\n            </button>\n          ")).appendTo($('.filter__filters-list'));
          }
          if (!filter.hidden) {
            if (filter_counter >= 4) {
              _this32.elements.additional_filters.append($filter);
              filter_counter++;
            } else {
              $('.filter__filters-list').append($filter);
              filter_counter++;
            }
            $filter.off('Filter:update').on('Filter:update', function () {
              _this32.elements.apply.addClass('is-active');
              _this32.elements.apply.addClass('selecting');
            });
          }
          if (index == _this32.list.length - 1) {
            $('.filter__filters-list').append(_this32.elements.additional_filters);
            _this32.elements.mobile_toggle_more = $("\n            <button class=\"filter__toggle-more filter__toggle-more--mobile js-toggle-more\" type=\"button\">\n              <span class=\"filter__toggle-text js-toggle-more-text\">".concat(theme.translations.filters.show.more, "</span>\n              <span aria-hidden=\"true\" class=\"toggle-button__plus js-toggle-plus\">\n                <svg class=\"plus_svg\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n                  <g fill-rule=\"evenodd\">\n                    <path d=\"M0 6.072H13.196V7.478H0z\" transform=\"translate(.66 .119)\" />\n                    <path d=\"M0.206 6.05L12.99 6.05 12.99 7.501 0.206 7.501z\" transform=\"translate(.66 .119) rotate(90 6.598 6.776)\" />\n                  </g>\n                </svg>\n              </span>\n              <span aria-hidden=\"true\" class=\"toggle-button__minus icon--subtract js-toggle-minus hide-it\"></span>\n            </button>\n          "));
            _this32.elements.mobile_filters_nav = $("\n            <div class=\"collection__nav--clear collection__nav--clear--mobile\">\n              <button class=\"btn btn--unstyled btn--clear-filters js-clear-filters\" type=\"button\" data-filter=\"clear-filters\">".concat(theme.translations.filters.clear.all, "</button>\n              ").concat(_this32.elements.mobile_toggle_more[0].outerHTML, "\n            </div>\n          ")).appendTo($('.filter__filters-list'));

            // Re-setting these 4 elements after mobile button is rendered
            _this32.elements.toggle_more = $('.js-toggle-more');
            _this32.elements.toggle_more_text = $('.js-toggle-more-text');
            _this32.elements.toggle_plus = $('.js-toggle-plus');
            _this32.elements.toggle_minus = $('.js-toggle-minus');
            _this32.elements.clear = $('.js-clear-filters');
            _this32.expanded = false;
            _this32.elements.toggle_more.on('click', function () {
              _this32.toggleMore();
            });
            _this32.elements.clear.on('click keyup', function (e) {
              /* 'Enter' and 'Spacebar' */
              if (e.type === 'click' || e.type === 'keyup' && (e.keyCode === 13 || e.keyCode === 32)) {
                // Clear Filters
                _this32.clearFilters();
              }
            });
          }
        });
        return $element.children();
      }
    }, {
      key: "renderPagination",
      value: function renderPagination() {
        var _this33 = this;
        var min = 1;
        var max = this.results.nbPages;
        var $pagination_container = $("<div class=\"pagination-wrapper\"></div>");
        this.elements.load_more_prev.empty();
        this.elements.load_more_next.empty();

        // Don't display pagination for one page
        if (max == 1) {
          this.elements.pagination.empty();
          return;
        }
        var $pagination_desktop = $("<nav class=\"pagination--desktop hidden-mobile\"></nav>").appendTo($pagination_container);
        if (this.load_view == 'all') {
          $("<a href=\"?load_view=pages\" class=\"pagination__view-all\">".concat(theme.translations.pagination.view_per_page, "</a>")).on('click', function (e) {
            e.preventDefault();
            _this33.load_view = 'pages';
            _this33.scrollTop();
            _this33.first_time_rendering = true;
          }).prependTo($pagination_desktop);
        } else if (this.load_view == 'load') {
          // Previous
          if (this.page_first > min) {
            $("<a href=\"?page=".concat(this.page - 1, "\" class=\"btn btn--outline pagination__previous hidden-desktop\">").concat(theme.translations.pagination.load_more, "</a>")).on('click', function (e) {
              e.preventDefault();
              _this33.load_parameters.append = 'before';
              _this33.load_parameters.product = theme.utils.getURLParams().product;
              _this33.page = _this33.page_first - 1;
              _this33.first_time_rendering = true;
            }).appendTo(this.elements.load_more_prev);
          }

          // Next
          if (this.page_last < max) {
            $("<a href=\"?page=".concat(this.page + 1, "\" class=\"btn btn--outline pagination__next hidden-desktop\">").concat(theme.translations.pagination.load_more, "</a>")).on('click', function (e) {
              e.preventDefault();
              _this33.load_parameters.append = 'after';
              _this33.page = _this33.page_last + 1;
              _this33.first_time_rendering = true;
            }).appendTo(this.elements.load_more_next);
          }
        } else {
          var prev_min = Math.max(min, this.page - 2);
          var next_max = Math.min(max, this.page + 2);
          var $pagination = $("<ul class=\"pagination\"></ul>").appendTo($pagination_desktop);
          var renderPage = function renderPage(page) {
            if (page == _this33.page) {
              $("<li class=\"active\"><span>".concat(page, "</span></li>")).appendTo($pagination);
            } else if (page) {
              $("<li><a href=\"?page=".concat(page, "\">").concat(page, "</a></li>")).on('click', 'a', function (e) {
                e.preventDefault();
                _this33.page = page;
                _this33.first_time_rendering = true;
              }).appendTo($pagination);
            } else {
              // Render ellipsis
              $("<li><span>&#8230;</span></li>").appendTo($pagination);
            }
          };

          // View all
          $("<a href=\"?load_view=all\" class=\"pagination__view-all\">".concat(theme.translations.pagination.view_all, "</a>")).on('click', function (e) {
            e.preventDefault();
            _this33.load_parameters.loading = false;
            _this33.load_view = 'all';
          }).prependTo($pagination_desktop);

          // Previous button
          if (this.page > min) {
            $("<li class=\"pagination_previous\">\n              <a href=\"?page=".concat(this.page - 1, "\">\n                <span class=\"icon icon--chevron-thick-left\" title=\"").concat(theme.translations.previous, "\"></span> ").concat(theme.translations.pagination.previous, "\n              </a>\n            </li>")).on('click', 'a', function (e) {
              e.preventDefault();
              _this33.page -= 1;
              _this33.first_time_rendering = true;
            }).appendTo($pagination);
          }

          // First page
          if (prev_min > min) {
            renderPage(min);
            if (prev_min > min + 1) {
              renderPage();
            }
          }

          // Pages
          for (var page = prev_min; page <= next_max; page++) {
            renderPage(page);
          }

          // Last page
          if (next_max < max) {
            if (next_max < max - 1) {
              renderPage();
            }
            renderPage(max);
          }

          // Next button
          if (this.page < max) {
            $("<li class=\"pagination_next\">\n              <a href=\"?page=".concat(this.page + 1, "\">\n                ").concat(theme.translations.pagination.next, " <span class=\"icon icon--chevron-thick-right\" title=\"").concat(theme.translations.next, "\"></span>\n              </a>\n            </li>")).on('click', 'a', function (e) {
              e.preventDefault();
              _this33.page += 1;
              _this33.first_time_rendering = true;
            }).appendTo($pagination);
          }
        }
        this.elements.pagination.empty().append($pagination_container.children());
      }

      /**
       * Retrieves facets to build the filters and load them.
       *
       * @memberof Filters
       */
    }, {
      key: "load",
      value: function load() {
        var _this34 = this;
        this.getFacets().then(function () {
          if ($.isEmptyObject(_this34.facets)) {
            _this34.list = [];
          } else {
            // Generate an array of filter objects
            _this34.list = _this34.list.filter(function (filter) {
              // Build the facets for this filter at the same time
              filter.options = [];

              // Facets with values are treated differently
              if (filter.facet.value.length) {
                filter.facet.value.forEach(function (value) {
                  if (filter.facet.type == 'tags') {
                    Object.keys(_this34.facets.tags || {}).forEach(function (tag) {
                      if (filter.absolute && value == tag) {
                        filter.options.push(value);
                        return;
                      }

                      // Check if there are tags that start with the tag value
                      var regex = new RegExp("^".concat(value, "(.+)"), 'g');
                      var match = regex.exec(tag);
                      if (match && match[1]) {
                        var tag_name = match[1];

                        // By some Algolia black magic, tags keep their accents?
                        // So we clean them out if the user is browsing in English
                        // Algolia ignores accents anyways ¯\_(ツ)_/¯
                        if (theme.locales.language_code == 'en') {
                          tag_name = tag_name.noAccents();
                        }
                        filter.options.push(tag_name);
                      }
                    });
                  } else {
                    // Build the Algolia facet key and check if there are any facets
                    var facet = _this34.facets["".concat(filter.facet.type, ".").concat(value)];
                    if (facet) {
                      // Since there can be multiple values, using the spread operator to flatten to a single array
                      filter.options = [].concat(_toConsumableArray(filter.options), _toConsumableArray(Object.keys(facet)));
                    }
                  }
                });
              } else {
                var facet = _this34.facets["".concat(filter.facet.type)];
                if (facet) {
                  filter.options = [].concat(_toConsumableArray(filter.options), _toConsumableArray(Object.keys(facet)));
                }
              }

              // Get a list of unique values only for filters with multiple values to look up
              filter.options = filter.options.filter(function (option, index, seen) {
                return seen.indexOf(option) === index;
              });

              // Sort range-type filters to be able to compare range of values in next step
              var sorted_options;
              filter.type == 'range' ? sorted_options = filter.options.sort(function (a, b) {
                return parseInt(a) - parseInt(b);
              }) : '';

              // Filter out any filters with no values or 1 value for range-type
              return filter.type == 'range' && sorted_options.length > 1 && Math.floor(sorted_options[0]) < Math.ceil(sorted_options[sorted_options.length - 1]) || filter.type != 'range' && filter.options.length;
            }).map(function (filter) {
              switch (filter.type) {
                case 'range':
                  return new window.filter.Range(filter);
                case 'list':
                  return new window.filter.List(filter);
                case 'items':
                  return new window.filter.Items(filter, {
                    size: filter.size
                  });
              }
            });
            _this34.renderPanel();
          }

          // Filter on load
          _this34.filter();

          // Scan all filters on page and set selected ones to active
          _this34.setActiveLabels();

          // Initialize any tooltips on the panel
          if (window.initizalizeTooltips) {
            window.initizalizeTooltips();
          }

          // Make sure OOS toggle is toggled properly.
          if (_this34.oos) {
            _this34.elements.show_oos_products.prop('checked', true);
            _this34.elements.show_oos_products_mobile.prop('checked', true);
          }

          // Make sure Price drop toggle is toggled properly.
          if (_this34.priceDrop) {
            _this34.elements.show_price_drop_products.prop('checked', true);
            _this34.elements.show_price_drop_products_mobile.prop('checked', true);
          }

          // Update the number of filters in the filter pill on mobile
          _this34.setActiveFiltersCount();
        });
      }
    }]);
    return Filters;
  }(); // Instantiate filters if on the approved pages
  if (~TEMPLATES.indexOf(theme.template.name) && window._filters) {
    window.filters = new Filters(window._filters);
  }
})(window.jQuery, window.theme = window.theme || {});
(function ($, Handlebars) {
  /**
   * Filters contstructor.
   * Can be instantiated on either a search or collection page.
   *
   * Dependencies:
   * - jQuery
   * - Handlebars
   *
   * Required parameters:
   * - {container} The Filter Wrapper
   * - {blogId} The Blog ID
   * - {hitsPerPage} Number of terms per page
   * - {termsCount} Total Number of protermsducts
   * - {paginationSelector} Pagination Wrapper
   * - {termGridSelector} Term Grid wrapper
   *
   * Optional parameters:
   * - {searchTerms} The search terms to filter results on
   *
   *
   * @param {*} params
   */
  window.GlossaryFilter = function (params) {
    var _container,
      _blogHandle,
      _client,
      _index,
      _page = 1,
      _hitsPerPage,
      _termsCount,
      _searchTerms,
      _paginationSelector,
      _termGridSelector,
      _activeFiltersSelector,
      _filtering = false,
      _loadingNextPage = false,
      _appendResults = false,
      _firstload = true,
      _beforeFilter,
      _afterFilter,
      _searchOptions;

    /**
     * On object initialize
     */
    function _init() {
      _container = params.scopeSelector, _client = algoliasearch(window.algoliaShopify.config.app_id, window.algoliaShopify.config.search_api_key), _index = _client.initIndex('' + window.algoliaShopify.config.index_prefix + 'articles_title_asc'), _blogHandle = params.blogHandle, _hitsPerPage = params.hitsPerPage, _termsCount = params.termsCount, _paginationSelector = params.paginationSelector, _termGridSelector = params.termGridSelector, _activeFiltersSelector = params.activeFiltersSelector, _beforeFilter = params.beforeFilter, _afterFilter = params.afterFilter, _searchTerms = params.searchTerms;

      // Register required handlers
      _register_handler('change', _container + ' ' + 'input[type="radio"][name="sort_by"]', _sort_by);
      _register_handler('change', _container + ' ' + 'input[type="checkbox"]', _filter_change);
      _register_handler('keyup', '.js-search-glossary', _filter_change);
      _register_handler('click', _paginationSelector + ' ' + '.js-load-more--next', _filter_load_more);
      _sort_by();
    }

    /**
     * Private handlers
     *
     * Handler for Sort By.
     * Swaps presorted index
     */
    function _sort_by() {
      _index = $(this).val() ? _client.initIndex($(this).val()) : _client.initIndex($('[name="sort_by"]:checked').val());
      if (!_filtering) {
        _filtering = true;
        _page = 1;
        _appendResults = false;
        try {
          _filter();
        } catch (error) {
          _filtering = false;
        }
      }
    }

    /**
     * Private handlers
     *
     * Handler for Filter Option change.
     * When a filter is selected, unselected
     */
    function _filter_change() {
      if (!_filtering) {
        _filtering = true;
        _page = 1;
        _appendResults = false;
        _searchTerms = $('.js-search-glossary').val();
        try {
          _filter();
        } catch (error) {
          _filtering = false;
        }
      }
    }

    /**
     * Private handlers
     *
     * Handler Load More
     * Load More results under the current displayed results
     */
    function _filter_load_more() {
      $(_paginationSelector + ' ' + '.loader').show();
      if (!_filtering) {
        _page = parseInt($(this).data('page'));
        _appendResults = true;
        try {
          _filter();
        } catch (error) {
          _filtering = false;
        }
      }
      $(_paginationSelector + ' ' + '.loader').hide();
    }

    /**
     * Use values of currently selected checkboxes to generate a
     * filter query and display results on page
     * @void
     */
    function _filter() {
      _filtering = true;
      params.beforeFilter();
      var $groups = $(_container + ' ' + '[data-group]');
      var query = [];
      $groups.each(function (i, group) {
        var groupQuery = [];
        $(group).find('input[type="checkbox"]:checked').each(function (i, option) {
          if ($(option).val() != '') groupQuery.push($(this).attr('name') + ':' + $(option).val());
        });
        if (groupQuery.length > 0) {
          query.push('(' + groupQuery.join(' OR ') + ')');
        }
      });
      if (_blogHandle) query.push('(blog.handle:' + _blogHandle + ')');
      _update_query_string_param('page', _page);
      _searchOptions = {
        hitsPerPage: _hitsPerPage,
        page: _page - 1,
        distinct: true,
        analytics: true
      };
      if (query.length > 0) {
        _searchOptions.filters = query.join(' AND ');
      }
      if (_searchTerms) _searchOptions.query = _searchTerms;
      if (_termsCount > 1000) {
        _index.setSettings({
          paginationLimitedTo: _termsCount + 1000
        });
      }
      theme.sendAnalytics(_searchOptions.query);
      _index.search(_searchOptions).then(function (results) {
        var terms = results.hits;
        _display_terms(terms);
        _paginate(results);
        _display_active_filters();
        _filtering = false;
        _loadingNextPage = false;
        params.afterFilter();
      }, function (results) {
        _filtering = false;
        _loadingNextPage = false;
      });
    }

    /**
     * Update Query String Parameter Helper Function
     *
     */
    function _update_query_string_param(key, value, url) {
      var baseUrl = url || [location.protocol, '//', location.host, location.pathname].join('');
      var urlQueryString = document.location.search;
      var newParam = key + '=' + value;
      var params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (urlQueryString) {
        var keyRegex = new RegExp('([\?&])' + key + '[^&]*');
        // If param exists already, update it
        if (urlQueryString.match(keyRegex) !== null) {
          params = urlQueryString.replace(keyRegex, "$1" + newParam);
        } else {
          // Otherwise, add it to end of query string
          params = urlQueryString + '&' + newParam;
        }
      }
      if (url) {
        return baseUrl + params;
      }
      if (window.history) {
        window.history.replaceState({}, "", baseUrl + params);
      }
    }
    function _display_terms(terms) {
      // Prepare terms for display
      var terms_html = '';
      terms = terms.map(function (term) {
        var t = term;
        t.title = t._highlightResult.title.value;
        t.content = t.body_html;
        var source = $('#accordion-item-template').html();
        if (source) {
          var template = Handlebars.compile(source);
          terms_html += template({
            'item': t,
            data: {
              random: theme.random()
            }
          });
        }
        return t;
      });

      // Update Term Grid
      if (!_appendResults) {
        $(_termGridSelector).addClass('filters-active');
        console.clear();
        if (!_firstload) {
          $('html, body').animate({
            scrollTop: $(_termGridSelector).first().offset().top - 200
          }, 300);
        }
        $(_termGridSelector).html('');
        $(_termGridSelector).removeClass('filters-active');
        _firstload = false;
      }
      $(_termGridSelector).first().append(terms_html);
      if (terms.length <= 0) $(_termGridSelector).first().html('<p class="terms--empty">' + theme.translations.no_terms + '</p>');
    }
    function _paginate(results) {
      _termsCount = results.nbHits;
      var paginate = {};
      paginate.items = results.nbHits;
      paginate.current_displayed = results.hits.length;
      paginate.pages = results.nbPages;
      paginate.parts = [];
      if (paginate.pages > 1) {
        // Previous Link
        if (_page > 1) {
          paginate.previous = {
            title: 'Previous',
            page: _page - 1
          };
        }
        // Next Link
        if (_page < paginate.pages) {
          paginate.next = {
            title: 'Next',
            page: _page + 1
          };
        }

        // Middle Links
        for (var i = 1; i <= paginate.pages; i++) {
          var part = {
            title: i,
            page: i
          };
          if (i == _page) {
            part.is_current_page = true;
          } else {
            part.is_link = true;
          }
          if (i >= _page - 2 && i <= _page + 2) {
            paginate.parts.push(part);
          }
          if (i == _page - 3) {
            part.title = 1;
            part.page = 1;
            paginate.parts.push(part);
            if (_page > 1 + 3) {
              paginate.parts.push({
                title: '...'
              });
            }
          }
          if (i == _page + 3) {
            if (_page < paginate.pages - 3) {
              paginate.parts.push({
                title: '...'
              });
            }
            part.title = paginate.pages;
            part.page = paginate.pages;
            paginate.parts.push(part);
          }
        }
      }
      var source = $('#load-more-template').html();
      if (source) {
        var template = Handlebars.compile(source);
        var pagination_html = template({
          'paginate': paginate
        });
        $(_paginationSelector).replaceWith($(pagination_html).addClass('filters-active'));
      }
    }
    function _display_active_filters() {
      var $selectedOptions = $(_container + ' ' + 'input[type="checkbox"]:checked');
      var activeFiltersArray = [];
      $selectedOptions.each(function (i, option) {
        if ($(option).data('display-name')) {
          activeFiltersArray.push({
            id: $(option).attr('id'),
            display_name: $(option).data('display-name')
          });
        }
      });
      var source = $('#applied-filters-template').html();
      if (source) {
        var template = Handlebars.compile(source);
        var activeFiltersHtml = template({
          applied_filters: activeFiltersArray
        });
        if ($(activeFiltersHtml).length) $(_activeFiltersSelector).html($(activeFiltersHtml));
      }
      $(_activeFiltersSelector).html(activeFiltersHtml);
      if (activeFiltersArray.length) $(_activeFiltersSelector).slideDown('fast');else $(_activeFiltersSelector).slideUp('fast');
    }

    /**
     * Register a handler with event delegation
     * @param {} vent
     * @param {*} selector
     * @param {*} callback
     */
    function _register_handler(vent, selector, callback) {
      $(document).on(vent, selector, callback);
    }
    _init();
  };
})(jQuery, Handlebars);
(function ($, theme) {
  if (theme.glossary) {
    $(function () {
      /**
       * Instantiate filters
       */
      theme.glossary_filter = new GlossaryFilter({
        scopeSelector: 'form.filter',
        blogHandle: theme.glossary.handle,
        hitsPerPage: theme.glossary.paginate_by,
        paginationSelector: '.glossary-of-terms .pagination-wrapper',
        termGridSelector: '.glossary-of-terms__terms',
        activeFiltersSelector: '.glossary-of-terms__applied-filters',
        beforeFilter: function beforeFilter() {},
        afterFilter: function afterFilter() {}
      });
      var loadingNextPage = false,
        pagination = '.pagination-wrapper',
        loader = '.glossary-of-terms .loader';

      // Terms Load More
      $(document).on('click', '.js-load-more', function (e) {
        e.preventDefault();
        var $nextPageLink = $(this);
        if (!loadingNextPage) {
          loadingNextPage = true;
          $(loader).fadeIn();
          $.get($nextPageLink.attr('href'), function (response) {
            if (response) {
              $('.pagination').remove();
              var responseArticles = $(response).find('.response-wrapper').html();
              var $responsePagination = $(response).find(pagination);
              $('.glossary-of-terms__terms').append(responseArticles);
              $(pagination).replaceWith($responsePagination);
            }
            $(loader).fadeOut();
          }).always(function () {
            loadingNextPage = false;
          });
        }
      });
      $(document).on('submit', 'form.filter', function (e) {
        e.preventDefault();
      });
    });
  }
})(jQuery, window.theme = window.theme || {});
(function ($, Handlebars, theme) {
  /**
   * Filters contstructor.
   * Can be instantiated on FAQ Page.
   *
   * Dependencies:
   * - jQuery
   * - Handlebars
   *
   * Required parameters:
   * - {container} The Filter Wrapper
   * - {blogId} The Blog ID
   * - {hitsPerPage} Number of faqs per page
   * - {faqsCount} Total Number of profaqsducts
   * - {paginationSelector} Pagination Wrapper
   * - {faqGridSelector} Term Grid wrapper
   *
   * Optional parameters:
   * - {searchTerms} The search faqs to filter results on
   *
   *
   * @param {*} params
   */
  window.FAQSearch = function (params) {
    var _container,
      _blogHandle,
      _client,
      _index,
      _page = 1,
      _hitsPerPage,
      _faqsCount,
      _searchTerms,
      _paginationSelector,
      _faqGridSelector,
      _activeFiltersSelector,
      _filtering = false,
      _loadingNextPage = false,
      _appendResults = false,
      _beforeFilter,
      _afterFilter,
      _searchOptions;

    /**
     * On object initialize
     */
    function _init() {
      _container = params.scopeSelector, _client = algoliasearch(window.algoliaShopify.config.app_id, window.algoliaShopify.config.search_api_key), _index = _client.initIndex('' + window.algoliaShopify.config.index_prefix + 'articles'), _blogHandle = params.blogHandle, _hitsPerPage = params.hitsPerPage, _faqsCount = params.faqsCount, _paginationSelector = params.paginationSelector, _faqGridSelector = params.faqGridSelector, _activeFiltersSelector = params.activeFiltersSelector, _beforeFilter = params.beforeFilter, _afterFilter = params.afterFilter, _searchTerms = document.location.href.split('?q=')[1] || params.searchTerms;

      // Register required handlers
      _register_handler('change', _container + ' ' + 'input[type="checkbox"]', _filter_change);
      _register_handler('keyup search change', '.js-search-faq', _filter_change);
      _register_handler('click', _paginationSelector + ' ' + '.js-load-more--next', _filter_load_more);
      _filter_on_load();
    }

    /**
     * Private handlers
     *
     * Filters on load if there is a seachTerm provided in the initiatization
     *
     */
    function _filter_on_load() {
      if (_searchTerms) {
        _filtering = true;
        _page = 1;
        _appendResults = false;
        $('.js-search-faq').val(_searchTerms);
        try {
          _filter();
        } catch (error) {
          _filtering = false;
          $('.js-search-faq').val();
        }
      }
      $('.faq-page__blog-accordion__heading.search-results').show();
    }

    /**
     * Private handlers
     *
     * Handler for Filter Option change.
     * When a filter is selected, unselected
     */
    function _filter_change() {
      if (!_filtering) {
        _filtering = true;
        _page = 1;
        _appendResults = false;
        _searchTerms = $('.js-search-faq').val();
        try {
          _filter();
        } catch (error) {
          _filtering = false;
        }
      }
      $('.faq-page__blog-accordion__heading.search-results').show();
    }

    /**
     * Private handlers
     *
     * Handler Load More
     * Load More results under the current displayed results
     */
    function _filter_load_more() {
      $(_paginationSelector + ' ' + '.loader').show();
      if (!_filtering) {
        _page = parseInt($(this).data('page'));
        _appendResults = true;
        try {
          _filter();
        } catch (error) {
          _filtering = false;
        }
      }
      $(_paginationSelector + ' ' + '.loader').hide();
    }

    /**
    * Use values of currently selected checkboxes to generate a
    * filter query and display results on page
    * @void
    */
    function _filter() {
      _filtering = true;
      params.beforeFilter();
      var $groups = $(_container + ' ' + '[data-group]');
      var query = [];
      $groups.each(function (i, group) {
        var groupQuery = [];
        $(group).find('input[type="checkbox"]:checked').each(function (i, option) {
          if ($(option).val() != '') groupQuery.push($(this).attr('name') + ':' + $(option).val());
        });
        if (groupQuery.length > 0) {
          query.push('(' + groupQuery.join(' OR ') + ')');
        }
      });
      if (_blogHandle) query.push('(blog.handle:' + _blogHandle + ')');
      query.push('tags:language--' + theme.locales.language_code);
      _searchOptions = {
        hitsPerPage: _hitsPerPage,
        page: _page - 1,
        distinct: true,
        analytics: true
      };
      if (query.length > 0) {
        _searchOptions.filters = query.join(' AND ');
      }
      if (_searchTerms) _searchOptions.query = _searchTerms;
      if (_faqsCount > 1000) {
        _index.setSettings({
          paginationLimitedTo: _faqsCount + 1000
        });
      }
      theme.sendAnalytics(_searchOptions.query);
      _index.search(_searchOptions).then(function (results) {
        var faqs = results.hits;
        _display_faqs(faqs);
        _paginate(results);
        _display_active_filters();
        _filtering = false;
        _loadingNextPage = false;
        params.afterFilter();
      }, function (results) {
        _filtering = false;
        _loadingNextPage = false;
      });
    }
    function _display_faqs(faqs) {
      // Prepare faqs for display
      var faqs_html = '';
      faqs = faqs.map(function (question) {
        var q = question;
        q.title = q._highlightResult.title.value;
        q.content = q.body_html;
        var source = $('#accordion-item-template').html();
        if (source) {
          var template = Handlebars.compile(source);
          faqs_html += template({
            'item': q,
            data: {
              random: theme.random()
            }
          });
        }
        return q;
      });

      // Update Term Grid
      if (!_appendResults) {
        $(_faqGridSelector).addClass('filters-active');
        $(_faqGridSelector).html('');
        $(_faqGridSelector).removeClass('filters-active');
      }
      $(_faqGridSelector).first().append(faqs_html);
      if (faqs.length <= 0) $(_faqGridSelector).first().parent().hide();else $(_faqGridSelector).first().parent().show();
    }
    function _paginate(results) {
      _faqsCount = results.nbHits;
      var paginate = {};
      paginate.items = results.nbHits;
      paginate.current_displayed = results.hits.length;
      paginate.pages = results.nbPages;
      paginate.parts = [];
      if (paginate.pages > 1) {
        // Previous Link
        if (_page > 1) {
          paginate.previous = {
            title: 'Previous',
            page: _page - 1
          };
        }
        // Next Link
        if (_page < paginate.pages) {
          paginate.next = {
            title: 'Next',
            page: _page + 1
          };
        }

        // Middle Links
        for (var i = 1; i <= paginate.pages; i++) {
          var part = {
            title: i,
            page: i
          };
          if (i == _page) {
            part.is_current_page = true;
          } else {
            part.is_link = true;
          }
          if (i >= _page - 2 && i <= _page + 2) {
            paginate.parts.push(part);
          }
          if (i == _page - 3) {
            part.title = 1;
            part.page = 1;
            paginate.parts.push(part);
            if (_page > 1 + 3) {
              paginate.parts.push({
                title: '...'
              });
            }
          }
          if (i == _page + 3) {
            if (_page < paginate.pages - 3) {
              paginate.parts.push({
                title: '...'
              });
            }
            part.title = paginate.pages;
            part.page = paginate.pages;
            paginate.parts.push(part);
          }
        }
      }
      var source = $('#load-more-template').html();
      if (source) {
        var template = Handlebars.compile(source);
        var pagination_html = template({
          'paginate': paginate
        });
        $(_paginationSelector).replaceWith($(pagination_html).addClass('filters-active'));
      }
    }
    function _display_active_filters() {
      var $selectedOptions = $(_container + ' ' + 'input[type="checkbox"]:checked');
      var activeFiltersArray = [];
      $selectedOptions.each(function (i, option) {
        if ($(option).data('display-name')) {
          activeFiltersArray.push({
            id: $(option).attr('id'),
            display_name: $(option).data('display-name')
          });
        }
      });
      var source = $('#applied-filters-template').html();
      if (source) {
        var template = Handlebars.compile(source);
        var activeFiltersHtml = template({
          applied_filters: activeFiltersArray
        });
        if ($(activeFiltersHtml).length) $(_activeFiltersSelector).html($(activeFiltersHtml));
      }
      $(_activeFiltersSelector).html(activeFiltersHtml);
      if (activeFiltersArray.length) $(_activeFiltersSelector).slideDown('fast');else $(_activeFiltersSelector).slideUp('fast');
    }

    /**
     * Register a handler with event delegation
     * @param {} vent
     * @param {*} selector
     * @param {*} callback
     */
    function _register_handler(vent, selector, callback) {
      $(document).on(vent, selector, callback);
    }
    _init();
  };
  if (theme.template.name == 'page' && theme.template.suffix == 'faq') {
    $(function () {
      /**
      * Instantiate search
      */
      theme["most-popular"] = new FAQSearch({
        scopeSelector: '.most-popular form.filter',
        hitsPerPage: 20,
        faqGridSelector: '.most-popular .faq-page__items',
        searchTerms: theme.utils.getURLParams().search || '',
        beforeFilter: function beforeFilter() {},
        afterFilter: function afterFilter() {}
      });
      theme.faq.blocks.forEach(function (block) {
        theme["".concat(block.handle, "--").concat(block.id)] = new FAQSearch({
          scopeSelector: ".".concat(block.handle, "--").concat(block.id, " form.filter"),
          blogHandle: block.handle,
          hitsPerPage: theme.faq.paginate_by,
          searchTerms: theme.utils.getURLParams().search || '',
          paginationSelector: ".".concat(block.handle, "--").concat(block.id, " .pagination-wrapper"),
          faqGridSelector: ".".concat(block.handle, "--").concat(block.id, " .faq-page__items"),
          beforeFilter: function beforeFilter() {},
          afterFilter: function afterFilter() {}
        });
      });
      var loadingNextPage = false;

      // FAQ Load More
      $(document).on('click', '.js-load-more', function (e) {
        e.preventDefault();
        var $container = $(this).closest('.faq-page__blog-accordion'),
          pagination = '.pagination-wrapper',
          $loader = $container.find('.loader'),
          $nextPageLink = $(this);
        if (!loadingNextPage) {
          loadingNextPage = true;
          $loader.fadeIn();
          $.get($nextPageLink.attr('href'), function (response) {
            if (response) {
              $container.find('.pagination').remove();
              var responseFaqs = $(response).find('.response-wrapper').html();
              var $responsePagination = $(response).find(pagination);
              $container.find('.faq-page__items').append(responseFaqs);
              $container.find(pagination).replaceWith($responsePagination);
            }
            $loader.fadeOut();
          }).always(function () {
            loadingNextPage = false;
          });
        }
      });
    });
  }
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, Handlebars, theme) {
  /**
   * Shop by Brands page filtering.
   *
   * Dependencies:
   * - jQuery
   * - Handlebars
   *
   * Required parameters:
   * - {searchFieldSelector} The selector for the search field input
   * - {resultsCountSelector} The selector for the results count element(s)
   * - {resultsLettersSelector} The selector for the element where the "letter" anchor elements are
   * - {resultsGridSelector} The selector for the element where the results should be injected
   * - {brands} An array of the brand collections, used for searching
   *
   *
   * @param {*} params
   */
  window.BrandsSearch = function (params) {
    // General variables
    var _searchFieldSelector,
      _resultsCountSelector,
      _resultsLetterAnchorsSelector,
      _resultsGridSelector,
      _brands,
      _letters = '0abcdefghijklmnopqrstuvwxyz'.split('');

    // Handlebars templates
    var letter_source = $('#brands__letter').html();
    var letter_brand_source = $('#brands__result').html();
    var letter_template = Handlebars.compile(letter_source);
    var letter_brand_template = Handlebars.compile(letter_brand_source);

    // Constructor
    function _init() {
      _searchFieldSelector = params.searchFieldSelector, _resultsCountSelector = params.resultsCountSelector, _resultsLetterAnchorsSelector = params.resultsLetterAnchorsSelector, _resultsGridSelector = params.resultsGridSelector, _brands = params.brands;
      _register_handler('keyup search', _searchFieldSelector, _filter);
    }

    // Finds brands matching the search query
    function _filter() {
      var query = $(this).val().toLowerCase();
      var matching_brands = _brands.filter(function (brand) {
        return ~brand.title.toLowerCase().indexOf(query);
      });

      // Handle results
      _display_brands(matching_brands);
    }

    // Processes results and appends them to the page
    function _display_brands(brands) {
      // For each letter, check if there are results
      // If there are, render each brand into a string, and
      // then use that string to render the letter's element itself
      var brands_results_html = '';
      var brands_found = 0;
      $.each(_letters, function (i, letter) {
        var letter_results = '',
          letter_brands_found = 0;
        $.each(brands, function (j, brand) {
          if (brand.first_letter == letter) {
            letter_results += letter_brand_template({
              brand: brand
            });
            letter_brands_found++;
          }
        });
        var letter_disabled = letter_brands_found == 0;
        brands_found += letter_brands_found;
        if (letter_brands_found) {
          brands_results_html += letter_template({
            letter: letter,
            letter_disabled: letter_disabled,
            letter_results: letter_results
          });
        }
        var letter_element = $(_resultsLetterAnchorsSelector + ' [data-letter="' + letter + '"]');
        letter_element.toggleClass('btn--disabled', letter_disabled);
        letter_element.attr('href', function (_, attr) {
          return letter_disabled ? null : letter_element.attr("data-target");
        });
        letter_element.attr('tabindex', function (_, attr) {
          return letter_disabled ? null : 0;
        });
      });

      // Append the completed results HTML into the appropriate element
      $(_resultsGridSelector).first().html(brands_results_html);
      $(_resultsCountSelector).text(brands_found);

      // If there are no results, display a no results message
      if (!brands_found) $(_resultsGridSelector).first().html('<p class="letter__results--empty">' + theme.translations.no_brands + '</p>');
    }

    /**
     * Register a handler with event delegation
     * @param {} event
     * @param {*} selector
     * @param {*} callback
     */
    function _register_handler(event, selector, callback) {
      $(document).on(event, selector, function (e) {
        callback.apply(this, [e]);
      });
    }
    _init();
  };
  if (theme.template.name == 'page' && theme.template.suffix == 'brands') {
    $(function () {
      /**
      * Instantiate search
      */
      theme.brands_search = new BrandsSearch({
        searchFieldSelector: ".js-brands-search-field",
        resultsCountSelector: ".js-brands-search-count",
        resultsLetterAnchorsSelector: ".js-brands-letter-anchors",
        resultsGridSelector: ".js-brands-search-results",
        brands: theme.brands
      });
    });
  }
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, Handlebars) {
  /**
   * Stores page filtering.
   *
   * Dependencies:
   * - jQuery
   * - Handlebars
   *
   * Required parameters:
   * - {searchFieldSelector} The selector for the search field input
   * - {resultsCountSelector} The selector for the results count element(s)
   * - {resultsLettersSelector} The selector for the element where the "letter" anchor elements are
   * - {resultsGridSelector} The selector for the element where the results should be injected
   * - {stores} An array of the store collections, used for searching
   *
   *
   * @param {*} params
   */
  window.StoresSearch = function (params) {
    // General variables
    var _searchFieldSelector,
      _resultsCountSelector,
      _resultsLetterAnchorsSelector,
      _resultsGridSelector,
      _stores,
      _letters = '0abcdefghijklmnopqrstuvwxyz'.split('');

    // Handlebars templates
    var letter_source = $('#stores__letter').html();
    var letter_store_source = $('#stores__result').html();
    var letter_template = Handlebars.compile(letter_source);
    var letter_store_template = Handlebars.compile(letter_store_source);

    // Constructor
    function _init() {
      _searchFieldSelector = params.searchFieldSelector, _resultsCountSelector = params.resultsCountSelector, _resultsLetterAnchorsSelector = params.resultsLetterAnchorsSelector, _resultsGridSelector = params.resultsGridSelector, _stores = params.stores;
      _register_handler('keyup search', _searchFieldSelector, _filter);
    }

    // Finds stores matching the search query
    function _filter() {
      var query = $(this).val().toLowerCase();
      var matching_stores = _stores.filter(function (store) {
        return ~store.title.toLowerCase().indexOf(query);
      });

      // Handle results
      _display_stores(matching_stores);
    }

    // Processes results and appends them to the page
    function _display_stores(stores) {
      // For each letter, check if there are results
      // If there are, render each store into a string, and
      // then use that string to render the letter's element itself
      var stores_results_html = '';
      var stores_found = 0;
      $.each(_letters, function (i, letter) {
        var letter_results = '',
          letter_stores_found = 0;
        $.each(stores, function (j, store) {
          if (store.first_letter == letter) {
            letter_results += letter_store_template({
              store: store
            });
            letter_stores_found++;
          }
        });
        var letter_disabled = letter_stores_found == 0;
        stores_found += letter_stores_found;
        if (letter_stores_found) {
          stores_results_html += letter_template({
            letter: letter,
            letter_disabled: letter_disabled,
            letter_results: letter_results
          });
        }
        $(_resultsLetterAnchorsSelector + ' [data-letter="' + letter + '"]').toggleClass('btn--disabled', letter_disabled);
      });

      // Append the completed results HTML into the appropriate element
      $(_resultsGridSelector).first().html(stores_results_html);
      $(_resultsCountSelector).text(stores_found);

      // If there are no results, display a no results message
      if (!stores_found) $(_resultsGridSelector).first().html('<p class="letter__results--empty">' + theme.translations.no_stores + '</p>');
    }

    /**
     * Register a handler with event delegation
     * @param {} event
     * @param {*} selector
     * @param {*} callback
     */
    function _register_handler(event, selector, callback) {
      $(document).on(event, selector, function (e) {
        callback.apply(this, [e]);
      });
    }
    _init();
  };
})(jQuery, Handlebars);
(function ($, Handlebars) {
  /**
   * Licensed Producers page filtering.
   *
   * Dependencies:
   * - jQuery
   * - Handlebars
   *
   * Required parameters:
   * - {searchFieldSelector} The selector for the search field input
   * - {resultsCountSelector} The selector for the results count element(s)
   * - {resultsLettersSelector} The selector for the element where the "letter" anchor elements are
   * - {resultsGridSelector} The selector for the element where the results should be injected
   * - {licensedProducers} An array of the licensed producer, used for searching
   *
   *
   * @param {*} params
   */
  window.LicensedProducersSearch = function (params) {
    // General variables
    var _searchFieldSelector,
      _resultsCountSelector,
      _resultsLetterAnchorsSelector,
      _resultsGridSelector,
      _licensedProducers,
      _letters = '0abcdefghijklmnopqrstuvwxyz'.split('');

    // Handlebars templates
    var letter_source = $('#licensed-producers__letter').html();
    var letter_licensed_producer_source = $('#licensed-producers__result').html();
    var letter_template = Handlebars.compile(letter_source);
    var letter_licensed_producer_template = Handlebars.compile(letter_licensed_producer_source);

    // Constructor
    function _init() {
      _searchFieldSelector = params.searchFieldSelector, _resultsCountSelector = params.resultsCountSelector, _resultsLetterAnchorsSelector = params.resultsLetterAnchorsSelector, _resultsGridSelector = params.resultsGridSelector, _licensedProducers = params.licensedProducers;
      _register_handler('keyup search', _searchFieldSelector, _filter);
    }

    // Finds licensed producers matching the search query
    function _filter() {
      var query = $(this).val().toLowerCase();
      var matching_licensed_producers = _licensedProducers.filter(function (licensed_producer) {
        return ~licensed_producer.title.toLowerCase().indexOf(query);
      });

      // Handle results
      _display_licensed_producers(matching_licensed_producers);
    }

    // Processes results and appends them to the page
    function _display_licensed_producers(licensed_producers) {
      // For each letter, check if there are results
      // If there are, render each licensed producer into a string, and
      // then use that string to render the letter's element itself
      var licensed_producers_results_html = '';
      var licensed_producers_found = 0;
      var previous_letter = '';
      $.each(_letters, function (i, letter) {
        var letter_results = '',
          seen_letter = false,
          letter_licensed_producers_found = 0;
        $.each(licensed_producers, function (j, licensed_producer) {
          if (licensed_producer.first_letter == letter) {
            seen_letter = licensed_producer.first_letter == previous_letter;
            var letter_upcase = letter.toUpperCase();
            letter_results += letter_licensed_producer_template({
              letter_upcase: letter_upcase,
              letter: letter,
              seen_letter: seen_letter,
              licensed_producer: licensed_producer
            });
            letter_licensed_producers_found++;
            previous_letter = letter;
          }
        });
        var letter_disabled = letter_licensed_producers_found == 0;
        licensed_producers_found += letter_licensed_producers_found;
        if (letter_licensed_producers_found) {
          licensed_producers_results_html += letter_template({
            letter_results: letter_results
          });
        }
        $(_resultsLetterAnchorsSelector + ' [data-letter="' + letter + '"]').toggleClass('btn--disabled', letter_disabled);
      });

      // Append the completed results HTML into the appropriate element
      $(_resultsGridSelector).first().html(licensed_producers_results_html);
      $(_resultsCountSelector).text(licensed_producers_found);

      // If there are no results, display a no results message
      if (!licensed_producers_found) $(_resultsGridSelector).first().html('<p class="letter__results--empty">' + theme.translations.no_licensed_producers + '</p>');
    }

    /**
    * Register a handler with event delegation
    * @param {} event
    * @param {*} selector
    * @param {*} callback
    */
    function _register_handler(event, selector, callback) {
      $(document).on(event, selector, function (e) {
        callback.apply(this, [e]);
      });
    }
    _init();
  };
})(jQuery, Handlebars);
$(function () {
  /**
   * Instantiate search
   */
  if (window.licensed_producers) {
    theme.licensedProducers_search = new LicensedProducersSearch({
      searchFieldSelector: '.js-licensed-producers-search-field',
      resultsCountSelector: '.js-licensed-producers-search-count',
      resultsLetterAnchorsSelector: '.js-licensed-producers-letter-anchors',
      resultsGridSelector: '.js-licensed-producers-search-results',
      licensedProducers: window.licensed_producers
    });
  }
});
(function ($, theme, google) {
  function StoreDetails(options) {
    var _map;
    var _map_options;
    var _address;
    var _directions_url;
    var _$map;
    function _init() {
      _$map = options.$map;
      _map_options = options.map_options;
      _address = options.address;
      _render_store_map();
    }
    function _render_store_map() {
      var full_address = "".concat(_address.address1, ", ").concat(_address.city, ", ").concat(_address.province, ", ").concat(_address.zip);
      var currentWindowSize = $(window).width();
      _map_options['zoomControl'] = true;
      if (currentWindowSize <= theme.bp.sm) {
        _map_options['zoomControl'] = false;
      }
      _map = new google.maps.Map(_$map[0], _map_options);
      _render_marker();
    }
    function _render_marker() {
      var icon = {
        url: theme.images.map_pin,
        scaledSize: new google.maps.Size(17.92, 23),
        origin: new google.maps.Point(0, 0),
        // origin
        anchor: new google.maps.Point(0, 0),
        labelOrigin: new google.maps.Point(8.41, 9)
      };
      var marker = new google.maps.Marker({
        position: {
          lat: _map_options.center.lat,
          lng: _map_options.center.lng
        },
        map: _map,
        icon: icon,
        optimized: false
      });
    }
    _init();
  }
  window.StoreDetails = StoreDetails;
})(jQuery, theme, google);
(function ($, Handlebars, theme) {
  $(function () {
    // $(document).on('click', '.js-search', function(e) {
    //   e.preventDefault();
    //   $(this).hide();
    //   $('.header .search-bar').addClass('is-active');
    //   $('.header .search-bar__field').focus();
    // });

    var pagination = '.search__articles .pagination-wrapper',
      loader = '.search__articles .loader',
      loadingNextPage = false;

    // Topics infinite scroll
    $(window).scroll(function () {
      var $nextPageLink = $('.js-infinite-scroll');
      if ($nextPageLink.length && $(window).scrollTop() == $(document).height() - $(window).height()) {
        if (!loadingNextPage) {
          loadingNextPage = true;
          $(loader).fadeIn();
          $.get($nextPageLink.attr('data-url'), function (response) {
            if (response) {
              $(pagination).remove();
              var responseArticles = $(response).find('.article-grid').html();
              var $responsePagination = $(response).find('.pagination-wrapper');
              $('.article-grid').append(responseArticles);
              $('.search__articles').append($responsePagination);
            } else {
              $(loader).fadeOut();
            }
          }).always(function () {
            loadingNextPage = false;
          });
        }
      }
    });

    // On the search page, initialize the three search panels
    if (theme.template.name == 'search') {
      // Updates the product layout and triggers a layout update for the whole page
      var updateProductLayout = function updateProductLayout(results) {
        $('.js-search-result-product-count').html(results.nbHits);
        search_results.products.done = true;
        search_results.products.count = results.nbHits;
        updateSearchLayout();
      }; // Updates the collection layout and triggers a layout update for the whole page
      var updateCollectionsLayout = function updateCollectionsLayout(results) {
        // Create a tile for each result and append to the page
        var tile_source = $('#collection-tile').html(),
          tile_template = Handlebars.compile(tile_source),
          $collectionTiles = $('.js-collections-grid'),
          numBrands = 0,
          $collectionsList = $('.js-collections-list'),
          numCollections = 0;
        // Collections pagination removed in commit 99b4bf7d

        var brandHandles = window.theme.brands && window.theme.brands.map(function (brand) {
          return brand.handle;
        });
        results.hits.forEach(function (collection) {
          var i = brandHandles.indexOf(collection.handle);
          if (i > -1) {
            if (numBrands == 0) $collectionTiles.empty();
            numBrands++;
            var brand = window.theme.brands[i];
            collection.image = brand.image;
            $collectionTiles.append(tile_template({
              collection: collection,
              images: theme.images
            }));
          } else {
            if (numCollections == 0) $collectionsList.empty();
            numCollections++;
            $collectionsList.append("<p><a href=\"/collections/".concat(collection.handle, "\">").concat(collection.title, "</a></p>"));
          }
        });
        $('.search__collections .loader').hide();
        $('.js-search-result-collection-count').html(results.nbHits);
        search_results.collections.done = true;
        search_results.collections.count = results.nbHits;
        if (!loading_more_results) updateSearchLayout();
        loading_more_results = false;
      }; // Updates the collection layout and triggers a layout update for the whole page
      var updateTopicsLayout = function updateTopicsLayout(results) {
        if (results.nbHits > 0) {
          $('.search__no-results').hide();
          // Create a tile for each topic and append to the page
          var tile_source = $('#topic-tile').html(),
            tile_template = Handlebars.compile(tile_source),
            $topicTiles = $('.topics-grid'),
            paginate = {},
            paginationSelector = '.search__topics .pagination-wrapper';
          results.hits.forEach(function (topic) {
            topic.body_html_safe = topic.body_html_safe.substring(0, 100) + '...';
            $topicTiles.append(tile_template({
              topic: topic
            }));
          });

          // Paginate
          if (results.nbPages > 1 && search_results.topics.page < results.nbPages) {
            paginate.next = {
              title: 'Next',
              page: search_results.topics.page + 1
            };
          }
          var source = $('#load-more-template').html();
          if (source) {
            var template = Handlebars.compile(source);
            var pagination_html = template({
              'paginate': paginate
            });
            $(paginationSelector).replaceWith($(pagination_html));
          }
          $('.search__topics .loader').hide();
          $('.js-search-result-topic-count').html(results.nbHits);
        }
        search_results.topics.done = true;
        search_results.topics.count = results.nbHits;
        if (!loading_more_results) updateSearchLayout();
        loading_more_results = false;
      }; // Updates the pages tab layout and triggers a layout update for the whole page
      var updatePagesTabLayout = function updatePagesTabLayout(results) {
        if (results.nbHits > 0) {
          $('.search__no-results').hide();
          // Create a tile for each topic and append to the page
          var tile_source = $('#page-tile').html(),
            tile_template = Handlebars.compile(tile_source),
            $pageTiles = $('.pages-grid'),
            paginate = {},
            paginationSelector = '.search__pages .pagination-wrapper';
          results.hits.forEach(function (page) {
            page.body_html_safe = page.body_html_safe.substring(0, 100) + '...';
            $pageTiles.append(tile_template({
              page: page
            }));
          });

          // Paginate
          if (results.nbPages > 1 && search_results.pages.page < results.nbPages) {
            paginate.next = {
              title: 'Next',
              page: search_results.pages.page + 1
            };
          }
          var source = $('#load-more-template').html();
          if (source) {
            var template = Handlebars.compile(source);
            var pagination_html = template({
              'paginate': paginate
            });
            $(paginationSelector).replaceWith($(pagination_html));
          }
          $('.search__pages .loader').hide();
          $('.js-search-result-pages-count').html(results.nbHits);
        }
        search_results.pages.done = true;
        search_results.pages.count = results.nbHits;
        if (!loading_more_results) updateSearchLayout();
        loading_more_results = false;
      }; // Updates the page layout. Decides which tab to show based on results
      var updateSearchLayout = function updateSearchLayout() {
        // variable that's updated when one of the product tabs has been opened,
        // to prevent click events being triggered on the other tabs
        var search_results_opened = false;
        $('.search__result-count').html(search_results.products.count + search_results.collections.count + search_results.pages.count + search_results.topics.count);

        // If products are loaded and there are products to show,
        // Enable and select the product tab
        if ($('.product-tile').length) {
          $('#search--products').removeClass('tab--disabled').click();
          search_results_opened = true;
          handleCollectionsTab();
        } else {
          $(document).on('Filters:loaded', function (e, filters) {
            if (filters.results.nbHits > 0 && $('#search--products').hasClass('tab--disabled')) {
              $('#search--products').removeClass('tab--disabled').click();
            }
            handleCollectionsTab();
          });
        }

        // Enable collections tab if they're loaded and there are some
        // Unless (product) search results are already open, open collection search results tab
        // If there are no products to show, select the collections tab
        function handleCollectionsTab() {
          if (search_results.collections.done && search_results.collections.count > 0) {
            $('#search--collections').removeClass('tab--disabled');
            if (!search_results_opened && !$('.product-tile').length) {
              $('#search--collections').click();
              search_results_opened = true;
            }
          }
          handlePagesTab();
        }

        // Enable pages tab if they're loaded and there are some
        // Unless (product or collection) search results are already open, open pages search results tab
        // If there are no products or collections or topics to show, select the pages tab
        function handlePagesTab() {
          if (search_results.pages.done && search_results.pages.count > 0) {
            $('#search--pages').removeClass('tab--disabled');
            if (!search_results_opened && search_results.collections.done && search_results.collections.count === 0 && !$('.product-tile').length) {
              $('#search--pages').click();
              search_results_opened = true;
            }
          }
          handleTopicsTab();
        }

        // Enable topics tab if they're loaded and there are some
        // Unless (product or collection or pages) search results are already open, open topics search results tab
        // If there are no products or collections or pages to show, select the topics tab
        function handleTopicsTab() {
          if (search_results.topics.done && search_results.topics.count > 0) {
            $('#search--topics').removeClass('tab--disabled');
            if (!search_results_opened && search_results.collections.done && search_results.collections.count === 0 && search_results.pages.done && search_results.pages.count === 0 && !$('.product-tile').length) {
              $('#search--topics').click();
              search_results_opened = true;
            }
          }
        }

        // If everything is loaded and there are no results at all
        // Show the topics tab (it contains a no-results message by default)
        if (!$('.product-tile').length && search_results.collections.done && search_results.collections.count == 0 && search_results.topics.done && search_results.topics.count == 0 && search_results.pages.done && search_results.pages.count == 0) {
          $('.topics-grid').hide();
          $('#search__panel--topics').addClass('tab__content--active');
        }
      };
      // Loads collections results into the collection tab
      var getCollections = function getCollections() {
        collections_index.search({
          // Override the default set in Algolia (20)
          hitsPerPage: 100,
          distinct: true,
          analytics: true,
          query: terms,
          page: search_results.collections.page - 1,
          filters: "meta.locale.language: ".concat(theme.locales.language_code, " AND products_count > 0")
        }).then(updateCollectionsLayout);
      }; // Loads pages results into the pages tab
      var getPages = function getPages() {
        var language_codes_supported_negate = theme.locales.language_codes_supported.filter(function (language_code) {
          return language_code != theme.locales.language_code;
        });
        var filters = '';
        language_codes_supported_negate.forEach(function (language_code, index) {
          if (filters !== '') {
            filters += " AND ";
          }
          filters += "NOT meta.locale.language:".concat(language_code);
        });
        pages_index.search({
          hitsPerPage: theme.paginate_by,
          distinct: true,
          analytics: true,
          query: terms,
          page: search_results.pages.page - 1,
          filters: filters
        }).then(updatePagesTabLayout);
      }; // Loads articles results into the articles tab
      var getTopics = function getTopics() {
        topics_index.search({
          hitsPerPage: theme.paginate_by,
          distinct: true,
          analytics: true,
          query: terms,
          page: search_results.topics.page - 1,
          filters: 'tags:language--' + theme.locales.language_code
        }).then(updateTopicsLayout);
      };
      var terms = theme.search.terms;
      var loading_more_results = false;
      var search_results = {
        products: {
          done: false,
          count: 0
        },
        collections: {
          done: false,
          count: 0,
          page: 1
        },
        pages: {
          done: false,
          count: 0,
          page: 1
        },
        topics: {
          done: false,
          count: 0,
          page: 1
        }
      };
      $(document).on('click', '.search__collections .js-load-more--next', function (e) {
        e.preventDefault();
        if (!loading_more_results) {
          loading_more_results = true;
          search_results.collections.page = Number($(this).data('page'));
          $('.search__collections .loader').show();
          getCollections();
        }
      });
      $(document).on('click', '.search__topics .js-load-more--next', function (e) {
        e.preventDefault();
        if (!loading_more_results) {
          loading_more_results = true;
          search_results.topics.page = Number($(this).data('page'));
          $('.search__topics .loader').show();
          getTopics();
        }
      });
      $(document).on('click', '.search__pages .js-load-more--next', function (e) {
        e.preventDefault();
        if (!loading_more_results) {
          loading_more_results = true;
          search_results.pages.page = Number($(this).data('page'));
          $('.search__pages .loader').show();
          getPages();
        }
      });
      var collectionsIndexKey = 'ocs_collections',
        topicsIndexKey = 'ocs_articles',
        pagesIndexKey = 'ocs_pages';
      var index_prefix = "".concat(window.algoliaShopify.config.index_prefix);
      if (index_prefix) {
        collectionsIndexKey = "".concat(index_prefix, "collections");
        topicsIndexKey = "".concat(index_prefix, "articles");
        pagesIndexKey = "".concat(index_prefix, "pages");
      }

      // Preps Algolia index for collection and topic tab results
      var _client = algoliasearch(window.algoliaShopify.config.app_id, window.algoliaShopify.config.search_api_key, {
          urlSync: {
            trackedParameters: []
          }
        }),
        collections_index = _client.initIndex(collectionsIndexKey),
        topics_index = _client.initIndex(topicsIndexKey),
        pages_index = _client.initIndex(pagesIndexKey);
      getCollections();
      getPages();
      getTopics();
    }
  });
})(jQuery, Handlebars, window.theme = window.theme || {});
(function ($, theme) {
  var Search = /*#__PURE__*/function () {
    function Search() {
      _classCallCheck(this, Search);
      this.index;
      this.elements = {};

      // Global query options
      this.options = {
        analytics: true,
        distinct: false,
        hitsPerPage: 4,
        clickAnalytics: true,
        highlightPreTag: "<strong>",
        highlightPostTag: "</strong>"
      };
      this.initializeInsights();
      this.query = new window.AlgoliaQuery();
      this.client = algoliasearch(window.algoliaShopify.config.app_id, window.algoliaShopify.config.search_api_key, {
        urlSync: {
          trackedParameters: []
        }
      });
    }

    // https://www.algolia.com/doc/guides/getting-insights-and-analytics/personalization/personalizing-results/how-to/send-personalization-events-with-instantsearch/js
    _createClass(Search, [{
      key: "initializeInsights",
      value: function initializeInsights() {
        var ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@2.2.1";
        !function (e, a, t, n, s, i, c) {
          e.AlgoliaAnalyticsObject = s, e[s] = e[s] || function () {
            (e[s].queue = e[s].queue || []).push(arguments);
          }, i = a.createElement(t), c = a.getElementsByTagName(t)[0], i.async = 1, i.src = n, c.parentNode.insertBefore(i, c);
        }(window, document, "script", ALGOLIA_INSIGHTS_SRC, "aa");

        // Initialize library
        aa('init', {
          appId: window.algoliaShopify.config.app_id,
          apiKey: window.algoliaShopify.config.search_api_key
        });

        // Set the analytics user ID when we bake in user accounts in the future
        aa('setUserToken', 'USER_ID');
      }

      // Render all results
    }, {
      key: "render",
      value: function render() {
        return "";
      }
    }, {
      key: "attachAnalytics",
      value: function attachAnalytics($element) {
        var _this35 = this;
        if (window.aa && $element.length) {
          $element.find('[data-aa-id]').off('click.aa').on('click.aa', function (event) {
            event.preventDefault();
            var $link = $(event.currentTarget);
            aa('clickedObjectIDs', {
              eventName: 'CLICK_HIT',
              index: _this35.index_key || '',
              objectIDs: [$link.data('aa-id')],
              positions: [$link.data('aa-position')],
              queryID: _this35.queryID || ''
            });
            window.location.href = "".concat($link.attr('href'), "?index=").concat(_this35.index_key, "&objectIDs=").concat($link.data('aa-id'), "&queryID=").concat(_this35.queryID);
          });
        }
      }
    }, {
      key: "search",
      value: function search(query) {
        var _this36 = this;
        var options = this.options;
        options.query = query;
        return this.index.search(options).then(function (resp) {
          _this36.results = resp.hits;
          _this36.queryID = resp.queryID;

          // If the search object has a GA event it should track, fire it
          if (_this36.ga_event && window.dataLayer) {
            // Track results in Google Analytics (GA)
            window.dataLayer.push({
              'event': _this36.ga_event,
              'Search Query': query,
              'Number of Hits': resp.nbHits
            });
          }
        });
      }
    }]);
    return Search;
  }();
  var ProductSearch = /*#__PURE__*/function (_Search) {
    _inherits(ProductSearch, _Search);
    var _super4 = _createSuper(ProductSearch);
    function ProductSearch() {
      var _this37;
      _classCallCheck(this, ProductSearch);
      _this37 = _super4.call(this);
      _this37.index_key = "".concat(algoliaShopify.config.index_prefix, "search_products");
      _this37.index = _this37.client.initIndex(_this37.index_key);

      // Set up individual query options
      _this37.options.hitsPerPage = 6;
      _this37.options.distinct = 100; // Maximum number of variants in Shopify
      _this37.options.filters = "tags:language--".concat(theme.locales.language_code);
      if (theme.ageGateRestrictedExperienceSearch) {
        _this37.options.filters += " AND tags:no_age-gate";
      }

      // Pass the Google Analystics tracking event
      _this37.ga_event = 'search';
      return _this37;
    }

    // Products need to get grouped together to get availability across all variants
    _createClass(ProductSearch, [{
      key: "results",
      get: function get() {
        return this._results;
      },
      set: function set(results) {
        this._results = this.query.groupHits(results);
      }
    }, {
      key: "renderNoInventoryAvailable",
      value: function renderNoInventoryAvailable(result) {
        if (result.tags.includes('availability--in-store')) {
          return "<span aria-hidden=\"true\" class=\"icon icon--store\"></span><span>".concat(window.theme.translations.product.inventory.in_store, "</span>");
        } else {
          return "<span aria-hidden=\"true\" class=\"icon icon--cross\"></span><span>".concat(window.theme.translations.product.inventory.out_of_stock, "</span>");
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this38 = this;
        if (this.results.length) {
          return "\n          <ul class=\"search-results search-results--product\">\n            ".concat(this.results.map(function (result, index) {
            var cannabinoids = theme.utils.formatCannabinoids(result);
            return "\n                <li class=\"search-result search-result--product\">\n                  <a href=\"/products/".concat(result.handle, "\" title=\"").concat(result.title, "\" data-aa-id=\"").concat(result.objectID, "\" data-aa-position=\"").concat(index + 1, "\">\n                    <div class=\"search-result__image-column\">                      \n                      ").concat(result.image && result.title ? "<p class=\"search-result__image\"><img src=\"".concat(result.image, "\" alt=\"").concat(result.title, "\"></p>") : "<p class=\"search-result__image search-result__no-image\" />", "\n                    </div>\n                    <div class=\"search-result__column\">\n                      ").concat(result.available && result.tags.indexOf('status--new') != -1 && window.theme.translations.product.new_label ? "<p class=\"search-result__new-label ".concat(result.compare_at_price ? "search-result--badge-offset" : "", "\"><span>").concat(window.theme.translations.product.new_label, "</span></p>") : '', "\n                      ").concat(result.available && result.compare_at_price && window.theme.translations.product.discount_label ? "<p class=\"search-result__discount-label\"><span>".concat(window.theme.translations.product.discount_label, "</span></p>") : '', "\n                      <p class=\"search-result__vendor\">\n                        ").concat(result._highlightResult.vendor ? result._highlightResult.vendor.value : result.vendor, "\n                      </p>\n                      <p class=\"search-result__title\">\n                        ").concat(result._highlightResult.title ? result._highlightResult.title.value : result.title, "\n                      </p>\n                      <p class=\"search-result__content\">\n                        ").concat(cannabinoids.thc ? "<span class=\"search-result__thc\">THC</span> ".concat(cannabinoids.thc.split('|', 1)) : '', "\n                        ").concat(cannabinoids.thc && cannabinoids.cbd ? "<br />" : '', "\n                        ").concat(cannabinoids.cbd ? "<span class=\"search-result__cbd\">CBD</span> ".concat(cannabinoids.cbd.split('|', 1)) : '', "\n                      </p>\n                      ").concat(result.available ? '' : "<p class=\"search-result__inventory\">".concat(_this38.renderNoInventoryAvailable(result), "</p>"), "\n                    </div>                    \n                  </a>\n                </li>\n              ");
          }).join(''), "\n          </ul>\n        ");
        } else if (theme.ageGateRestrictedExperienceSearch) {
          return "<p class=\"instant-search__no-results\">".concat(theme.translations.search.no_products_age_restricted, "</p>");
        } else {
          return "<p class=\"instant-search__no-results\">".concat(theme.translations.search.no_products, "</p>");
        }
      }
    }]);
    return ProductSearch;
  }(Search);
  var CollectionSearch = /*#__PURE__*/function (_Search2) {
    _inherits(CollectionSearch, _Search2);
    var _super5 = _createSuper(CollectionSearch);
    function CollectionSearch() {
      var _this39;
      _classCallCheck(this, CollectionSearch);
      _this39 = _super5.call(this);
      _this39.index_key = "".concat(window.algoliaShopify.config.index_prefix, "collections");
      _this39.index = _this39.client.initIndex(_this39.index_key);
      // Set up individual query options
      _this39.options.filters = "meta.locale.language:".concat(theme.locales.language_code, " AND products_count > 0");
      if (theme.ageGateRestrictedExperienceSearch) {
        _this39.options.filters += " AND meta.auth.no_agegate:true";
      }
      return _this39;
    }
    _createClass(CollectionSearch, [{
      key: "render",
      value: function render() {
        if (this.results.length) {
          return "\n          <ul class=\"search-results search-results--collection\">\n            ".concat(this.results.map(function (result, index) {
            return "\n              <li class=\"search-result search-result--collection\">\n                <a href=\"/collections/".concat(result.handle, "\" title=\"").concat(result.title, "\" data-aa-id=\"").concat(result.objectID, "\" data-aa-position=\"").concat(index + 1, "\">\n                  <p class=\"search-result__title\">\n                    ").concat(result._highlightResult.title ? result._highlightResult.title.value : result.title, "\n                  </p>\n                </a>\n              </li>\n            ");
          }).join(''), "\n          </ul>\n        ");
        } else if (theme.ageGateRestrictedExperienceSearch) {
          return "<p class=\"instant-search__no-results\">".concat(theme.translations.search.no_collections_age_restricted, "</p>");
        } else {
          return "<p class=\"instant-search__no-results\">".concat(theme.translations.search.no_collections, "</p>");
        }
      }
    }]);
    return CollectionSearch;
  }(Search);
  var PageSearch = /*#__PURE__*/function (_Search3) {
    _inherits(PageSearch, _Search3);
    var _super6 = _createSuper(PageSearch);
    function PageSearch() {
      var _this40;
      _classCallCheck(this, PageSearch);
      _this40 = _super6.call(this);
      _this40.index_key = "".concat(window.algoliaShopify.config.index_prefix, "pages");
      _this40.index = _this40.client.initIndex(_this40.index_key);

      // Set up individual query options
      _this40.options.hitsPerPage = 3;
      _this40.options.filters = '';
      var language_codes_supported_negate = theme.locales.language_codes_supported.filter(function (language_code) {
        return language_code != theme.locales.language_code;
      });
      language_codes_supported_negate.forEach(function (language_code, index) {
        if (index) {
          _this40.options.filters += " AND ";
        }
        _this40.options.filters += "NOT meta.locale.language:".concat(language_code);
      });
      if (theme.ageGateRestrictedExperienceSearch) {
        _this40.options.filters += " AND meta.auth.no_agegate:true";
      }
      return _this40;
    }
    _createClass(PageSearch, [{
      key: "render",
      value: function render() {
        if (this.results.length) {
          return "\n          <ul class=\"search-results search-results--page\">\n            ".concat(this.results.map(function (result, index) {
            return "\n              <li class=\"search-result search-result--page\">\n                <a href=\"/pages/".concat(result.handle, "\" title=\"").concat(result.title, "\" data-aa-id=\"").concat(result.objectID, "\" data-aa-position=\"").concat(index + 1, "\">\n                  <p class=\"search-result__title\">\n                    ").concat(result._highlightResult.title ? result._highlightResult.title.value : result.title, "\n                  </p>\n                  <p class=\"search-result__content\">\n                    <span>\n                      ").concat(function () {
              var max_char = 100;
              var body = (result._highlightResult.body_html_safe ? result._highlightResult.body_html_safe.value : result.body_html_safe).trim();
              return body.length > max_char ? "".concat(body.substring(0, max_char), "...") : body;
            }(), "\n                    </span>\n                  </p>\n                </a>\n              </li>\n            ");
          }).join(''), "\n          </ul>\n        ");
        } else if (theme.ageGateRestrictedExperienceSearch) {
          return "<p class=\"instant-search__no-results\">".concat(theme.translations.search.no_pages_age_restricted, "</p>");
        } else {
          return "<p class=\"instant-search__no-results\">".concat(theme.translations.search.no_pages, "</p>");
        }
      }
    }]);
    return PageSearch;
  }(Search);
  var ArticleSearch = /*#__PURE__*/function (_Search4) {
    _inherits(ArticleSearch, _Search4);
    var _super7 = _createSuper(ArticleSearch);
    function ArticleSearch() {
      var _this41;
      _classCallCheck(this, ArticleSearch);
      _this41 = _super7.call(this);
      _this41.index_key = "".concat(window.algoliaShopify.config.index_prefix, "articles");
      _this41.index = _this41.client.initIndex(_this41.index_key);

      // Set up individual query options
      _this41.options.hitsPerPage = 3;
      _this41.options.filters = "tags:language--".concat(theme.locales.language_code);
      if (theme.ageGateRestrictedExperienceSearch) {
        _this41.options.filters += " AND tags:no_age-gate";
      }
      return _this41;
    }
    _createClass(ArticleSearch, [{
      key: "render",
      value: function render() {
        if (this.results.length) {
          return "\n          <ul class=\"search-results search-results--article\">\n            ".concat(this.results.map(function (result, index) {
            return "\n              <li class=\"search-result search-result--article\">\n                <a href=\"/blogs/".concat(result.blog.handle, "/").concat(result.handle, "\" title=\"").concat(result.title, "\" data-aa-id=\"").concat(result.objectID, "\" data-aa-position=\"").concat(index + 1, "\">\n                  <p class=\"search-result__title\">\n                    ").concat(result._highlightResult.title ? result._highlightResult.title.value : result.title, "\n                  </p>\n                  <p class=\"search-result__content\">\n                    <span>\n                      ").concat(function () {
              var max_char = 100;
              var body = (result._highlightResult.body_html_safe ? result._highlightResult.body_html_safe.value : result.body_html_safe).trim();
              return body.length > max_char ? "".concat(body.substring(0, max_char), "...") : body;
            }(), "\n                    </span>\n                  </p>\n                </a>\n              </li>\n            ");
          }).join(''), "\n          </ul>\n        ");
        } else if (theme.ageGateRestrictedExperienceSearch) {
          return "<p class=\"instant-search__no-results\">".concat(theme.translations.search.no_articles_age_restricted, "</p>");
        } else {
          return "<p class=\"instant-search__no-results\">".concat(theme.translations.search.no_articles, "</p>");
        }
      }
    }]);
    return ArticleSearch;
  }(Search);
  var InstantSearch = /*#__PURE__*/function () {
    function InstantSearch() {
      var _this42 = this;
      _classCallCheck(this, InstantSearch);
      theme.ageGateRestrictedExperienceSearch = theme.age_gate_restricted_search_experience && theme.ageGateRestrictedExperience;
      this.elements = {
        searchFullSearchBar: $('#full-search-bar'),
        input: $('.js-search-input'),
        clear: $('.js-search-clear'),
        container: $('.js-instant-search'),
        submit: $('.js-search-submit'),
        document: $(document),
        megamenu: $('.mega-menu'),
        header: $('header.nav'),
        content: $('.js-instant-search-container'),
        topNotification: $('#shopify-section-notice-banner'),
        topRecallBanner: $('#shopify-section-recall-banner'),
        fullSearchForm: $('#full-search-bar > form'),
        popularSearch: $('#full-search-bar .js-search-popular'),
        viewAllButton: $('.js-search-view-all')
      };
      this.searches = [{
        $container: $('.js-search-pages'),
        instance: new PageSearch()
      }, {
        $container: $('.js-search-articles'),
        instance: new ArticleSearch()
      }, {
        $container: $('.js-search-products'),
        instance: new ProductSearch()
      }, {
        $container: $('.js-search-collections'),
        instance: new CollectionSearch()
      }];
      var closeResults = function closeResults(remove_freeze) {
        if (remove_freeze) {
          $('html, body').removeClass('body--freeze');
        }
        _this42.elements.clear.addClass('visually-hidden');
        _this42.elements.container.slideUp(150).removeClass('active');
        if ($('html').hasClass('touchevents')) {
          _this42.elements.header.removeClass('header--stick');
        }
      };
      var adjustMobileResults = function adjustMobileResults() {
        _this42.elements.content.scrollTop(0);

        // Prevent iOS header scroll / gap issues
        if ($('html').hasClass('touchevents')) {
          _this42.elements.header.addClass('header--stick');
        }
      };
      var remove_freeze = true;
      var positionSearchResults = function positionSearchResults() {
        $('html, body').addClass('body--freeze');
        if ($(window).width() < theme.bp.md) {
          adjustMobileResults();
        }
      };
      this.elements.input.on('keyup focus', theme.debounce(function (e) {
        var query = typeof _this42.elements.input.val() !== 'undefined' ? _this42.elements.input.val().trim() : void 0;
        if (query.length > 0) {
          $('html, body').addClass('body--freeze');
          _this42.elements.popularSearch.addClass('hidden');
          if (e && e.which == 13) {
            _this42.elements.fullSearchForm.submit();
          }
          _this42.search(query);
          positionSearchResults();
          _this42.elements.container.addClass('active').slideDown(150);
          _this42.elements.clear.removeClass('visually-hidden');
          if ($(window).width() < theme.bp.md) {
            adjustMobileResults();
          }
        } else {
          var _theme$search, _theme$search2;
          if (_this42.elements.popularSearch.length > 0 || _this42.elements.popularSearch.is(':visible')) {
            remove_freeze = false;
          }
          closeResults(remove_freeze);
          var terms = typeof ((_theme$search = theme.search) === null || _theme$search === void 0 ? void 0 : _theme$search.terms) !== 'undefined' ? (_theme$search2 = theme.search) === null || _theme$search2 === void 0 ? void 0 : _theme$search2.terms.trim() : void 0;
          if ((query.length < 1 || terms.length < 1) && _this42.elements.popularSearch.length > 0) {
            _this42.elements.popularSearch.removeClass('hidden');
          }
        }
      }, 50));
      this.elements.submit.on('click', function (e) {
        if (typeof _this42.elements.input.val() !== 'undefined' && _this42.elements.input.val().trim().length < 1) {
          e.preventDefault();
          _this42.elements.input.focus();
          return false;
        }
        return true;
      });

      // Handle search clear
      this.elements.clear.on('click', function (e) {
        e.preventDefault();
        _this42.elements.input.val('').trigger('keyup');
      });
      window.addEventListener('resize', theme.debounce(function () {
        if (typeof _this42.elements.input.val() !== 'undefined' && _this42.elements.input.val().trim().length > 0 && _this42.elements.container.hasClass('active') && _this42.elements.container.is(':visible')) {
          positionSearchResults();
        } else {
          if (!_this42.elements.megamenu.hasClass('active') || !$('.flyout--cart').is('.active')) {
            remove_freeze = false;
            closeResults(remove_freeze);
          } else {
            closeResults(remove_freeze);
          }
        }
      }, 250));

      // Handle click away close
      this.elements.document.on('focus click', 'body', function (e) {
        var $this = $(e.target);
        if (!_this42.elements.searchFullSearchBar.is(e.target) && _this42.elements.searchFullSearchBar.has(e.target).length === 0) {
          remove_freeze = true;
          closeResults(remove_freeze);
        }
      });
      if (theme.ageGateRestrictedExperienceSearch) {
        this.elements.viewAllButton.html(theme.translations.search.see_all_results_age_restricted);
      }
    }
    _createClass(InstantSearch, [{
      key: "search",
      value: function search(query) {
        this.searches.map(function (search) {
          search.instance.search(query).then(function () {
            search.$container.html(search.instance.render());
            // Bind Algolia click events
            search.instance.attachAnalytics(search.$container);
          });
        });
      }
    }]);
    return InstantSearch;
  }();
  window.InstantSearch = new InstantSearch();
})(window.jQuery, window.theme);
'use strict';
(function ($) {
  $(function () {
    var $singleItemReorder = $('.reorder-form--item');
    var $fullOrderReorder = $('.reorder-form--order');
    function constructItem($element, addingType) {
      var item = {};
      item.properties = {};
      var properties = $element.find('.item--property');
      $.each(properties, function (i, v) {
        item.properties[$(v).data('property-name')] = $(v).val();
      });
      item.id = $element.find('[name=id]').val();
      item.quantity = $element.find('[name=quantity]').val();
      item.analytics = {
        variant_id: item.id,
        variant_option: item.properties['_fr-CA_options'],
        quantity: item.quantity,
        base_product: {
          'vendor': $element.find('[name=vendor]').val(),
          'title': $element.find('[name=title]').val()
        },
        location: 'Order History',
        atc_type: addingType
      };
      return item;
    }
    $singleItemReorder.submit(function (e) {
      e.preventDefault();
      theme.cart.add(constructItem($(this), 'single'));
    });
    $fullOrderReorder.submit(function (e) {
      e.preventDefault();
      if (window.theme.wipe_cart_on_reorder) {
        theme.cart.clear();
      }
      var items = [];
      var reorderItemBlocks = $(this).find('.reorder-block');
      var copy = $('.order__unpurchasable-copy').data('reorder-copy');
      $(this).closest('.order').find('.order__unpurchasable-copy').html('<span aria-hidden="true" class="icon icon--warning"></span> ' + copy);
      $.each(reorderItemBlocks, function (i, v) {
        items.push(constructItem($(v), 'reorder'));
      });
      $.each(items, function (i, v) {
        if (i < items.length - 1) {
          theme.cart.add(v, {
            quiet: true
          });
        } else {
          theme.cart.add(v);
        }
      });
    });
  });
})(jQuery);
(function ($) {
  $(function () {
    window.FormValidator = function (formSelector) {
      var _inputs,
        _passwords,
        _mandatoryCheckboxes,
        _submit,
        _formValidated = true,
        _validArray = [],
        _emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      /*
           Updates the custom placeholder value
         */
      function _updateLabel(input) {
        if (input.val().trim().length > 0) {
          input.addClass('has-value');
        } else {
          input.removeClass('has-value');
        }
      }

      /*
           Validates input by checking its length
         */
      function _validateText(input) {
        if (input.val().trim().length) {
          input.removeClass('invalid-value');
          _formValidated = true;
        } else {
          input.addClass('invalid-value');
          _formValidated = false;
        }
      }

      /*
           Validates input by checking for generic email format
         */
      function _validateEmail(input) {
        if (input.val().trim().length && _emailRegex.test(input.val())) {
          input.removeClass('invalid-value');
          _formValidated = true;
        } else {
          input.addClass('invalid-value');
          _formValidated = false;
        }
      }

      /*
           Validates input by checking for number
         */
      function _validateNumber(input) {
        if (!isNaN(input.val())) {
          input.removeClass('invalid-value');
          _formValidated = true;
        } else {
          input.addClass('invalid-value');
          _formValidated = false;
        }
      }

      /*
           Validates checkboxes by checking if they're checked
         */
      function _validateCheckbox(checkbox) {
        var checkboxes = $(formSelector).find('input[type=checkbox][name="' + checkbox.attr('name') + '"]:checked');
        if (checkboxes.length) {
          _formValidated = true;
        } else {
          _formValidated = false;
        }
      }

      /*
           Validates password based on form.
           If it can find a confirm password that targets the original password via data attribute, it will compare the 2.
           If it doesn't, it will only check for minimum requirement of length 6.
         */
      function _validatePasswords() {
        $.each(_passwords, function (i, v) {
          if (!$(this).data('skip-validation')) {
            if ($(v).data('compare-pw')) {
              var pwCompareSelector = $(v).data('compare-pw');
              if ($(v).val() === $(pwCompareSelector).val() && $(pwCompareSelector).val().trim().length >= 6) {
                _passwords.removeClass('invalid-value');
                _formValidated = true;
              } else {
                _passwords.addClass('invalid-value');
                _formValidated = false;
              }
            } else {
              if ($(v).val().trim().length >= 6) {
                _passwords.removeClass('invalid-value');
                _formValidated = true;
              } else {
                _passwords.addClass('invalid-value');
                _formValidated = false;
              }
            }
          }
          _validArray.push(_formValidated);
        });
      }
      function _validatePassword(v) {
        if ($(v).data('compare-pw')) {
          var pwCompareSelector = $(v).data('compare-pw');
          if ($(v).val() === $(pwCompareSelector).val() && _meetsPasswordRequirements($(v).val().trim())) {
            $(v).removeClass('invalid-value');
            _formValidated = true;
          } else {
            $(v).addClass('invalid-value');
            _formValidated = false;
          }
        } else {
          if (_meetsPasswordRequirements($(v).val().trim())) {
            $(v).removeClass('invalid-value');
            _formValidated = true;
          } else {
            $(v).addClass('invalid-value');
            _formValidated = false;
          }
        }
        _validArray.push(_formValidated);
        _activateBtn();
      }
      function _meetsPasswordRequirements(password) {
        var MIN_LENGTH = /^.{12,40}$/;
        var UPPER_CASE = /[A-Z]/;
        var LOWER_CASE = /[a-z]/;
        var NUMBER = /[0-9]/;
        var SPECIAL_CHAR = /[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/]/;
        return MIN_LENGTH.test(password) && UPPER_CASE.test(password) && LOWER_CASE.test(password) && NUMBER.test(password) && SPECIAL_CHAR.test(password);
      }

      /*
           Validates by checking if the option selected is not the default blank option.
         */
      function _validateSelect(select) {
        if (select.val() != '') {
          select.removeClass('invalid-value');
          _formValidated = true;
        } else {
          select.addClass('invalid-value');
          _formValidated = false;
        }
      }

      /*
           Loops through all the fields and and validates based on what input the current iteration is.
         */
      function _validateFields() {
        for (var i = 0; i < _inputs.length; i++) {
          if ($(_inputs[i]).prop('required')) {
            if ($(_inputs[i]).is('[type="email"]')) {
              _validateEmail($(_inputs[i]));
            }
            if ($(_inputs[i]).is('[type="text"]') || $(_inputs[i]).is('textarea')) {
              _validateText($(_inputs[i]));
            }
            if ($(_inputs[i]).is('[type="number"]')) {
              _validateNumber($(_inputs[i]));
            }
            if ($(_inputs[i]).is('[type="checkbox"]')) {
              _validateCheckbox($(_inputs[i]));
            }
            if ($(_inputs[i]).is('select')) {
              _validateSelect($(_inputs[i]));
            }
          }
          _validArray.push(_formValidated);
        }
      }

      /*
           Checks for all required checkboxes to be checked before enabling the submit button.
         */
      function _activateSubmit() {
        $(_mandatoryCheckboxes).on('change', function () {
          var allChecked = true;
          $.each(_mandatoryCheckboxes, function () {
            if (!$(this).is(':checked')) {
              allChecked = false;
              return false;
            }
          });
          _submit.attr('data-confirm-checkbox', allChecked);
          _activateBtn();
        });
      }
      function _activateBtn() {
        var allPasswordFieldsValid = true;
        if (_passwords) {
          _passwords.each(function () {
            if ($(this).hasClass('invalid-value')) {
              allPasswordFieldsValid = false;
              return false;
            }
          });
        }
        var CheckboxValidation = _submit.attr('data-confirm-checkbox') ? _submit.attr('data-confirm-checkbox') : true;
        var disabledFlag = JSON.parse(CheckboxValidation) && allPasswordFieldsValid;
        _submit.prop('disabled', !disabledFlag);
      }

      /*
           Stores an array of boolean, submits the form if no false can be found in said array.
         */
      function _validateForm() {
        _validArray.length = 0;
        _validateFields();
        _validatePasswords();
        return _validArray.indexOf(false) < 0;
      }

      /*
           Initializes the form object for validation
         */
      function _init() {
        _inputs = $(formSelector).find(':input:not([type="hidden"], [type="submit"], [type="password"]), textarea, select');
        _passwords = $(formSelector).find('[type="password"]');
        _submit = $(formSelector).find('[type="submit"]');
        _mandatoryCheckboxes = $(formSelector).find('[type="checkbox"][required]');
        _activateSubmit();
        _inputs.on('keyup', function () {
          _updateLabel($(this));
        });
        _inputs.on('load', function () {
          _inputs.map(function (input) {
            _updateLabel(input);
          });
        });
        _passwords.on('keyup blur', function () {
          _passwords.each(function () {
            _updateLabel($(this));
            if (!$(this).data('skip-validation')) {
              _validatePassword(this);
            }
          });
        });
        $(document).on('submit', formSelector, function (e) {
          return _validateForm();
        });
      }
      _init();
    };
  });
})(jQuery);
(function ($, theme) {
  $(function () {
    document.querySelectorAll('#eyeButton').forEach(function (span) {
      span.addEventListener('click', function () {
        var passwordField = this.previousElementSibling;
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          this.classList.remove('icon--eye-open');
          this.classList.add('icon--eye-closed');
        } else {
          passwordField.type = 'password';
          this.classList.remove('icon--eye-closed');
          this.classList.add('icon--eye-open');
        }
      });
    });
    if ($('#customer_login').length) {
      var _window$theme;
      theme.loginForm = new FormValidator('#customer_login');
      theme.overwrite_form_errors('#customer_login');
      if ((_window$theme = window.theme) !== null && _window$theme !== void 0 && _window$theme.login_form_state) {
        window.dataLayer.push({
          'event': 'myaccount_login',
          'sign_in': 'failed'
        });
      }
    }
    if ($('#recover_password').length) {
      var _window$theme2, _window$theme3;
      theme.forgotPassword = new FormValidator('#recover_password');
      theme.overwrite_form_errors('#recover_password');

      //Prevent enter key submission
      $('#recover_email').on('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      });

      // GTM - My accounts password reset 
      if (((_window$theme2 = window.theme) === null || _window$theme2 === void 0 ? void 0 : _window$theme2.reset_pw_form_status) == 'success') {
        window.dataLayer.push({
          'event': 'myaccount_password',
          'reset_email': 'success'
        });
      } else if (((_window$theme3 = window.theme) === null || _window$theme3 === void 0 ? void 0 : _window$theme3.reset_pw_form_status) == 'failure') {
        window.dataLayer.push({
          'event': 'myaccount_password',
          'reset_email': 'failure'
        });
      }
    }
    if ($('#reset_password').length) {
      theme.resetForm = new FormValidator('#reset_password');
    }
    if ($('#create_customer').length) {
      theme.registerForm = new FormValidator('#create_customer');
      $('.js-accepts-marketing').on('click', function () {
        var accepts_marketing = $(this).prop("value");
        $(this).prop("value", accepts_marketing == "true" ? "false" : "true");
        var customer_tags = $("#register_lang");
        var coma_seprated_tags = ",cals--acctcreation,newsletter_lang--".concat(theme.locales.language_code);
        customer_tags.val(customer_tags.val().replace(coma_seprated_tags, ''));
        if (accepts_marketing == "false") {
          customer_tags.val(customer_tags.val().concat(coma_seprated_tags));
        }
        var returnToInput = $('#create_customer input[name="return_to"]');
        var returnToUrl = returnToInput.val();
        var _returnToUrl$split = returnToUrl.split('?'),
          _returnToUrl$split2 = _slicedToArray(_returnToUrl$split, 2),
          path = _returnToUrl$split2[0],
          queryString = _returnToUrl$split2[1];
        var params = new URLSearchParams(queryString);
        params.set('accepts_marketing', accepts_marketing == "true" ? "false" : "true");
        returnToUrl = "".concat(path, "?").concat(params.toString());
        returnToInput.val(returnToUrl);
      });
      theme.overwrite_form_errors('#create_customer');
    }
    if ($('#activate_account').length) {
      theme.activateAccount = new FormValidator('#activate_account');
    }
    var loginForm = document.getElementById('customer-login-form'),
      resetForm = document.getElementById('reset-password-form');
    var switchForms = function switchForms() {
      loginForm.classList.toggle('visible');
      loginForm.classList.toggle('hidden');
      resetForm.classList.toggle('visible');
      resetForm.classList.toggle('hidden');
    };
    $(document).on('click', '#forgot-password-cta', function (e) {
      switchForms();
    });
    if (window.location.hash === '#recover') {
      switchForms();
    }
    if (theme.template.name === 'register') {
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      if (params.has('create')) {
        var accepts_marketing_flag = params.get('accepts_marketing') || "false";
        params["delete"]('create');
        params["delete"]('accepts_marketing');
        window.history.replaceState({}, '', "".concat(url.pathname).concat(params.toString() ? "?".concat(params) : ''));
        if (window.theme.needs_verification) {
          window.dataLayer.push({
            event: 'myaccount_creation',
            'accepts_marketing': accepts_marketing_flag
          });
        } else if (!window.theme.register_errors) {
          window.location.href = "".concat(window.location.origin, "/account?create=true&accepts_marketing=").concat(accepts_marketing_flag);
        }
      }
    }
  });
})(jQuery, window.theme = window.theme || {});
(function ($) {
  $(function () {
    $(document).on('click', '.js-read-bio', function (e) {
      e.preventDefault();
      $('.member').removeClass('active');
      $('.member').css('height', '');
      $(this).closest('.member').addClass('active');

      /* Ajust sibling tiles heights when Bio is open
                  In order to maintain grid layout
               */
      var tileHeight = $(this).closest('.member').outerHeight(true) + 1;
      $('.member').height(tileHeight);
    });
  });
})(jQuery);
(function ($, Cookies, theme) {
  /**
   * Check the stock of all product tiles within a given scope and render their state
   * @param {$}  $scope
   */
  window.theme.check_and_render_store_stock = function ($scope) {
    var store_id = Cookies.get('_saved_store');
    var ids = theme.product_ids_from_dom($scope);
    if (ids.length) {
      theme.store_repository.fetch_store_availability(ids, store_id, function (availabilities) {
        theme.render_tile_store_availability(availabilities, $scope);
      });
    }
  };
})(jQuery, Cookies, theme);
(function ($, theme) {
  $(function () {
    $(document).on('click', '.order__details-toggle', function (e) {
      e.preventDefault();
      $(this).closest('.order').toggleClass('is-expanded');
    });
    var elementsNeedSpaceTrigger = $('.accounts__info-logout-link a');
    elementsNeedSpaceTrigger.push($('.page-nav__links a'));
    elementsNeedSpaceTrigger.push($('.js_delete_address'));
    elementsNeedSpaceTrigger.push($('#create_customer a'));
    elementsNeedSpaceTrigger.push($('#customer_login a'));
    elementsNeedSpaceTrigger.push($('#recover_password a'));
    elementsNeedSpaceTrigger.push($('.address-form a'));
    elementsNeedSpaceTrigger.push($('#reset_password a'));
    elementsNeedSpaceTrigger.each(function () {
      $(this).keydown(function (e) {
        if (e.key === " " || e.keyCode === 32 || e.keyCode === 13) {
          this.click();
          e.preventDefault();
        }
      });
    });
    if (theme.template.name == 'addresses') {
      $(document).on('click', '[data-modal-open]', function name(params) {
        $('header.nav .header').hide();
        $('.addresses').addClass('addresses--modal-open');
      });
      $(document).on('click', '[data-modal-close]', function name(params) {
        $('header.nav .header').show();
        $('.addresses').removeClass('addresses--modal-open');
      });
      $('.js_delete_address').on('click', function (e) {
        if (confirm(theme.translations.account.address.delete_warning || "Are you sure you wish to delete this address?")) {
          $(document).trigger('gtm_myaccount_addresses_event', {
            'myaccount_address': $(this).attr('name').replace('gtm-', '')
          });
          Shopify.postLink("/account/addresses/" + $(this).data('address-id'), {
            parameters: {
              _method: "delete"
            }
          });
        }
      });
      $('.js_address_phone').on('input', function () {
        var value = $(this).val().replace(/\D/g, '');
        if (value.length > 3 && value.length <= 6) {
          value = value.slice(0, 3) + '-' + value.slice(3);
        } else if (value.length > 6) {
          value = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 10);
        }
        $(this).val(value);
      });
      $('.js_address_phone').trigger('input');
      $('.address-form .field--input').on('input', function () {
        if ($(this).val()) {
          $(this).addClass('has-value');
        } else {
          $(this).removeClass('has-value');
        }
      });
      theme.overwrite_form_errors('form[id*="address_form"]');
    }
    if (theme.template.name == 'account') {
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      if (params.has('create')) {
        if (params.has('create') == true) {
          window.dataLayer.push({
            'event': 'myaccount_creation',
            "accepts_marketing": params.get('accepts_marketing') || "false"
          });
        }
        params["delete"]('accepts_marketing');
        params["delete"]('create');
        window.history.replaceState({}, '', "".concat(url.pathname).concat(params.toString() ? "?".concat(params) : ''));
      }
      ;
      if (params.has('loggedin')) {
        if (params.has('loggedin') == true) {
          window.dataLayer.push({
            'event': 'myaccount_login',
            'sign_in': 'successful'
          });
        }
        params["delete"]('loggedin');
        window.history.replaceState({}, '', "".concat(url.pathname).concat(params.toString() ? "?".concat(params) : ''));
      }
      ;
    }
    if (theme.template.name === 'register' || theme.template.name === 'reset_password') {
      $(document).on('click', '.js-customer-account__privacy-notice-toggler', function (e) {
        e.preventDefault();
        var $toggler = $(this),
          $label = $toggler.find('.toggler-label'),
          $container = $toggler.parent();
        $container.toggleClass('expanded');
        if ($container.hasClass('expanded')) {
          $label.text($toggler.data('label-expanded'));
        } else {
          $label.text($toggler.data('label'));
        }
      });
    }
  });
})(jQuery, window.theme = window.theme || {});
(function ($, theme) {
  /*
  **Product Page Zoom:: Library
  * to zoom in on
  * onZoomIn function closes zoom when mouse leaves element
  * zooming class changes cursor to minus sign magnifying glass
  */
  $(function () {
    var zoom_settings = {
      magnify: 1,
      on: 'click',
      onZoomIn: function onZoomIn() {
        $(this).one('mouseleave', function () {
          $(document).trigger('click.zoom');
        }).closest('.product-images__slide').addClass('zooming');
      },
      onZoomOut: function onZoomOut() {
        $(this).closest('.product-images__slide').removeClass('zooming');
      }
    };
    $(window).on('load resize orientationchange', function () {
      var currentWindow = $(window).width();
      // check if zoom img element is present in the dom
      var zoom_is_initiated = $('.product-images__slide').has('.zoomImg').length ? true : false;

      // check if mobile and if zoom img element, and destroy zoom
      if (currentWindow < theme.bp.sm && zoom_is_initiated) {
        $('.product-images__slide').trigger('zoom.destroy');
        zoom_is_initiated = false;
      }

      // check if desktop and if no zoom, and create zoom
      if (!zoom_is_initiated && currentWindow > theme.bp.sm) {
        $('.product-images__slide').zoom(zoom_settings);
        zoom_is_initiated = true;
      }
    });
  });
})(jQuery, window.theme = window.theme || {});
(function ($, theme, google, Cookies) {
  function StoreLocator(options) {
    var _default_zoom = 25;
    var _empty_search_radius_km = 25;
    var _page = 1;
    var _view_all = false;
    var _results_per_page = 3;
    var _reloading = false;
    var _current_search_coords;
    var _current_search_name;
    var _current_search;
    var _current_marker;
    var _request_location_onload;
    var _current_focus;
    var _search_this_location;
    var _active_tile = false;
    var _$locator;
    var _$input;
    var _$map;
    var _$jsToggleMap;
    var _$geolocate;
    var _$stores;
    var _$location_name = $('.store-locator__main__locations__place');
    var _input;
    var _map;
    var _autocomplete;
    var _markers = [];
    var _bounds;
    var _sku;
    var _service;
    var _store_location_tile_source = $('#store-location-tile').html();
    var _store_location_tile_template = Handlebars.compile(_store_location_tile_source);
    var _store_details_source = $('#store-details').html();
    var _store_details_template = Handlebars.compile(_store_details_source);
    var _directions_url_prefix = "https://www.google.com/maps/dir/?api=1&hl=".concat(theme.locales && theme.locales.current_locale ? theme.locales.current_locale : 'en', "&destination=");
    var infowindow = new google.maps.InfoWindow({
      pixelOffset: this._marker
    });
    var prev_marker;
    function _init() {
      if (options.$locator.length && options.map_options) {
        if (options.sku) {
          _sku = options.sku;
        }
        _request_location_onload = options.request_location_onload || false;

        /**
         * Instantiate selectors
         */
        _$locator = options.$locator;
        _$input = _$locator.find('.store-locator__input');
        _$jsToggleMap = _$locator.find('.js-toggle-map');
        _$geolocate = _$locator.find('.store-locator__geolocate');
        _$stores = _$locator.find('.store-locator__main__locations__list');
        _$map = _$locator.find('.store-locator__main__map__container__map');

        /**
         * Instantiate map
         */
        var styles = [{
          featureType: 'administrative',
          elementType: 'labels',
          stylers: [{
            visibility: 'off'
          }]
        }, {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{
            visibility: 'off'
          }]
        }, {
          featureType: 'water',
          elementType: 'labels',
          stylers: [{
            visibility: 'off'
          }]
        }, {
          featureType: 'transit',
          elementType: 'labels',
          stylers: [{
            visibility: 'off'
          }]
        }];
        _input = _$input[0];
        _select_first_on_enter(_input);
        _map = new google.maps.Map(_$map[0], options.map_options);
        _map.set('styles', styles);
        _autocomplete = new google.maps.places.Autocomplete(_input, {
          componentRestrictions: {
            country: 'CA'
          }
        });
        _service = new google.maps.places.PlacesService(_map);
        _autocomplete.bindTo('bounds', _map);
        _zoom_on_resize();
        theme.utils.disableInputZoom(_input);
        _set_search_this_location();

        /**
         * Kick things off
         */

        _current_search = _get_current_search();
        _fetch_and_render_stores(_request_location_onload);

        /**
         * Sets the local variable _current_search_name to the name from the cookies object,
         * and sets the city name in the header to be whatever is stored in cookies
         */
        if (_current_search) {
          _current_search_name = _current_search.name;
          _render_current_search(_current_search_name, _current_search.query);
          _set_current_position({
            position: [_current_search.position[0], _current_search.position[1]]
          });
          _handle_map_change();
        }

        /**
         * Event handlers
         */
        google.maps.event.addListener(_autocomplete, 'place_changed', function () {
          var place = _autocomplete.getPlace();
          if (place.address_components) {
            _handle_place_change(place);
          }
        });

        // _map.addListener('zoom_changed', function () {
        // 	_handle_map_change();
        // });

        // _map.addListener('center_changed', function () {
        // 	_handle_map_change();
        // });

        // _map.addListener('resize', function () {
        // 	_handle_map_change();
        // });

        // should need to move / redo this so that it actually renders specific store info
        $(document).on('click', '[data-modal-open=store-details-modal]', function (e) {
          e.preventDefault();
          var storeId = _render_detail_view($(this).closest('[data-store-id]').data('store-id'));
        });

        // Fix for google map modal not rendering in hidden container
        $(document).on('click', '[data-modal-open="store_locator_modal"]', function () {
          setTimeout(function () {
            _fetch_and_render_stores(true);
          }, 50);
        });

        // show/hide map on mobile
        _$jsToggleMap.click(function () {
          _$locator.find('.store-locator__main__map__container').toggleClass('hide');
          if (_$jsToggleMap.html() == "<span>".concat(theme.translations.store_locator.hide_map, "</span><span aria-hidden=\"true\" class=\"icon icon--subtract\"></span>")) {
            _$jsToggleMap.html("<span>".concat(theme.translations.store_locator.show_map, "</span><span aria-hidden=\"true\" class=\"icon icon--plus\"></span>"));
          } else {
            _$jsToggleMap.html("<span>".concat(theme.translations.store_locator.hide_map, "</span><span aria-hidden=\"true\" class=\"icon icon--subtract\"></span>"));
          }
        });

        // Geolocation toggle
        // sends the lat and long to set_current_position and updates the location text shown
        _$geolocate.on('click', function () {
          _get_user_position(function (pos) {
            _page = 1;
            _$location_name.html(window.theme.translations.store_locator.near_you.toUpperCase()).removeClass('h6').addClass('h5');
            $('.store-locator__results').removeClass('is-hidden');
            _save_current_search({
              position: pos
            });
            _set_current_position({
              position: pos
            });
            _handle_map_change();
          });
        });

        // sets 'my store'
        _$locator.on('click', '.js-set-store', function (e) {
          e.preventDefault();
          var $tile = $(this).closest('.store-location-tile');
          var store_id = $(this).closest('[data-store-id]').data('store-id');
          if (store_id) {
            if ($tile.hasClass('is-active')) {
              theme.saved_store.remove(function () {
                $('.js-set-store, .store-location-tile').removeClass('store--active is-active');
              });
            } else {
              theme.saved_store.set(store_id, function (store) {
                $('.js-set-store, .store-location-tile').removeClass('store--active is-active');
                $('.js-set-store[data-store-id="' + store_id + '"]').addClass('store--active');
                $tile.addClass('is-active');

                // brings user back to the page they came from if there's a url param for it
                var origin_page = theme.utils.getURLParams(window.location.href).from || null;
                var redirect_url = origin_page == '/' ? '/' : '/' + origin_page;
                if (origin_page) {
                  window.location.assign(redirect_url);
                }
              });
            }
          }
        });

        // Prevent search field from submitting the form
        _$input.closest('form').on('submit', function (e) {
          e.preventDefault();
        });
        google.maps.event.addDomListener(window, 'load', function () {
          _$locator.find('[type="submit"]').off('click').on('click', function (e) {
            var keydown = document.createEvent('HTMLEvents');
            keydown.initEvent('keydown', true, false);
            Object.defineProperty(keydown, 'keyCode', {
              get: function get() {
                return 13;
              }
            });
            Object.defineProperty(keydown, 'which', {
              get: function get() {
                return 13;
              }
            });
            _input.dispatchEvent(keydown);
          });
        });

        // Pagination events
        // When changing page, update internal page number and then force a map update.
        _$locator.on('click', '.js-page-link', function (e) {
          e.preventDefault();
          _page = parseInt($(this).data('page'));
          _set_current_position({
            position: _current_focus
          });
          _handle_map_change();
        });

        // See all Stores event
        _$locator.on('click', '.js-view-all', function (e) {
          e.preventDefault();
          _view_all = true;
          _page = 1;
          $('.js-location-list').addClass('view-all');
          $(this).hide();
        });

        // Distance trigger toggling on click and enter press for AODA compliance
        _$locator.on('click keydown', '.js-store-locator-distance-trigger', function (e) {
          if (e.keyCode === 13 || e.type === 'click') {
            if ($(this).hasClass('store-locator__distance__trigger--expanded')) {
              $(this).removeClass('store-locator__distance__trigger--expanded');
              $('.store-locator__distance').removeClass('store-locator__distance--expanded');
            } else {
              $(this).addClass('store-locator__distance__trigger--expanded');
              $('.store-locator__distance').addClass('store-locator__distance--expanded');
            }
          }
        });

        // Map filters
        // Distance filter events
        _$locator.on('change', '.js-store-locator-distance', function (e) {
          var input_distance = parseInt($(this).data('distance'));
          var input_zoom = parseInt($(this).data('zoom'));
          if (input_distance) {
            _empty_search_radius_km = input_distance;
          }
          if (input_zoom) {
            if (_default_zoom < input_zoom) _page = 1;
            _default_zoom = input_zoom;
            _map.setZoom(input_zoom);
          }
          if (_current_focus) {
            _set_current_position({
              position: _current_focus
            });
            _handle_map_change();
          }
          $('.js-store-locator-current-distance').text(input_distance);
        });
      }
    }
    function _fetch_and_render_stores(request_position) {
      theme.store_repository.fetch_stores().done(function (stores) {
        var bounds = _render_markers(stores);
        _map.fitBounds(bounds);
        setTimeout(function () {
          if (_current_search) {
            _set_current_position({
              position: _current_search.position
            });
          } else if (request_position) {
            _get_user_position(function (pos) {
              _$location_name.html(window.theme.translations.store_locator.near_you.toUpperCase()).removeClass('h6').addClass('h5');
              $('.store-locator__results').removeClass('is-hidden');
              _save_current_search({
                position: pos
              });
              _set_current_position({
                position: pos
              });
              _handle_map_change();
            });
          }
          $('.js-store-locator-distance:checked').trigger('change');
        }, 200);
      });
    }
    function _handle_place_change(place) {
      _page = 1;
      _save_current_search({
        place: place
      });
      _render_current_search(_current_search_name);
      if (place.geometry && place.geometry.location) {
        _set_current_position({
          position: [place.geometry.location.lat(), place.geometry.location.lng()]
          // zoom: _default_zoom
        });
      } else if (place.geometry && place.geometry.viewport) {
        _set_current_position({
          viewport: place.geometry.viewport
        });
      }
      _handle_map_change();
    }
    function _render_current_search(search, query) {
      _$location_name.html("".concat(search, " <span aria-hidden=\"true\" class=\"icon icon--location--filled\"></span>")).removeClass('h5').addClass('h6');
      $('.store-locator__results').removeClass('is-hidden');
      if (_$stores.hasClass('list--shorter')) {
        _$stores.removeClass('list--shorter');
      }
      if (query) {
        _$input.val(query);
      }
    }
    function _parse_place_name(place) {
      var filteredResults = place.address_components.filter(function (x) {
        return x.types.indexOf('locality') > -1 || x.types.indexOf('administrative_area_level_1') > -1;
      });
      if (filteredResults.length) {
        var _filteredResults$, _filteredResults$2;
        var namesArray = [(_filteredResults$ = filteredResults[0]) === null || _filteredResults$ === void 0 ? void 0 : _filteredResults$.long_name, (_filteredResults$2 = filteredResults[1]) === null || _filteredResults$2 === void 0 ? void 0 : _filteredResults$2.short_name];
        var filteredNames = namesArray.filter(function (item) {
          return item !== null && item !== undefined && item.length > 0;
        });
        return filteredNames.join(', ');
      }
    }
    function _save_current_search(search) {
      if (search.place) {
        _current_search_coords = [search.place.geometry.location.lat(), search.place.geometry.location.lng()];
        _current_search_name = _parse_place_name(search.place) || undefined;
        Cookies.set('_current_search_coords', JSON.stringify(_current_search_coords));
        Cookies.set('_current_search_name', _current_search_name);
        Cookies.set('_current_search_query', search.place.name);
      } else if (search.position) {
        _current_search_coords = search.position;
        _current_search_name = undefined;
        Cookies.set('_current_search_coords', JSON.stringify(_current_search_coords));
        Cookies.set('_current_search_name', '');
        Cookies.set('_current_search_query', '');
      }
    }
    function _get_current_search() {
      var search = {};
      try {
        if (Cookies.get('_current_search_coords')) {
          search.position = JSON.parse(Cookies.get('_current_search_coords'));
        }
      } catch (err) {}
      search.name = Cookies.get('_current_search_name');
      search.query = Cookies.get('_current_search_query');

      // search.zoom = parseInt(Cookies.get('_current_search_zoom'));

      if (search.position || search.name || search.query) {
        return search;
      } else {
        return undefined;
      }
    }
    function _handle_map_change(bounds) {
      if (_current_focus && _map) {
        var center = _map.getCenter();
        var radius = _calculate_radius_from_bounds(bounds);

        // If we have a SKU, load store line items with inventory in mind
        if (_sku) {
          // Get map radius and position
          theme.store_repository.fetch_product_stores(_sku).done(function (avails) {
            var stores = theme.store_repository.filter_by_radius_and_sku([center.lat(), center.lng()], radius, _sku, _current_focus);
            stores.map(function (store) {
              var availer = avails.find(function (avail) {
                return store.id == avail.store_id;
              });
              if (availer) {
                store.inventory = availer.quantity;
              } else {
                store.inventory = 0;
              }
              return store;
            });
            _render_store_tiles(stores, radius);
          });
        } else {
          theme.store_repository.fetch_stores().done(function (response) {
            var stores = theme.store_repository.filter_by_radius([center.lat(), center.lng()], radius, _current_focus);

            // If there are less than 3 results, we look for an extra 3 store outside the search radius
            if (stores.length < 3) {
              var numStores = 3 + stores.length;
              stores = theme.store_repository.filter_by_radius([center.lat(), center.lng()], 9999, _current_focus).slice(0, numStores);
            }
            if (stores.length && !_reloading) {
              _reloading = true;
              _bounds = new google.maps.LatLngBounds();
              _bounds.extend({
                lat: center.lat(),
                lng: center.lng()
              });
              stores.forEach(function (store) {
                _bounds.extend({
                  lat: store.latitude,
                  lng: store.longitude
                });
              });
              _map.fitBounds(_bounds);
            }
            _render_store_tiles(stores, radius);
          });
        }
      }
      _hide_search_this_location();
    }
    function _get_user_position(cb) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (p) {
          cb([p.coords.latitude, p.coords.longitude]);
        });
      }
    }
    function _set_sku(sku) {
      _sku = sku;
    }
    function _set_current_position(options) {
      _reloading = false;
      var zoom = options.zoom || _default_zoom;
      if (options.viewport) {
        var position = options.viewport.getCenter().toJSON();
        _map.fitBounds(options.viewport);
        _set_position_marker([position.lat, position.lng]);
        _current_focus = [position.lat, position.lng];
      } else if (options.position) {
        _current_focus = options.position;
        _map.setZoom(zoom);
        _map.panTo(new google.maps.LatLng(options.position[0], options.position[1]));
        _set_position_marker(options.position);
      }
    }
    function _set_position_marker(position) {
      position = new google.maps.LatLng(position[0], position[1]);
      if (_current_marker) {
        _current_marker.setPosition(position);
      } else {
        var i = {
          url: theme.images.current_location_pin,
          scaledSize: new google.maps.Size(44, 44),
          origin: new google.maps.Point(0, 0),
          // origin
          anchor: new google.maps.Point(22, 44),
          labelOrigin: new google.maps.Point(12, 12.8)
        };
        _current_marker = new google.maps.Marker({
          position: position,
          map: _map,
          animation: google.maps.Animation.DROP,
          icon: i,
          optimized: false
        });
      }
    }
    function _calculate_radius_from_bounds(bounds) {
      if (!bounds) {
        return _empty_search_radius_km;
      }
      var c = bounds.getCenter();
      var ne = bounds.getNorthEast();
      return theme.haversine_distance([c.lat(), c.lng()], [ne.lat(), c.lng()]);
    }
    function _render_markers(stores) {
      _bounds = new google.maps.LatLngBounds();
      stores.forEach(function (store) {
        var store_id = store.id;
        var icon = {
          url: theme.images.map_pin_marker,
          scaledSize: new google.maps.Size(62, 62),
          origin: new google.maps.Point(0, 0),
          // origin
          anchor: new google.maps.Point(31, 62),
          labelOrigin: new google.maps.Point(30.5, 23.8)
        };
        var icon_selected = {
          url: theme.images.map_pin_selected,
          scaledSize: new google.maps.Size(62, 62),
          origin: new google.maps.Point(0, 0),
          // origin
          anchor: new google.maps.Point(31, 62),
          labelOrigin: new google.maps.Point(30.5, 23.8)
        };
        var marker = new google.maps.Marker({
          position: {
            lat: parseFloat(store.latitude),
            lng: parseFloat(store.longitude)
          },
          map: _map,
          icon: icon,
          store_id: store_id,
          zIndex: parseInt(store_id),
          optimized: false
        });
        var store_details = _generate_store(store);
        infowindow.setOptions({
          maxWidth: 295
        });
        var close = function close() {
          var $tile_marker = $('[data-store-id="' + store_id + '"] .numbered-marker');
          var $tile_cards = $('.store-location-tile');
          infowindow.close();
          marker.setIcon(icon);
          $tile_marker.find('.svg--pin-selected').hide();
          $tile_marker.find('.svg--pin-empty').css('display', 'block');

          // Check all tiles and make them inactive
          $tile_cards.each(function () {
            $(this).removeClass('selected-tile');
          });
        };
        google.maps.event.addListener(marker, 'click', function () {
          _hide_search_this_location();
          _active_tile = true;
          var $tile_marker = $('[data-store-id="' + this.store_id + '"] .numbered-marker');
          var $tile_markers = $('[data-store-id] .numbered-marker');
          var $tile_card = $('[data-store-id="' + this.store_id + '"]');
          var $tile_cards = $('.store-location-tile');
          if (prev_marker) {
            prev_marker.setIcon(icon);
          }
          infowindow.setContent(store_details);
          infowindow.open(_map, this);
          marker.setIcon(icon_selected);
          $tile_markers.find('.svg--pin-selected').hide();
          $tile_markers.find('.svg--pin-empty').css('display', 'block');

          // Check all tiles and make them inactive
          $tile_cards.each(function () {
            $(this).removeClass('selected-tile');
          });
          $tile_marker.find('.svg--pin-empty').hide();
          $tile_marker.find('.svg--pin-empty').css('display', 'block');

          // Set green background to indicate selected tile
          $tile_card.addClass('selected-tile');
          prev_marker = marker;
          this._marker = marker;
        });
        google.maps.event.addListener(_map, 'click', function () {
          _active_tile = false;
          close();
        });
        google.maps.event.addListener(infowindow, 'closeclick', function () {
          _active_tile = false;
          close();
        });
        _markers.push(marker);
        _bounds.extend(marker.getPosition());
      });
      return _bounds;
    }
    function _find_marker_by_store_id(store_id) {
      return _markers.filter(function (marker) {
        return marker.store_id == store_id;
      })[0];
    }
    function _generate_store(store) {
      var now = new Date();
      var day;
      var timezone = now.getTimezoneOffset() === 240 ? '-04:00' : '-05:00';
      switch (now.getDay()) {
        case 0:
          day = 'sun';
          break;
        case 1:
          day = 'mon';
          break;
        case 2:
          day = 'tue';
          break;
        case 3:
          day = 'wed';
          break;
        case 4:
          day = 'thu';
          break;
        case 5:
          day = 'fri';
          break;
        case 6:
          day = 'sat';
      }
      var payload = {
          store: store,
          translations: theme.translations.store_locator.handlebars,
          open: false
        },
        address = "".concat(store.address1, ", ").concat(store.city, ", ").concat(store.province, ", ").concat(store.zip),
        store_hours = store.hours[day];
      payload.store.directions_url = _directions_url_prefix + encodeURIComponent(address);
      if (store_hours) {
        var store_open = store_hours.open.split(':').map(function (chunk) {
          return chunk.length > 1 ? chunk : '0' + chunk;
        });
        var store_close = store_hours.close.split(':').map(function (chunk) {
          return chunk.length > 1 ? chunk : '0' + chunk;
        });
        var date_string = now.getFullYear() + '-' + (now.getMonth() + 1 > 9 ? now.getMonth() + 1 : '0' + (now.getMonth() + 1)) + '-' + (now.getDate() > 9 ? now.getDate() : '0' + now.getDate());

        // NOTE: The 'open' and 'close' Date objects below are initialized with the old-school T formatting
        // in order to please our high-maintenance friend Sir IE11
        var open = new Date(date_string + 'T' + store_open[0] + ':' + store_open[1] + ':00' + timezone);
        var close = new Date(date_string + 'T' + store_close[0] + ':' + store_close[1] + ':00' + timezone);
        payload.open = now.getTime() >= open.getTime() && now.getTime() < close.getTime();
      }
      if (store.hours && store_hours && store_hours.open && store_hours.close) {
        payload.hoursOpen = timeConvert24To12(store_hours['open']);
        payload.hoursClose = timeConvert24To12(store_hours['close']);
      }
      payload.is_open = store_hours.is_open;
      if (theme.saved_store.get_id() == store.id) {
        payload.store.active = true;
      } else {
        payload.store.active = false;
      }

      // Add holiday messaging if we are on a holiday today
      var current_holidays = theme.holidays.filter(function (h) {
        var year = parseInt(h.date.split('-')[0]);
        var month = parseInt(h.date.split('-')[1]);
        var day = parseInt(h.date.split('-')[2]);
        return now.getDate() === day && now.getMonth() === month - 1 && now.getFullYear() === year;
      });
      if (current_holidays && current_holidays[0]) {
        var holiday = current_holidays[0];
        holiday.message = theme.holiday_default_message;
        if (holiday["".concat(theme.locales.language_code, "_holiday_message")] != '') {
          holiday.message = holiday["".concat(theme.locales.language_code, "_holiday_message")];
        }
        payload.holiday = holiday;
      }

      // Add global messaging if we are on a global message day
      if (typeof store.global_message !== 'undefined') {
        if (store.global_message.date.indexOf(',') > -1) {
          var global_start = store.global_message.date.split(',')[0],
            global_end = store.global_message.date.split(',')[1],
            global_start_year = parseInt(global_start.split('-')[0]),
            global_start_month = parseInt(global_start.split('-')[1]),
            global_start_day = parseInt(global_start.split('-')[2]),
            global_end_year = parseInt(global_end.split('-')[0]),
            global_end_month = parseInt(global_end.split('-')[1]),
            global_end_day = parseInt(global_end.split('-')[2]);

          // If we are the start day of the global message, or later
          if (now.getFullYear() > global_start_year || now.getFullYear() === global_start_year && now.getMonth() > global_start_month - 1 || now.getFullYear() === global_start_year && now.getMonth() === global_start_month - 1 && now.getDate() >= global_start_day) {
            // And if we are the end day of the global message, or earlier
            if (now.getFullYear() < global_end_year || now.getFullYear() === global_end_year && now.getMonth() < global_end_month - 1 || now.getFullYear() === global_end_year && now.getMonth() === global_end_month - 1 && now.getDate() <= global_end_day) {
              payload.global_message = store.global_message.message;
            }
          }
        } else {
          var global_date = store.global_message.date,
            global_year = parseInt(global_date.split('-')[0]),
            global_month = parseInt(global_date.split('-')[1]),
            global_day = parseInt(global_date.split('-')[2]);

          // If we are the day of the global message
          if (now.getDate() === global_day && now.getMonth() === global_month - 1 && now.getFullYear() === global_year) {
            payload.global_message = store.global_message.message;
          }
        }
      }
      payload.store.website = store.website && store.website.indexOf('http') === -1 ? 'https://' + payload.store.website : store.website;
      payload.store.website_text = store.website ? store.website.split('//')[1].replace('/', '') : '';
      return _store_location_tile_template(payload);
    }
    function _render_store_tiles(all_stores, radius) {
      // current page's stores
      var page_stores = all_stores.filter(function (store) {
        if (_view_all) {
          return true;
        } else {
          return store.index > (_page - 1) * _results_per_page && store.index <= _page * _results_per_page;
        }
      });

      // stores within range
      var stores = all_stores.filter(function (store) {
        return store.distance_km <= radius;
      });

      // stores that are out of range
      var other_stores = all_stores.filter(function (store) {
        return store.distance_km > radius;
      });
      _$stores.html(' ');
      _markers.forEach(function (marker) {
        marker.setVisible(false);
      });
      all_stores.forEach(function (store) {
        var marker = _find_marker_by_store_id(store.id);
        if (marker) {
          marker.set('label', {
            text: store.index,
            fontSize: '12px',
            fontWeight: '600',
            fontFamily: 'Calibre',
            letterSpacing: 'normal',
            fontStyle: 'normal'
          });
          marker.setVisible(true);
        }
      });
      stores.forEach(function (store) {
        _$stores.append(_generate_store(store));
      });
      if (other_stores.length) {
        if (_current_search_name) {
          _$stores.append("<h2 class=\"h5 store-locator__other\">".concat(theme.translations.store_locator.other_locations, " '").concat(_current_search_name, "'</h2>"));
        } else {
          _$stores.append("<h2 class=\"h5 store-locator__other\">".concat(theme.translations.store_locator.other_locations_you, "</h2>"));
        }
        _$stores.addClass('list--shorter');
        other_stores.forEach(function (other_store) {
          _$stores.append(_generate_store(other_store));
        });
      }

      // sets the message that is displayed next to the map
      $('.store-locator__unavailable, .store-locator__cta, .store-locator__results, .store-locator__available').removeClass('active-message');
      if (stores.length == 0) {
        if (_sku) {
          $('.store-locator__unavailable').addClass('active-message');
        } else {
          $('.store-locator__cta').addClass('active-message');
        }
      } else {
        if (_sku) {
          $('.store-locator__available').addClass('active-message');
        } else {
          $('.store-locator__results').addClass('active-message').removeClass('is-hidden');
        }
      }
      $('.store-locator__main__map__toggle').removeClass('is-hidden');

      // Set up pagination
      _paginate(all_stores, _$locator.find('.store-locator__main__locations__pagination'));
    }
    function _render_detail_view(store_id) {
      var _$parentElement = $('.store-details-wrapper');
      var store = theme.store_repository.find_store(store_id);

      // each parking_msg begins with en or fr
      var current_lang_code = window.theme.locales.language_code;
      if (store.hours) {
        Object.keys(store.hours).forEach(function (key) {
          if (key != 'timezone') {
            var day = key;
            if (!store.hours[day].is_open) store.hours[day].hours_string = theme.translations.store_locator.handlebars.closed;else store.hours[day].hours_string = timeConvert24To12(store.hours[day].open) + ' - ' + timeConvert24To12(store.hours[day].close);
          }
        });
      }
      var payload = {
        store: store,
        translations: theme.translations.store_locator.handlebars,
        days: theme.translations.days,
        content: store["".concat(current_lang_code, "_content")],
        authorized_logo: theme.translations.general.authorized_logo
      };
      var full_address = "".concat(store.address1, ", ").concat(store.city, ", ").concat(store.province, ", ").concat(store.zip);
      payload.store.directions_url = _directions_url_prefix + encodeURIComponent(full_address);
      _$parentElement.html(_store_details_template(payload));
      var currentWindowSize = $(window).width();
      var zoomControl = true;
      if (currentWindowSize <= theme.bp.sm) {
        zoomControl = false;
      }
      var _detail_map = new google.maps.Map($('.store-details__map')[0], {
        center: {
          lat: store.latitude,
          lng: store.longitude
        },
        disableDefaultUI: true,
        zoomControl: zoomControl,
        zoom: 16,
        scrollwheel: false
      });

      // Render Marker on store details page
      var icon = {
        url: theme.images.map_pin_marker,
        scaledSize: new google.maps.Size(62, 62),
        origin: new google.maps.Point(0, 0),
        // origin
        // anchor: new google.maps.Point(12, 32),
        labelOrigin: new google.maps.Point(30.5, 23.8)
      };
      var marker = new google.maps.Marker({
        position: {
          lat: store.latitude,
          lng: store.longitude
        },
        map: _detail_map,
        icon: icon,
        optimized: false
      });
      if (marker) {
        marker.set('label', {
          text: store.index,
          fontSize: '12px',
          fontWeight: '600',
          fontFamily: 'Calibre',
          letterSpacing: 'normal',
          fontStyle: 'normal',
          keyboard: true
        });
        marker.setVisible(true);
      }
    }
    function _paginate(response, selector) {
      var _storeCount = response.length;
      var _paginationSelector = selector;
      if (_storeCount > 0) $('.js-results-count').html('(' + _storeCount + ')');else $('.js-results-count').html('');
      var paginate = {};
      paginate.no_infinite_scroll = true;
      paginate.items = _storeCount; // total number of stores (Number)
      paginate.current_displayed = _view_all ? _storeCount : _results_per_page; // Number of products displayed on current page (Number)
      paginate.pages = Math.ceil(_storeCount / paginate.current_displayed); // Number of pages needed to diplay all results
      paginate.parts = [];
      if (paginate.pages > 1) {
        // Previous Link
        if (_page > 1) {
          paginate.previous = {
            title: 'Previous',
            page: _page - 1
          };
        }

        // Next Link
        if (_page < paginate.pages) {
          paginate.next = {
            title: 'Next',
            page: _page + 1
          };
        }

        // Middle Links
        for (var i = 1; i <= paginate.pages; i++) {
          var part = {
            title: i,
            page: i
          };
          if (i == _page) {
            part.is_current_page = true;
          } else {
            part.is_link = true;
          }
          if (i >= _page - 2 && i <= _page + 2) {
            paginate.parts.push(part);
          }
          if (i == _page - 3) {
            part.title = 1;
            part.page = 1;
            paginate.parts.push(part);
            if (_page > 1 + 3) {
              paginate.parts.push({
                title: '...'
              });
            }
          }
          if (i == _page + 3) {
            if (_page < paginate.pages - 3) {
              paginate.parts.push({
                title: '...'
              });
            }
            part.title = paginate.pages;
            part.page = paginate.pages;
            paginate.parts.push(part);
          }
        }
      }
      var source = $('#filter-pagination-template').html();
      if (source) {
        var template = Handlebars.compile(source);
        var pagination_html = template({
          'paginate': paginate
        });
        $(_paginationSelector).html(pagination_html);
      }
      if (paginate.pages <= 1) {
        $('.js-view-all').hide();
      } else {
        $('.js-view-all').show();
      }
    }

    // Stack Overflow solution. Instead of having client specify time as
    // "6:00pm", we have them specify it in 24h time and use this function to
    // convert. This is for scalability, to be able to use the time for any
    // potential calculations needed in the future (e.g. is the store currently open?)
    function timeConvert24To12(time) {
      // Check correct time format and split into components
      time = time.toString().match(/^([01]?\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }

      return time.join(''); // return adjusted time or original string
    }

    function _select_first_on_enter(input) {
      var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;
      function addEventListenerWrapper(type, listener) {
        if (type == "keydown") {
          var orig_listener = listener;
          listener = function listener(event) {
            var suggestion_selected = $(".pac-item-selected").length > 0;
            if (event.which == 13 && !suggestion_selected) {
              var simulated_downarrow = $.Event("keydown", {
                keyCode: 40,
                which: 40
              });
              orig_listener.apply(input, [simulated_downarrow]);
            }
            orig_listener.apply(input, [event]);
          };
        }
        _addEventListener.apply(input, [type, listener]);
      }
      if (input.addEventListener) {
        input.addEventListener = addEventListenerWrapper;
      } else if (input.attachEvent) {
        input.attachEvent = addEventListenerWrapper;
      }
    }
    function _zoom_on_resize() {
      var currentWindow = $(window).width();
      $(window).on('resize', function (e) {
        var newWidth = $(window).width();
        if (currentWindow <= theme.bp.sm && newWidth > theme.bp.sm || currentWindow > theme.bp.sm && newWidth <= theme.bp.sm || currentWindow <= theme.bp.md && newWidth > theme.bp.md || currentWindow > theme.bp.md && newWidth <= theme.bp.md || currentWindow <= theme.bp.lg && newWidth > theme.bp.lg || currentWindow > theme.bp.lg && newWidth <= theme.bp.lg) {
          if (_current_focus) {
            _set_current_position({
              position: _current_focus
            });
            _handle_map_change();
          } else {
            _map.fitBounds(_bounds);
          }
        }
        currentWindow = newWidth;
      });
    }
    function _set_search_this_location() {
      var topCenter = _map.controls[google.maps.ControlPosition.TOP_CENTER];
      var controlDiv = document.createElement('button');
      controlDiv.classList.add('gm-search-this-location');
      controlDiv.innerHTML = "".concat(theme.translations.store_locator.search_this_location);

      // Show the 'Search this location' button on dragend
      _map.addListener('dragend', function () {
        if (!_active_tile) {
          _search_this_location.style.transform = 'translateY(0)';
          _search_this_location.setAttribute('tabindex', '0');
        }
      });

      // Handle click
      controlDiv.addEventListener('click', function (e) {
        e.preventDefault();
        var center = _map.getCenter();
        _$location_name.html("".concat(theme.translations.store_locator.your_area, "<span aria-hidden=\"true\" class=\"icon icon--location--filled\"></span>"));
        _current_focus = [center.lat(), center.lng()];
        _current_search_name = '';
        _set_position_marker(_current_focus);
        _handle_map_change(_map.getBounds());
      });
      _search_this_location = controlDiv;
      _hide_search_this_location();
      topCenter.push(controlDiv);
    }
    function _hide_search_this_location() {
      if (!_search_this_location) {
        return;
      }
      _search_this_location.style.transform = 'translateY(-100px)';
      _search_this_location.setAttribute('tabindex', '-1');
    }

    /**
     * Public API
     * @param {array} latlong
     */

    this.render_store_tiles = function (stores) {
      return _render_store_tiles(stores);
    };
    this.set_sku = function (sku) {
      _set_sku(sku);
    };
    _init();
  }
  window.StoreLocator = StoreLocator;
  if (theme.store_locator_key) {
    $(function () {
      var API_KEY = theme.store_locator_key;
      theme.store_locator_key = null;
      var locator = new StoreLocator({
        $locator: $('.store_locator_page'),
        map_options: {
          center: {
            lat: 43.6532,
            lng: -79.3832
          },
          disableDefaultUI: true,
          zoomControl: true,
          zoom: 13,
          scrollwheel: false
        },
        api_key: API_KEY,
        request_location_onload: true
      });
    });
  }
})(jQuery, window.theme = window.theme || {}, google, Cookies);
$(function () {
  if (window.store_options) {
    var API_KEY = window.store_options.API_KEY;
    var store_details = new StoreDetails({
      $map: $('.store-details__map'),
      address: window.store_options.address,
      map_options: {
        center: {
          lat: window.store_options.lat,
          lng: window.store_options.lng
        },
        disableDefaultUI: true,
        zoomControl: true,
        zoom: 13,
        scrollwheel: false
      },
      api_key: API_KEY,
      request_location_onload: true
    });
    var params = theme.utils.getURLParams();
    if (params.store_index && !isNaN(params.store_index)) {
      $('.js-store-index').text(params.store_index);
    }
  }
});
$(function () {
  /**
  * Instantiate search
  */
  if (window.stores) {
    theme.stores_search = new StoresSearch({
      searchFieldSelector: '.js-stores-search-field',
      resultsCountSelector: '.js-stores-search-count',
      resultsLetterAnchorsSelector: '.js-stores-letter-anchors',
      resultsGridSelector: '.js-stores-search-results',
      stores: window.stores
    });
  }
});
$(function () {
  // Recently Viewed
  $(document).on('click', '.recently-viewed .product-tile a', function () {
    var product_url = window.theme.shop.url + $(this).attr('href');
    if (dataLayer) {
      dataLayer.push({
        'event': 'Click from recently_viewed',
        'click_url': product_url
      });
    }
  });

  // Collections
  $(document).on('click', '.collection__products .product-tile a', function () {
    var product_url = window.theme.shop.url + $(this).attr('href');
    if (dataLayer) {
      dataLayer.push({
        'event': 'Click from collections',
        'click_url': product_url
      });
    }
  });

  // Suggested Accessories
  $(document).on('click', '.suggested-accessories .product-tile a', function (e) {
    var product_url = window.theme.shop.url + $(this).attr('href');
    if (dataLayer) {
      dataLayer.push({
        'event': 'Click from on_page_accessory_recommendations',
        'click_url': product_url
      });
    }
  });

  // Cart Accessories
  $(document).on('click', '.cart__accessories--list .product-tile a', function (e) {
    var product_url = window.theme.shop.url + $(this).attr('href');
    if (dataLayer) {
      dataLayer.push({
        'event': 'Click from cart_accessory_recommendations',
        'click_url': product_url
      });
    }
  });

  // Featured Homepage Products
  if (window.theme.template.name == 'index') {
    $(document).on('click', '.product-carousel .product-tile a, .explore-products__item a', function () {
      var product_url = window.theme.shop.url + $(this).attr('href');
      if (dataLayer) {
        dataLayer.push({
          'event': 'Click from featured_home_page_product',
          'click_url': product_url
        });
      }
    });
    $(document).on('click', '.explore-products__items .explore-products__item a', function () {
      var product_url = window.theme.shop.url + $(this).attr('href');
      if (dataLayer) {
        dataLayer.push({
          'event': 'Click from home_page_explore_product',
          'click_url': product_url
        });
      }
    });
  }

  // GTM events - add-to-cart
  $(document).on('gtm_add_to_cart', function (event, data) {
    var _data$base_product, _data$base_product2;
    var data_layer_load = {
      event: 'add_to_cart',
      location: data.location,
      quantity: data.quantity,
      variant_option: data.variant_option,
      title: (_data$base_product = data.base_product) === null || _data$base_product === void 0 ? void 0 : _data$base_product.title,
      vendor: (_data$base_product2 = data.base_product) === null || _data$base_product2 === void 0 ? void 0 : _data$base_product2.vendor
    };
    if (data.atc_type) {
      data_layer_load.atc_type = data.atc_type;
    }
    dataLayer.push(data_layer_load);
  });

  // GTM event - sort-filters
  $(document).on('gtm_sort_filter', function (event, data) {
    dataLayer.push({
      event: 'sort_filter',
      sorted_by: data.sorted_by
    });
  });

  // GTM event - show all products and price drop toggles
  $(document).on('change', '.collection__nav--sort .nav__item input', function (e) {
    var _e$target2, _e$target2$nextElemen, _e$target3;
    var toggleCta = e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : (_e$target2$nextElemen = _e$target2.nextElementSibling) === null || _e$target2$nextElemen === void 0 ? void 0 : _e$target2$nextElemen.innerText;
    var toggleState = e !== null && e !== void 0 && (_e$target3 = e.target) !== null && _e$target3 !== void 0 && _e$target3.checked ? 'on' : 'off';
    dataLayer.push({
      'event': 'toggle_change',
      'toggle_cta': toggleCta,
      'toggle_state': toggleState
    });
  });
  $('form[name="gtm-edit-address-form__edited"], form[name="gtm-new-address-form__added"]').on('submit', function () {
    sendMyAccountAddressEvent({
      'myaccount_address': $(this).attr('name').split('__')[1]
    });
  });
  $(document).on('gtm_myaccount_addresses_event', function (event, data) {
    sendMyAccountAddressEvent(data);
  });
  function sendMyAccountAddressEvent(data) {
    dataLayer.push(_objectSpread({
      event: 'myaccount_addresses'
    }, data));
  }
});
(function ($, theme) {
  $(function () {
    var BIG_MONTHS = [1, 3, 5, 7, 8, 10, 12];
    var date_selects = '.dob__fields input',
      $age_submit = $('.screen--start button[type=submit]'),
      $body = $('body');
    var date_of_birth;
    $body.removeClass('checking-age');
    theme.utils.showAgeGate();
    function updateDOBValue() {
      var day = Number($('#dob__day').val()),
        month = Number($('#dob__month').val()),
        year = Number($('#dob__year').val());
      date_of_birth = day && month && year && new Date(year, month - 1, day);
    }
    function dobValid() {
      updateDOBValue();
      return date_of_birth && date_of_birth.getFullYear() == $('#dob__year').val() && date_of_birth.getMonth() + 1 == $('#dob__month').val() && date_of_birth.getDate() == $('#dob__day').val() && date_of_birth.getFullYear() >= Number($('#dob__year').data('min')) && date_of_birth.getFullYear() <= Number($('#dob__year').data('max'));
    }
    function dobLegal() {
      var gateDate = new Date();
      gateDate.setFullYear(gateDate.getFullYear() - 19);
      return date_of_birth <= gateDate;
    }

    // Check that the key press is a digit
    function isDigit(e) {
      return e.keyCode >= 48 && e.keyCode <= 57 && !e.shiftKey || e.keyCode >= 96 && e.keyCode <= 105 || e.keyCode === 229;
    }
    $('.overlay').on('keydown', date_selects, function (e) {
      if (e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 13) {
        // Check that they key pressed is between 0-9 (without the shift key) or 0-9 on the num pad
        if (!isDigit(e)) {
          return false;
        }
      }
    });
    $('.overlay').on('keyup', date_selects, function (e) {
      if (e.keyCode === 9 || e.keyCode === 16 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40) {
        return;
      }
      if (isDigit(e) || e.keyCode === 8 || e.keyCode === 229) {
        updateDOBValue();
        if ($(this).val() === '' && e.keyCode === 8) {
          $(this).closest('.dropdown').prev().find('input').focus();
        }
        if (($(this).is('[name=dob__month]') || $(this).is('[name=dob__day]')) && $(this).val().length >= 2) {
          $(this).closest('.dropdown').next().find('input').focus();
        }
        if ($('[name=dob__month]').val().length >= 1 && $('[name=dob__day]').val().length >= 1 && $('[name=dob__year]').val().length >= 4) {
          $age_submit.toggleClass('btn--disabled', !date_of_birth);
        }
      } else {
        return false;
      }
    });
    $('.overlay').on('change', date_selects, function (e) {
      if ($(this).is('[name=dob__month]') || $(this).is('[name=dob__day]')) {
        if ($(this).val().length > 2) {
          $(this).val($(this).val().substring(0, 2));
        }
        if (Number($(this).val()) < 1 && $(this).val() != '') {
          $(this).val(1);
        }
        if ($(this).val().length < 2 && $(this).val().length > 0) {
          $(this).val(0 + $(this).val());
        }
      }
      if ($(this).is('[name=dob__month]')) {
        if (Number($(this).val() > 12)) {
          $(this).val(12);
        }
        if (Number($(this).val() == 2)) {
          if (Number($('[name=dob__day]').val() > 29)) {
            $('[name=dob__day]').val(29);
          }
        }
      }
      if ($(this).is('[name=dob__day]')) {
        if (Number($('[name=dob__month]').val()) == 2 && Number($(this).val()) > 29) {
          $(this).val(29);
        } else {
          if (BIG_MONTHS.indexOf(Number($('[name=dob__month]').val())) > -1) {
            if (Number($(this).val()) > 31) {
              $(this).val(31);
            }
          } else {
            if (Number($(this).val()) > 30) {
              $(this).val(30);
            }
          }
        }
      }
      updateDOBValue();
      $('.dob__invalid-date-message, .dob__empty-fields-message, .dob__invalid-age-message').removeClass('active');
      $age_submit.toggleClass('btn--disabled', !date_of_birth);
    });
    $age_submit.click(function (e) {
      e.preventDefault();
      updateDOBValue();
      if (!date_of_birth) {
        $('.dob__empty-fields-message').addClass('active');
        return false;
      }
      if (!dobValid()) {
        $('.dob__invalid-date-message').addClass('active');
        return false;
      }
      if (date_of_birth && !dobLegal()) {
        $('.dob__invalid-age-message').addClass('active');
        return false;
      }
      if (dobValid() && date_of_birth && dobLegal()) {
        Cookies.set('age_verified', 'verified', {
          expires: 14
        });
        $body.removeClass('agewall-show checking-age');
        $(window).scrollTop(0);
      }
    });
  });
})(jQuery, window.theme = window.theme || {});
$(function () {
  // Equalize the height of all the elements of the same class within a container
  function equalize_height($container, selector) {
    if ($(window).width() > theme.bp.sm) {
      var highestTile = 0;
      $(selector, $container).each(function () {
        if ($(this).height() > highestTile) {
          highestTile = $(this).height();
        }
      });
      $(selector, $container).height(highestTile).show();
    }
  }
  $(window).on('load resize orientationchange', function () {
    if ($(window).width() > theme.bp.sm) {
      $('.square-tiles').each(function () {
        equalize_height($(this), '.square-tile__title');
        equalize_height($(this), '.square-tile__description');
      });
    }
  });
});
(function ($, theme) {
  $(function () {
    $('.js-brand-header').click(function (e) {
      if ($(window).width() <= theme.bp.sm) {
        $(this).next().slideToggle();
      }
    });
  });
})(jQuery, window.theme = window.theme || {});
(function ($, VariantSelector, theme) {
  /**
   * CollectionQuickAdd class
   * Contains all the logic for the quick add to work on the collection page.
   */
  var CollectionQuickAdd = /*#__PURE__*/function () {
    /**
     * Creates an instance of CollectionQuickAdd.
     *
     * @param {Node} tile - The DOM node of the tile we want to add quick add to.
     * @param {string} product_handle - The product handle. Used to fetch the data for the variant selector.
     */
    function CollectionQuickAdd(tile, product_handle) {
      _classCallCheck(this, CollectionQuickAdd);
      this.elements = {
        root: tile,
        price_display: tile.querySelector('.js-price-shown'),
        price_from: tile.querySelector('.js-from'),
        ppu_price: tile.querySelector('.js-ppu-price'),
        ppu_unit_custom: tile.querySelector('.js-ppu-unit'),
        price_from_secondary: tile.querySelector('.js-from-secondary'),
        container: tile.querySelector('.js-collection-quick-add-swatches'),
        price_compare: tile.querySelector('.js-price-compare'),
        new_label: tile.querySelector('.js-product-tile-new-label'),
        discount_label: tile.querySelector('.js-product-tile-discount-label')
      };
      this._button_selector = '.js-quick-add-button';
      this._product_handle = product_handle;
      this._already_loaded = false;
      this._has_multiple_variants = false;
      this._default_variant = '';
      this._is_mobile = window.innerWidth < theme.bp.sm ? true : false;
      this.base_product;
      this._chosen_variant;
      this.current_options;
      this._available;
      this._price_shown;
      this._price_per_unit;
      this._ppu_unit_custom;
      this._show_ppu;
      this._price_compare;
      this._price_shown_orig;
      this._price_compare_orig;
      this._price_per_unit_orig;
      this._ppu_unit_custom_orig;
      this._tile_options;
      this._preselect_single_variant = false;
      // populate the this._tile_options object
      this._fetch_tile_options();
      this._create_variant_selector();
      this._cache_initial_prices();
    }
    _createClass(CollectionQuickAdd, [{
      key: "_add_to_cart",
      value: function _add_to_cart(variant) {
        var _this43 = this;
        var payload = {
          id: variant.id,
          quantity: 1,
          properties: {
            '_fr-CA': variant.metafields.translation['fr-CA'] || '',
            '_fr-CA_title': variant.metafields.translation['fr-CA_title'] || '',
            '_fr-CA_vendor': variant.metafields.translation['fr-CA_vendor'] || '',
            '_fr-CA_options': this.current_options
          },
          analytics: {
            variant_id: variant.id,
            variant_option: this.current_options,
            quantity: 1,
            base_product: this.base_product,
            location: 'PLP'
          }
        };

        // Resetting in 'done/fail' rather than 'always' for better timing
        return theme.cart.add(payload).done(function () {
          _this43._reset(700);
        }).fail(function (e) {
          if (e.status == 422) {
            alert(theme.translations.cart_error.out_of_stock);
          }
          _this43._reset(700);
        });
      }

      /*
       * Private methods
       */
    }, {
      key: "_bindEvents",
      value: function _bindEvents() {
        var _this44 = this;
        window.addEventListener('resize', function () {
          _this44._is_mobile = window.innerWidth < theme.bp.sm ? true : false;
        });
      }

      // Cache initial price(s) in case need to reset
    }, {
      key: "_cache_initial_prices",
      value: function _cache_initial_prices() {
        this._price_shown_orig = this.elements.price_display.innerHTML;
        this._price_compare_orig = this.elements.price_compare.innerHTML;
        this._price_per_unit_orig = this.elements.ppu_price.innerHTML;
        this._ppu_unit_custom_orig = this.elements.ppu_unit_custom.innerHTML;
      }
    }, {
      key: "_create_add_cart_cta",
      value: function _create_add_cart_cta() {
        return "<button type=\"button\" class=\"btn btn--primary btn--outline product-tile__button js-quick-add-button\" aria-disabled=\"true\" tabindex=\"0\">\n                ".concat(theme.translations.select_size, "\n              </button>");
      }
    }, {
      key: "_create_variant_selector",
      value: function _create_variant_selector() {
        var _this45 = this;
        return $.get("/products/".concat(this._product_handle, "?view=quickview"), function (response) {
          response = JSON.parse(response);
          _this45.base_product = response.product;
          var product_is_available_online = !theme.in_store_exclusive(response.product);
          var any_variant_is_instore = false;
          response.variants.map(function (v) {
            if (v.option1.indexOf('x') > -1 && v.option1.indexOf('g') > -1) {
              v.option1 = v.option1.split('x').join(' x ');
            }
            if (product_is_available_online) {
              var _v$metafields, _v$metafields$variant2;
              any_variant_is_instore = any_variant_is_instore || (v === null || v === void 0 ? void 0 : (_v$metafields = v.metafields) === null || _v$metafields === void 0 ? void 0 : (_v$metafields$variant2 = _v$metafields.variant) === null || _v$metafields$variant2 === void 0 ? void 0 : _v$metafields$variant2.availability) === 'in-store';
            }
            return v;
          });
          if (response.product.options[0] == 'Title' && response.product.variants.length == 1) {
            _this45.current_options = theme.translate_options(response.product.variants[0].options, response.product.options_with_values);
            _this45._default_variant = response.variants[0];
          } else {
            // Display discount banner as soon as any of the available variants has a valid compare at price.
            if (response.product.variants.filter(function (variant) {
              return variant.available == true && variant.compare_at_price != 0 && variant.compare_at_price > variant.price;
            }).length >= 1 && _this45.elements.discount_label) {
              _this45.elements.discount_label.classList.remove('is-hidden');
            }
            _this45._preselect_single_variant = _this45._preselect_single_variant && response.product.variants.filter(function (variant) {
              return variant.available == true;
            }).length === 1;
            new VariantSelector({
              callbacks: {
                selection_change: function selection_change(variants) {
                  var ppu;

                  /* Cartridges/Vapes can have custom ppu */
                  if (variants[0].metafields.variant.custom_pricing) {
                    ppu = theme.utils.toMoney(variants[0].metafields.variant.custom_pricing);
                    /* Most products */
                  } else if (variants[0].price_per_unit) {
                    ppu = "$" + variants[0].price_per_unit;
                    /* Some product data deviate from standard model, so accounting for that here */
                  } else if (variants[0].metafields.variant.price_per_unit) {
                    ppu = "$" + variants[0].metafields.variant.price_per_unit;
                  } else if (variants[0].options.length > 0 && variants[0].price) {
                    ppu = theme.utils.toMoney(variants[0].price, {
                      cents: true
                    });
                  } else if (!ppu) {
                    ppu = "";
                    console.error('Data error, variant PPU not found');
                  }
                  _this45.selected_input = _this45.elements.root.querySelector('.variant-selector:checked');
                  _this45.current_options = theme.translate_options(variants[0].options, response.product.options_with_values);
                  _this45._chosen_variant = variants[0];
                  _this45._price_shown = theme.utils.toMoney(variants[0].price, {
                    cents: true
                  });
                  var compare_price = variants[0].compare_at_price;
                  var valid_compare = compare_price != 0 && compare_price > variants[0].price ? true : false;
                  _this45._price_compare = valid_compare ? theme.utils.toMoney(compare_price, {
                    cents: true
                  }) : '';
                  _this45._price_per_unit = ppu;

                  // commenting as we don't need to call it here anymore
                  // this._set_multi_indicator(false);

                  setTimeout(function () {
                    _this45._update_price(true);
                    _this45._update_button();
                  });
                }
              },
              scope_selector: "#".concat(_this45.elements.root.id),
              container_selector: '.product-tile__variants',
              variants: response.variants,
              options_with_values: response.product.options_with_values,
              product_id: response.product.id,
              tags: response.product.tags,
              product: response.product,
              preselect: _this45._preselect_single_variant,
              data: {
                unselected_text: theme.translations.product.unselected_text,
                choose_option: theme.translations.product.choose_option,
                capsules: theme.translations.product.capsule,
                capsule_suffix: theme.translations.product.capsule_suffix,
                gram_per_capsule_suffix: theme.translations.product.gram_per_capsule_suffix,
                volume: theme.translations.product.volume,
                seeds: theme.translations.product.seed,
                total_suffix: theme.translations.product.total_suffix,
                equivalent_suffix: theme.translations.product.equivalent_suffix,
                roll_total_suffix: theme.translations.product.roll_total_suffix,
                roll_suffix_singular: theme.translations.product.roll_suffix_singular,
                roll_suffix_plural: theme.translations.product.roll_suffix_plural,
                gram_per_roll_suffix: theme.translations.product.gram_per_roll_suffix
              },
              default_template: '#option-selector--default',
              // Templates for dried flowers, pre-rolled, capsules, and oils.
              templates: [{
                tags: ['subcategory--Pre-Rolled'],
                selector_type: 'variant',
                template: '#variant-selector--rolls'
              }, {
                tags: ['subcategory--Oils', 'subcategory--Beverages'],
                selector_type: 'variant',
                template: '#variant-selector--volume'
              }, {
                tags: ['subcategory--Capsules'],
                selector_type: 'variant',
                template: '#variant-selector--capsules'
              }, {
                options: ['Weight', 'Pois', 'Poids', 'Size', 'Taille', 'Grandeur'],
                selector_type: 'variant',
                template: '#variant-selector--weight'
              }, {
                options: ['Size', 'Grandeur'],
                selector_type: 'option',
                template: '#option-selector--size'
              }]
            });
            _this45._has_multiple_variants = true;
            _this45._ppu_unit_custom = response.variants[0].metafields.variant.custom_uom || '';
            _this45._show_ppu = response.product.metafields.product.content_uom_type === 'g' ? true : false;
          }

          // #### SET prices for custom_ppu scenarios
          _this45._set_custom_ppu(response);

          // #### HANDLE AVAILABILITY / OOS / MULTI INDICATOR scenarios
          _this45._available = response.product.available;
          if (_this45._available) {
            _this45._set_quick_add_button();
            if (response.variants.filter(function (v) {
              return v.available === true;
            }).length > 1) {
              _this45._set_multi_indicator(true);
            }
          }
          ;

          // #### UPDATE DOM with prices for custom_ppu scenarios
          if (_this45._tile_options.custom_ppu) {
            _this45._update_price(false);
          }

          // #### Update DOM to remove if we are displaying wholsesale price
          if (product_is_available_online && any_variant_is_instore) {
            _this45._check_wholesale_price(response);
          }
          _this45.elements.price_display.removeAttribute('data-default-plp-price');

          // caching the final updated initial default prices shown on UI
          _this45._cache_initial_prices();
          _this45._already_loaded = true;
        });
      }
    }, {
      key: "_reset",
      value: function _reset(time) {
        var _this46 = this;
        if (!this._default_variant && !this._preselect_single_variant) {
          setTimeout(function () {
            _this46.elements.price_display.innerHTML = _this46._price_shown_orig;
            _this46.elements.price_compare.innerHTML = _this46._price_compare_orig;
            _this46.elements.ppu_price.parentElement.classList.add('hide');
            _this46.selected_input.checked = false;
            _this46.elements.button.classList.add('btn--outline');
            _this46.elements.button.setAttribute('aria-disabled', 'true');
            _this46.elements.button.innerHTML = theme.translations.select_size;

            // Handling RESET for custom_ppu scenarios
            if (_this46._tile_options.custom_ppu) {
              _this46.elements.ppu_price.innerHTML = _this46._price_per_unit_orig;
              _this46.elements.ppu_unit_custom.innerHTML = _this46._ppu_unit_custom_orig;
              if (_this46.elements.ppu_price.parentElement.classList.contains('hide')) {
                _this46.elements.ppu_price.parentElement.classList.remove('hide');
              }
            }
          }, time);
        }
      }
    }, {
      key: "_set_quick_add_button",
      value: function _set_quick_add_button() {
        var _this47 = this;
        this.elements.button = this.elements.root.querySelector(this._button_selector);
        if (this._default_variant && this._available) {
          this.elements.button.classList.remove('btn--outline');
          this.elements.button.setAttribute('aria-disabled', 'false');
          this.elements.button.innerHTML = 'Add To Cart';
        }

        /* Replace the liquid-generated OOS button in rare cases where the liquid-generated
           availability flag differs from its Algolia-generated counterpart. */
        if (this.elements.root.querySelector('.quick-add-button--oos') && this._available) {
          var button_container = this.elements.root.querySelector('.quick-add-button__container');
          button_container.innerHTML = '';
          button_container.insertAdjacentHTML('afterbegin', this._create_add_cart_cta());
          this.elements.button = button_container.querySelector(this._button_selector);
          this.elements.root.classList.remove('product-tile--oos');
        }
        this.elements.button.addEventListener('click', function (event) {
          if (_this47._has_multiple_variants) {
            _this47._add_to_cart(_this47._chosen_variant);
          }
          if (_this47._default_variant && _this47._available) {
            _this47._add_to_cart(_this47._default_variant);
          }
          if (window.aa_info && theme.template.name == 'search') {
            var $element = $(event.target).closest('.product-tile').find('[data-aa-id]');
            if ($element.length) {
              window.aa('convertedObjectIDsAfterSearch', {
                index: window.aa_info.index,
                eventName: 'atc_on_pdp',
                queryID: window.aa_info.queryID || '',
                objectIDs: [$element.data('aa-id')]
              });
            }
          }
        });
      }
    }, {
      key: "_set_custom_ppu",
      value: function _set_custom_ppu(response) {
        var custom_pricing_key = 'custom_pricing';
        var custom_uom_key = 'custom_uom';
        if (!response.variants[0].metafields.variant.custom_pricing) {
          custom_pricing_key = 'display_ppu';
          custom_uom_key = 'display_uom';
        }
        if (this._tile_options.custom_ppu) {
          var online_variants = response.variants.filter(function (_v) {
            var _v$metafields2, _v$metafields2$varian;
            return (_v === null || _v === void 0 ? void 0 : (_v$metafields2 = _v.metafields) === null || _v$metafields2 === void 0 ? void 0 : (_v$metafields2$varian = _v$metafields2.variant) === null || _v$metafields2$varian === void 0 ? void 0 : _v$metafields2$varian.availability) !== 'in-store';
          });
          online_variants.sort(function (a, b) {
            return +a.metafields.variant.custom_pricing - +b.metafields.variant.custom_pricing;
          });
          var variant = online_variants.filter(function (variant) {
            return variant.available == true;
          })[0];

          // Fallback for out of stock toggle scenario when every online variant is unavailable also filtering the in-store prices to prevent from displaying 
          if (!variant) {
            if (online_variants.length > 0) {
              variant = online_variants[0];
            } else {
              return;
            }
          }

          // This is not used anymore, but keeping it for future reference
          var weight;
          var option = variant.options[0];
          if (option && option.indexOf('g') > -1) {
            weight = Number(option.slice(0, -1));
          }

          // primary price - first price line item in the card
          this._price_shown = theme.utils.toMoney(variant.price, {
            cents: true
          });

          // primary price drop
          if (variant.compare_at_price && variant.compare_at_price > 0) {
            this._price_compare = variant.compare_at_price;
            this._price_compare = this._price_compare > variant.price ? theme.utils.toMoney(this._price_compare, {
              cents: true
            }) : '';
          }

          // secondary price - second price line item in the card
          if (variant.metafields.variant[custom_pricing_key]) {
            this._price_per_unit = theme.utils.toMoney(variant.metafields.variant[custom_pricing_key]);
          }

          // secondary uom
          this._ppu_unit_custom = variant.metafields.variant[custom_uom_key];
        }
      }
    }, {
      key: "_set_multi_indicator",
      value: function _set_multi_indicator() {
        var showFromText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        if (this._tile_options.custom_ppu) {
          this.elements.price_from.innerHTML = '';
          this.elements.price_from_secondary.innerHTML = showFromText ? theme.translations.multi_price_indicator_tile : '';
        } else {
          this.elements.price_from.innerHTML = showFromText ? theme.translations.multi_price_indicator_tile : '';
          this.elements.price_from_secondary.innerHTML = '';
        }
      }
    }, {
      key: "_update_button",
      value: function _update_button() {
        if (this.elements.button.classList.contains('btn--outline')) {
          this.elements.button.classList.remove('btn--outline');
          this.elements.button.setAttribute('aria-disabled', 'false');
          this.elements.button.innerHTML = theme.translations.add_to_cart;
        }
      }
    }, {
      key: "_update_price",
      value: function _update_price() {
        var afterCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        // primary price
        if (typeof this._price_shown != 'undefined') {
          this.elements.price_display.innerHTML = this._price_shown ? this._price_shown : '';
        }

        // primary price drop
        if (typeof this._price_compare != 'undefined') {
          this.elements.price_compare.innerHTML = this._price_compare ? this._price_compare : '';
        }

        // adding trailing 0 to complete 2 decimal price in cents
        var price_delimiter = ".";
        if (this._price_per_unit && this._price_per_unit.toString().includes(',')) {
          price_delimiter = ',';
        }
        if (this._price_per_unit && this._price_per_unit.split(price_delimiter)[1].length === 1) {
          this._price_per_unit = this._price_per_unit.concat("0");
        }
        if (this._show_ppu) {
          // secondary price
          if (typeof this._price_per_unit != 'undefined') {
            if (afterCallback) {
              this.elements.ppu_price.innerHTML = this._price_per_unit;
            } else {
              this.elements.ppu_price.innerHTML += this._price_per_unit;
            }
          }

          // secondary uom
          if (this._ppu_unit_custom) {
            this.elements.ppu_unit_custom.innerHTML = '/ ' + this._ppu_unit_custom;
          }
          if (this.elements.ppu_price.parentElement.classList.contains('hide')) {
            this.elements.ppu_price.parentElement.classList.remove('hide');
          }
        }

        // if there is an updated price then we need to update 'data-default-plp-price' attribute on wrapper dom element
        if (!afterCallback) {
          this._update_default_plp_price(this.elements.price_display);
        }
      }
    }, {
      key: "_fetch_tile_options",
      value: function _fetch_tile_options() {
        // fetching the tile options object (used to create the tile) from tile_factory cache
        this._tile_options = theme.tile_factory.getOptions({
          product_id: this.elements.root.getAttribute('data-product-id')
        });
        // console.log(this._tile_options);
      }
    }, {
      key: "_update_default_plp_price",
      value: function _update_default_plp_price(elem_) {
        if (elem_) {
          var _elem_$innerHTML;
          // this RegEx is to get the dollar amount on PLP cards from DOM on either FR or EN locals
          // it matches a $ amount in a string then then matches a decimal number with . or , after the 
          // pipe it does simillar task but $ after the string aslo g at the end matches patterns globally
          // for example  string "From $2.95" or "From 2,95$" will be returned as $2.95 or 2,95$
          var _reg_exp = /[\$]\s*?(\d+(?:(\.|,)\d{1,2})?)|(\d+(?:(\.|,)\d{1,2})?)\s*?[\$]/g;
          var _price_shown = (_elem_$innerHTML = elem_.innerHTML) === null || _elem_$innerHTML === void 0 ? void 0 : _elem_$innerHTML.replaceAll('&nbsp;', '');
          var _matched_array = _price_shown.match(_reg_exp);
          if (_matched_array !== null && Array.isArray(_matched_array) && _matched_array.length > 0) {
            this.elements.price_display.setAttribute('data-default-plp-price', _matched_array[0]);
          }
        }
      }
    }, {
      key: "_check_wholesale_price",
      value: function _check_wholesale_price(response) {
        var _this$elements$price_, _this$elements$price_2, _this$elements$price_3, _this$elements$price_4;
        var displayed_price = (_this$elements$price_ = this.elements.price_display.getAttribute('data-default-plp-price')) === null || _this$elements$price_ === void 0 ? void 0 : (_this$elements$price_2 = _this$elements$price_.trim()) === null || _this$elements$price_2 === void 0 ? void 0 : (_this$elements$price_3 = _this$elements$price_2.replaceAll(',', '.')) === null || _this$elements$price_3 === void 0 ? void 0 : (_this$elements$price_4 = _this$elements$price_3.replaceAll('$', '')) === null || _this$elements$price_4 === void 0 ? void 0 : _this$elements$price_4.toString();
        function variant_has_price(price, variant_object) {
          var key_words = ['product', 'variant', 'metafield', 'ppu', 'price', 'pricing'];
          var _loop = function _loop(key) {
            if (variant_object.hasOwnProperty(key) && key_words.some(function (kw) {
              return key.indexOf(kw) !== -1;
            })) {
              var _variant_object$key;
              if (((_variant_object$key = variant_object[key]) === null || _variant_object$key === void 0 ? void 0 : _variant_object$key.toString()) === (price === null || price === void 0 ? void 0 : price.toString())) {
                return {
                  v: true
                };
              } else if (_typeof(variant_object[key]) === 'object') {
                if (variant_has_price(price, variant_object[key])) {
                  return {
                    v: true
                  };
                }
                ;
              }
              ;
            }
            ;
          };
          for (var key in variant_object) {
            var _ret = _loop(key);
            if (_typeof(_ret) === "object") return _ret.v;
          }
          ;
          return false;
        }
        ;
        var variant_has_price_instore = false;
        var variant_has_price_online = false;
        response.variants.map(function (v) {
          if (variant_has_price(displayed_price, v)) {
            var _v$metafields3, _v$metafields3$varian, _v$metafields4, _v$metafields4$varian;
            variant_has_price_instore = variant_has_price_instore || (v === null || v === void 0 ? void 0 : (_v$metafields3 = v.metafields) === null || _v$metafields3 === void 0 ? void 0 : (_v$metafields3$varian = _v$metafields3.variant) === null || _v$metafields3$varian === void 0 ? void 0 : _v$metafields3$varian.availability) === 'in-store';
            variant_has_price_online = variant_has_price_online || (v === null || v === void 0 ? void 0 : (_v$metafields4 = v.metafields) === null || _v$metafields4 === void 0 ? void 0 : (_v$metafields4$varian = _v$metafields4.variant) === null || _v$metafields4$varian === void 0 ? void 0 : _v$metafields4$varian.availability) === 'online';
          }
          ;
        });
        function check_null_remove_innerhtml(_html_element) {
          if (_html_element) {
            _html_element.innerHTML = '';
          }
          return _html_element;
        }
        if (variant_has_price_instore && !variant_has_price_online) {
          var _this$elements, _this$elements2, _this$elements3, _this$elements4, _this$elements5, _this$elements6, _this$elements$price_5, _this$elements$ppu_pr;
          check_null_remove_innerhtml((_this$elements = this.elements) === null || _this$elements === void 0 ? void 0 : _this$elements.price_from);
          check_null_remove_innerhtml((_this$elements2 = this.elements) === null || _this$elements2 === void 0 ? void 0 : _this$elements2.price_from_secondary);
          check_null_remove_innerhtml((_this$elements3 = this.elements) === null || _this$elements3 === void 0 ? void 0 : _this$elements3.price_display);
          check_null_remove_innerhtml((_this$elements4 = this.elements) === null || _this$elements4 === void 0 ? void 0 : _this$elements4.price_compare);
          check_null_remove_innerhtml((_this$elements5 = this.elements) === null || _this$elements5 === void 0 ? void 0 : _this$elements5.ppu_price);
          check_null_remove_innerhtml((_this$elements6 = this.elements) === null || _this$elements6 === void 0 ? void 0 : _this$elements6.ppu_unit_custom);
          (_this$elements$price_5 = this.elements.price_display) === null || _this$elements$price_5 === void 0 ? void 0 : _this$elements$price_5.appendChild(this.elements.price_from ? this.elements.price_from : void 0);
          (_this$elements$ppu_pr = this.elements.ppu_price) === null || _this$elements$ppu_pr === void 0 ? void 0 : _this$elements$ppu_pr.appendChild(this.elements.price_from_secondary ? this.elements.price_from_secondary : void 0);
        }
      }
    }]);
    return CollectionQuickAdd;
  }();
  theme.CollectionQuickAdd = CollectionQuickAdd;
})(jQuery, VariantSelector, window.theme = window.theme || {});
(function ($) {
  var focusable = 'input:visible, button:visible, textarea:visible, a:visible';
  $('.js-close-maximum').click(function (e) {
    $('.js-maximum-exceeded').removeClass('is-shown');
    $('body').removeClass('showing-maximum body--freeze');
    $('html').removeClass('body--freeze');
    $('body').find(focusable).first().focus();
  });
  $(document).on('keydown', '.js-maximum-exceeded.is-shown', function (e) {
    if (e.which == 9) {
      e.preventDefault();
    }
  });
})(jQuery);
(function () {
  var closeBtn = document.querySelectorAll('.notice-banner__closing-outerbox')[0]; // probably there's only one of them
  var noticeBanner = document.querySelectorAll('.notice-banner__alert-wrapper')[0]; // keep the class names consistent

  var hideAlertBanner = sessionStorage.getItem('hideAlertBanner');
  if (hideAlertBanner && noticeBanner) {
    noticeBanner.classList.add('is-hidden');
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      noticeBanner.classList.add('is-hidden');
      sessionStorage.setItem('hideAlertBanner', true);
    });
  }
})();
(function ($) {
  $(function () {
    window.EmailMarketingFormValidator = function (formSelector) {
      var _inputs,
        _mandatoryCheckboxes,
        _submit,
        _formValidated = false,
        _validArray = [],
        _emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      /*
           Updates the custom placeholder value
         */
      function _updateLabel(input) {
        if (input.val().trim().length > 0) {
          input.addClass('has-value');
        } else {
          input.removeClass('has-value');
        }
      }

      /*
           Validates input by checking for generic email format
         */
      function _validateEmail(input) {
        var errorElem = $(formSelector).find('[data-error-id="' + input.attr('id') + '"]');
        if (input.val().trim().length && input.val().trim().length < 50 && _emailRegex.test(input.val())) {
          input.removeClass('invalid-value');
          input.addClass('valid-value');
          errorElem.hide();
          _formValidated = true;
        } else {
          if (input.attr('touched') && input.hasClass('has-value')) {
            input.removeClass('valid-value');
            input.addClass('invalid-value');
            errorElem.show();
            // errorElem.focus();
          }

          _formValidated = false;
        }
        return _formValidated;
      }

      /*
           Validates checkboxes by checking if they're checked
         */
      function _validateCheckbox(checkbox) {
        var isChecked = $(formSelector).find('input[type=checkbox][name="' + checkbox.attr('name') + '"]:checked');
        var errorElem = $(formSelector).find('[data-error-id="' + checkbox.attr('id') + '"]');
        if (isChecked.length) {
          errorElem.hide();
          _formValidated = true;
        } else {
          if (checkbox.attr('touched')) {
            errorElem.show();
          }
          _formValidated = false;
        }
        return _formValidated;
      }

      /*
           Loops through all the fields and and validates based on what input the current iteration is.
         */
      function _validateFields() {
        for (var i = 0; i < _inputs.length; i++) {
          if ($(_inputs[i]).prop('required')) {
            if ($(_inputs[i]).is('[type="email"]') && (!$(_inputs[i]).is(':focus') || $(_inputs[i]).hasClass('invalid-value'))) {
              _validateEmail($(_inputs[i]));
            }
            if ($(_inputs[i]).is('[type="checkbox"]')) {
              _validateCheckbox($(_inputs[i]));
            }
          }
          _validArray.push(_formValidated);
        }
      }

      /*
           Stores an array of boolean, submits the form if no false can be found in said array.
         */
      function _validateForm() {
        _validArray.length = 0;
        _validateFields();
        return _validArray.indexOf(false) < 0;
      }

      /**
       * _validateMandatoryCheckboxes fxn
       */
      // function _validateMandatoryCheckboxes() {
      // 	$(_mandatoryCheckboxes).on('change', function() {
      // 		var allChecked = true;

      // 		$.each(_mandatoryCheckboxes, function() {
      // 			if (!$(this).is(':checked')) {
      // 				allChecked = false;
      // 				return false;
      // 			}
      // 		});

      // 		_submit.prop('disabled', !allChecked);
      // 	});
      // }

      /*
      	Enabling / Disabling the submit button.
         */
      function _activateSubmit() {
        var _isFormValid = _validateForm();
        _submit.prop('disabled', !_isFormValid);
      }

      /*
      	Registers various required form listeners for submit button activation
      	Checks for all required input fields / checkboxes to be checked before enabling the submit button.
         */
      function _activateSubmitListeners() {
        var _loop2 = function _loop2() {
          if ($(_inputs[i]).prop('required')) {
            if ($(_inputs[i]).is('[type="email"]')) {
              var keyCode = null;
              $(_inputs[i]).on('keydown', function (event) {
                keyCode = event === null || event === void 0 ? void 0 : event.which;
              });
              $(_inputs[i]).blur(function () {
                _activateSubmit();
                if (keyCode == 9 && $(this).hasClass('invalid-value')) {
                  $(formSelector).find('[data-error-id="' + $(this).attr('id') + '"]').focus();
                }
              });
            }
            if ($(_inputs[i]).is('[type="checkbox"]')) {
              $(_inputs[i]).change(function () {
                _activateSubmit();
              });
            }
          }
        };
        for (var i = 0; i < _inputs.length; i++) {
          _loop2();
        }
      }

      /*
           Initializes the form object for validation
         */
      function _init() {
        _inputs = $(formSelector).find(':input:not([type="hidden"], [type="submit"], [type="password"]), textarea, select');
        _submit = $(formSelector).find('[type="submit"]');
        _mandatoryCheckboxes = $(formSelector).find('[type="checkbox"][required]');
        _activateSubmitListeners();
        _inputs.on('focus', function () {
          $(this).attr('touched', 'true');
        });
        _inputs.on('keyup', function () {
          _updateLabel($(this));
          _validateFields();
          if ($(this).hasClass('valid-value')) {
            $(formSelector).find('[data-error-id="' + $(this).attr('id') + '"]').hide();
          }
        });
        _inputs.on('load', function () {
          _inputs.map(function (input) {
            _updateLabel(input);
          });
        });
        $(document).on('submit', formSelector, function (e) {
          return _validateForm();
        });
      }
      _init();
    };
  });
})(jQuery);
(function ($, Handlebars, theme) {
  $(function () {
    if ($('#email_marketing_form').length) {
      theme.emailMarketingForm = new EmailMarketingFormValidator('#email_marketing_form');
    }
  });
})(jQuery, Handlebars, window.theme = window.theme || {});